//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable()
export class AppClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    query(body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/validate/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuery(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuery(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuery(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    version(): Observable<void> {
        let url_ = this.baseUrl + "/api/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVersion(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVersion(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVersion(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    status(): Observable<void> {
        let url_ = this.baseUrl + "/api/status";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatus(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param maxRecords (optional) 
     * @return OK
     */
    imageupdate(maxRecords: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/imageupdate?";
        if (maxRecords === null)
            throw new globalThis.Error("The parameter 'maxRecords' cannot be null.");
        else if (maxRecords !== undefined)
            url_ += "maxRecords=" + encodeURIComponent("" + maxRecords) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImageupdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImageupdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImageupdate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param simple (optional) 
     * @return OK
     */
    featureset(ownerID: number, respondentID: number, ownerKey: string, standalone: boolean, simple: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/App/featureset/{ownerID}/{respondentID}/{ownerKey}/{standalone}?";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        if (respondentID === undefined || respondentID === null)
            throw new globalThis.Error("The parameter 'respondentID' must be defined.");
        url_ = url_.replace("{respondentID}", encodeURIComponent("" + respondentID));
        if (ownerKey === undefined || ownerKey === null)
            throw new globalThis.Error("The parameter 'ownerKey' must be defined.");
        url_ = url_.replace("{ownerKey}", encodeURIComponent("" + ownerKey));
        if (standalone === undefined || standalone === null)
            throw new globalThis.Error("The parameter 'standalone' must be defined.");
        url_ = url_.replace("{standalone}", encodeURIComponent("" + standalone));
        if (simple === null)
            throw new globalThis.Error("The parameter 'simple' cannot be null.");
        else if (simple !== undefined)
            url_ += "simple=" + encodeURIComponent("" + simple) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFeatureset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFeatureset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFeatureset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    progress(processGUID: string): Observable<void> {
        let url_ = this.baseUrl + "/api/progress/{processGUID}";
        if (processGUID === undefined || processGUID === null)
            throw new globalThis.Error("The parameter 'processGUID' must be defined.");
        url_ = url_.replace("{processGUID}", encodeURIComponent("" + processGUID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProgress(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgress(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProgress(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param datasetID (optional) 
     * @return OK
     */
    dataset(datasetID: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset?";
        if (datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' cannot be null.");
        else if (datasetID !== undefined)
            url_ += "datasetID=" + encodeURIComponent("" + datasetID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDataset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDataset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDataset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param datasetID (optional) 
     * @param complete (optional) 
     * @param iteration (optional) 
     * @return OK
     */
    markcomplete(datasetID: number | undefined, complete: boolean | undefined, iteration: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/markcomplete?";
        if (datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' cannot be null.");
        else if (datasetID !== undefined)
            url_ += "datasetID=" + encodeURIComponent("" + datasetID) + "&";
        if (complete === null)
            throw new globalThis.Error("The parameter 'complete' cannot be null.");
        else if (complete !== undefined)
            url_ += "complete=" + encodeURIComponent("" + complete) + "&";
        if (iteration === null)
            throw new globalThis.Error("The parameter 'iteration' cannot be null.");
        else if (iteration !== undefined)
            url_ += "iteration=" + encodeURIComponent("" + iteration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkcomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkcomplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMarkcomplete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param datasetID (optional) 
     * @param respondentID (optional) 
     * @param iteration (optional) 
     * @param submitData (optional) 
     * @return OK
     */
    submitGET(datasetID: number | undefined, respondentID: number | undefined, iteration: number | undefined, submitData: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/submit?";
        if (datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' cannot be null.");
        else if (datasetID !== undefined)
            url_ += "datasetID=" + encodeURIComponent("" + datasetID) + "&";
        if (respondentID === null)
            throw new globalThis.Error("The parameter 'respondentID' cannot be null.");
        else if (respondentID !== undefined)
            url_ += "respondentID=" + encodeURIComponent("" + respondentID) + "&";
        if (iteration === null)
            throw new globalThis.Error("The parameter 'iteration' cannot be null.");
        else if (iteration !== undefined)
            url_ += "iteration=" + encodeURIComponent("" + iteration) + "&";
        if (submitData === null)
            throw new globalThis.Error("The parameter 'submitData' cannot be null.");
        else if (submitData !== undefined)
            url_ += "submitData=" + encodeURIComponent("" + submitData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubmitGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param datasetID (optional) 
     * @param respondentID (optional) 
     * @param iteration (optional) 
     * @param menuRootDTID (optional) 
     * @return OK
     */
    validatepage(datasetID: number | undefined, respondentID: number | undefined, iteration: number | undefined, menuRootDTID: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/validatepage?";
        if (datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' cannot be null.");
        else if (datasetID !== undefined)
            url_ += "datasetID=" + encodeURIComponent("" + datasetID) + "&";
        if (respondentID === null)
            throw new globalThis.Error("The parameter 'respondentID' cannot be null.");
        else if (respondentID !== undefined)
            url_ += "respondentID=" + encodeURIComponent("" + respondentID) + "&";
        if (iteration === null)
            throw new globalThis.Error("The parameter 'iteration' cannot be null.");
        else if (iteration !== undefined)
            url_ += "iteration=" + encodeURIComponent("" + iteration) + "&";
        if (menuRootDTID === null)
            throw new globalThis.Error("The parameter 'menuRootDTID' cannot be null.");
        else if (menuRootDTID !== undefined)
            url_ += "menuRootDTID=" + encodeURIComponent("" + menuRootDTID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatepage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatepage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidatepage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param datasetID (optional) 
     * @param respondentID (optional) 
     * @param iterateExpressionData (optional) 
     * @return OK
     */
    bump(datasetID: number | undefined, respondentID: number | undefined, iterateExpressionData: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/iteration/bump?";
        if (datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' cannot be null.");
        else if (datasetID !== undefined)
            url_ += "datasetID=" + encodeURIComponent("" + datasetID) + "&";
        if (respondentID === null)
            throw new globalThis.Error("The parameter 'respondentID' cannot be null.");
        else if (respondentID !== undefined)
            url_ += "respondentID=" + encodeURIComponent("" + respondentID) + "&";
        if (iterateExpressionData === null)
            throw new globalThis.Error("The parameter 'iterateExpressionData' cannot be null.");
        else if (iterateExpressionData !== undefined)
            url_ += "iterateExpressionData=" + encodeURIComponent("" + iterateExpressionData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBump(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBump(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBump(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param datasetID (optional) 
     * @param respondentID (optional) 
     * @param iteration (optional) 
     * @param buttonID (optional) 
     * @param datapointTargetID (optional) 
     * @param groupByValueIndex (optional) 
     * @return OK
     */
    button(datasetID: number | undefined, respondentID: number | undefined, iteration: number | undefined, buttonID: number | undefined, datapointTargetID: number | undefined, groupByValueIndex: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/button?";
        if (datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' cannot be null.");
        else if (datasetID !== undefined)
            url_ += "datasetID=" + encodeURIComponent("" + datasetID) + "&";
        if (respondentID === null)
            throw new globalThis.Error("The parameter 'respondentID' cannot be null.");
        else if (respondentID !== undefined)
            url_ += "respondentID=" + encodeURIComponent("" + respondentID) + "&";
        if (iteration === null)
            throw new globalThis.Error("The parameter 'iteration' cannot be null.");
        else if (iteration !== undefined)
            url_ += "iteration=" + encodeURIComponent("" + iteration) + "&";
        if (buttonID === null)
            throw new globalThis.Error("The parameter 'buttonID' cannot be null.");
        else if (buttonID !== undefined)
            url_ += "buttonID=" + encodeURIComponent("" + buttonID) + "&";
        if (datapointTargetID === null)
            throw new globalThis.Error("The parameter 'datapointTargetID' cannot be null.");
        else if (datapointTargetID !== undefined)
            url_ += "datapointTargetID=" + encodeURIComponent("" + datapointTargetID) + "&";
        if (groupByValueIndex === null)
            throw new globalThis.Error("The parameter 'groupByValueIndex' cannot be null.");
        else if (groupByValueIndex !== undefined)
            url_ += "groupByValueIndex=" + encodeURIComponent("" + groupByValueIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processButton(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processButton(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processButton(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param datasetID (optional) 
     * @param respondentID (optional) 
     * @param iteration (optional) 
     * @param datapointTargetID (optional) 
     * @param valueText (optional) 
     * @param referenceNumber (optional) 
     * @param expressionExternalParams (optional) 
     * @param groupByValueIndex (optional) 
     * @param displayParentDatapointTargetID (optional) 
     * @param pinPriorValueID (optional) 
     * @return OK
     */
    datapointGET(datasetID: number | undefined, respondentID: number | undefined, iteration: number | undefined, datapointTargetID: number | undefined, valueText: string | undefined, referenceNumber: string | undefined, expressionExternalParams: string | undefined, groupByValueIndex: number[] | undefined, displayParentDatapointTargetID: number | undefined, pinPriorValueID: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/datapoint?";
        if (datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' cannot be null.");
        else if (datasetID !== undefined)
            url_ += "datasetID=" + encodeURIComponent("" + datasetID) + "&";
        if (respondentID === null)
            throw new globalThis.Error("The parameter 'respondentID' cannot be null.");
        else if (respondentID !== undefined)
            url_ += "respondentID=" + encodeURIComponent("" + respondentID) + "&";
        if (iteration === null)
            throw new globalThis.Error("The parameter 'iteration' cannot be null.");
        else if (iteration !== undefined)
            url_ += "iteration=" + encodeURIComponent("" + iteration) + "&";
        if (datapointTargetID === null)
            throw new globalThis.Error("The parameter 'datapointTargetID' cannot be null.");
        else if (datapointTargetID !== undefined)
            url_ += "datapointTargetID=" + encodeURIComponent("" + datapointTargetID) + "&";
        if (valueText === null)
            throw new globalThis.Error("The parameter 'valueText' cannot be null.");
        else if (valueText !== undefined)
            url_ += "valueText=" + encodeURIComponent("" + valueText) + "&";
        if (referenceNumber === null)
            throw new globalThis.Error("The parameter 'referenceNumber' cannot be null.");
        else if (referenceNumber !== undefined)
            url_ += "referenceNumber=" + encodeURIComponent("" + referenceNumber) + "&";
        if (expressionExternalParams === null)
            throw new globalThis.Error("The parameter 'expressionExternalParams' cannot be null.");
        else if (expressionExternalParams !== undefined)
            url_ += "expressionExternalParams=" + encodeURIComponent("" + expressionExternalParams) + "&";
        if (groupByValueIndex === null)
            throw new globalThis.Error("The parameter 'groupByValueIndex' cannot be null.");
        else if (groupByValueIndex !== undefined)
            groupByValueIndex && groupByValueIndex.forEach(item => { url_ += "groupByValueIndex=" + encodeURIComponent("" + item) + "&"; });
        if (displayParentDatapointTargetID === null)
            throw new globalThis.Error("The parameter 'displayParentDatapointTargetID' cannot be null.");
        else if (displayParentDatapointTargetID !== undefined)
            url_ += "displayParentDatapointTargetID=" + encodeURIComponent("" + displayParentDatapointTargetID) + "&";
        if (pinPriorValueID === null)
            throw new globalThis.Error("The parameter 'pinPriorValueID' cannot be null.");
        else if (pinPriorValueID !== undefined)
            url_ += "pinPriorValueID=" + encodeURIComponent("" + pinPriorValueID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    datapointPUT(body: DatapointValueRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/datapoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    datapoints(body: DatapointValuesRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/datapoints";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapoints(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapoints(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapoints(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    delete(datasetID: number, datapointTargetID: number, groupByValueIndex: number, iteration: number): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/datapoints/formgroup/delete/{datasetID}/{datapointTargetID}/{groupByValueIndex}/{iteration}";
        if (datasetID === undefined || datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' must be defined.");
        url_ = url_.replace("{datasetID}", encodeURIComponent("" + datasetID));
        if (datapointTargetID === undefined || datapointTargetID === null)
            throw new globalThis.Error("The parameter 'datapointTargetID' must be defined.");
        url_ = url_.replace("{datapointTargetID}", encodeURIComponent("" + datapointTargetID));
        if (groupByValueIndex === undefined || groupByValueIndex === null)
            throw new globalThis.Error("The parameter 'groupByValueIndex' must be defined.");
        url_ = url_.replace("{groupByValueIndex}", encodeURIComponent("" + groupByValueIndex));
        if (iteration === undefined || iteration === null)
            throw new globalThis.Error("The parameter 'iteration' must be defined.");
        url_ = url_.replace("{iteration}", encodeURIComponent("" + iteration));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    filePOST(datasetID: number, iteration: number, datapointTargetID: number, groupByValueIndex: number, respondentID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/{datasetID}/{iteration}/{datapointTargetID}/{groupByValueIndex}/{respondentID}/file";
        if (datasetID === undefined || datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' must be defined.");
        url_ = url_.replace("{datasetID}", encodeURIComponent("" + datasetID));
        if (iteration === undefined || iteration === null)
            throw new globalThis.Error("The parameter 'iteration' must be defined.");
        url_ = url_.replace("{iteration}", encodeURIComponent("" + iteration));
        if (datapointTargetID === undefined || datapointTargetID === null)
            throw new globalThis.Error("The parameter 'datapointTargetID' must be defined.");
        url_ = url_.replace("{datapointTargetID}", encodeURIComponent("" + datapointTargetID));
        if (groupByValueIndex === undefined || groupByValueIndex === null)
            throw new globalThis.Error("The parameter 'groupByValueIndex' must be defined.");
        url_ = url_.replace("{groupByValueIndex}", encodeURIComponent("" + groupByValueIndex));
        if (respondentID === undefined || respondentID === null)
            throw new globalThis.Error("The parameter 'respondentID' must be defined.");
        url_ = url_.replace("{respondentID}", encodeURIComponent("" + respondentID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFilePOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    fileDELETE(datasetID: number, iteration: number, datapointTargetID: number, groupByValueIndex: number): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/{datasetID}/{iteration}/{datapointTargetID}/{groupByValueIndex}/file";
        if (datasetID === undefined || datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' must be defined.");
        url_ = url_.replace("{datasetID}", encodeURIComponent("" + datasetID));
        if (iteration === undefined || iteration === null)
            throw new globalThis.Error("The parameter 'iteration' must be defined.");
        url_ = url_.replace("{iteration}", encodeURIComponent("" + iteration));
        if (datapointTargetID === undefined || datapointTargetID === null)
            throw new globalThis.Error("The parameter 'datapointTargetID' must be defined.");
        url_ = url_.replace("{datapointTargetID}", encodeURIComponent("" + datapointTargetID));
        if (groupByValueIndex === undefined || groupByValueIndex === null)
            throw new globalThis.Error("The parameter 'groupByValueIndex' must be defined.");
        url_ = url_.replace("{groupByValueIndex}", encodeURIComponent("" + groupByValueIndex));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFileDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    fileGET(datasetID: number, iteration: number, datapointTargetID: number, groupByValueIndex: number): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/{datasetID}/{iteration}/{datapointTargetID}/{groupByValueIndex}/file";
        if (datasetID === undefined || datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' must be defined.");
        url_ = url_.replace("{datasetID}", encodeURIComponent("" + datasetID));
        if (iteration === undefined || iteration === null)
            throw new globalThis.Error("The parameter 'iteration' must be defined.");
        url_ = url_.replace("{iteration}", encodeURIComponent("" + iteration));
        if (datapointTargetID === undefined || datapointTargetID === null)
            throw new globalThis.Error("The parameter 'datapointTargetID' must be defined.");
        url_ = url_.replace("{datapointTargetID}", encodeURIComponent("" + datapointTargetID));
        if (groupByValueIndex === undefined || groupByValueIndex === null)
            throw new globalThis.Error("The parameter 'groupByValueIndex' must be defined.");
        url_ = url_.replace("{groupByValueIndex}", encodeURIComponent("" + groupByValueIndex));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFileGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param groupByValueIndex (optional) 
     * @param key1 (optional) 
     * @param key2 (optional) 
     * @param note (optional) 
     * @param valueText (optional) 
     * @return OK
     */
    detail(datasetID: number, iteration: number, respondentID: number, groupByValueIndex: number | undefined, key1: string | undefined, key2: string | undefined, note: string | undefined, valueText: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/detail/{datasetID}/{iteration}/{respondentID}?";
        if (datasetID === undefined || datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' must be defined.");
        url_ = url_.replace("{datasetID}", encodeURIComponent("" + datasetID));
        if (iteration === undefined || iteration === null)
            throw new globalThis.Error("The parameter 'iteration' must be defined.");
        url_ = url_.replace("{iteration}", encodeURIComponent("" + iteration));
        if (respondentID === undefined || respondentID === null)
            throw new globalThis.Error("The parameter 'respondentID' must be defined.");
        url_ = url_.replace("{respondentID}", encodeURIComponent("" + respondentID));
        if (groupByValueIndex === null)
            throw new globalThis.Error("The parameter 'groupByValueIndex' cannot be null.");
        else if (groupByValueIndex !== undefined)
            url_ += "groupByValueIndex=" + encodeURIComponent("" + groupByValueIndex) + "&";
        if (key1 === null)
            throw new globalThis.Error("The parameter 'key1' cannot be null.");
        else if (key1 !== undefined)
            url_ += "key1=" + encodeURIComponent("" + key1) + "&";
        if (key2 === null)
            throw new globalThis.Error("The parameter 'key2' cannot be null.");
        else if (key2 !== undefined)
            url_ += "key2=" + encodeURIComponent("" + key2) + "&";
        if (note === null)
            throw new globalThis.Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        if (valueText === null)
            throw new globalThis.Error("The parameter 'valueText' cannot be null.");
        else if (valueText !== undefined)
            url_ += "valueText=" + encodeURIComponent("" + valueText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDetail(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param key1 (optional) 
     * @param key2 (optional) 
     * @param note (optional) 
     * @param valueText (optional) 
     * @return OK
     */
    detail2(respondentID: number, datapointTargetID: number, key1: string | undefined, key2: string | undefined, note: string | undefined, valueText: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/datapointtarget/detail/{respondentID}/{datapointTargetID}?";
        if (respondentID === undefined || respondentID === null)
            throw new globalThis.Error("The parameter 'respondentID' must be defined.");
        url_ = url_.replace("{respondentID}", encodeURIComponent("" + respondentID));
        if (datapointTargetID === undefined || datapointTargetID === null)
            throw new globalThis.Error("The parameter 'datapointTargetID' must be defined.");
        url_ = url_.replace("{datapointTargetID}", encodeURIComponent("" + datapointTargetID));
        if (key1 === null)
            throw new globalThis.Error("The parameter 'key1' cannot be null.");
        else if (key1 !== undefined)
            url_ += "key1=" + encodeURIComponent("" + key1) + "&";
        if (key2 === null)
            throw new globalThis.Error("The parameter 'key2' cannot be null.");
        else if (key2 !== undefined)
            url_ += "key2=" + encodeURIComponent("" + key2) + "&";
        if (note === null)
            throw new globalThis.Error("The parameter 'note' cannot be null.");
        else if (note !== undefined)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        if (valueText === null)
            throw new globalThis.Error("The parameter 'valueText' cannot be null.");
        else if (valueText !== undefined)
            url_ += "valueText=" + encodeURIComponent("" + valueText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDetail2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDetail2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDetail2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param asHierarchy (optional) 
     * @param tagName (optional) 
     * @param includeOptions (optional) 
     * @param omitGridDups (optional) 
     * @param includeInterSurveyInputs (optional) 
     * @param initFormGroupQuestions (optional) 
     * @param includeSubTargets (optional) 
     * @return OK
     */
    dataset2(targetID: number, datasetID: number, respondentID: number, iteration: number, asHierarchy: boolean | undefined, tagName: string | undefined, includeOptions: boolean | undefined, omitGridDups: boolean | undefined, includeInterSurveyInputs: boolean | undefined, initFormGroupQuestions: boolean | undefined, includeSubTargets: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/{targetID}/{datasetID}/{respondentID}/{iteration}/{asHierarchy}/{tagName}/{includeOptions}/{omitGridDups}/{includeInterSurveyInputs}/{initFormGroupQuestions}/{includeSubTargets}?";
        if (targetID === undefined || targetID === null)
            throw new globalThis.Error("The parameter 'targetID' must be defined.");
        url_ = url_.replace("{targetID}", encodeURIComponent("" + targetID));
        if (datasetID === undefined || datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' must be defined.");
        url_ = url_.replace("{datasetID}", encodeURIComponent("" + datasetID));
        if (respondentID === undefined || respondentID === null)
            throw new globalThis.Error("The parameter 'respondentID' must be defined.");
        url_ = url_.replace("{respondentID}", encodeURIComponent("" + respondentID));
        if (iteration === undefined || iteration === null)
            throw new globalThis.Error("The parameter 'iteration' must be defined.");
        url_ = url_.replace("{iteration}", encodeURIComponent("" + iteration));
        if (asHierarchy === null)
            throw new globalThis.Error("The parameter 'asHierarchy' cannot be null.");
        else if (asHierarchy !== undefined)
            url_ += "asHierarchy=" + encodeURIComponent("" + asHierarchy) + "&";
        if (tagName === null)
            throw new globalThis.Error("The parameter 'tagName' cannot be null.");
        else if (tagName !== undefined)
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&";
        if (includeOptions === null)
            throw new globalThis.Error("The parameter 'includeOptions' cannot be null.");
        else if (includeOptions !== undefined)
            url_ += "includeOptions=" + encodeURIComponent("" + includeOptions) + "&";
        if (omitGridDups === null)
            throw new globalThis.Error("The parameter 'omitGridDups' cannot be null.");
        else if (omitGridDups !== undefined)
            url_ += "omitGridDups=" + encodeURIComponent("" + omitGridDups) + "&";
        if (includeInterSurveyInputs === null)
            throw new globalThis.Error("The parameter 'includeInterSurveyInputs' cannot be null.");
        else if (includeInterSurveyInputs !== undefined)
            url_ += "includeInterSurveyInputs=" + encodeURIComponent("" + includeInterSurveyInputs) + "&";
        if (initFormGroupQuestions === null)
            throw new globalThis.Error("The parameter 'initFormGroupQuestions' cannot be null.");
        else if (initFormGroupQuestions !== undefined)
            url_ += "initFormGroupQuestions=" + encodeURIComponent("" + initFormGroupQuestions) + "&";
        if (includeSubTargets === null)
            throw new globalThis.Error("The parameter 'includeSubTargets' cannot be null.");
        else if (includeSubTargets !== undefined)
            url_ += "includeSubTargets=" + encodeURIComponent("" + includeSubTargets) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDataset2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDataset2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDataset2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param asHierarchy (optional) 
     * @param tagName (optional) 
     * @param includeOptions (optional) 
     * @param omitGridDups (optional) 
     * @param includeInterSurveyInputs (optional) 
     * @param initFormGroupQuestions (optional) 
     * @param includeSubTargets (optional) 
     * @return OK
     */
    bulkGET(bulkTargetID: string, bulkTargetValueID: number, datasetID: number, respondentID: number, iteration: number, asHierarchy: boolean | undefined, tagName: string | undefined, includeOptions: boolean | undefined, omitGridDups: boolean | undefined, includeInterSurveyInputs: boolean | undefined, initFormGroupQuestions: boolean | undefined, includeSubTargets: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/bulk/{bulkTargetID}/{bulkTargetValueID}/{datasetID}/{respondentID}/{iteration}/{asHierarchy}/{tagName}/{includeOptions}/{omitGridDups}/{includeInterSurveyInputs}/{initFormGroupQuestions}/{includeSubTargets}?";
        if (bulkTargetID === undefined || bulkTargetID === null)
            throw new globalThis.Error("The parameter 'bulkTargetID' must be defined.");
        url_ = url_.replace("{bulkTargetID}", encodeURIComponent("" + bulkTargetID));
        if (bulkTargetValueID === undefined || bulkTargetValueID === null)
            throw new globalThis.Error("The parameter 'bulkTargetValueID' must be defined.");
        url_ = url_.replace("{bulkTargetValueID}", encodeURIComponent("" + bulkTargetValueID));
        if (datasetID === undefined || datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' must be defined.");
        url_ = url_.replace("{datasetID}", encodeURIComponent("" + datasetID));
        if (respondentID === undefined || respondentID === null)
            throw new globalThis.Error("The parameter 'respondentID' must be defined.");
        url_ = url_.replace("{respondentID}", encodeURIComponent("" + respondentID));
        if (iteration === undefined || iteration === null)
            throw new globalThis.Error("The parameter 'iteration' must be defined.");
        url_ = url_.replace("{iteration}", encodeURIComponent("" + iteration));
        if (asHierarchy === null)
            throw new globalThis.Error("The parameter 'asHierarchy' cannot be null.");
        else if (asHierarchy !== undefined)
            url_ += "asHierarchy=" + encodeURIComponent("" + asHierarchy) + "&";
        if (tagName === null)
            throw new globalThis.Error("The parameter 'tagName' cannot be null.");
        else if (tagName !== undefined)
            url_ += "tagName=" + encodeURIComponent("" + tagName) + "&";
        if (includeOptions === null)
            throw new globalThis.Error("The parameter 'includeOptions' cannot be null.");
        else if (includeOptions !== undefined)
            url_ += "includeOptions=" + encodeURIComponent("" + includeOptions) + "&";
        if (omitGridDups === null)
            throw new globalThis.Error("The parameter 'omitGridDups' cannot be null.");
        else if (omitGridDups !== undefined)
            url_ += "omitGridDups=" + encodeURIComponent("" + omitGridDups) + "&";
        if (includeInterSurveyInputs === null)
            throw new globalThis.Error("The parameter 'includeInterSurveyInputs' cannot be null.");
        else if (includeInterSurveyInputs !== undefined)
            url_ += "includeInterSurveyInputs=" + encodeURIComponent("" + includeInterSurveyInputs) + "&";
        if (initFormGroupQuestions === null)
            throw new globalThis.Error("The parameter 'initFormGroupQuestions' cannot be null.");
        else if (initFormGroupQuestions !== undefined)
            url_ += "initFormGroupQuestions=" + encodeURIComponent("" + initFormGroupQuestions) + "&";
        if (includeSubTargets === null)
            throw new globalThis.Error("The parameter 'includeSubTargets' cannot be null.");
        else if (includeSubTargets !== undefined)
            url_ += "includeSubTargets=" + encodeURIComponent("" + includeSubTargets) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    externalparams(body: ExternalDataParamsRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/config/externalparams";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternalparams(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternalparams(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExternalparams(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    config(externalID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/owner/config/{externalID}";
        if (externalID === undefined || externalID === null)
            throw new globalThis.Error("The parameter 'externalID' must be defined.");
        url_ = url_.replace("{externalID}", encodeURIComponent("" + externalID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfig(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfig(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfig(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    config2(ownerID: number, externalID: number, externalName: string, externalSourceTable: string): Observable<void> {
        let url_ = this.baseUrl + "/api/respondent/config/{ownerID}/{externalID}/{externalName}/{externalSourceTable}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        if (externalID === undefined || externalID === null)
            throw new globalThis.Error("The parameter 'externalID' must be defined.");
        url_ = url_.replace("{externalID}", encodeURIComponent("" + externalID));
        if (externalName === undefined || externalName === null)
            throw new globalThis.Error("The parameter 'externalName' must be defined.");
        url_ = url_.replace("{externalName}", encodeURIComponent("" + externalName));
        if (externalSourceTable === undefined || externalSourceTable === null)
            throw new globalThis.Error("The parameter 'externalSourceTable' must be defined.");
        url_ = url_.replace("{externalSourceTable}", encodeURIComponent("" + externalSourceTable));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfig2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfig2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfig2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    config3(ownerID: number, externalID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/respondent/config/{ownerID}/{externalID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        if (externalID === undefined || externalID === null)
            throw new globalThis.Error("The parameter 'externalID' must be defined.");
        url_ = url_.replace("{externalID}", encodeURIComponent("" + externalID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfig3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfig3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfig3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param currentIteration (optional) 
     * @param library (optional) 
     * @return OK
     */
    config4(targetID: number, externalID: number, externalSourceTable: string, global: boolean, currentIteration: number | undefined, library: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/config/{targetID}/{externalID}/{externalSourceTable}/{global}?";
        if (targetID === undefined || targetID === null)
            throw new globalThis.Error("The parameter 'targetID' must be defined.");
        url_ = url_.replace("{targetID}", encodeURIComponent("" + targetID));
        if (externalID === undefined || externalID === null)
            throw new globalThis.Error("The parameter 'externalID' must be defined.");
        url_ = url_.replace("{externalID}", encodeURIComponent("" + externalID));
        if (externalSourceTable === undefined || externalSourceTable === null)
            throw new globalThis.Error("The parameter 'externalSourceTable' must be defined.");
        url_ = url_.replace("{externalSourceTable}", encodeURIComponent("" + externalSourceTable));
        if (global === undefined || global === null)
            throw new globalThis.Error("The parameter 'global' must be defined.");
        url_ = url_.replace("{global}", encodeURIComponent("" + global));
        if (currentIteration === null)
            throw new globalThis.Error("The parameter 'currentIteration' cannot be null.");
        else if (currentIteration !== undefined)
            url_ += "currentIteration=" + encodeURIComponent("" + currentIteration) + "&";
        if (library === null)
            throw new globalThis.Error("The parameter 'library' cannot be null.");
        else if (library !== undefined)
            url_ += "library=" + encodeURIComponent("" + library) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfig4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfig4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfig4(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    percentcomplete(datasetID: number, datapointTargetID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/percentcomplete/{datasetID}/{datapointTargetID}";
        if (datasetID === undefined || datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' must be defined.");
        url_ = url_.replace("{datasetID}", encodeURIComponent("" + datasetID));
        if (datapointTargetID === undefined || datapointTargetID === null)
            throw new globalThis.Error("The parameter 'datapointTargetID' must be defined.");
        url_ = url_.replace("{datapointTargetID}", encodeURIComponent("" + datapointTargetID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPercentcomplete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPercentcomplete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPercentcomplete(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    prereqinfos(datapointTargetID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/datapointtarget/{datapointTargetID}/prereqinfos";
        if (datapointTargetID === undefined || datapointTargetID === null)
            throw new globalThis.Error("The parameter 'datapointTargetID' must be defined.");
        url_ = url_.replace("{datapointTargetID}", encodeURIComponent("" + datapointTargetID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrereqinfos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrereqinfos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPrereqinfos(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    prereq(body: DatasetDatapoint | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/datapointtarget/prereq";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrereq(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrereq(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPrereq(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    result(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/target/result/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param ownerID (optional) 
     * @param bulk (optional) 
     * @param bulkTargetID (optional) 
     * @return OK
     */
    preview(targetID: number, ownerID: number | undefined, bulk: boolean | undefined, bulkTargetID: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/target/preview/{targetID}?";
        if (targetID === undefined || targetID === null)
            throw new globalThis.Error("The parameter 'targetID' must be defined.");
        url_ = url_.replace("{targetID}", encodeURIComponent("" + targetID));
        if (ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' cannot be null.");
        else if (ownerID !== undefined)
            url_ += "ownerID=" + encodeURIComponent("" + ownerID) + "&";
        if (bulk === null)
            throw new globalThis.Error("The parameter 'bulk' cannot be null.");
        else if (bulk !== undefined)
            url_ += "bulk=" + encodeURIComponent("" + bulk) + "&";
        if (bulkTargetID === null)
            throw new globalThis.Error("The parameter 'bulkTargetID' cannot be null.");
        else if (bulkTargetID !== undefined)
            url_ += "bulkTargetID=" + encodeURIComponent("" + bulkTargetID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPreview(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    starts(targetID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/target/starts/{targetID}";
        if (targetID === undefined || targetID === null)
            throw new globalThis.Error("The parameter 'targetID' must be defined.");
        url_ = url_.replace("{targetID}", encodeURIComponent("" + targetID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStarts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStarts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStarts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param iteration (optional) 
     * @return OK
     */
    menu(targetID: number, datasetID: number, respondentID: number, iteration: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/menu/{targetID}/{datasetID}/{respondentID}/{iteration}?";
        if (targetID === undefined || targetID === null)
            throw new globalThis.Error("The parameter 'targetID' must be defined.");
        url_ = url_.replace("{targetID}", encodeURIComponent("" + targetID));
        if (datasetID === undefined || datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' must be defined.");
        url_ = url_.replace("{datasetID}", encodeURIComponent("" + datasetID));
        if (respondentID === undefined || respondentID === null)
            throw new globalThis.Error("The parameter 'respondentID' must be defined.");
        url_ = url_.replace("{respondentID}", encodeURIComponent("" + respondentID));
        if (iteration === null)
            throw new globalThis.Error("The parameter 'iteration' cannot be null.");
        else if (iteration !== undefined)
            url_ += "iteration=" + encodeURIComponent("" + iteration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMenu(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMenu(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMenu(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param iteration (optional) 
     * @return OK
     */
    bulkGET2(bulkTargetID: string, datasetID: number, respondentID: number, iteration: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/menu/bulk/{bulkTargetID}/{datasetID}/{respondentID}/{iteration}?";
        if (bulkTargetID === undefined || bulkTargetID === null)
            throw new globalThis.Error("The parameter 'bulkTargetID' must be defined.");
        url_ = url_.replace("{bulkTargetID}", encodeURIComponent("" + bulkTargetID));
        if (datasetID === undefined || datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' must be defined.");
        url_ = url_.replace("{datasetID}", encodeURIComponent("" + datasetID));
        if (respondentID === undefined || respondentID === null)
            throw new globalThis.Error("The parameter 'respondentID' must be defined.");
        url_ = url_.replace("{respondentID}", encodeURIComponent("" + respondentID));
        if (iteration === null)
            throw new globalThis.Error("The parameter 'iteration' cannot be null.");
        else if (iteration !== undefined)
            url_ += "iteration=" + encodeURIComponent("" + iteration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkGET2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param iteration (optional) 
     * @return OK
     */
    progress2(datasetID: number, respondentID: number, iteration: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/progress/{datasetID}/{respondentID}/{iteration}?";
        if (datasetID === undefined || datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' must be defined.");
        url_ = url_.replace("{datasetID}", encodeURIComponent("" + datasetID));
        if (respondentID === undefined || respondentID === null)
            throw new globalThis.Error("The parameter 'respondentID' must be defined.");
        url_ = url_.replace("{respondentID}", encodeURIComponent("" + respondentID));
        if (iteration === null)
            throw new globalThis.Error("The parameter 'iteration' cannot be null.");
        else if (iteration !== undefined)
            url_ += "iteration=" + encodeURIComponent("" + iteration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProgress2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProgress2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProgress2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    styles(targetID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/target/{targetID}/styles";
        if (targetID === undefined || targetID === null)
            throw new globalThis.Error("The parameter 'targetID' must be defined.");
        url_ = url_.replace("{targetID}", encodeURIComponent("" + targetID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStyles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStyles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStyles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    style(targetID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/target/{targetID}/style";
        if (targetID === undefined || targetID === null)
            throw new globalThis.Error("The parameter 'targetID' must be defined.");
        url_ = url_.replace("{targetID}", encodeURIComponent("" + targetID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStyle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStyle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStyle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    js(targetID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/target/{targetID}/js";
        if (targetID === undefined || targetID === null)
            throw new globalThis.Error("The parameter 'targetID' must be defined.");
        url_ = url_.replace("{targetID}", encodeURIComponent("" + targetID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processJs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processJs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processJs(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    preview2(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/target/{ownerID}/styles/preview";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreview2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreview2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPreview2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    preview3(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/target/{ownerID}/js/preview";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreview3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreview3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPreview3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param datapointID (optional) 
     * @param body (optional) 
     * @return OK
     */
    datapointPOST(targetID: number, parentDPTID: number, sequence: number, datapointID: number | undefined, body: Datapoint | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/target/{targetID}/{parentDPTID}/{sequence}/datapoint?";
        if (targetID === undefined || targetID === null)
            throw new globalThis.Error("The parameter 'targetID' must be defined.");
        url_ = url_.replace("{targetID}", encodeURIComponent("" + targetID));
        if (parentDPTID === undefined || parentDPTID === null)
            throw new globalThis.Error("The parameter 'parentDPTID' must be defined.");
        url_ = url_.replace("{parentDPTID}", encodeURIComponent("" + parentDPTID));
        if (sequence === undefined || sequence === null)
            throw new globalThis.Error("The parameter 'sequence' must be defined.");
        url_ = url_.replace("{sequence}", encodeURIComponent("" + sequence));
        if (datapointID === null)
            throw new globalThis.Error("The parameter 'datapointID' cannot be null.");
        else if (datapointID !== undefined)
            url_ += "datapointID=" + encodeURIComponent("" + datapointID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    datapointPUT2(targetID: number, datapointTargetID: number, newParentDPTID: number, newSequence: number): Observable<void> {
        let url_ = this.baseUrl + "/api/target/{targetID}/{datapointTargetID}/{newParentDPTID}/{newSequence}/datapoint";
        if (targetID === undefined || targetID === null)
            throw new globalThis.Error("The parameter 'targetID' must be defined.");
        url_ = url_.replace("{targetID}", encodeURIComponent("" + targetID));
        if (datapointTargetID === undefined || datapointTargetID === null)
            throw new globalThis.Error("The parameter 'datapointTargetID' must be defined.");
        url_ = url_.replace("{datapointTargetID}", encodeURIComponent("" + datapointTargetID));
        if (newParentDPTID === undefined || newParentDPTID === null)
            throw new globalThis.Error("The parameter 'newParentDPTID' must be defined.");
        url_ = url_.replace("{newParentDPTID}", encodeURIComponent("" + newParentDPTID));
        if (newSequence === undefined || newSequence === null)
            throw new globalThis.Error("The parameter 'newSequence' must be defined.");
        url_ = url_.replace("{newSequence}", encodeURIComponent("" + newSequence));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointPUT2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointPUT2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointPUT2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    datapointDELETE(targetID: number, datapointTargetID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/target/{targetID}/{datapointTargetID}/datapoint";
        if (targetID === undefined || targetID === null)
            throw new globalThis.Error("The parameter 'targetID' must be defined.");
        url_ = url_.replace("{targetID}", encodeURIComponent("" + targetID));
        if (datapointTargetID === undefined || datapointTargetID === null)
            throw new globalThis.Error("The parameter 'datapointTargetID' must be defined.");
        url_ = url_.replace("{datapointTargetID}", encodeURIComponent("" + datapointTargetID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param iteration (optional) 
     * @param newFormGroup (optional) 
     * @param groupByValueIndex (optional) 
     * @return OK
     */
    section(datapointTargetID: number, datasetID: number, respondentID: number, iteration: number | undefined, newFormGroup: boolean | undefined, groupByValueIndex: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/section/{datapointTargetID}/{datasetID}/{respondentID}/{iteration}/{newFormGroup}/{groupByValueIndex}?";
        if (datapointTargetID === undefined || datapointTargetID === null)
            throw new globalThis.Error("The parameter 'datapointTargetID' must be defined.");
        url_ = url_.replace("{datapointTargetID}", encodeURIComponent("" + datapointTargetID));
        if (datasetID === undefined || datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' must be defined.");
        url_ = url_.replace("{datasetID}", encodeURIComponent("" + datasetID));
        if (respondentID === undefined || respondentID === null)
            throw new globalThis.Error("The parameter 'respondentID' must be defined.");
        url_ = url_.replace("{respondentID}", encodeURIComponent("" + respondentID));
        if (iteration === null)
            throw new globalThis.Error("The parameter 'iteration' cannot be null.");
        else if (iteration !== undefined)
            url_ += "iteration=" + encodeURIComponent("" + iteration) + "&";
        if (newFormGroup === null)
            throw new globalThis.Error("The parameter 'newFormGroup' cannot be null.");
        else if (newFormGroup !== undefined)
            url_ += "newFormGroup=" + encodeURIComponent("" + newFormGroup) + "&";
        if (groupByValueIndex === null)
            throw new globalThis.Error("The parameter 'groupByValueIndex' cannot be null.");
        else if (groupByValueIndex !== undefined)
            url_ += "groupByValueIndex=" + encodeURIComponent("" + groupByValueIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSection(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSection(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSection(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param iteration (optional) 
     * @param newFormGroup (optional) 
     * @param groupByValueIndex (optional) 
     * @return OK
     */
    bulkGET3(bulkTargetID: string, bulkTargetValueID: number, datapointTargetID: number, datasetID: number, respondentID: number, iteration: number | undefined, newFormGroup: boolean | undefined, groupByValueIndex: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dataset/section/bulk/{bulkTargetID}/{bulkTargetValueID}/{datapointTargetID}/{datasetID}/{respondentID}/{iteration}/{newFormGroup}/{groupByValueIndex}?";
        if (bulkTargetID === undefined || bulkTargetID === null)
            throw new globalThis.Error("The parameter 'bulkTargetID' must be defined.");
        url_ = url_.replace("{bulkTargetID}", encodeURIComponent("" + bulkTargetID));
        if (bulkTargetValueID === undefined || bulkTargetValueID === null)
            throw new globalThis.Error("The parameter 'bulkTargetValueID' must be defined.");
        url_ = url_.replace("{bulkTargetValueID}", encodeURIComponent("" + bulkTargetValueID));
        if (datapointTargetID === undefined || datapointTargetID === null)
            throw new globalThis.Error("The parameter 'datapointTargetID' must be defined.");
        url_ = url_.replace("{datapointTargetID}", encodeURIComponent("" + datapointTargetID));
        if (datasetID === undefined || datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' must be defined.");
        url_ = url_.replace("{datasetID}", encodeURIComponent("" + datasetID));
        if (respondentID === undefined || respondentID === null)
            throw new globalThis.Error("The parameter 'respondentID' must be defined.");
        url_ = url_.replace("{respondentID}", encodeURIComponent("" + respondentID));
        if (iteration === null)
            throw new globalThis.Error("The parameter 'iteration' cannot be null.");
        else if (iteration !== undefined)
            url_ += "iteration=" + encodeURIComponent("" + iteration) + "&";
        if (newFormGroup === null)
            throw new globalThis.Error("The parameter 'newFormGroup' cannot be null.");
        else if (newFormGroup !== undefined)
            url_ += "newFormGroup=" + encodeURIComponent("" + newFormGroup) + "&";
        if (groupByValueIndex === null)
            throw new globalThis.Error("The parameter 'groupByValueIndex' cannot be null.");
        else if (groupByValueIndex !== undefined)
            url_ += "groupByValueIndex=" + encodeURIComponent("" + groupByValueIndex) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkGET3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkGET3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkGET3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param name (optional) 
     * @param value (optional) 
     * @param datasetExternalID (optional) 
     * @param datasetID (optional) 
     * @param iteration (optional) 
     * @return OK
     */
    variable(name: string | undefined, value: string | undefined, datasetExternalID: number | undefined, datasetID: number | undefined, iteration: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/session/variable?";
        if (name === null)
            throw new globalThis.Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (value === null)
            throw new globalThis.Error("The parameter 'value' cannot be null.");
        else if (value !== undefined)
            url_ += "value=" + encodeURIComponent("" + value) + "&";
        if (datasetExternalID === null)
            throw new globalThis.Error("The parameter 'datasetExternalID' cannot be null.");
        else if (datasetExternalID !== undefined)
            url_ += "datasetExternalID=" + encodeURIComponent("" + datasetExternalID) + "&";
        if (datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' cannot be null.");
        else if (datasetID !== undefined)
            url_ += "datasetID=" + encodeURIComponent("" + datasetID) + "&";
        if (iteration === null)
            throw new globalThis.Error("The parameter 'iteration' cannot be null.");
        else if (iteration !== undefined)
            url_ += "iteration=" + encodeURIComponent("" + iteration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVariable(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVariable(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processVariable(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class AssessmentsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    acceptTVRA(): Observable<void> {
        let url_ = this.baseUrl + "/api/Assessments/AcceptTVRA";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptTVRA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptTVRA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcceptTVRA(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    acceptTvra(): Observable<void> {
        let url_ = this.baseUrl + "/api/Assessments/accept-tvra";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcceptTvra(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcceptTvra(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcceptTvra(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    startOverTvra(): Observable<void> {
        let url_ = this.baseUrl + "/api/Assessments/start-over-tvra";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartOverTvra(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartOverTvra(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStartOverTvra(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class AuthKeyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    key(key: string): Observable<void> {
        let url_ = this.baseUrl + "/api/AuthKey/key/{key}";
        if (key === undefined || key === null)
            throw new globalThis.Error("The parameter 'key' must be defined.");
        url_ = url_.replace("{key}", encodeURIComponent("" + key));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processKey(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    authKeyPOST(body: AuthKey | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/AuthKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthKeyPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthKeyPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAuthKeyPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    authKeyPUT(body: AuthKey | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/AuthKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthKeyPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthKeyPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAuthKeyPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    authKeyGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/AuthKey/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthKeyGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthKeyGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAuthKeyGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    authKeyDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/AuthKey/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthKeyDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthKeyDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAuthKeyDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/AuthKey/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET2(): Observable<void> {
        let url_ = this.baseUrl + "/api/AuthKey/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class BulkTargetClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    bulkTargetGET(bulkTargetID: string, datasetID: number, iteration: number, respondentExternalID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/BulkTarget/{bulkTargetID}/{datasetID}/{iteration}/{respondentExternalID}";
        if (bulkTargetID === undefined || bulkTargetID === null)
            throw new globalThis.Error("The parameter 'bulkTargetID' must be defined.");
        url_ = url_.replace("{bulkTargetID}", encodeURIComponent("" + bulkTargetID));
        if (datasetID === undefined || datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' must be defined.");
        url_ = url_.replace("{datasetID}", encodeURIComponent("" + datasetID));
        if (iteration === undefined || iteration === null)
            throw new globalThis.Error("The parameter 'iteration' must be defined.");
        url_ = url_.replace("{iteration}", encodeURIComponent("" + iteration));
        if (respondentExternalID === undefined || respondentExternalID === null)
            throw new globalThis.Error("The parameter 'respondentExternalID' must be defined.");
        url_ = url_.replace("{respondentExternalID}", encodeURIComponent("" + respondentExternalID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkTargetGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkTargetGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkTargetGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    value(bulkTargetValueID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/BulkTarget/value/{bulkTargetValueID}";
        if (bulkTargetValueID === undefined || bulkTargetValueID === null)
            throw new globalThis.Error("The parameter 'bulkTargetValueID' must be defined.");
        url_ = url_.replace("{bulkTargetValueID}", encodeURIComponent("" + bulkTargetValueID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    datasets(bulkTargetValueID: number, body: DatasetKey[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/BulkTarget/value/{bulkTargetValueID}/datasets";
        if (bulkTargetValueID === undefined || bulkTargetValueID === null)
            throw new globalThis.Error("The parameter 'bulkTargetValueID' must be defined.");
        url_ = url_.replace("{bulkTargetValueID}", encodeURIComponent("" + bulkTargetValueID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatasets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatasets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatasets(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    submitted(bulkTargetValueID: number, submitted: boolean): Observable<void> {
        let url_ = this.baseUrl + "/api/BulkTarget/value/submitted/{bulkTargetValueID}/{submitted}";
        if (bulkTargetValueID === undefined || bulkTargetValueID === null)
            throw new globalThis.Error("The parameter 'bulkTargetValueID' must be defined.");
        url_ = url_.replace("{bulkTargetValueID}", encodeURIComponent("" + bulkTargetValueID));
        if (submitted === undefined || submitted === null)
            throw new globalThis.Error("The parameter 'submitted' must be defined.");
        url_ = url_.replace("{submitted}", encodeURIComponent("" + submitted));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitted(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitted(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubmitted(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkTargetPOST(body: Tag | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/BulkTarget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkTargetPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkTargetPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkTargetPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkTargetPUT(body: Tag | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/BulkTarget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkTargetPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkTargetPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkTargetPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    bulkTargetGET2(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/BulkTarget/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkTargetGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkTargetGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkTargetGET2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    bulkTargetDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/BulkTarget/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkTargetDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkTargetDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkTargetDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET3(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/BulkTarget/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET4(): Observable<void> {
        let url_ = this.baseUrl + "/api/BulkTarget/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET4(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ConfigClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    configPOST(body: Config | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfigPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfigPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfigPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    configPUT(body: Config | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfigPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfigPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfigPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    configGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Config/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfigGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfigGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfigGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    configDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Config/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfigDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfigDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processConfigDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET5(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Config/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET5(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET5(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET6(): Observable<void> {
        let url_ = this.baseUrl + "/api/Config/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET6(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET6(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET6(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class CrimecastClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param siteID (optional) 
     * @param groupName (optional) 
     * @return OK
     */
    sitegroupusers(siteID: number | undefined, groupName: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Crimecast/sitegroupusers?";
        if (siteID === null)
            throw new globalThis.Error("The parameter 'siteID' cannot be null.");
        else if (siteID !== undefined)
            url_ += "siteID=" + encodeURIComponent("" + siteID) + "&";
        if (groupName === null)
            throw new globalThis.Error("The parameter 'groupName' cannot be null.");
        else if (groupName !== undefined)
            url_ += "groupName=" + encodeURIComponent("" + groupName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSitegroupusers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSitegroupusers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSitegroupusers(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    tasks(crimecastUserID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Crimecast/users/{crimecastUserID}/tasks";
        if (crimecastUserID === undefined || crimecastUserID === null)
            throw new globalThis.Error("The parameter 'crimecastUserID' must be defined.");
        url_ = url_.replace("{crimecastUserID}", encodeURIComponent("" + crimecastUserID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTasks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTasks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTasks(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    click(crimecastUserID: number, taskStatusID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Crimecast/users/{crimecastUserID}/tasks/{taskStatusID}/click";
        if (crimecastUserID === undefined || crimecastUserID === null)
            throw new globalThis.Error("The parameter 'crimecastUserID' must be defined.");
        url_ = url_.replace("{crimecastUserID}", encodeURIComponent("" + crimecastUserID));
        if (taskStatusID === undefined || taskStatusID === null)
            throw new globalThis.Error("The parameter 'taskStatusID' must be defined.");
        url_ = url_.replace("{taskStatusID}", encodeURIComponent("" + taskStatusID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClick(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClick(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClick(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    click2(crimecastUserID: number, datapointTargetID: number, iteration: number, groupByValueIndex: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Crimecast/users/{crimecastUserID}/pushes/{datapointTargetID}/{iteration}/{groupByValueIndex}/click";
        if (crimecastUserID === undefined || crimecastUserID === null)
            throw new globalThis.Error("The parameter 'crimecastUserID' must be defined.");
        url_ = url_.replace("{crimecastUserID}", encodeURIComponent("" + crimecastUserID));
        if (datapointTargetID === undefined || datapointTargetID === null)
            throw new globalThis.Error("The parameter 'datapointTargetID' must be defined.");
        url_ = url_.replace("{datapointTargetID}", encodeURIComponent("" + datapointTargetID));
        if (iteration === undefined || iteration === null)
            throw new globalThis.Error("The parameter 'iteration' must be defined.");
        url_ = url_.replace("{iteration}", encodeURIComponent("" + iteration));
        if (groupByValueIndex === undefined || groupByValueIndex === null)
            throw new globalThis.Error("The parameter 'groupByValueIndex' must be defined.");
        url_ = url_.replace("{groupByValueIndex}", encodeURIComponent("" + groupByValueIndex));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClick2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClick2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClick2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class DashboardClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    dashboardPOST(body: Dashboard | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Dashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboardPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboardPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDashboardPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    dashboardPUT(body: Dashboard | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Dashboard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboardPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboardPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDashboardPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    dashboardGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Dashboard/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboardGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboardGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDashboardGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    dashboardDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Dashboard/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDashboardDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDashboardDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDashboardDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET7(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Dashboard/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET7(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET7(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET7(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET8(): Observable<void> {
        let url_ = this.baseUrl + "/api/Dashboard/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET8(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET8(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET8(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class DatapointClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param targetID (optional) 
     * @param datasetID (optional) 
     * @param respondentID (optional) 
     * @param iteration (optional) 
     * @param templateKey (optional) 
     * @param datapointTargetID (optional) 
     * @param readOnly (optional) 
     * @param hidden (optional) 
     * @param bulk (optional) 
     * @param bulkTargetValueID (optional) 
     * @return OK
     */
    htmltemplate(targetID: number | undefined, datasetID: number | undefined, respondentID: number | undefined, iteration: number | undefined, templateKey: string | undefined, datapointTargetID: number | undefined, readOnly: boolean | undefined, hidden: boolean | undefined, bulk: boolean | undefined, bulkTargetValueID: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Datapoint/htmltemplate?";
        if (targetID === null)
            throw new globalThis.Error("The parameter 'targetID' cannot be null.");
        else if (targetID !== undefined)
            url_ += "targetID=" + encodeURIComponent("" + targetID) + "&";
        if (datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' cannot be null.");
        else if (datasetID !== undefined)
            url_ += "datasetID=" + encodeURIComponent("" + datasetID) + "&";
        if (respondentID === null)
            throw new globalThis.Error("The parameter 'respondentID' cannot be null.");
        else if (respondentID !== undefined)
            url_ += "respondentID=" + encodeURIComponent("" + respondentID) + "&";
        if (iteration === null)
            throw new globalThis.Error("The parameter 'iteration' cannot be null.");
        else if (iteration !== undefined)
            url_ += "iteration=" + encodeURIComponent("" + iteration) + "&";
        if (templateKey === null)
            throw new globalThis.Error("The parameter 'templateKey' cannot be null.");
        else if (templateKey !== undefined)
            url_ += "templateKey=" + encodeURIComponent("" + templateKey) + "&";
        if (datapointTargetID === null)
            throw new globalThis.Error("The parameter 'datapointTargetID' cannot be null.");
        else if (datapointTargetID !== undefined)
            url_ += "datapointTargetID=" + encodeURIComponent("" + datapointTargetID) + "&";
        if (readOnly === null)
            throw new globalThis.Error("The parameter 'readOnly' cannot be null.");
        else if (readOnly !== undefined)
            url_ += "readOnly=" + encodeURIComponent("" + readOnly) + "&";
        if (hidden === null)
            throw new globalThis.Error("The parameter 'hidden' cannot be null.");
        else if (hidden !== undefined)
            url_ += "hidden=" + encodeURIComponent("" + hidden) + "&";
        if (bulk === null)
            throw new globalThis.Error("The parameter 'bulk' cannot be null.");
        else if (bulk !== undefined)
            url_ += "bulk=" + encodeURIComponent("" + bulk) + "&";
        if (bulkTargetValueID === null)
            throw new globalThis.Error("The parameter 'bulkTargetValueID' cannot be null.");
        else if (bulkTargetValueID !== undefined)
            url_ += "bulkTargetValueID=" + encodeURIComponent("" + bulkTargetValueID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHtmltemplate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHtmltemplate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHtmltemplate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param omitGridDups (optional) 
     * @return OK
     */
    listGET9(ownerID: number, omitGridDups: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Datapoint/list/{ownerID}/{omitGridDups}?";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        if (omitGridDups === null)
            throw new globalThis.Error("The parameter 'omitGridDups' cannot be null.");
        else if (omitGridDups !== undefined)
            url_ += "omitGridDups=" + encodeURIComponent("" + omitGridDups) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET9(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET9(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET9(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    datapointPOST(body: Datapoint | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Datapoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    datapointPUT(body: Datapoint | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Datapoint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    datapointGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Datapoint/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    datapointDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Datapoint/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    grid(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Datapoint/grid/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGrid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGrid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGrid(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET10(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Datapoint/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET10(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET10(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET10(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET11(): Observable<void> {
        let url_ = this.baseUrl + "/api/Datapoint/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET11(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET11(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET11(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class DatapointTargetClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    datapointTargetPUT(body: DatapointTarget | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTarget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointTargetPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointTargetPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointTargetPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    datapointTargetPOST(body: DatapointTarget | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTarget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointTargetPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointTargetPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointTargetPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param datasetID (optional) 
     * @param iteration (optional) 
     * @param body (optional) 
     * @return OK
     */
    valueoptions(datasetID: number | undefined, iteration: number | undefined, body: DatasetDatapoint | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTarget/valueoptions?";
        if (datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' cannot be null.");
        else if (datasetID !== undefined)
            url_ += "datasetID=" + encodeURIComponent("" + datasetID) + "&";
        if (iteration === null)
            throw new globalThis.Error("The parameter 'iteration' cannot be null.");
        else if (iteration !== undefined)
            url_ += "iteration=" + encodeURIComponent("" + iteration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValueoptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValueoptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValueoptions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param ownerID (optional) 
     * @param datapointTargetID (optional) 
     * @param styleID (optional) 
     * @param remove (optional) 
     * @return OK
     */
    style2(ownerID: number | undefined, datapointTargetID: number | undefined, styleID: number | undefined, remove: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTarget/property/style?";
        if (ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' cannot be null.");
        else if (ownerID !== undefined)
            url_ += "ownerID=" + encodeURIComponent("" + ownerID) + "&";
        if (datapointTargetID === null)
            throw new globalThis.Error("The parameter 'datapointTargetID' cannot be null.");
        else if (datapointTargetID !== undefined)
            url_ += "datapointTargetID=" + encodeURIComponent("" + datapointTargetID) + "&";
        if (styleID === null)
            throw new globalThis.Error("The parameter 'styleID' cannot be null.");
        else if (styleID !== undefined)
            url_ += "styleID=" + encodeURIComponent("" + styleID) + "&";
        if (remove === null)
            throw new globalThis.Error("The parameter 'remove' cannot be null.");
        else if (remove !== undefined)
            url_ += "remove=" + encodeURIComponent("" + remove) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStyle2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStyle2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStyle2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param datapointTargetID (optional) 
     * @param parentDatapointTargetDesignerID (optional) 
     * @return OK
     */
    parent(datapointTargetID: number | undefined, parentDatapointTargetDesignerID: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTarget/property/parent?";
        if (datapointTargetID === null)
            throw new globalThis.Error("The parameter 'datapointTargetID' cannot be null.");
        else if (datapointTargetID !== undefined)
            url_ += "datapointTargetID=" + encodeURIComponent("" + datapointTargetID) + "&";
        if (parentDatapointTargetDesignerID === null)
            throw new globalThis.Error("The parameter 'parentDatapointTargetDesignerID' cannot be null.");
        else if (parentDatapointTargetDesignerID !== undefined)
            url_ += "parentDatapointTargetDesignerID=" + encodeURIComponent("" + parentDatapointTargetDesignerID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processParent(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processParent(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processParent(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param datapointTargetID (optional) 
     * @param rerenderDesignerID (optional) 
     * @return OK
     */
    rerender(datapointTargetID: number | undefined, rerenderDesignerID: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTarget/property/rerender?";
        if (datapointTargetID === null)
            throw new globalThis.Error("The parameter 'datapointTargetID' cannot be null.");
        else if (datapointTargetID !== undefined)
            url_ += "datapointTargetID=" + encodeURIComponent("" + datapointTargetID) + "&";
        if (rerenderDesignerID === null)
            throw new globalThis.Error("The parameter 'rerenderDesignerID' cannot be null.");
        else if (rerenderDesignerID !== undefined)
            url_ += "rerenderDesignerID=" + encodeURIComponent("" + rerenderDesignerID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRerender(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRerender(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRerender(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param datapointTargetDesignerID (optional) 
     * @param parentDatapointTargetID (optional) 
     * @return OK
     */
    intertarget(datapointTargetDesignerID: string | undefined, parentDatapointTargetID: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTarget/property/parent/intertarget?";
        if (datapointTargetDesignerID === null)
            throw new globalThis.Error("The parameter 'datapointTargetDesignerID' cannot be null.");
        else if (datapointTargetDesignerID !== undefined)
            url_ += "datapointTargetDesignerID=" + encodeURIComponent("" + datapointTargetDesignerID) + "&";
        if (parentDatapointTargetID === null)
            throw new globalThis.Error("The parameter 'parentDatapointTargetID' cannot be null.");
        else if (parentDatapointTargetID !== undefined)
            url_ += "parentDatapointTargetID=" + encodeURIComponent("" + parentDatapointTargetID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIntertarget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIntertarget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processIntertarget(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    property(name: string, body: DatapointTarget | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTarget/property/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProperty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProperty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProperty(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param targetID (optional) 
     * @param datatypeName (optional) 
     * @return OK
     */
    datatype(targetID: number | undefined, datatypeName: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTarget/datatype?";
        if (targetID === null)
            throw new globalThis.Error("The parameter 'targetID' cannot be null.");
        else if (targetID !== undefined)
            url_ += "targetID=" + encodeURIComponent("" + targetID) + "&";
        if (datatypeName === null)
            throw new globalThis.Error("The parameter 'datatypeName' cannot be null.");
        else if (datatypeName !== undefined)
            url_ += "datatypeName=" + encodeURIComponent("" + datatypeName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatatype(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatatype(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatatype(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param datapointTargetID (optional) 
     * @return OK
     */
    reporttype(datapointTargetID: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTarget/reporttype?";
        if (datapointTargetID === null)
            throw new globalThis.Error("The parameter 'datapointTargetID' cannot be null.");
        else if (datapointTargetID !== undefined)
            url_ += "datapointTargetID=" + encodeURIComponent("" + datapointTargetID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReporttype(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReporttype(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReporttype(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    datapointTargetGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTarget/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointTargetGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointTargetGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointTargetGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    datapointTargetDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTarget/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointTargetDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointTargetDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointTargetDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET12(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTarget/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET12(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET12(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET12(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET13(): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTarget/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET13(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET13(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET13(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class DatapointTargetPrereqClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    datapointTargetPrereqPOST(body: DatapointTargetPrereq | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTargetPrereq";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointTargetPrereqPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointTargetPrereqPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointTargetPrereqPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    datapointTargetPrereqPUT(body: DatapointTargetPrereq | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTargetPrereq";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointTargetPrereqPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointTargetPrereqPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointTargetPrereqPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    datapointTargetPrereqGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTargetPrereq/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointTargetPrereqGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointTargetPrereqGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointTargetPrereqGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    datapointTargetPrereqDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTargetPrereq/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointTargetPrereqDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointTargetPrereqDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointTargetPrereqDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET14(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTargetPrereq/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET14(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET14(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET14(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET15(): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTargetPrereq/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET15(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET15(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET15(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class DatapointTargetScriptClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    datapointTargetScriptPOST(body: DatapointTargetScript | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTargetScript";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointTargetScriptPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointTargetScriptPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointTargetScriptPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    datapointTargetScriptPUT(body: DatapointTargetScript | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTargetScript";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointTargetScriptPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointTargetScriptPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointTargetScriptPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    datapointTargetScriptGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTargetScript/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointTargetScriptGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointTargetScriptGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointTargetScriptGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    datapointTargetScriptDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTargetScript/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatapointTargetScriptDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatapointTargetScriptDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatapointTargetScriptDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET16(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTargetScript/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET16(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET16(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET16(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET17(): Observable<void> {
        let url_ = this.baseUrl + "/api/DatapointTargetScript/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET17(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET17(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET17(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class DatatypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    datatypePOST(body: Datatype | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Datatype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatatypePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatatypePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatatypePOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    datatypePUT(body: Datatype | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Datatype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatatypePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatatypePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatatypePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    datatypeGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Datatype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatatypeGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatatypeGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatatypeGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    datatypeDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Datatype/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDatatypeDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDatatypeDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDatatypeDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET18(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Datatype/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET18(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET18(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET18(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET19(): Observable<void> {
        let url_ = this.baseUrl + "/api/Datatype/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET19(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET19(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET19(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class DndClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    upsertLocations(body: CreateLocationDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dnd/location";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertLocations(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertLocations(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUpsertLocations(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    refreshAtmMonthly(body: CreateAtmMonthlyDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dnd/atm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshAtmMonthly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshAtmMonthly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRefreshAtmMonthly(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    refreshVestibuleHourly(body: CreateVestibuleHourlyDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/dnd/vestibule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshVestibuleHourly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshVestibuleHourly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRefreshVestibuleHourly(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class EmailClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    workflow(body: AdvanceSignal | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Email/legacy/workflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWorkflow(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    test(): Observable<void> {
        let url_ = this.baseUrl + "/api/Email/queue/test";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTest(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    process(): Observable<void> {
        let url_ = this.baseUrl + "/api/Email/queue/process";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProcess(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    testNoWorkflow(): Observable<void> {
        let url_ = this.baseUrl + "/api/Email/queue/test-no-workflow";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTestNoWorkflow(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTestNoWorkflow(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTestNoWorkflow(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ETKClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Bulk imports ETK records from the request body.
     * @param body (optional) List of ETK records
     * @return Returns true or false for completion
     */
    import(body: ETKDTO[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/etk/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("If the request object is malformed or empty", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("If an internal server error occurs", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Bulk imports ETK records from a CSV file upload.
     * @param file (optional) CSV file containing ETK rows
     * @return Returns true or false for completion
     */
    importETKRecordsCsv(file: FileParameter | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/etk/import/csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImportETKRecordsCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImportETKRecordsCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImportETKRecordsCsv(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("If the request object is malformed, empty, or not a CSV file", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("If an internal server error occurs", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    report(siteId: number): Observable<ETKSiteReportResponse> {
        let url_ = this.baseUrl + "/api/etk/sites/{siteId}/report";
        if (siteId === undefined || siteId === null)
            throw new globalThis.Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ETKSiteReportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ETKSiteReportResponse>;
        }));
    }

    protected processReport(response: HttpResponseBase): Observable<ETKSiteReportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ETKSiteReportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ETKSiteReportResponse>(null as any);
    }

    /**
     * @return OK
     */
    actionsGET(etkId: string): Observable<ETKActionContext> {
        let url_ = this.baseUrl + "/api/etk/{etkId}/actions";
        if (etkId === undefined || etkId === null)
            throw new globalThis.Error("The parameter 'etkId' must be defined.");
        url_ = url_.replace("{etkId}", encodeURIComponent("" + etkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActionsGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActionsGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ETKActionContext>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ETKActionContext>;
        }));
    }

    protected processActionsGET(response: HttpResponseBase): Observable<ETKActionContext> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ETKActionContext.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ETKActionContext>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    actionsPOST(etkId: string, body: SubmitETKActionRequest | undefined): Observable<ETKActionContext> {
        let url_ = this.baseUrl + "/api/etk/{etkId}/actions";
        if (etkId === undefined || etkId === null)
            throw new globalThis.Error("The parameter 'etkId' must be defined.");
        url_ = url_.replace("{etkId}", encodeURIComponent("" + etkId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActionsPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActionsPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ETKActionContext>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ETKActionContext>;
        }));
    }

    protected processActionsPOST(response: HttpResponseBase): Observable<ETKActionContext> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ETKActionContext.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ETKActionContext>(null as any);
    }
}

@Injectable()
export class FetchClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * This is intended to reload the cache of searchable api data nightly.
     * @param cacheMode (optional) 
     * @return OK
     */
    batch(cacheMode: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Fetch/batch?";
        if (cacheMode === null)
            throw new globalThis.Error("The parameter 'cacheMode' cannot be null.");
        else if (cacheMode !== undefined)
            url_ += "cacheMode=" + encodeURIComponent("" + cacheMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processBatch(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * This is intended to preload visible api data into the cache for just-in-time reports
     * @param datasetID (optional) 
     * @param cacheMode (optional) 
     * @return OK
     */
    dataset3(datasetID: number | undefined, cacheMode: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/Fetch/dataset?";
        if (datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' cannot be null.");
        else if (datasetID !== undefined)
            url_ += "datasetID=" + encodeURIComponent("" + datasetID) + "&";
        if (cacheMode === null)
            throw new globalThis.Error("The parameter 'cacheMode' cannot be null.");
        else if (cacheMode !== undefined)
            url_ += "cacheMode=" + encodeURIComponent("" + cacheMode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDataset3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDataset3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDataset3(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }

    /**
     * Cleans the CcsSiteDataResponses table daily, removing records older than 7 days.
     * @return OK
     */
    clean(): Observable<string> {
        let url_ = this.baseUrl + "/api/Fetch/clean";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClean(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClean(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processClean(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(null as any);
    }
}

@Injectable()
export class FileTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fileTypePOST(body: FileType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/FileType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileTypePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileTypePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFileTypePOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fileTypePUT(body: FileType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/FileType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileTypePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileTypePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFileTypePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    fileTypeGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/FileType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileTypeGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileTypeGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFileTypeGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    fileTypeDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/FileType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileTypeDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileTypeDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFileTypeDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET20(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/FileType/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET20(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET20(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET20(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET21(): Observable<void> {
        let url_ = this.baseUrl + "/api/FileType/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET21(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET21(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET21(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class GuardServiceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkCreate(body: CreateGuardRequestMessage | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/bulk-create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validatePOST(body: CreateGuardRequestMessage | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/bulk-create/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidatePOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param sitesInErrorCSV (optional) 
     * @return OK
     */
    message(bulkTargetValueID: number, respondentExternalID: number, sitesInErrorCSV: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/bulk-create/message/{bulkTargetValueID}/{respondentExternalID}?";
        if (bulkTargetValueID === undefined || bulkTargetValueID === null)
            throw new globalThis.Error("The parameter 'bulkTargetValueID' must be defined.");
        url_ = url_.replace("{bulkTargetValueID}", encodeURIComponent("" + bulkTargetValueID));
        if (respondentExternalID === undefined || respondentExternalID === null)
            throw new globalThis.Error("The parameter 'respondentExternalID' must be defined.");
        url_ = url_.replace("{respondentExternalID}", encodeURIComponent("" + respondentExternalID));
        if (sitesInErrorCSV === null)
            throw new globalThis.Error("The parameter 'sitesInErrorCSV' cannot be null.");
        else if (sitesInErrorCSV !== undefined)
            url_ += "sitesInErrorCSV=" + encodeURIComponent("" + sitesInErrorCSV) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMessage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMessage(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMessage(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param sitesInErrorCSV (optional) 
     * @return OK
     */
    message2(bulkTargetValueID: number, respondentExternalID: number, sitesInErrorCSV: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/bulk-modify/message/{bulkTargetValueID}/{respondentExternalID}?";
        if (bulkTargetValueID === undefined || bulkTargetValueID === null)
            throw new globalThis.Error("The parameter 'bulkTargetValueID' must be defined.");
        url_ = url_.replace("{bulkTargetValueID}", encodeURIComponent("" + bulkTargetValueID));
        if (respondentExternalID === undefined || respondentExternalID === null)
            throw new globalThis.Error("The parameter 'respondentExternalID' must be defined.");
        url_ = url_.replace("{respondentExternalID}", encodeURIComponent("" + respondentExternalID));
        if (sitesInErrorCSV === null)
            throw new globalThis.Error("The parameter 'sitesInErrorCSV' cannot be null.");
        else if (sitesInErrorCSV !== undefined)
            url_ += "sitesInErrorCSV=" + encodeURIComponent("" + sitesInErrorCSV) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMessage2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMessage2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMessage2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkModify(body: GuardServiceModificationRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/bulk-modify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkModify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkModify(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkModify(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validatePOST2(body: GuardServiceModificationRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/bulk-modify/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePOST2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePOST2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidatePOST2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkCancel(body: CancelGuardServiceMessage | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/bulk-cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validatePOST3(body: CancelGuardServiceMessage | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/bulk-cancel/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePOST3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePOST3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidatePOST3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cancel(body: CancelGuardServiceRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancel(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validatePOST4(body: CancelGuardServiceRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/cancel/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePOST4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePOST4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidatePOST4(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    bulkExtend(body: ExtendGuardServiceMessage | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/bulk-extend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkExtend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkExtend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkExtend(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validatePOST5(body: ExtendGuardServiceMessage | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/bulk-extend/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePOST5(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePOST5(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidatePOST5(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    extend(body: ExtendGuardServiceRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/extend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtend(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtend(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExtend(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    validatePOST6(body: ExtendGuardServiceRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/extend/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidatePOST6(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidatePOST6(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidatePOST6(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Get guard services assigned to a specific site.
     * @param siteId The Site ID to retrieve guards for.
     * @return OK
     */
    site(siteId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/site/{siteId}";
        if (siteId === undefined || siteId === null)
            throw new globalThis.Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSite(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSite(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSite(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Search guard services by site IDs
     * @param body (optional) 
     * @return Success
     */
    search(body: GuardServicesForSitesQuery | undefined): Observable<GuardServiceDetailsListPagedResult> {
        let url_ = this.baseUrl + "/api/guard-service/sites/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuardServiceDetailsListPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuardServiceDetailsListPagedResult>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<GuardServiceDetailsListPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuardServiceDetailsListPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Invalid input", status, _responseText, _headers);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No guard services found", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unexpected error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuardServiceDetailsListPagedResult>(null as any);
    }

    /**
     * @param includeSites (optional) 
     * @param activeServices (optional) 
     * @return OK
     */
    accounts(accountId: number, includeSites: boolean | undefined, activeServices: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/accounts/{accountId}?";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        if (includeSites === null)
            throw new globalThis.Error("The parameter 'includeSites' cannot be null.");
        else if (includeSites !== undefined)
            url_ += "includeSites=" + encodeURIComponent("" + includeSites) + "&";
        if (activeServices === null)
            throw new globalThis.Error("The parameter 'activeServices' cannot be null.");
        else if (activeServices !== undefined)
            url_ += "activeServices=" + encodeURIComponent("" + activeServices) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAccounts(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Get Guard Requests by Bulk Target Value ID
     * @return Success
     */
    byTarget(bulkTargetValueId: number): Observable<GuardServiceDetails[]> {
        let url_ = this.baseUrl + "/api/guard-service/requests/bulk/by-target/{bulkTargetValueId}";
        if (bulkTargetValueId === undefined || bulkTargetValueId === null)
            throw new globalThis.Error("The parameter 'bulkTargetValueId' must be defined.");
        url_ = url_.replace("{bulkTargetValueId}", encodeURIComponent("" + bulkTargetValueId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByTarget(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByTarget(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuardServiceDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuardServiceDetails[]>;
        }));
    }

    protected processByTarget(response: HttpResponseBase): Observable<GuardServiceDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuardServiceDetails.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No guard requests found for this ID", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unexpected error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuardServiceDetails[]>([]);
    }

    /**
     * Get Guard Requests by Bulk Task ID
     * @return Success
     */
    byTask(taskId: string): Observable<GuardServiceDetails[]> {
        let url_ = this.baseUrl + "/api/guard-service/requests/bulk/by-task/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new globalThis.Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processByTask(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processByTask(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuardServiceDetails[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuardServiceDetails[]>;
        }));
    }

    protected processByTask(response: HttpResponseBase): Observable<GuardServiceDetails[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuardServiceDetails.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("No guard requests found for this Task ID", status, _responseText, _headers);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Unexpected error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuardServiceDetails[]>([]);
    }

    /**
     * @param datasetId (optional) 
     * @param iteration (optional) 
     * @return OK
     */
    schedulesGET(datasetId: number | undefined, iteration: number | undefined): Observable<RequestSchedulesResponse> {
        let url_ = this.baseUrl + "/api/guard-service/requests/form/schedules?";
        if (datasetId === null)
            throw new globalThis.Error("The parameter 'datasetId' cannot be null.");
        else if (datasetId !== undefined)
            url_ += "datasetId=" + encodeURIComponent("" + datasetId) + "&";
        if (iteration === null)
            throw new globalThis.Error("The parameter 'iteration' cannot be null.");
        else if (iteration !== undefined)
            url_ += "iteration=" + encodeURIComponent("" + iteration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchedulesGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchedulesGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestSchedulesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestSchedulesResponse>;
        }));
    }

    protected processSchedulesGET(response: HttpResponseBase): Observable<RequestSchedulesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestSchedulesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RequestSchedulesResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    schedulesPUT(body: UpsertGuardSchedulesRequest | undefined): Observable<RequestSchedulesResponse> {
        let url_ = this.baseUrl + "/api/guard-service/requests/form/schedules";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSchedulesPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSchedulesPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RequestSchedulesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RequestSchedulesResponse>;
        }));
    }

    protected processSchedulesPUT(response: HttpResponseBase): Observable<RequestSchedulesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RequestSchedulesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RequestSchedulesResponse>(null as any);
    }

    /**
     * @param accountId (optional) 
     * @param onlyActive (optional) 
     * @param supplierName (optional) 
     * @param search (optional) 
     * @param sortBy (optional) 
     * @param sortDirection (optional) 
     * @param filters (optional) 
     * @param includeOccurrences (optional) 
     * @param includeLocationInfo (optional) 
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    getGuardRequests(accountId: number | undefined, onlyActive: boolean | undefined, supplierName: string | undefined, search: string | undefined, sortBy: string | undefined, sortDirection: string | undefined, filters: string | undefined, includeOccurrences: boolean | undefined, includeLocationInfo: boolean | undefined, page: number | undefined, pageSize: number | undefined): Observable<GuardRequestModelPagedResult> {
        let url_ = this.baseUrl + "/api/guard-service/requests?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (onlyActive === null)
            throw new globalThis.Error("The parameter 'onlyActive' cannot be null.");
        else if (onlyActive !== undefined)
            url_ += "onlyActive=" + encodeURIComponent("" + onlyActive) + "&";
        if (supplierName === null)
            throw new globalThis.Error("The parameter 'supplierName' cannot be null.");
        else if (supplierName !== undefined)
            url_ += "supplierName=" + encodeURIComponent("" + supplierName) + "&";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (sortBy === null)
            throw new globalThis.Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (sortDirection === null)
            throw new globalThis.Error("The parameter 'sortDirection' cannot be null.");
        else if (sortDirection !== undefined)
            url_ += "sortDirection=" + encodeURIComponent("" + sortDirection) + "&";
        if (filters === null)
            throw new globalThis.Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&";
        if (includeOccurrences === null)
            throw new globalThis.Error("The parameter 'includeOccurrences' cannot be null.");
        else if (includeOccurrences !== undefined)
            url_ += "includeOccurrences=" + encodeURIComponent("" + includeOccurrences) + "&";
        if (includeLocationInfo === null)
            throw new globalThis.Error("The parameter 'includeLocationInfo' cannot be null.");
        else if (includeLocationInfo !== undefined)
            url_ += "includeLocationInfo=" + encodeURIComponent("" + includeLocationInfo) + "&";
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGuardRequests(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGuardRequests(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuardRequestModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuardRequestModelPagedResult>;
        }));
    }

    protected processGetGuardRequests(response: HttpResponseBase): Observable<GuardRequestModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuardRequestModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Gateway Timeout", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuardRequestModelPagedResult>(null as any);
    }

    /**
     * @param q (optional) 
     * @param accountId (optional) 
     * @param onlyActive (optional) 
     * @param supplierName (optional) 
     * @param search (optional) 
     * @param filters (optional) 
     * @param limit (optional) 
     * @return OK
     */
    getGuardRequestFilterOptions(field: string, q: string | undefined, accountId: number | undefined, onlyActive: boolean | undefined, supplierName: string | undefined, search: string | undefined, filters: string | undefined, limit: number | undefined): Observable<string[]> {
        let url_ = this.baseUrl + "/api/guard-service/requests/filter-options/{field}?";
        if (field === undefined || field === null)
            throw new globalThis.Error("The parameter 'field' must be defined.");
        url_ = url_.replace("{field}", encodeURIComponent("" + field));
        if (q === null)
            throw new globalThis.Error("The parameter 'q' cannot be null.");
        else if (q !== undefined)
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (onlyActive === null)
            throw new globalThis.Error("The parameter 'onlyActive' cannot be null.");
        else if (onlyActive !== undefined)
            url_ += "onlyActive=" + encodeURIComponent("" + onlyActive) + "&";
        if (supplierName === null)
            throw new globalThis.Error("The parameter 'supplierName' cannot be null.");
        else if (supplierName !== undefined)
            url_ += "supplierName=" + encodeURIComponent("" + supplierName) + "&";
        if (search === null)
            throw new globalThis.Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (filters === null)
            throw new globalThis.Error("The parameter 'filters' cannot be null.");
        else if (filters !== undefined)
            url_ += "filters=" + encodeURIComponent("" + filters) + "&";
        if (limit === null)
            throw new globalThis.Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGuardRequestFilterOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGuardRequestFilterOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetGuardRequestFilterOptions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status === 504) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Gateway Timeout", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string[]>([]);
    }

    /**
     * @return OK
     */
    getGuardRequestInfo(guardRequestId: string): Observable<GuardRequestInfo> {
        let url_ = this.baseUrl + "/api/guard-service/request/{guardRequestId}";
        if (guardRequestId === undefined || guardRequestId === null)
            throw new globalThis.Error("The parameter 'guardRequestId' must be defined.");
        url_ = url_.replace("{guardRequestId}", encodeURIComponent("" + guardRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGuardRequestInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGuardRequestInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuardRequestInfo>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuardRequestInfo>;
        }));
    }

    protected processGetGuardRequestInfo(response: HttpResponseBase): Observable<GuardRequestInfo> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuardRequestInfo.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuardRequestInfo>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    actionsPOST2(body: GuardRequestActionRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/requests/form/actions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActionsPOST2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActionsPOST2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActionsPOST2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitPOST(body: GuardRequestForm | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/requests/form/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSubmitPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    fulfillment(body: GuardServiceSupplierFulfillmentRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/requests/supplier/fulfillment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFulfillment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFulfillment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFulfillment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    getGuardServiceSupplierFulfillment(guardRequestId: string): Observable<GuardRequestFulfillment> {
        let url_ = this.baseUrl + "/api/guard-service/requests/{guardRequestId}/supplier/fulfillment";
        if (guardRequestId === undefined || guardRequestId === null)
            throw new globalThis.Error("The parameter 'guardRequestId' must be defined.");
        url_ = url_.replace("{guardRequestId}", encodeURIComponent("" + guardRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGuardServiceSupplierFulfillment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGuardServiceSupplierFulfillment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuardRequestFulfillment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuardRequestFulfillment>;
        }));
    }

    protected processGetGuardServiceSupplierFulfillment(response: HttpResponseBase): Observable<GuardRequestFulfillment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuardRequestFulfillment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuardRequestFulfillment>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    submitSupplierActions(body: GuardServiceSupplierActionRequest | undefined): Observable<GuardServiceSupplierActionSubmitResponse> {
        let url_ = this.baseUrl + "/api/guard-service/requests/supplier/action/submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSubmitSupplierActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSubmitSupplierActions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuardServiceSupplierActionSubmitResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuardServiceSupplierActionSubmitResponse>;
        }));
    }

    protected processSubmitSupplierActions(response: HttpResponseBase): Observable<GuardServiceSupplierActionSubmitResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuardServiceSupplierActionSubmitResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuardServiceSupplierActionSubmitResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    acknowledgeSupplierActions(body: GuardServiceSupplierAcknowledgeRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/requests/supplier/action/acknowledge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAcknowledgeSupplierActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAcknowledgeSupplierActions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAcknowledgeSupplierActions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ProblemDetails.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    getSupplierActions(guardRequestId: string): Observable<GuardServiceSupplierActionRequest> {
        let url_ = this.baseUrl + "/api/guard-service/requests/{guardRequestId}/supplier/action";
        if (guardRequestId === undefined || guardRequestId === null)
            throw new globalThis.Error("The parameter 'guardRequestId' must be defined.");
        url_ = url_.replace("{guardRequestId}", encodeURIComponent("" + guardRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSupplierActions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSupplierActions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GuardServiceSupplierActionRequest>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GuardServiceSupplierActionRequest>;
        }));
    }

    protected processGetSupplierActions(response: HttpResponseBase): Observable<GuardServiceSupplierActionRequest> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuardServiceSupplierActionRequest.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GuardServiceSupplierActionRequest>(null as any);
    }

    /**
     * @return OK
     */
    viewPreviousComment(guardRequestId: string): Observable<RowComment> {
        let url_ = this.baseUrl + "/api/guard-service/requests/{guardRequestId}/supplier/previous-comment";
        if (guardRequestId === undefined || guardRequestId === null)
            throw new globalThis.Error("The parameter 'guardRequestId' must be defined.");
        url_ = url_.replace("{guardRequestId}", encodeURIComponent("" + guardRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processViewPreviousComment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processViewPreviousComment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RowComment>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RowComment>;
        }));
    }

    protected processViewPreviousComment(response: HttpResponseBase): Observable<RowComment> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RowComment.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RowComment>(null as any);
    }

    /**
     * Notifies respondents about workflow exceptions for specific Guard Services.
    Sends in-app notifications and, if needed, email notifications.
     * @param body (optional) The Guard Service IDs with exceptions.
     * @return OK
     */
    workflowExceptions(body: DatasetKey[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/notifications/workflow-exceptions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflowExceptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflowExceptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWorkflowExceptions(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    create(body: DatasetKey[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/notifications/email/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    extend2(body: DatasetKey[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/notifications/email/extend";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExtend2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExtend2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExtend2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    modify(body: DatasetKey[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/notifications/email/modify";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processModify(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processModify(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processModify(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    cancel2(body: DatasetKey[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/guard-service/notifications/email/cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancel2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancel2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCancel2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ImageClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    filePOST2(imageID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Image/file/{imageID}";
        if (imageID === undefined || imageID === null)
            throw new globalThis.Error("The parameter 'imageID' must be defined.");
        url_ = url_.replace("{imageID}", encodeURIComponent("" + imageID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFilePOST2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFilePOST2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFilePOST2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    tokenGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/images/token/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTokenGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTokenGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTokenGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    serve(system: string, userName: string, ownerID: number, name: string, token: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Image/serve/{system}/{userName}/{ownerID}/{name}/{token}";
        if (system === undefined || system === null)
            throw new globalThis.Error("The parameter 'system' must be defined.");
        url_ = url_.replace("{system}", encodeURIComponent("" + system));
        if (userName === undefined || userName === null)
            throw new globalThis.Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (token === undefined || token === null)
            throw new globalThis.Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServe(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServe(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processServe(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    serve2(system: string, userName: string, imageID: number, token: string): Observable<void> {
        let url_ = this.baseUrl + "/api/Image/serve/{system}/{userName}/{imageID}/{token}";
        if (system === undefined || system === null)
            throw new globalThis.Error("The parameter 'system' must be defined.");
        url_ = url_.replace("{system}", encodeURIComponent("" + system));
        if (userName === undefined || userName === null)
            throw new globalThis.Error("The parameter 'userName' must be defined.");
        url_ = url_.replace("{userName}", encodeURIComponent("" + userName));
        if (imageID === undefined || imageID === null)
            throw new globalThis.Error("The parameter 'imageID' must be defined.");
        url_ = url_.replace("{imageID}", encodeURIComponent("" + imageID));
        if (token === undefined || token === null)
            throw new globalThis.Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processServe2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processServe2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processServe2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param url (optional) 
     * @param width (optional) 
     * @param height (optional) 
     * @return OK
     */
    fromurl(url: string | undefined, width: number | undefined, height: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Image/fromurl?";
        if (url === null)
            throw new globalThis.Error("The parameter 'url' cannot be null.");
        else if (url !== undefined)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        if (width === null)
            throw new globalThis.Error("The parameter 'width' cannot be null.");
        else if (width !== undefined)
            url_ += "width=" + encodeURIComponent("" + width) + "&";
        if (height === null)
            throw new globalThis.Error("The parameter 'height' cannot be null.");
        else if (height !== undefined)
            url_ += "height=" + encodeURIComponent("" + height) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFromurl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFromurl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFromurl(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    imagePOST(body: Image | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImagePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImagePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImagePOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    imagePUT(body: Image | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImagePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImagePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImagePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    imageGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Image/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImageGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImageGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImageGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    imageDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Image/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImageDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImageDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImageDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET22(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Image/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET22(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET22(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET22(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET23(): Observable<void> {
        let url_ = this.baseUrl + "/api/Image/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET23(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET23(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET23(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class IncidentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Bulk imports incidents from the request body.
     * @param body (optional) List of incidents
     * @return Returns true or false for completion
     */
    import2(body: IncidentDTO[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/incident/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImport2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("If the request object is malformed or empty", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("If an internal server error occurs", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Queries incidents 12 quarters back from today
     * @param accountId The CCS account for the incident search.
     * @return Returns the incident data
     */
    queryRiskModelCsv(accountId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/incident/query-risk-model-csv/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryRiskModelCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryRiskModelCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQueryRiskModelCsv(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("If the query is malformed", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("If the model is not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("If an internal server error occurs", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Queries incidents by owner and optionally an incident date range
     * @param body (optional) The query parameters for the incident search.
     * @return Returns the incident data
     */
    queryCsv(body: IncidentQuery | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/incident/query-csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueryCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueryCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQueryCsv(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("If the query is malformed", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("If the model is not found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("If an internal server error occurs", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class InteractClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    perform(body: PerformActionRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Interact/actions/perform";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPerform(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPerform(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPerform(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param userId (optional) 
     * @param accountId (optional) 
     * @return OK
     */
    actionsGET2(userId: number | undefined, accountId: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Interact/actions?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "AccountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActionsGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActionsGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processActionsGET2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class IntervalExpressionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    intervalExpressionPOST(body: IntervalExpression | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/IntervalExpression";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIntervalExpressionPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIntervalExpressionPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processIntervalExpressionPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    intervalExpressionPUT(body: IntervalExpression | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/IntervalExpression";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIntervalExpressionPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIntervalExpressionPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processIntervalExpressionPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    intervalExpressionGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/IntervalExpression/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIntervalExpressionGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIntervalExpressionGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processIntervalExpressionGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    intervalExpressionDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/IntervalExpression/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIntervalExpressionDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIntervalExpressionDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processIntervalExpressionDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET24(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/IntervalExpression/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET24(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET24(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET24(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET25(): Observable<void> {
        let url_ = this.baseUrl + "/api/IntervalExpression/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET25(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET25(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET25(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class LoggingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    action(body: ActionLog | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/logging/action";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAction(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    error(body: ErrorLog | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/logging/error";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processError(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processError(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processError(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class LoginClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param ownerID (optional) 
     * @param password (optional) 
     * @return OK
     */
    hash(ownerID: number | undefined, password: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/login/hash?";
        if (ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' cannot be null.");
        else if (ownerID !== undefined)
            url_ += "ownerID=" + encodeURIComponent("" + ownerID) + "&";
        if (password === null)
            throw new globalThis.Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHash(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHash(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHash(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param email (optional) 
     * @return OK
     */
    reset(email: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/login/reset?";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReset(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param resetPasswordToken (optional) 
     * @param newPassword (optional) 
     * @return OK
     */
    resetpassword(resetPasswordToken: string | undefined, newPassword: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/login/resetpassword?";
        if (resetPasswordToken === null)
            throw new globalThis.Error("The parameter 'resetPasswordToken' cannot be null.");
        else if (resetPasswordToken !== undefined)
            url_ += "resetPasswordToken=" + encodeURIComponent("" + resetPasswordToken) + "&";
        if (newPassword === null)
            throw new globalThis.Error("The parameter 'newPassword' cannot be null.");
        else if (newPassword !== undefined)
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetpassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetpassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processResetpassword(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param password (optional) 
     * @return OK
     */
    validateGET(password: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/login/password/validate?";
        if (password === null)
            throw new globalThis.Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValidateGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param ownerID (optional) 
     * @return OK
     */
    loginjwt(ownerID: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/loginjwt?";
        if (ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' cannot be null.");
        else if (ownerID !== undefined)
            url_ += "ownerID=" + encodeURIComponent("" + ownerID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginjwt(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginjwt(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLoginjwt(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param sessionID (optional) 
     * @param accountID (optional) 
     * @param accountName (optional) 
     * @param accountSource (optional) 
     * @param durationHours (optional) 
     * @return OK
     */
    tokenGET2(sessionID: number | undefined, accountID: number | undefined, accountName: string | undefined, accountSource: string | undefined, durationHours: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/login/token?";
        if (sessionID === null)
            throw new globalThis.Error("The parameter 'sessionID' cannot be null.");
        else if (sessionID !== undefined)
            url_ += "sessionID=" + encodeURIComponent("" + sessionID) + "&";
        if (accountID === null)
            throw new globalThis.Error("The parameter 'accountID' cannot be null.");
        else if (accountID !== undefined)
            url_ += "accountID=" + encodeURIComponent("" + accountID) + "&";
        if (accountName === null)
            throw new globalThis.Error("The parameter 'accountName' cannot be null.");
        else if (accountName !== undefined)
            url_ += "accountName=" + encodeURIComponent("" + accountName) + "&";
        if (accountSource === null)
            throw new globalThis.Error("The parameter 'accountSource' cannot be null.");
        else if (accountSource !== undefined)
            url_ += "accountSource=" + encodeURIComponent("" + accountSource) + "&";
        if (durationHours === null)
            throw new globalThis.Error("The parameter 'durationHours' cannot be null.");
        else if (durationHours !== undefined)
            url_ += "durationHours=" + encodeURIComponent("" + durationHours) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTokenGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTokenGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTokenGET2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param sessionKey (optional) 
     * @return OK
     */
    linkdata(sessionKey: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/login/linkdata?";
        if (sessionKey === null)
            throw new globalThis.Error("The parameter 'sessionKey' cannot be null.");
        else if (sessionKey !== undefined)
            url_ += "sessionKey=" + encodeURIComponent("" + sessionKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkdata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkdata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLinkdata(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param sessionKey (optional) 
     * @param password (optional) 
     * @return OK
     */
    external(sessionKey: string | undefined, password: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/login/external?";
        if (sessionKey === null)
            throw new globalThis.Error("The parameter 'sessionKey' cannot be null.");
        else if (sessionKey !== undefined)
            url_ += "sessionKey=" + encodeURIComponent("" + sessionKey) + "&";
        if (password === null)
            throw new globalThis.Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExternal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param ownerSessionPasswordID (optional) 
     * @param password (optional) 
     * @return OK
     */
    hash2(ownerSessionPasswordID: number | undefined, password: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/login/ownersessionpassword/hash?";
        if (ownerSessionPasswordID === null)
            throw new globalThis.Error("The parameter 'ownerSessionPasswordID' cannot be null.");
        else if (ownerSessionPasswordID !== undefined)
            url_ += "ownerSessionPasswordID=" + encodeURIComponent("" + ownerSessionPasswordID) + "&";
        if (password === null)
            throw new globalThis.Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHash2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHash2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHash2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    tokenPOST(body: TokenRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Login/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTokenPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTokenPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTokenPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param s (optional) 
     * @param oeid (optional) 
     * @param oen (optional) 
     * @param oest (optional) 
     * @param reid (optional) 
     * @param ren (optional) 
     * @param rest (optional) 
     * @param d (optional) 
     * @return OK
     */
    token2(s: number | undefined, oeid: number | undefined, oen: string | undefined, oest: string | undefined, reid: number | undefined, ren: string | undefined, rest: string | undefined, d: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Login/token2?";
        if (s === null)
            throw new globalThis.Error("The parameter 's' cannot be null.");
        else if (s !== undefined)
            url_ += "s=" + encodeURIComponent("" + s) + "&";
        if (oeid === null)
            throw new globalThis.Error("The parameter 'oeid' cannot be null.");
        else if (oeid !== undefined)
            url_ += "oeid=" + encodeURIComponent("" + oeid) + "&";
        if (oen === null)
            throw new globalThis.Error("The parameter 'oen' cannot be null.");
        else if (oen !== undefined)
            url_ += "oen=" + encodeURIComponent("" + oen) + "&";
        if (oest === null)
            throw new globalThis.Error("The parameter 'oest' cannot be null.");
        else if (oest !== undefined)
            url_ += "oest=" + encodeURIComponent("" + oest) + "&";
        if (reid === null)
            throw new globalThis.Error("The parameter 'reid' cannot be null.");
        else if (reid !== undefined)
            url_ += "reid=" + encodeURIComponent("" + reid) + "&";
        if (ren === null)
            throw new globalThis.Error("The parameter 'ren' cannot be null.");
        else if (ren !== undefined)
            url_ += "ren=" + encodeURIComponent("" + ren) + "&";
        if (rest === null)
            throw new globalThis.Error("The parameter 'rest' cannot be null.");
        else if (rest !== undefined)
            url_ += "rest=" + encodeURIComponent("" + rest) + "&";
        if (d === null)
            throw new globalThis.Error("The parameter 'd' cannot be null.");
        else if (d !== undefined)
            url_ += "d=" + encodeURIComponent("" + d) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processToken2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processToken2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processToken2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class MacroClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    report2(reportID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Macro/report/{reportID}";
        if (reportID === undefined || reportID === null)
            throw new globalThis.Error("The parameter 'reportID' must be defined.");
        url_ = url_.replace("{reportID}", encodeURIComponent("" + reportID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReport2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReport2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReport2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    macroPOST(body: ReportMacro | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Macro";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMacroPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMacroPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMacroPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    macroPUT(body: ReportMacro | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Macro";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMacroPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMacroPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMacroPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    macroGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Macro/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMacroGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMacroGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMacroGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    macroDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Macro/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMacroDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMacroDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMacroDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET26(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Macro/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET26(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET26(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET26(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET27(): Observable<void> {
        let url_ = this.baseUrl + "/api/Macro/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET27(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET27(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET27(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ObjectGroupClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    objectGroupPOST(body: ObjectGroup | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ObjectGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObjectGroupPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjectGroupPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processObjectGroupPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    objectGroupPUT(body: ObjectGroup | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ObjectGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObjectGroupPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjectGroupPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processObjectGroupPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    objectGroupGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ObjectGroup/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObjectGroupGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjectGroupGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processObjectGroupGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    objectGroupDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ObjectGroup/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObjectGroupDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjectGroupDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processObjectGroupDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET28(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ObjectGroup/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET28(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET28(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET28(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET29(): Observable<void> {
        let url_ = this.baseUrl + "/api/ObjectGroup/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET29(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET29(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET29(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ObjectGroupAccessTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    objectGroupAccessTypePOST(body: ObjectGroupAccessType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ObjectGroupAccessType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObjectGroupAccessTypePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjectGroupAccessTypePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processObjectGroupAccessTypePOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    objectGroupAccessTypePUT(body: ObjectGroupAccessType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ObjectGroupAccessType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObjectGroupAccessTypePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjectGroupAccessTypePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processObjectGroupAccessTypePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    objectGroupAccessTypeGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ObjectGroupAccessType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObjectGroupAccessTypeGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjectGroupAccessTypeGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processObjectGroupAccessTypeGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    objectGroupAccessTypeDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ObjectGroupAccessType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObjectGroupAccessTypeDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjectGroupAccessTypeDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processObjectGroupAccessTypeDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET30(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ObjectGroupAccessType/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET30(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET30(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET30(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET31(): Observable<void> {
        let url_ = this.baseUrl + "/api/ObjectGroupAccessType/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET31(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET31(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET31(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ObjectTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    objectTypePOST(body: ObjectType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ObjectType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObjectTypePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjectTypePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processObjectTypePOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    objectTypePUT(body: ObjectType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ObjectType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObjectTypePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjectTypePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processObjectTypePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    objectTypeGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ObjectType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObjectTypeGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjectTypeGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processObjectTypeGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    objectTypeDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ObjectType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processObjectTypeDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processObjectTypeDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processObjectTypeDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET32(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ObjectType/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET32(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET32(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET32(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET33(): Observable<void> {
        let url_ = this.baseUrl + "/api/ObjectType/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET33(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET33(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET33(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class OwnerClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    ownerPOST(body: Owner | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Owner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOwnerPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOwnerPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOwnerPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    ownerPUT(body: Owner | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Owner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOwnerPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOwnerPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOwnerPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET34(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Owner/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET34(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET34(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET34(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    ownerGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Owner/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOwnerGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOwnerGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOwnerGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    ownerDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Owner/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOwnerDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOwnerDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOwnerDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET35(): Observable<void> {
        let url_ = this.baseUrl + "/api/Owner/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET35(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET35(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET35(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class PdfClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param targetID (optional) 
     * @param iteration (optional) 
     * @param datasetExternalID (optional) 
     * @param datasetExternalSourceTable (optional) 
     * @param global (optional) 
     * @param templateID (optional) 
     * @return OK
     */
    downloadGET(targetID: number | undefined, iteration: number | undefined, datasetExternalID: number | undefined, datasetExternalSourceTable: string | undefined, global: boolean | undefined, templateID: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/preview/summary/target/download?";
        if (targetID === null)
            throw new globalThis.Error("The parameter 'targetID' cannot be null.");
        else if (targetID !== undefined)
            url_ += "targetID=" + encodeURIComponent("" + targetID) + "&";
        if (iteration === null)
            throw new globalThis.Error("The parameter 'iteration' cannot be null.");
        else if (iteration !== undefined)
            url_ += "iteration=" + encodeURIComponent("" + iteration) + "&";
        if (datasetExternalID === null)
            throw new globalThis.Error("The parameter 'datasetExternalID' cannot be null.");
        else if (datasetExternalID !== undefined)
            url_ += "datasetExternalID=" + encodeURIComponent("" + datasetExternalID) + "&";
        if (datasetExternalSourceTable === null)
            throw new globalThis.Error("The parameter 'datasetExternalSourceTable' cannot be null.");
        else if (datasetExternalSourceTable !== undefined)
            url_ += "datasetExternalSourceTable=" + encodeURIComponent("" + datasetExternalSourceTable) + "&";
        if (global === null)
            throw new globalThis.Error("The parameter 'global' cannot be null.");
        else if (global !== undefined)
            url_ += "global=" + encodeURIComponent("" + global) + "&";
        if (templateID === null)
            throw new globalThis.Error("The parameter 'templateID' cannot be null.");
        else if (templateID !== undefined)
            url_ += "templateID=" + encodeURIComponent("" + templateID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param sessionKey (optional) 
     * @param ownerID (optional) 
     * @return OK
     */
    downloadGET2(sessionKey: string | undefined, ownerID: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Pdf/summary/owner/download?";
        if (sessionKey === null)
            throw new globalThis.Error("The parameter 'sessionKey' cannot be null.");
        else if (sessionKey !== undefined)
            url_ += "sessionKey=" + encodeURIComponent("" + sessionKey) + "&";
        if (ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' cannot be null.");
        else if (ownerID !== undefined)
            url_ += "ownerID=" + encodeURIComponent("" + ownerID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadGET2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param captureURL (optional) 
     * @param waitFor (optional) 
     * @param margins (optional) 
     * @param delay (optional) 
     * @param scale (optional) 
     * @param mode (optional) 
     * @param hideSelectors (optional) 
     * @param pageCount (optional) 
     * @param processGUID (optional) 
     * @param orientation (optional) 
     * @return OK
     */
    capture(captureURL: string | undefined, waitFor: string | undefined, margins: string | undefined, delay: number | undefined, scale: number | undefined, mode: number | undefined, hideSelectors: string | undefined, pageCount: number | undefined, processGUID: string | undefined, orientation: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Pdf/capture?";
        if (captureURL === null)
            throw new globalThis.Error("The parameter 'captureURL' cannot be null.");
        else if (captureURL !== undefined)
            url_ += "captureURL=" + encodeURIComponent("" + captureURL) + "&";
        if (waitFor === null)
            throw new globalThis.Error("The parameter 'waitFor' cannot be null.");
        else if (waitFor !== undefined)
            url_ += "waitFor=" + encodeURIComponent("" + waitFor) + "&";
        if (margins === null)
            throw new globalThis.Error("The parameter 'margins' cannot be null.");
        else if (margins !== undefined)
            url_ += "margins=" + encodeURIComponent("" + margins) + "&";
        if (delay === null)
            throw new globalThis.Error("The parameter 'delay' cannot be null.");
        else if (delay !== undefined)
            url_ += "delay=" + encodeURIComponent("" + delay) + "&";
        if (scale === null)
            throw new globalThis.Error("The parameter 'scale' cannot be null.");
        else if (scale !== undefined)
            url_ += "scale=" + encodeURIComponent("" + scale) + "&";
        if (mode === null)
            throw new globalThis.Error("The parameter 'mode' cannot be null.");
        else if (mode !== undefined)
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        if (hideSelectors === null)
            throw new globalThis.Error("The parameter 'hideSelectors' cannot be null.");
        else if (hideSelectors !== undefined)
            url_ += "hideSelectors=" + encodeURIComponent("" + hideSelectors) + "&";
        if (pageCount === null)
            throw new globalThis.Error("The parameter 'pageCount' cannot be null.");
        else if (pageCount !== undefined)
            url_ += "pageCount=" + encodeURIComponent("" + pageCount) + "&";
        if (processGUID === null)
            throw new globalThis.Error("The parameter 'processGUID' cannot be null.");
        else if (processGUID !== undefined)
            url_ += "processGUID=" + encodeURIComponent("" + processGUID) + "&";
        if (orientation === null)
            throw new globalThis.Error("The parameter 'orientation' cannot be null.");
        else if (orientation !== undefined)
            url_ += "orientation=" + encodeURIComponent("" + orientation) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCapture(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCapture(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCapture(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ProcessClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    processPOST(body: Process | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProcessPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    processPUT(body: Process | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Process";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProcessPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    processGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Process/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProcessGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    processDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Process/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processProcessDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET36(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Process/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET36(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET36(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET36(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET37(): Observable<void> {
        let url_ = this.baseUrl + "/api/Process/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET37(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET37(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET37(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class QuestionNumberTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    questionNumberTypePOST(body: QuestionNumberType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/QuestionNumberType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionNumberTypePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionNumberTypePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuestionNumberTypePOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    questionNumberTypePUT(body: QuestionNumberType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/QuestionNumberType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionNumberTypePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionNumberTypePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuestionNumberTypePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    questionNumberTypeGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/QuestionNumberType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionNumberTypeGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionNumberTypeGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuestionNumberTypeGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    questionNumberTypeDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/QuestionNumberType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuestionNumberTypeDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuestionNumberTypeDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processQuestionNumberTypeDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET38(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/QuestionNumberType/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET38(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET38(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET38(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET39(): Observable<void> {
        let url_ = this.baseUrl + "/api/QuestionNumberType/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET39(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET39(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET39(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class RateCardV2Client {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param reviewOnly (optional) 
     * @param body (optional) 
     * @return OK
     */
    upsertRateCardV2(reviewOnly: boolean | undefined, body: UpsertRateCardV2Dto[] | undefined): Observable<RateCardV2UpsertResult> {
        let url_ = this.baseUrl + "/api/rate-card-v2/import?";
        if (reviewOnly === null)
            throw new globalThis.Error("The parameter 'reviewOnly' cannot be null.");
        else if (reviewOnly !== undefined)
            url_ += "reviewOnly=" + encodeURIComponent("" + reviewOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertRateCardV2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertRateCardV2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RateCardV2UpsertResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RateCardV2UpsertResult>;
        }));
    }

    protected processUpsertRateCardV2(response: HttpResponseBase): Observable<RateCardV2UpsertResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RateCardV2UpsertResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RateCardV2UpsertResult>(null as any);
    }

    /**
     * @param reviewOnly (optional) 
     * @param file (optional) 
     * @return OK
     */
    upsertRateCardV2Csv(reviewOnly: boolean | undefined, file: FileParameter | undefined): Observable<RateCardV2UpsertResult> {
        let url_ = this.baseUrl + "/api/rate-card-v2/import/csv?";
        if (reviewOnly === null)
            throw new globalThis.Error("The parameter 'reviewOnly' cannot be null.");
        else if (reviewOnly !== undefined)
            url_ += "reviewOnly=" + encodeURIComponent("" + reviewOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertRateCardV2Csv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertRateCardV2Csv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RateCardV2UpsertResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RateCardV2UpsertResult>;
        }));
    }

    protected processUpsertRateCardV2Csv(response: HttpResponseBase): Observable<RateCardV2UpsertResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RateCardV2UpsertResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RateCardV2UpsertResult>(null as any);
    }
}

@Injectable()
export class ReassessmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    guardChangeNewService(body: CheckGuardChangeReassessmentNewServiceMessage | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/reassessment/guard-change-new-service";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGuardChangeNewService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGuardChangeNewService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGuardChangeNewService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    guardChangeModifiedService(body: CheckGuardChangeReassessmentModifiedServiceMessage | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/reassessment/guard-change-modified-service";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGuardChangeModifiedService(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGuardChangeModifiedService(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGuardChangeModifiedService(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    scoreChange(body: CheckScoreReassessmentMessage | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/reassessment/score-change";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScoreChange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScoreChange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processScoreChange(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class RegexClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    regexPOST(body: Regex | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Regex";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegexPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegexPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRegexPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    regexPUT(body: Regex | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Regex";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegexPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegexPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRegexPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    regexGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Regex/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegexGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegexGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRegexGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    regexDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Regex/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegexDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegexDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRegexDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET40(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Regex/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET40(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET40(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET40(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET41(): Observable<void> {
        let url_ = this.baseUrl + "/api/Regex/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET41(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET41(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET41(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class RenderTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    renderTypePOST(body: RenderType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RenderType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenderTypePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenderTypePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRenderTypePOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    renderTypePUT(body: RenderType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RenderType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenderTypePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenderTypePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRenderTypePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    renderTypeGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/RenderType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenderTypeGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenderTypeGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRenderTypeGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    renderTypeDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/RenderType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenderTypeDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenderTypeDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRenderTypeDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET42(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/RenderType/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET42(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET42(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET42(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET43(): Observable<void> {
        let url_ = this.baseUrl + "/api/RenderType/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET43(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET43(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET43(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    reportPOST(body: Report | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReportPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    reportPUT(id: string, body: Report | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Report/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReportPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    reportGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Report/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReportGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    reportDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Report/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReportDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param targetID (optional) 
     * @param datasetID (optional) 
     * @param iteration (optional) 
     * @param sessionID (optional) 
     * @param respondentExternalID (optional) 
     * @param currentPage (optional) 
     * @return OK
     */
    external2(id: number, targetID: number | undefined, datasetID: number | undefined, iteration: number | undefined, sessionID: number | undefined, respondentExternalID: number | undefined, currentPage: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Report/{id}/external?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (targetID === null)
            throw new globalThis.Error("The parameter 'targetID' cannot be null.");
        else if (targetID !== undefined)
            url_ += "targetID=" + encodeURIComponent("" + targetID) + "&";
        if (datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' cannot be null.");
        else if (datasetID !== undefined)
            url_ += "datasetID=" + encodeURIComponent("" + datasetID) + "&";
        if (iteration === null)
            throw new globalThis.Error("The parameter 'iteration' cannot be null.");
        else if (iteration !== undefined)
            url_ += "iteration=" + encodeURIComponent("" + iteration) + "&";
        if (sessionID === null)
            throw new globalThis.Error("The parameter 'sessionID' cannot be null.");
        else if (sessionID !== undefined)
            url_ += "sessionID=" + encodeURIComponent("" + sessionID) + "&";
        if (respondentExternalID === null)
            throw new globalThis.Error("The parameter 'respondentExternalID' cannot be null.");
        else if (respondentExternalID !== undefined)
            url_ += "respondentExternalID=" + encodeURIComponent("" + respondentExternalID) + "&";
        if (currentPage === null)
            throw new globalThis.Error("The parameter 'currentPage' cannot be null.");
        else if (currentPage !== undefined)
            url_ += "currentPage=" + encodeURIComponent("" + currentPage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExternal2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExternal2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processExternal2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param externalID (optional) 
     * @param simple (optional) 
     * @return OK
     */
    listGET44(ownerID: number, externalID: number | undefined, simple: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Report/list/{ownerID}/{externalID}?";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        if (externalID === null)
            throw new globalThis.Error("The parameter 'externalID' cannot be null.");
        else if (externalID !== undefined)
            url_ += "externalID=" + encodeURIComponent("" + externalID) + "&";
        if (simple === null)
            throw new globalThis.Error("The parameter 'simple' cannot be null.");
        else if (simple !== undefined)
            url_ += "simple=" + encodeURIComponent("" + simple) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET44(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET44(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET44(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param externalID (optional) 
     * @param respondentExternalID (optional) 
     * @param simple (optional) 
     * @return OK
     */
    bundles(ownerID: number, externalID: number | undefined, respondentExternalID: number | undefined, simple: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Report/list/bundles/{ownerID}/{externalID}/{respondentExternalID}?";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        if (externalID === null)
            throw new globalThis.Error("The parameter 'externalID' cannot be null.");
        else if (externalID !== undefined)
            url_ += "externalID=" + encodeURIComponent("" + externalID) + "&";
        if (respondentExternalID === null)
            throw new globalThis.Error("The parameter 'respondentExternalID' cannot be null.");
        else if (respondentExternalID !== undefined)
            url_ += "respondentExternalID=" + encodeURIComponent("" + respondentExternalID) + "&";
        if (simple === null)
            throw new globalThis.Error("The parameter 'simple' cannot be null.");
        else if (simple !== undefined)
            url_ += "simple=" + encodeURIComponent("" + simple) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBundles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBundles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBundles(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    bundle(reportBundleID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Report/bundle/{reportBundleID}";
        if (reportBundleID === undefined || reportBundleID === null)
            throw new globalThis.Error("The parameter 'reportBundleID' must be defined.");
        url_ = url_.replace("{reportBundleID}", encodeURIComponent("" + reportBundleID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBundle(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBundle(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBundle(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * Called by Crimecast to get reports available to add to the dashboard.
    Therefore, only returns reports where ExternalVisible = true, ExternalSearchable = true
     * @param simple (optional) 
     * @param userID (optional) 
     * @return OK
     */
    listGET45(ownerExternalID: number, ownerExternalSourceTable: string, simple: boolean | undefined, userID: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Report/info/list/{ownerExternalID}/{ownerExternalSourceTable}?";
        if (ownerExternalID === undefined || ownerExternalID === null)
            throw new globalThis.Error("The parameter 'ownerExternalID' must be defined.");
        url_ = url_.replace("{ownerExternalID}", encodeURIComponent("" + ownerExternalID));
        if (ownerExternalSourceTable === undefined || ownerExternalSourceTable === null)
            throw new globalThis.Error("The parameter 'ownerExternalSourceTable' must be defined.");
        url_ = url_.replace("{ownerExternalSourceTable}", encodeURIComponent("" + ownerExternalSourceTable));
        if (simple === null)
            throw new globalThis.Error("The parameter 'simple' cannot be null.");
        else if (simple !== undefined)
            url_ += "simple=" + encodeURIComponent("" + simple) + "&";
        if (userID === null)
            throw new globalThis.Error("The parameter 'userID' cannot be null.");
        else if (userID !== undefined)
            url_ += "userID=" + encodeURIComponent("" + userID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET45(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET45(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET45(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    tokenPOST2(body: ReportTokenRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Report/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTokenPOST2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTokenPOST2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTokenPOST2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param reportID (optional) 
     * @return OK
     */
    downloadonly(reportID: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Report/downloadonly?";
        if (reportID === null)
            throw new globalThis.Error("The parameter 'reportID' cannot be null.");
        else if (reportID !== undefined)
            url_ += "reportID=" + encodeURIComponent("" + reportID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadonly(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadonly(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadonly(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET46(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Report/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET46(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET46(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET46(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET47(): Observable<void> {
        let url_ = this.baseUrl + "/api/Report/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET47(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET47(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET47(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ReportResultClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    reportResult(body: ReportRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ReportResult";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportResult(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportResult(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReportResult(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param respondentExternalID (optional) 
     * @param body (optional) 
     * @return OK
     */
    reportResult2(reportID: number, respondentExternalID: number | undefined, body: ReportMacro[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ReportResult/{reportID}?";
        if (reportID === undefined || reportID === null)
            throw new globalThis.Error("The parameter 'reportID' must be defined.");
        url_ = url_.replace("{reportID}", encodeURIComponent("" + reportID));
        if (respondentExternalID === null)
            throw new globalThis.Error("The parameter 'respondentExternalID' cannot be null.");
        else if (respondentExternalID !== undefined)
            url_ += "respondentExternalID=" + encodeURIComponent("" + respondentExternalID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportResult2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportResult2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReportResult2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    postexternal(body: PostToExternalRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ReportResult/postexternal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostexternal(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostexternal(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPostexternal(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param sessionID (optional) 
     * @param respondentExternalID (optional) 
     * @param body (optional) 
     * @return OK
     */
    drilldown(reportID: number, drillDownSeries: string, drillDownName: string, drillDownValue: string, drillDownActive: boolean, postToExternal: boolean, sessionID: number | undefined, respondentExternalID: number | undefined, body: ReportMacro[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ReportResult/drilldown/{reportID}/{drillDownSeries}/{drillDownName}/{drillDownValue}/{drillDownActive}/{postToExternal}/{sessionID}/{respondentExternalID}?";
        if (reportID === undefined || reportID === null)
            throw new globalThis.Error("The parameter 'reportID' must be defined.");
        url_ = url_.replace("{reportID}", encodeURIComponent("" + reportID));
        if (drillDownSeries === undefined || drillDownSeries === null)
            throw new globalThis.Error("The parameter 'drillDownSeries' must be defined.");
        url_ = url_.replace("{drillDownSeries}", encodeURIComponent("" + drillDownSeries));
        if (drillDownName === undefined || drillDownName === null)
            throw new globalThis.Error("The parameter 'drillDownName' must be defined.");
        url_ = url_.replace("{drillDownName}", encodeURIComponent("" + drillDownName));
        if (drillDownValue === undefined || drillDownValue === null)
            throw new globalThis.Error("The parameter 'drillDownValue' must be defined.");
        url_ = url_.replace("{drillDownValue}", encodeURIComponent("" + drillDownValue));
        if (drillDownActive === undefined || drillDownActive === null)
            throw new globalThis.Error("The parameter 'drillDownActive' must be defined.");
        url_ = url_.replace("{drillDownActive}", encodeURIComponent("" + drillDownActive));
        if (postToExternal === undefined || postToExternal === null)
            throw new globalThis.Error("The parameter 'postToExternal' must be defined.");
        url_ = url_.replace("{postToExternal}", encodeURIComponent("" + postToExternal));
        if (sessionID === null)
            throw new globalThis.Error("The parameter 'sessionID' cannot be null.");
        else if (sessionID !== undefined)
            url_ += "sessionID=" + encodeURIComponent("" + sessionID) + "&";
        if (respondentExternalID === null)
            throw new globalThis.Error("The parameter 'respondentExternalID' cannot be null.");
        else if (respondentExternalID !== undefined)
            url_ += "respondentExternalID=" + encodeURIComponent("" + respondentExternalID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDrilldown(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDrilldown(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDrilldown(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param sessionID (optional) 
     * @param respondentExternalID (optional) 
     * @param body (optional) 
     * @return OK
     */
    drilldown2(reportID: number, drillDownActive: boolean, postToExternal: boolean, sessionID: number | undefined, respondentExternalID: number | undefined, body: ReportMacro[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ReportResult/drilldown/{reportID}/{drillDownActive}/{postToExternal}/{sessionID}/{respondentExternalID}?";
        if (reportID === undefined || reportID === null)
            throw new globalThis.Error("The parameter 'reportID' must be defined.");
        url_ = url_.replace("{reportID}", encodeURIComponent("" + reportID));
        if (drillDownActive === undefined || drillDownActive === null)
            throw new globalThis.Error("The parameter 'drillDownActive' must be defined.");
        url_ = url_.replace("{drillDownActive}", encodeURIComponent("" + drillDownActive));
        if (postToExternal === undefined || postToExternal === null)
            throw new globalThis.Error("The parameter 'postToExternal' must be defined.");
        url_ = url_.replace("{postToExternal}", encodeURIComponent("" + postToExternal));
        if (sessionID === null)
            throw new globalThis.Error("The parameter 'sessionID' cannot be null.");
        else if (sessionID !== undefined)
            url_ += "sessionID=" + encodeURIComponent("" + sessionID) + "&";
        if (respondentExternalID === null)
            throw new globalThis.Error("The parameter 'respondentExternalID' cannot be null.");
        else if (respondentExternalID !== undefined)
            url_ += "respondentExternalID=" + encodeURIComponent("" + respondentExternalID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDrilldown2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDrilldown2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDrilldown2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param reportToken (optional) 
     * @return OK
     */
    tokenGET3(reportToken: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ReportResult/token?";
        if (reportToken === null)
            throw new globalThis.Error("The parameter 'reportToken' cannot be null.");
        else if (reportToken !== undefined)
            url_ += "reportToken=" + encodeURIComponent("" + reportToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTokenGET3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTokenGET3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTokenGET3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ReportTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    dptlist(): Observable<void> {
        let url_ = this.baseUrl + "/api/ReportType/dptlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDptlist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDptlist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDptlist(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    reportTypePOST(body: ReportType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ReportType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportTypePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportTypePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReportTypePOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    reportTypePUT(body: ReportType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ReportType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportTypePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportTypePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReportTypePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    reportTypeGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ReportType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportTypeGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportTypeGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReportTypeGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    reportTypeDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ReportType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReportTypeDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReportTypeDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReportTypeDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET48(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ReportType/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET48(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET48(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET48(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET49(): Observable<void> {
        let url_ = this.baseUrl + "/api/ReportType/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET49(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET49(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET49(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class RespondentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param externalID (optional) 
     * @param externalSourceTable (optional) 
     * @return OK
     */
    lastactivity(externalID: number | undefined, externalSourceTable: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/lastactivity?";
        if (externalID === null)
            throw new globalThis.Error("The parameter 'externalID' cannot be null.");
        else if (externalID !== undefined)
            url_ += "externalID=" + encodeURIComponent("" + externalID) + "&";
        if (externalSourceTable === null)
            throw new globalThis.Error("The parameter 'externalSourceTable' cannot be null.");
        else if (externalSourceTable !== undefined)
            url_ += "externalSourceTable=" + encodeURIComponent("" + externalSourceTable) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLastactivity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLastactivity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLastactivity(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    ssoLogin(body: SSOLoginRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/respondent/sso-login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSsoLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSsoLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processSsoLogin(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class RetentionPolicyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    retentionPolicyPOST(body: RetentionPolicy | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RetentionPolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetentionPolicyPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetentionPolicyPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRetentionPolicyPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    retentionPolicyPUT(body: RetentionPolicy | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/RetentionPolicy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetentionPolicyPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetentionPolicyPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRetentionPolicyPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    retentionPolicyGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/RetentionPolicy/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetentionPolicyGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetentionPolicyGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRetentionPolicyGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    retentionPolicyDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/RetentionPolicy/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRetentionPolicyDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRetentionPolicyDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRetentionPolicyDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET50(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/RetentionPolicy/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET50(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET50(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET50(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET51(): Observable<void> {
        let url_ = this.baseUrl + "/api/RetentionPolicy/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET51(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET51(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET51(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class RiskModelClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieves all risk model releases for the specified account.
     * @param accountId The ID of the account to fetch releases for.
     * @return Returns the list of releases
     */
    releases(accountId: number): Observable<RiskModelRelease[]> {
        let url_ = this.baseUrl + "/api/risk-model/account/{accountId}/releases";
        if (accountId === undefined || accountId === null)
            throw new globalThis.Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReleases(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReleases(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskModelRelease[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskModelRelease[]>;
        }));
    }

    protected processReleases(response: HttpResponseBase): Observable<RiskModelRelease[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RiskModelRelease.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("If the accountId is invalid", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("If an internal server error occurs", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RiskModelRelease[]>([]);
    }

    /**
     * Queries the risk model for by Account. Optionally filters by Site (SiteId/ExternalId), Year, and Quarter.
     * @param body (optional) The query parameters for the risk model search.
     * @return Returns the risk model data
     */
    query2(body: RiskModelQuery | undefined): Observable<RiskModelPagedResult> {
        let url_ = this.baseUrl + "/api/risk-model/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQuery2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQuery2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskModelPagedResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskModelPagedResult>;
        }));
    }

    protected processQuery2(response: HttpResponseBase): Observable<RiskModelPagedResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskModelPagedResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("If the query is malformed", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Forbidden", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("If no model is found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("If an internal server error occurs", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<RiskModelPagedResult>(null as any);
    }
}

@Injectable()
export class RoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rolePOST(body: Role | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRolePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRolePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRolePOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    rolePUT(body: Role | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Role";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRolePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRolePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRolePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    roleGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Role/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoleGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoleGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRoleGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    roleDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Role/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRoleDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRoleDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRoleDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET52(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Role/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET52(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET52(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET52(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET53(): Observable<void> {
        let url_ = this.baseUrl + "/api/Role/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET53(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET53(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET53(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ScriptClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    scriptPOST(body: Script | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Script";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScriptPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScriptPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processScriptPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    scriptPUT(body: Script | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Script";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScriptPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScriptPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processScriptPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    scriptGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Script/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScriptGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScriptGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processScriptGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    scriptDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Script/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScriptDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScriptDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processScriptDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET54(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Script/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET54(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET54(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET54(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET55(): Observable<void> {
        let url_ = this.baseUrl + "/api/Script/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET55(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET55(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET55(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ScriptTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    scriptTypePOST(body: ScriptType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ScriptType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScriptTypePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScriptTypePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processScriptTypePOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    scriptTypePUT(body: ScriptType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ScriptType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScriptTypePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScriptTypePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processScriptTypePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    scriptTypeGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ScriptType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScriptTypeGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScriptTypeGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processScriptTypeGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    scriptTypeDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ScriptType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processScriptTypeDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processScriptTypeDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processScriptTypeDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET56(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ScriptType/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET56(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET56(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET56(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET57(): Observable<void> {
        let url_ = this.baseUrl + "/api/ScriptType/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET57(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET57(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET57(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class SearchClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    ccs2(body: SearchRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Search/ccs2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCcs2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCcs2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCcs2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    ccs(body: SearchRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Search/ccs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCcs(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCcs(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCcs(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    accessible(body: AccessibleRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Search/ccs/metadata/accessible";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAccessible(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAccessible(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAccessible(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param maxProcessCount (optional) 
     * @return OK
     */
    poll(maxProcessCount: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Search/poll?";
        if (maxProcessCount === null)
            throw new globalThis.Error("The parameter 'maxProcessCount' cannot be null.");
        else if (maxProcessCount !== undefined)
            url_ += "maxProcessCount=" + encodeURIComponent("" + maxProcessCount) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPoll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPoll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPoll(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class SiteClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    site2(siteId: number): Observable<Site> {
        let url_ = this.baseUrl + "/api/site/{siteId}";
        if (siteId === undefined || siteId === null)
            throw new globalThis.Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSite2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSite2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Site>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Site>;
        }));
    }

    protected processSite2(response: HttpResponseBase): Observable<Site> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Site.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Site>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    listAll(body: SiteQueryRequest | undefined): Observable<Site[]> {
        let url_ = this.baseUrl + "/api/site/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Site[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Site[]>;
        }));
    }

    protected processListAll(response: HttpResponseBase): Observable<Site[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Site.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Site[]>([]);
    }

    /**
     * @param siteId (optional) 
     * @return OK
     */
    regionalSites(siteId: number | undefined): Observable<Site[]> {
        let url_ = this.baseUrl + "/api/site/regional-sites?";
        if (siteId === null)
            throw new globalThis.Error("The parameter 'siteId' cannot be null.");
        else if (siteId !== undefined)
            url_ += "siteId=" + encodeURIComponent("" + siteId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegionalSites(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegionalSites(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<Site[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<Site[]>;
        }));
    }

    protected processRegionalSites(response: HttpResponseBase): Observable<Site[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Site.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Site[]>([]);
    }
}

@Injectable()
export class SuppliersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    bulkPOST(file: FileParameter | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/suppliers/permits/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBulkPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBulkPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processBulkPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param accountId (optional) 
     * @param onlyActives (optional) 
     * @return OK
     */
    permits(accountId: number | undefined, onlyActives: boolean | undefined): Observable<PermitVetting[]> {
        let url_ = this.baseUrl + "/api/suppliers/permits?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (onlyActives === null)
            throw new globalThis.Error("The parameter 'onlyActives' cannot be null.");
        else if (onlyActives !== undefined)
            url_ += "onlyActives=" + encodeURIComponent("" + onlyActives) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPermits(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPermits(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PermitVetting[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PermitVetting[]>;
        }));
    }

    protected processPermits(response: HttpResponseBase): Observable<PermitVetting[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PermitVetting.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<PermitVetting[]>([]);
    }

    /**
     * @param accountId (optional) 
     * @return OK
     */
    contacts(accountId: number | undefined): Observable<SupplierContactList[]> {
        let url_ = this.baseUrl + "/api/suppliers/contacts?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processContacts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processContacts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierContactList[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierContactList[]>;
        }));
    }

    protected processContacts(response: HttpResponseBase): Observable<SupplierContactList[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupplierContactList.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplierContactList[]>([]);
    }

    /**
     * @param accountId (optional) 
     * @return OK
     */
    etk(accountId: number | undefined): Observable<SupplierETKResponse[]> {
        let url_ = this.baseUrl + "/api/suppliers/etk?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEtk(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEtk(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierETKResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierETKResponse[]>;
        }));
    }

    protected processEtk(response: HttpResponseBase): Observable<SupplierETKResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupplierETKResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplierETKResponse[]>([]);
    }

    /**
     * @param accountId (optional) 
     * @param onlyActives (optional) 
     * @return OK
     */
    permitVettings(accountId: number | undefined, onlyActives: boolean | undefined): Observable<SupplierPermitVettingResponse[]> {
        let url_ = this.baseUrl + "/api/suppliers/permit-vettings?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        if (onlyActives === null)
            throw new globalThis.Error("The parameter 'onlyActives' cannot be null.");
        else if (onlyActives !== undefined)
            url_ += "onlyActives=" + encodeURIComponent("" + onlyActives) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPermitVettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPermitVettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierPermitVettingResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierPermitVettingResponse[]>;
        }));
    }

    protected processPermitVettings(response: HttpResponseBase): Observable<SupplierPermitVettingResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupplierPermitVettingResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplierPermitVettingResponse[]>([]);
    }

    /**
     * @param accountId (optional) 
     * @return OK
     */
    supplierCoverages(accountId: number | undefined): Observable<SupplierCoveragesResponse[]> {
        let url_ = this.baseUrl + "/api/suppliers/supplier-coverages?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupplierCoverages(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupplierCoverages(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SupplierCoveragesResponse[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SupplierCoveragesResponse[]>;
        }));
    }

    protected processSupplierCoverages(response: HttpResponseBase): Observable<SupplierCoveragesResponse[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupplierCoveragesResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SupplierCoveragesResponse[]>([]);
    }

    /**
     * @return OK
     */
    report3(siteId: number): Observable<InvoiceSiteReportResponse> {
        let url_ = this.baseUrl + "/api/suppliers/invoices/sites/{siteId}/report";
        if (siteId === undefined || siteId === null)
            throw new globalThis.Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReport3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReport3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceSiteReportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceSiteReportResponse>;
        }));
    }

    protected processReport3(response: HttpResponseBase): Observable<InvoiceSiteReportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceSiteReportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceSiteReportResponse>(null as any);
    }

    /**
     * @param supplierName (optional) 
     * @param invoiceId (optional) 
     * @return OK
     */
    supplierReport(siteId: number, supplierName: string | undefined, invoiceId: number | undefined): Observable<InvoiceSiteSupplierReportResponse> {
        let url_ = this.baseUrl + "/api/suppliers/invoices/sites/{siteId}/supplier-report?";
        if (siteId === undefined || siteId === null)
            throw new globalThis.Error("The parameter 'siteId' must be defined.");
        url_ = url_.replace("{siteId}", encodeURIComponent("" + siteId));
        if (supplierName === null)
            throw new globalThis.Error("The parameter 'supplierName' cannot be null.");
        else if (supplierName !== undefined)
            url_ += "supplierName=" + encodeURIComponent("" + supplierName) + "&";
        if (invoiceId === null)
            throw new globalThis.Error("The parameter 'invoiceId' cannot be null.");
        else if (invoiceId !== undefined)
            url_ += "invoiceId=" + encodeURIComponent("" + invoiceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSupplierReport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSupplierReport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceSiteSupplierReportResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceSiteSupplierReportResponse>;
        }));
    }

    protected processSupplierReport(response: HttpResponseBase): Observable<InvoiceSiteSupplierReportResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceSiteSupplierReportResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceSiteSupplierReportResponse>(null as any);
    }

    /**
     * @param includeHistory (optional) 
     * @return OK
     */
    actionsGET3(invoiceId: number, includeHistory: boolean | undefined): Observable<InvoiceAction> {
        let url_ = this.baseUrl + "/api/suppliers/invoices/{invoiceId}/actions?";
        if (invoiceId === undefined || invoiceId === null)
            throw new globalThis.Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        if (includeHistory === null)
            throw new globalThis.Error("The parameter 'includeHistory' cannot be null.");
        else if (includeHistory !== undefined)
            url_ += "includeHistory=" + encodeURIComponent("" + includeHistory) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActionsGET3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActionsGET3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceAction>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceAction>;
        }));
    }

    protected processActionsGET3(response: HttpResponseBase): Observable<InvoiceAction> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceAction.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceAction>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    actionsPOST3(invoiceId: number, body: SubmitInvoiceActionRequest | undefined): Observable<InvoiceAction> {
        let url_ = this.baseUrl + "/api/suppliers/invoices/{invoiceId}/actions";
        if (invoiceId === undefined || invoiceId === null)
            throw new globalThis.Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processActionsPOST3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processActionsPOST3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceAction>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceAction>;
        }));
    }

    protected processActionsPOST3(response: HttpResponseBase): Observable<InvoiceAction> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceAction.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = InvoiceAction.fromJS(resultData409);
            return throwException("Conflict", status, _responseText, _headers, result409);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceAction>(null as any);
    }

    /**
     * @param page (optional) 
     * @param pageSize (optional) 
     * @return OK
     */
    history(invoiceId: number, page: number | undefined, pageSize: number | undefined): Observable<InvoiceActionHistoryPageResponse> {
        let url_ = this.baseUrl + "/api/suppliers/invoices/{invoiceId}/actions/history?";
        if (invoiceId === undefined || invoiceId === null)
            throw new globalThis.Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        if (page === null)
            throw new globalThis.Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new globalThis.Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InvoiceActionHistoryPageResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InvoiceActionHistoryPageResponse>;
        }));
    }

    protected processHistory(response: HttpResponseBase): Observable<InvoiceActionHistoryPageResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InvoiceActionHistoryPageResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InvoiceActionHistoryPageResponse>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    addInvoices(body: CreateInvoiceDto[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/suppliers/invoices/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddInvoices(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddInvoices(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddInvoices(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    getInvoice(invoiceId: number): Observable<void> {
        let url_ = this.baseUrl + "/api/suppliers/invoices/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new globalThis.Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInvoice(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInvoice(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processGetInvoice(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 404) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class SuppliersInvoiceCsvClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param file (optional) 
     * @return OK
     */
    addInvoicesCsv(file: FileParameter | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/suppliers/invoices/bulk/csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file === null || file === undefined)
            throw new globalThis.Error("The parameter 'file' cannot be null.");
        else
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddInvoicesCsv(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddInvoicesCsv(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processAddInvoicesCsv(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TagClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    tagPOST(body: Tag | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTagPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTagPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTagPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    tagPUT(body: Tag | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTagPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTagPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTagPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    tagGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Tag/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTagGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTagGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTagGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    tagDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Tag/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTagDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTagDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTagDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET58(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Tag/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET58(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET58(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET58(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET59(): Observable<void> {
        let url_ = this.baseUrl + "/api/Tag/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET59(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET59(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET59(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TargetClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param datasetID (optional) 
     * @param iteration (optional) 
     * @param nextIteration (optional) 
     * @return OK
     */
    targetGET(id: number, datasetID: number | undefined, iteration: number | undefined, respondentExternalID: number, nextIteration: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Target/{id}/{respondentExternalID}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (respondentExternalID === undefined || respondentExternalID === null)
            throw new globalThis.Error("The parameter 'respondentExternalID' must be defined.");
        url_ = url_.replace("{respondentExternalID}", encodeURIComponent("" + respondentExternalID));
        if (datasetID === null)
            throw new globalThis.Error("The parameter 'datasetID' cannot be null.");
        else if (datasetID !== undefined)
            url_ += "datasetID=" + encodeURIComponent("" + datasetID) + "&";
        if (iteration === null)
            throw new globalThis.Error("The parameter 'iteration' cannot be null.");
        else if (iteration !== undefined)
            url_ += "iteration=" + encodeURIComponent("" + iteration) + "&";
        if (nextIteration === null)
            throw new globalThis.Error("The parameter 'nextIteration' cannot be null.");
        else if (nextIteration !== undefined)
            url_ += "nextIteration=" + encodeURIComponent("" + nextIteration) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTargetGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTargetGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTargetGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param externalID (optional) 
     * @param respondentExternalID (optional) 
     * @param global (optional) 
     * @param dashboardID (optional) 
     * @param impersonationMode (optional) 
     * @param mode (optional) 
     * @param simple (optional) 
     * @param library (optional) 
     * @param fromExternalSystem (optional) 
     * @return OK
     */
    listGET60(ownerID: number, externalID: number | undefined, respondentExternalID: number | undefined, global: boolean | undefined, dashboardID: number | undefined, impersonationMode: number | undefined, mode: number | undefined, simple: boolean | undefined, library: boolean | undefined, fromExternalSystem: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Target/list/{ownerID}/{externalID}/{respondentExternalID}/{global}/{dashboardID}/{impersonationMode}/{mode}?";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        if (externalID === null)
            throw new globalThis.Error("The parameter 'externalID' cannot be null.");
        else if (externalID !== undefined)
            url_ += "externalID=" + encodeURIComponent("" + externalID) + "&";
        if (respondentExternalID === null)
            throw new globalThis.Error("The parameter 'respondentExternalID' cannot be null.");
        else if (respondentExternalID !== undefined)
            url_ += "respondentExternalID=" + encodeURIComponent("" + respondentExternalID) + "&";
        if (global === null)
            throw new globalThis.Error("The parameter 'global' cannot be null.");
        else if (global !== undefined)
            url_ += "global=" + encodeURIComponent("" + global) + "&";
        if (dashboardID === null)
            throw new globalThis.Error("The parameter 'dashboardID' cannot be null.");
        else if (dashboardID !== undefined)
            url_ += "dashboardID=" + encodeURIComponent("" + dashboardID) + "&";
        if (impersonationMode === null)
            throw new globalThis.Error("The parameter 'impersonationMode' cannot be null.");
        else if (impersonationMode !== undefined)
            url_ += "impersonationMode=" + encodeURIComponent("" + impersonationMode) + "&";
        if (mode === null)
            throw new globalThis.Error("The parameter 'mode' cannot be null.");
        else if (mode !== undefined)
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        if (simple === null)
            throw new globalThis.Error("The parameter 'simple' cannot be null.");
        else if (simple !== undefined)
            url_ += "simple=" + encodeURIComponent("" + simple) + "&";
        if (library === null)
            throw new globalThis.Error("The parameter 'library' cannot be null.");
        else if (library !== undefined)
            url_ += "library=" + encodeURIComponent("" + library) + "&";
        if (fromExternalSystem === null)
            throw new globalThis.Error("The parameter 'fromExternalSystem' cannot be null.");
        else if (fromExternalSystem !== undefined)
            url_ += "fromExternalSystem=" + encodeURIComponent("" + fromExternalSystem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET60(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET60(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET60(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET61(ownerID: number, loadCompletionData: boolean): Observable<void> {
        let url_ = this.baseUrl + "/api/Target/list/{ownerID}/{loadCompletionData}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        if (loadCompletionData === undefined || loadCompletionData === null)
            throw new globalThis.Error("The parameter 'loadCompletionData' must be defined.");
        url_ = url_.replace("{loadCompletionData}", encodeURIComponent("" + loadCompletionData));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET61(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET61(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET61(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    targetDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Target/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTargetDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTargetDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTargetDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    targetGET2(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Target/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTargetGET2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTargetGET2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTargetGET2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param includeRelated (optional) 
     * @param includeDatasets (optional) 
     * @param includeValues (optional) 
     * @param includeDPTDetails (optional) 
     * @return OK
     */
    clone(id: number, toOwnerID: number, toSystem: string, includeRelated: boolean | undefined, includeDatasets: boolean | undefined, includeValues: boolean | undefined, includeDPTDetails: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Target/{id}/clone/{toOwnerID}/{toSystem}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (toOwnerID === undefined || toOwnerID === null)
            throw new globalThis.Error("The parameter 'toOwnerID' must be defined.");
        url_ = url_.replace("{toOwnerID}", encodeURIComponent("" + toOwnerID));
        if (toSystem === undefined || toSystem === null)
            throw new globalThis.Error("The parameter 'toSystem' must be defined.");
        url_ = url_.replace("{toSystem}", encodeURIComponent("" + toSystem));
        if (includeRelated === null)
            throw new globalThis.Error("The parameter 'includeRelated' cannot be null.");
        else if (includeRelated !== undefined)
            url_ += "includeRelated=" + encodeURIComponent("" + includeRelated) + "&";
        if (includeDatasets === null)
            throw new globalThis.Error("The parameter 'includeDatasets' cannot be null.");
        else if (includeDatasets !== undefined)
            url_ += "includeDatasets=" + encodeURIComponent("" + includeDatasets) + "&";
        if (includeValues === null)
            throw new globalThis.Error("The parameter 'includeValues' cannot be null.");
        else if (includeValues !== undefined)
            url_ += "includeValues=" + encodeURIComponent("" + includeValues) + "&";
        if (includeDPTDetails === null)
            throw new globalThis.Error("The parameter 'includeDPTDetails' cannot be null.");
        else if (includeDPTDetails !== undefined)
            url_ += "includeDPTDetails=" + encodeURIComponent("" + includeDPTDetails) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processClone(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processClone(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processClone(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    publish(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Target/{id}/publish";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPublish(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPublish(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPublish(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    eval(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Target/{id}/eval";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEval(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEval(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEval(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    index(body: Target[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Target/list/index";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIndex(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIndex(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processIndex(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    lock(id: number, locked: boolean): Observable<void> {
        let url_ = this.baseUrl + "/api/Target/{id}/lock/{locked}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (locked === undefined || locked === null)
            throw new globalThis.Error("The parameter 'locked' must be defined.");
        url_ = url_.replace("{locked}", encodeURIComponent("" + locked));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLock(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLock(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processLock(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    targetPOST(body: Target | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Target";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTargetPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTargetPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTargetPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    targetPUT(body: Target | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Target";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTargetPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTargetPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTargetPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET62(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Target/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET62(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET62(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET62(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET63(): Observable<void> {
        let url_ = this.baseUrl + "/api/Target/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET63(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET63(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET63(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TargetTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    targetTypePOST(body: TargetType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TargetType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTargetTypePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTargetTypePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTargetTypePOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    targetTypePUT(body: TargetType | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/TargetType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTargetTypePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTargetTypePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTargetTypePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    targetTypeGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/TargetType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTargetTypeGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTargetTypeGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTargetTypeGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    targetTypeDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/TargetType/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTargetTypeDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTargetTypeDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTargetTypeDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET64(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/TargetType/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET64(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET64(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET64(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET65(): Observable<void> {
        let url_ = this.baseUrl + "/api/TargetType/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET65(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET65(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET65(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TemplateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    chunks(templateID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Template/chunks/{templateID}";
        if (templateID === undefined || templateID === null)
            throw new globalThis.Error("The parameter 'templateID' must be defined.");
        url_ = url_.replace("{templateID}", encodeURIComponent("" + templateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChunks(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChunks(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processChunks(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    owner(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Template/summary/owner/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOwner(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOwner(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processOwner(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param code (optional) 
     * @param body (optional) 
     * @return OK
     */
    htmlPOST(code: string | undefined, body: ReportMacro[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Template/code/html?";
        if (code === null)
            throw new globalThis.Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHtmlPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHtmlPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHtmlPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param datasetExternalID (optional) 
     * @param respondentExternalID (optional) 
     * @param parent (optional) 
     * @return OK
     */
    htmlGET(templateID: number, datasetExternalID: number | undefined, respondentExternalID: number | undefined, parent: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Template/{templateID}/html?";
        if (templateID === undefined || templateID === null)
            throw new globalThis.Error("The parameter 'templateID' must be defined.");
        url_ = url_.replace("{templateID}", encodeURIComponent("" + templateID));
        if (datasetExternalID === null)
            throw new globalThis.Error("The parameter 'datasetExternalID' cannot be null.");
        else if (datasetExternalID !== undefined)
            url_ += "datasetExternalID=" + encodeURIComponent("" + datasetExternalID) + "&";
        if (respondentExternalID === null)
            throw new globalThis.Error("The parameter 'respondentExternalID' cannot be null.");
        else if (respondentExternalID !== undefined)
            url_ += "respondentExternalID=" + encodeURIComponent("" + respondentExternalID) + "&";
        if (parent === null)
            throw new globalThis.Error("The parameter 'parent' cannot be null.");
        else if (parent !== undefined)
            url_ += "parent=" + encodeURIComponent("" + parent) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHtmlGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHtmlGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHtmlGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param datasetExternalID (optional) 
     * @param respondentExternalID (optional) 
     * @param parent (optional) 
     * @param processGUID (optional) 
     * @param body (optional) 
     * @return OK
     */
    htmlPOST2(templateID: number, datasetExternalID: number | undefined, respondentExternalID: number | undefined, parent: string | undefined, processGUID: string | undefined, body: ReportMacro[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Template/{templateID}/html?";
        if (templateID === undefined || templateID === null)
            throw new globalThis.Error("The parameter 'templateID' must be defined.");
        url_ = url_.replace("{templateID}", encodeURIComponent("" + templateID));
        if (datasetExternalID === null)
            throw new globalThis.Error("The parameter 'datasetExternalID' cannot be null.");
        else if (datasetExternalID !== undefined)
            url_ += "datasetExternalID=" + encodeURIComponent("" + datasetExternalID) + "&";
        if (respondentExternalID === null)
            throw new globalThis.Error("The parameter 'respondentExternalID' cannot be null.");
        else if (respondentExternalID !== undefined)
            url_ += "respondentExternalID=" + encodeURIComponent("" + respondentExternalID) + "&";
        if (parent === null)
            throw new globalThis.Error("The parameter 'parent' cannot be null.");
        else if (parent !== undefined)
            url_ += "parent=" + encodeURIComponent("" + parent) + "&";
        if (processGUID === null)
            throw new globalThis.Error("The parameter 'processGUID' cannot be null.");
        else if (processGUID !== undefined)
            url_ += "processGUID=" + encodeURIComponent("" + processGUID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processHtmlPOST2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processHtmlPOST2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processHtmlPOST2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    templatePOST(body: Template | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTemplatePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTemplatePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTemplatePOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    templatePUT(body: Template | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Template";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTemplatePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTemplatePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTemplatePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    templateGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Template/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTemplateGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTemplateGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTemplateGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    templateDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Template/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTemplateDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTemplateDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTemplateDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET66(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Template/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET66(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET66(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET66(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET67(): Observable<void> {
        let url_ = this.baseUrl + "/api/Template/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET67(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET67(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET67(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class TransferClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    targetPOST(targetID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Transfer/file/target/{targetID}";
        if (targetID === undefined || targetID === null)
            throw new globalThis.Error("The parameter 'targetID' must be defined.");
        url_ = url_.replace("{targetID}", encodeURIComponent("" + targetID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTargetPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTargetPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTargetPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    listPOST(body: BlobListRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Transfer/blob/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    import3(body: ImportDataRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processImport3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    targetGET(targetID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Transfer/download/template/target/{targetID}";
        if (targetID === undefined || targetID === null)
            throw new globalThis.Error("The parameter 'targetID' must be defined.");
        url_ = url_.replace("{targetID}", encodeURIComponent("" + targetID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTargetGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTargetGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTargetGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param siteID (optional) 
     * @return OK
     */
    downloadGET3(ownerID: number, siteID: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Transfer/download/{ownerID}/{siteID}?";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        if (siteID === null)
            throw new globalThis.Error("The parameter 'siteID' cannot be null.");
        else if (siteID !== undefined)
            url_ += "siteID=" + encodeURIComponent("" + siteID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadGET3(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadGET3(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadGET3(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    archivedAssessment(body: FileDownloadRequest | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Transfer/download/archived-assessment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processArchivedAssessment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processArchivedAssessment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processArchivedAssessment(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    downloadPUT(reportID: number, downloadType: string, body: ReportMacro[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/report/download/{downloadType}/{reportID}";
        if (reportID === undefined || reportID === null)
            throw new globalThis.Error("The parameter 'reportID' must be defined.");
        url_ = url_.replace("{reportID}", encodeURIComponent("" + reportID));
        if (downloadType === undefined || downloadType === null)
            throw new globalThis.Error("The parameter 'downloadType' must be defined.");
        url_ = url_.replace("{downloadType}", encodeURIComponent("" + downloadType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ValueClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    valuePUT(valueID: number, body: string | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Value/{valueID}";
        if (valueID === undefined || valueID === null)
            throw new globalThis.Error("The parameter 'valueID' must be defined.");
        url_ = url_.replace("{valueID}", encodeURIComponent("" + valueID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValuePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValuePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValuePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    valueDELETE(valueID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Value/{valueID}";
        if (valueID === undefined || valueID === null)
            throw new globalThis.Error("The parameter 'valueID' must be defined.");
        url_ = url_.replace("{valueID}", encodeURIComponent("" + valueID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValueDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValueDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValueDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param size (optional) 
     * @return OK
     */
    url(valueID: number, size: number | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Value/{valueID}/image/url?";
        if (valueID === undefined || valueID === null)
            throw new globalThis.Error("The parameter 'valueID' must be defined.");
        url_ = url_.replace("{valueID}", encodeURIComponent("" + valueID));
        if (size === null)
            throw new globalThis.Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUrl(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUrl(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processUrl(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    downloadGET4(valueID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Value/{valueID}/image/download";
        if (valueID === undefined || valueID === null)
            throw new globalThis.Error("The parameter 'valueID' must be defined.");
        url_ = url_.replace("{valueID}", encodeURIComponent("" + valueID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadGET4(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadGET4(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processDownloadGET4(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    valuePOST(body: Tag | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Value";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValuePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValuePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValuePOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    valuePUT2(body: Tag | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Value";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValuePUT2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValuePUT2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValuePUT2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    valueGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Value/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValueGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValueGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValueGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET68(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Value/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET68(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET68(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET68(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET69(): Observable<void> {
        let url_ = this.baseUrl + "/api/Value/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET69(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET69(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET69(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ValueConfigClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    valueConfigPOST(body: ValueConfig | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ValueConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValueConfigPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValueConfigPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValueConfigPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    valueConfigPUT(body: ValueConfig | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ValueConfig";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValueConfigPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValueConfigPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValueConfigPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    valueConfigGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ValueConfig/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValueConfigGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValueConfigGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValueConfigGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    valueConfigDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ValueConfig/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValueConfigDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValueConfigDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValueConfigDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET70(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ValueConfig/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET70(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET70(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET70(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET71(): Observable<void> {
        let url_ = this.baseUrl + "/api/ValueConfig/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET71(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET71(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET71(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class ValueConfigOptionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    valueConfigOptionPOST(body: ValueConfigOption | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ValueConfigOption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValueConfigOptionPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValueConfigOptionPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValueConfigOptionPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    valueConfigOptionPUT(body: ValueConfigOption | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/ValueConfigOption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValueConfigOptionPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValueConfigOptionPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValueConfigOptionPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    valueConfigOptionGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ValueConfigOption/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValueConfigOptionGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValueConfigOptionGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValueConfigOptionGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    valueConfigOptionDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ValueConfigOption/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValueConfigOptionDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValueConfigOptionDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processValueConfigOptionDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET72(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/ValueConfigOption/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET72(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET72(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET72(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET73(): Observable<void> {
        let url_ = this.baseUrl + "/api/ValueConfigOption/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET73(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET73(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET73(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class WorkflowClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    poll2(): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflow/poll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPoll2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPoll2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processPoll2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param stakeholderID (optional) 
     * @return OK
     */
    receive(stakeholderID: number | undefined, requestID: number, actionID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflow/request/action/receive/{requestID}/{actionID}?";
        if (requestID === undefined || requestID === null)
            throw new globalThis.Error("The parameter 'requestID' must be defined.");
        url_ = url_.replace("{requestID}", encodeURIComponent("" + requestID));
        if (actionID === undefined || actionID === null)
            throw new globalThis.Error("The parameter 'actionID' must be defined.");
        url_ = url_.replace("{actionID}", encodeURIComponent("" + actionID));
        if (stakeholderID === null)
            throw new globalThis.Error("The parameter 'stakeholderID' cannot be null.");
        else if (stakeholderID !== undefined)
            url_ += "stakeholderID=" + encodeURIComponent("" + stakeholderID) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReceive(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReceive(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processReceive(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    enter(requestID: number, stateID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflow/request/state/enter/{requestID}/{stateID}";
        if (requestID === undefined || requestID === null)
            throw new globalThis.Error("The parameter 'requestID' must be defined.");
        url_ = url_.replace("{requestID}", encodeURIComponent("" + requestID));
        if (stateID === undefined || stateID === null)
            throw new globalThis.Error("The parameter 'stateID' must be defined.");
        url_ = url_.replace("{stateID}", encodeURIComponent("" + stateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnter(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnter(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processEnter(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    flowchartdata(processID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflow/process/{processID}/flowchartdata";
        if (processID === undefined || processID === null)
            throw new globalThis.Error("The parameter 'processID' must be defined.");
        url_ = url_.replace("{processID}", encodeURIComponent("" + processID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFlowchartdata(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFlowchartdata(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processFlowchartdata(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    statePOST(body: State | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflow/process/state";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatePOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    stateDELETE(stateID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflow/process/state/{stateID}";
        if (stateID === undefined || stateID === null)
            throw new globalThis.Error("The parameter 'stateID' must be defined.");
        url_ = url_.replace("{stateID}", encodeURIComponent("" + stateID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStateDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStateDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStateDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    statePUT(stateID: number, body: State | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflow/process/state/{stateID}";
        if (stateID === undefined || stateID === null)
            throw new globalThis.Error("The parameter 'stateID' must be defined.");
        url_ = url_.replace("{stateID}", encodeURIComponent("" + stateID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStatePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStatePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processStatePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    transitionactionPOST(processID: number, body: FlowchartLink | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflow/process/transitionaction/{processID}";
        if (processID === undefined || processID === null)
            throw new globalThis.Error("The parameter 'processID' must be defined.");
        url_ = url_.replace("{processID}", encodeURIComponent("" + processID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransitionactionPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransitionactionPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTransitionactionPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    transitionactionDELETE(transitionID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflow/process/transitionaction/{transitionID}";
        if (transitionID === undefined || transitionID === null)
            throw new globalThis.Error("The parameter 'transitionID' must be defined.");
        url_ = url_.replace("{transitionID}", encodeURIComponent("" + transitionID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransitionactionDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransitionactionDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTransitionactionDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    transitionactionPUT(transitionID: number, body: FlowchartLink | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflow/process/transitionaction/{transitionID}";
        if (transitionID === undefined || transitionID === null)
            throw new globalThis.Error("The parameter 'transitionID' must be defined.");
        url_ = url_.replace("{transitionID}", encodeURIComponent("" + transitionID));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTransitionactionPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTransitionactionPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTransitionactionPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    test2(body: WorkflowResult[] | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflow/result/test";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTest2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTest2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processTest2(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    workflowPOST(body: Action | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflowPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflowPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWorkflowPOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    workflowPUT(body: Action | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflow";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflowPUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflowPUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWorkflowPUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    workflowGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflow/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflowGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflowGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWorkflowGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    workflowDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflow/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflowDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflowDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWorkflowDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET74(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflow/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET74(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET74(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET74(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET75(): Observable<void> {
        let url_ = this.baseUrl + "/api/Workflow/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET75(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET75(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET75(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

@Injectable()
export class WorkflowStateClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    workflowStatePOST(body: State | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/WorkflowState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflowStatePOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflowStatePOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWorkflowStatePOST(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    workflowStatePUT(body: State | undefined): Observable<void> {
        let url_ = this.baseUrl + "/api/WorkflowState";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflowStatePUT(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflowStatePUT(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWorkflowStatePUT(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    workflowStateGET(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/WorkflowState/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflowStateGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflowStateGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWorkflowStateGET(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    workflowStateDELETE(id: number): Observable<void> {
        let url_ = this.baseUrl + "/api/WorkflowState/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkflowStateDELETE(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkflowStateDELETE(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processWorkflowStateDELETE(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET76(ownerID: number): Observable<void> {
        let url_ = this.baseUrl + "/api/WorkflowState/list/{ownerID}";
        if (ownerID === undefined || ownerID === null)
            throw new globalThis.Error("The parameter 'ownerID' must be defined.");
        url_ = url_.replace("{ownerID}", encodeURIComponent("" + ownerID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET76(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET76(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET76(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    /**
     * @return OK
     */
    listGET77(): Observable<void> {
        let url_ = this.baseUrl + "/api/WorkflowState/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGET77(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGET77(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processListGET77(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }
}

export class AccessibleRequest implements IAccessibleRequest {
    accountID?: number;
    userID?: number;
    siteID?: number | null;
    userGroupNames?: string[] | null;

    constructor(data?: IAccessibleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountID = _data["accountID"] !== undefined ? _data["accountID"] : null as any;
            this.userID = _data["userID"] !== undefined ? _data["userID"] : null as any;
            this.siteID = _data["siteID"] !== undefined ? _data["siteID"] : null as any;
            if (Array.isArray(_data["userGroupNames"])) {
                this.userGroupNames = [] as any;
                for (let item of _data["userGroupNames"])
                    this.userGroupNames!.push(item);
            }
            else {
                this.userGroupNames = null as any;
            }
        }
    }

    static fromJS(data: any): AccessibleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AccessibleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountID"] = this.accountID !== undefined ? this.accountID : null as any;
        data["userID"] = this.userID !== undefined ? this.userID : null as any;
        data["siteID"] = this.siteID !== undefined ? this.siteID : null as any;
        if (Array.isArray(this.userGroupNames)) {
            data["userGroupNames"] = [];
            for (let item of this.userGroupNames)
                data["userGroupNames"].push(item);
        }
        return data;
    }
}

export interface IAccessibleRequest {
    accountID?: number;
    userID?: number;
    siteID?: number | null;
    userGroupNames?: string[] | null;
}

export class Action implements IAction {
    processID?: number;
    name!: string;
    description?: string | null;
    designerID!: string;
    processDesignerID!: string;
    id?: number;

    constructor(data?: IAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processID = _data["processID"] !== undefined ? _data["processID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.processDesignerID = _data["processDesignerID"] !== undefined ? _data["processDesignerID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): Action {
        data = typeof data === 'object' ? data : {};
        let result = new Action();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processID"] = this.processID !== undefined ? this.processID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["processDesignerID"] = this.processDesignerID !== undefined ? this.processDesignerID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IAction {
    processID?: number;
    name: string;
    description?: string | null;
    designerID: string;
    processDesignerID: string;
    id?: number;
}

export class ActionContext implements IActionContext {
    action?: string | null;
    displayName?: string | null;
    commentRequired?: boolean;
    possibleReasons?: ActionReason[] | null;

    constructor(data?: IActionContext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"] !== undefined ? _data["action"] : null as any;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null as any;
            this.commentRequired = _data["commentRequired"] !== undefined ? _data["commentRequired"] : null as any;
            if (Array.isArray(_data["possibleReasons"])) {
                this.possibleReasons = [] as any;
                for (let item of _data["possibleReasons"])
                    this.possibleReasons!.push(ActionReason.fromJS(item));
            }
            else {
                this.possibleReasons = null as any;
            }
        }
    }

    static fromJS(data: any): ActionContext {
        data = typeof data === 'object' ? data : {};
        let result = new ActionContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action !== undefined ? this.action : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        data["commentRequired"] = this.commentRequired !== undefined ? this.commentRequired : null as any;
        if (Array.isArray(this.possibleReasons)) {
            data["possibleReasons"] = [];
            for (let item of this.possibleReasons)
                data["possibleReasons"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IActionContext {
    action?: string | null;
    displayName?: string | null;
    commentRequired?: boolean;
    possibleReasons?: ActionReason[] | null;
}

export class ActionLog implements IActionLog {
    createdDate!: Date;
    action!: string;
    message?: string | null;
    ownerID?: number | null;
    respondentID?: number | null;
    errorLogID?: number | null;
    id?: number;

    constructor(data?: IActionLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.action = _data["action"] !== undefined ? _data["action"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.respondentID = _data["respondentID"] !== undefined ? _data["respondentID"] : null as any;
            this.errorLogID = _data["errorLogID"] !== undefined ? _data["errorLogID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): ActionLog {
        data = typeof data === 'object' ? data : {};
        let result = new ActionLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["action"] = this.action !== undefined ? this.action : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["respondentID"] = this.respondentID !== undefined ? this.respondentID : null as any;
        data["errorLogID"] = this.errorLogID !== undefined ? this.errorLogID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IActionLog {
    createdDate: Date;
    action: string;
    message?: string | null;
    ownerID?: number | null;
    respondentID?: number | null;
    errorLogID?: number | null;
    id?: number;
}

export class ActionQuestionAnswer implements IActionQuestionAnswer {
    questionId?: string | null;
    name?: string | null;
    value?: string | null;

    constructor(data?: IActionQuestionAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"] !== undefined ? _data["questionId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static fromJS(data: any): ActionQuestionAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new ActionQuestionAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId !== undefined ? this.questionId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }
}

export interface IActionQuestionAnswer {
    questionId?: string | null;
    name?: string | null;
    value?: string | null;
}

export class ActionReason implements IActionReason {
    reason?: string | null;
    displayName?: string | null;

    constructor(data?: IActionReason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null as any;
        }
    }

    static fromJS(data: any): ActionReason {
        data = typeof data === 'object' ? data : {};
        let result = new ActionReason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        return data;
    }
}

export interface IActionReason {
    reason?: string | null;
    displayName?: string | null;
}

export class AdvanceSignal implements IAdvanceSignal {
    reason?: string | null;
    metaData?: string | null;

    constructor(data?: IAdvanceSignal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.metaData = _data["metaData"] !== undefined ? _data["metaData"] : null as any;
        }
    }

    static fromJS(data: any): AdvanceSignal {
        data = typeof data === 'object' ? data : {};
        let result = new AdvanceSignal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["metaData"] = this.metaData !== undefined ? this.metaData : null as any;
        return data;
    }
}

export interface IAdvanceSignal {
    reason?: string | null;
    metaData?: string | null;
}

export class AuthKey implements IAuthKey {
    key?: string | null;
    ownerID?: number;
    owner?: Owner;
    respondentID?: number | null;
    respondent?: Respondent;
    notes?: string | null;
    authMessage?: string | null;
    ownerSystem?: string | null;
    id?: number;

    constructor(data?: IAuthKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : null as any;
            this.respondentID = _data["respondentID"] !== undefined ? _data["respondentID"] : null as any;
            this.respondent = _data["respondent"] ? Respondent.fromJS(_data["respondent"]) : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.authMessage = _data["authMessage"] !== undefined ? _data["authMessage"] : null as any;
            this.ownerSystem = _data["ownerSystem"] !== undefined ? _data["ownerSystem"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): AuthKey {
        data = typeof data === 'object' ? data : {};
        let result = new AuthKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["owner"] = this.owner ? this.owner.toJSON() : null as any;
        data["respondentID"] = this.respondentID !== undefined ? this.respondentID : null as any;
        data["respondent"] = this.respondent ? this.respondent.toJSON() : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["authMessage"] = this.authMessage !== undefined ? this.authMessage : null as any;
        data["ownerSystem"] = this.ownerSystem !== undefined ? this.ownerSystem : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IAuthKey {
    key?: string | null;
    ownerID?: number;
    owner?: Owner;
    respondentID?: number | null;
    respondent?: Respondent;
    notes?: string | null;
    authMessage?: string | null;
    ownerSystem?: string | null;
    id?: number;
}

export enum BillingPeriod {
    Daily = "Daily",
    Weekly = "Weekly",
    Monthly = "Monthly",
}

export enum BillingType {
    PerStop = "PerStop",
    PerStopScheduled = "PerStopScheduled",
    Hourly = "Hourly",
    Dedicated = "Dedicated",
}

export class BlobListRequest implements IBlobListRequest {
    path?: string | null;
    regex?: string | null;

    constructor(data?: IBlobListRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.path = _data["path"] !== undefined ? _data["path"] : null as any;
            this.regex = _data["regex"] !== undefined ? _data["regex"] : null as any;
        }
    }

    static fromJS(data: any): BlobListRequest {
        data = typeof data === 'object' ? data : {};
        let result = new BlobListRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["path"] = this.path !== undefined ? this.path : null as any;
        data["regex"] = this.regex !== undefined ? this.regex : null as any;
        return data;
    }
}

export interface IBlobListRequest {
    path?: string | null;
    regex?: string | null;
}

export class BulkTarget implements IBulkTarget {
    id!: string;
    name!: string;
    description?: string | null;
    targetID?: number | null;
    target?: Target;
    workflowStateID?: number | null;
    workflowState?: State;
    ownerID?: number | null;
    messageRoute!: string;
    validateRoute?: string | null;
    submitRoute!: string;
    targetCategoryID?: number | null;
    readonly targetCategoryCode?: string | null;
    targetDesignerID!: string;
    workflowStateDesignerID?: string | null;

    constructor(data?: IBulkTarget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.targetID = _data["targetID"] !== undefined ? _data["targetID"] : null as any;
            this.target = _data["target"] ? Target.fromJS(_data["target"]) : null as any;
            this.workflowStateID = _data["workflowStateID"] !== undefined ? _data["workflowStateID"] : null as any;
            this.workflowState = _data["workflowState"] ? State.fromJS(_data["workflowState"]) : null as any;
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.messageRoute = _data["messageRoute"] !== undefined ? _data["messageRoute"] : null as any;
            this.validateRoute = _data["validateRoute"] !== undefined ? _data["validateRoute"] : null as any;
            this.submitRoute = _data["submitRoute"] !== undefined ? _data["submitRoute"] : null as any;
            this.targetCategoryID = _data["targetCategoryID"] !== undefined ? _data["targetCategoryID"] : null as any;
            (this as any).targetCategoryCode = _data["targetCategoryCode"] !== undefined ? _data["targetCategoryCode"] : null as any;
            this.targetDesignerID = _data["targetDesignerID"] !== undefined ? _data["targetDesignerID"] : null as any;
            this.workflowStateDesignerID = _data["workflowStateDesignerID"] !== undefined ? _data["workflowStateDesignerID"] : null as any;
        }
    }

    static fromJS(data: any): BulkTarget {
        data = typeof data === 'object' ? data : {};
        let result = new BulkTarget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["targetID"] = this.targetID !== undefined ? this.targetID : null as any;
        data["target"] = this.target ? this.target.toJSON() : null as any;
        data["workflowStateID"] = this.workflowStateID !== undefined ? this.workflowStateID : null as any;
        data["workflowState"] = this.workflowState ? this.workflowState.toJSON() : null as any;
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["messageRoute"] = this.messageRoute !== undefined ? this.messageRoute : null as any;
        data["validateRoute"] = this.validateRoute !== undefined ? this.validateRoute : null as any;
        data["submitRoute"] = this.submitRoute !== undefined ? this.submitRoute : null as any;
        data["targetCategoryID"] = this.targetCategoryID !== undefined ? this.targetCategoryID : null as any;
        data["targetCategoryCode"] = this.targetCategoryCode !== undefined ? this.targetCategoryCode : null as any;
        data["targetDesignerID"] = this.targetDesignerID !== undefined ? this.targetDesignerID : null as any;
        data["workflowStateDesignerID"] = this.workflowStateDesignerID !== undefined ? this.workflowStateDesignerID : null as any;
        return data;
    }
}

export interface IBulkTarget {
    id: string;
    name: string;
    description?: string | null;
    targetID?: number | null;
    target?: Target;
    workflowStateID?: number | null;
    workflowState?: State;
    ownerID?: number | null;
    messageRoute: string;
    validateRoute?: string | null;
    submitRoute: string;
    targetCategoryID?: number | null;
    targetCategoryCode?: string | null;
    targetDesignerID: string;
    workflowStateDesignerID?: string | null;
}

export class Button implements IButton {
    ownerID?: number;
    markup!: string;
    sql!: string;
    notes?: string | null;
    designerID!: string;
    ownerDesignerID!: string;
    id?: number;

    constructor(data?: IButton) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.markup = _data["markup"] !== undefined ? _data["markup"] : null as any;
            this.sql = _data["sql"] !== undefined ? _data["sql"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.ownerDesignerID = _data["ownerDesignerID"] !== undefined ? _data["ownerDesignerID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): Button {
        data = typeof data === 'object' ? data : {};
        let result = new Button();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["markup"] = this.markup !== undefined ? this.markup : null as any;
        data["sql"] = this.sql !== undefined ? this.sql : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["ownerDesignerID"] = this.ownerDesignerID !== undefined ? this.ownerDesignerID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IButton {
    ownerID?: number;
    markup: string;
    sql: string;
    notes?: string | null;
    designerID: string;
    ownerDesignerID: string;
    id?: number;
}

export class CancelGuardServiceMessage implements ICancelGuardServiceMessage {
    messageId?: string;
    timestamp?: Date;
    respondentExternalId?: number;
    guardServiceIds?: DatasetKey[] | null;
    endDate?: Date;
    bulkRequestID?: DatasetKey;
    submissionId?: string;
    readonly countOfItemsToProcess?: number;

    constructor(data?: ICancelGuardServiceMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"] !== undefined ? _data["messageId"] : null as any;
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : null as any;
            this.respondentExternalId = _data["respondentExternalId"] !== undefined ? _data["respondentExternalId"] : null as any;
            if (Array.isArray(_data["guardServiceIds"])) {
                this.guardServiceIds = [] as any;
                for (let item of _data["guardServiceIds"])
                    this.guardServiceIds!.push(DatasetKey.fromJS(item));
            }
            else {
                this.guardServiceIds = null as any;
            }
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            this.bulkRequestID = _data["bulkRequestID"] ? DatasetKey.fromJS(_data["bulkRequestID"]) : null as any;
            this.submissionId = _data["submissionId"] !== undefined ? _data["submissionId"] : null as any;
            (this as any).countOfItemsToProcess = _data["countOfItemsToProcess"] !== undefined ? _data["countOfItemsToProcess"] : null as any;
        }
    }

    static fromJS(data: any): CancelGuardServiceMessage {
        data = typeof data === 'object' ? data : {};
        let result = new CancelGuardServiceMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId !== undefined ? this.messageId : null as any;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : null as any;
        data["respondentExternalId"] = this.respondentExternalId !== undefined ? this.respondentExternalId : null as any;
        if (Array.isArray(this.guardServiceIds)) {
            data["guardServiceIds"] = [];
            for (let item of this.guardServiceIds)
                data["guardServiceIds"].push(item ? item.toJSON() : null as any);
        }
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["bulkRequestID"] = this.bulkRequestID ? this.bulkRequestID.toJSON() : null as any;
        data["submissionId"] = this.submissionId !== undefined ? this.submissionId : null as any;
        data["countOfItemsToProcess"] = this.countOfItemsToProcess !== undefined ? this.countOfItemsToProcess : null as any;
        return data;
    }
}

export interface ICancelGuardServiceMessage {
    messageId?: string;
    timestamp?: Date;
    respondentExternalId?: number;
    guardServiceIds?: DatasetKey[] | null;
    endDate?: Date;
    bulkRequestID?: DatasetKey;
    submissionId?: string;
    countOfItemsToProcess?: number;
}

export class CancelGuardServiceRequest implements ICancelGuardServiceRequest {
    respondentExternalId?: number;
    guardServiceId?: DatasetKey;
    cancelDate?: Date;
    bulkRequestID?: DatasetKey;

    constructor(data?: ICancelGuardServiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.respondentExternalId = _data["respondentExternalId"] !== undefined ? _data["respondentExternalId"] : null as any;
            this.guardServiceId = _data["guardServiceId"] ? DatasetKey.fromJS(_data["guardServiceId"]) : null as any;
            this.cancelDate = _data["cancelDate"] ? new Date(_data["cancelDate"].toString()) : null as any;
            this.bulkRequestID = _data["bulkRequestID"] ? DatasetKey.fromJS(_data["bulkRequestID"]) : null as any;
        }
    }

    static fromJS(data: any): CancelGuardServiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CancelGuardServiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["respondentExternalId"] = this.respondentExternalId !== undefined ? this.respondentExternalId : null as any;
        data["guardServiceId"] = this.guardServiceId ? this.guardServiceId.toJSON() : null as any;
        data["cancelDate"] = this.cancelDate ? this.cancelDate.toISOString() : null as any;
        data["bulkRequestID"] = this.bulkRequestID ? this.bulkRequestID.toJSON() : null as any;
        return data;
    }
}

export interface ICancelGuardServiceRequest {
    respondentExternalId?: number;
    guardServiceId?: DatasetKey;
    cancelDate?: Date;
    bulkRequestID?: DatasetKey;
}

export class CheckGuardChangeReassessmentModifiedServiceMessage implements ICheckGuardChangeReassessmentModifiedServiceMessage {
    messageId?: string;
    timestamp?: Date;
    siteId?: number;
    serviceId?: DatasetKey;
    oldServiceType?: GuardServiceType;
    newServiceType?: GuardServiceType;
    respondentExternalId?: number;
    readonly countOfItemsToProcess?: number;

    constructor(data?: ICheckGuardChangeReassessmentModifiedServiceMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"] !== undefined ? _data["messageId"] : null as any;
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : null as any;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null as any;
            this.serviceId = _data["serviceId"] ? DatasetKey.fromJS(_data["serviceId"]) : null as any;
            this.oldServiceType = _data["oldServiceType"] !== undefined ? _data["oldServiceType"] : null as any;
            this.newServiceType = _data["newServiceType"] !== undefined ? _data["newServiceType"] : null as any;
            this.respondentExternalId = _data["respondentExternalId"] !== undefined ? _data["respondentExternalId"] : null as any;
            (this as any).countOfItemsToProcess = _data["countOfItemsToProcess"] !== undefined ? _data["countOfItemsToProcess"] : null as any;
        }
    }

    static fromJS(data: any): CheckGuardChangeReassessmentModifiedServiceMessage {
        data = typeof data === 'object' ? data : {};
        let result = new CheckGuardChangeReassessmentModifiedServiceMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId !== undefined ? this.messageId : null as any;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : null as any;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null as any;
        data["serviceId"] = this.serviceId ? this.serviceId.toJSON() : null as any;
        data["oldServiceType"] = this.oldServiceType !== undefined ? this.oldServiceType : null as any;
        data["newServiceType"] = this.newServiceType !== undefined ? this.newServiceType : null as any;
        data["respondentExternalId"] = this.respondentExternalId !== undefined ? this.respondentExternalId : null as any;
        data["countOfItemsToProcess"] = this.countOfItemsToProcess !== undefined ? this.countOfItemsToProcess : null as any;
        return data;
    }
}

export interface ICheckGuardChangeReassessmentModifiedServiceMessage {
    messageId?: string;
    timestamp?: Date;
    siteId?: number;
    serviceId?: DatasetKey;
    oldServiceType?: GuardServiceType;
    newServiceType?: GuardServiceType;
    respondentExternalId?: number;
    countOfItemsToProcess?: number;
}

export class CheckGuardChangeReassessmentNewServiceMessage implements ICheckGuardChangeReassessmentNewServiceMessage {
    messageId?: string;
    timestamp?: Date;
    siteId?: number;
    serviceId?: DatasetKey;
    respondentExternalId?: number;
    readonly countOfItemsToProcess?: number;

    constructor(data?: ICheckGuardChangeReassessmentNewServiceMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"] !== undefined ? _data["messageId"] : null as any;
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : null as any;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null as any;
            this.serviceId = _data["serviceId"] ? DatasetKey.fromJS(_data["serviceId"]) : null as any;
            this.respondentExternalId = _data["respondentExternalId"] !== undefined ? _data["respondentExternalId"] : null as any;
            (this as any).countOfItemsToProcess = _data["countOfItemsToProcess"] !== undefined ? _data["countOfItemsToProcess"] : null as any;
        }
    }

    static fromJS(data: any): CheckGuardChangeReassessmentNewServiceMessage {
        data = typeof data === 'object' ? data : {};
        let result = new CheckGuardChangeReassessmentNewServiceMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId !== undefined ? this.messageId : null as any;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : null as any;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null as any;
        data["serviceId"] = this.serviceId ? this.serviceId.toJSON() : null as any;
        data["respondentExternalId"] = this.respondentExternalId !== undefined ? this.respondentExternalId : null as any;
        data["countOfItemsToProcess"] = this.countOfItemsToProcess !== undefined ? this.countOfItemsToProcess : null as any;
        return data;
    }
}

export interface ICheckGuardChangeReassessmentNewServiceMessage {
    messageId?: string;
    timestamp?: Date;
    siteId?: number;
    serviceId?: DatasetKey;
    respondentExternalId?: number;
    countOfItemsToProcess?: number;
}

export class CheckScoreReassessmentMessage implements ICheckScoreReassessmentMessage {
    messageId?: string;
    timestamp?: Date;
    siteIds?: number[] | null;
    oldReleaseYear?: number;
    oldReleaseQuarter?: number;
    newReleaseYear?: number;
    newReleaseQuarter?: number;
    respondentExternalId?: number;
    readonly countOfItemsToProcess?: number;

    constructor(data?: ICheckScoreReassessmentMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"] !== undefined ? _data["messageId"] : null as any;
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : null as any;
            if (Array.isArray(_data["siteIds"])) {
                this.siteIds = [] as any;
                for (let item of _data["siteIds"])
                    this.siteIds!.push(item);
            }
            else {
                this.siteIds = null as any;
            }
            this.oldReleaseYear = _data["oldReleaseYear"] !== undefined ? _data["oldReleaseYear"] : null as any;
            this.oldReleaseQuarter = _data["oldReleaseQuarter"] !== undefined ? _data["oldReleaseQuarter"] : null as any;
            this.newReleaseYear = _data["newReleaseYear"] !== undefined ? _data["newReleaseYear"] : null as any;
            this.newReleaseQuarter = _data["newReleaseQuarter"] !== undefined ? _data["newReleaseQuarter"] : null as any;
            this.respondentExternalId = _data["respondentExternalId"] !== undefined ? _data["respondentExternalId"] : null as any;
            (this as any).countOfItemsToProcess = _data["countOfItemsToProcess"] !== undefined ? _data["countOfItemsToProcess"] : null as any;
        }
    }

    static fromJS(data: any): CheckScoreReassessmentMessage {
        data = typeof data === 'object' ? data : {};
        let result = new CheckScoreReassessmentMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId !== undefined ? this.messageId : null as any;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : null as any;
        if (Array.isArray(this.siteIds)) {
            data["siteIds"] = [];
            for (let item of this.siteIds)
                data["siteIds"].push(item);
        }
        data["oldReleaseYear"] = this.oldReleaseYear !== undefined ? this.oldReleaseYear : null as any;
        data["oldReleaseQuarter"] = this.oldReleaseQuarter !== undefined ? this.oldReleaseQuarter : null as any;
        data["newReleaseYear"] = this.newReleaseYear !== undefined ? this.newReleaseYear : null as any;
        data["newReleaseQuarter"] = this.newReleaseQuarter !== undefined ? this.newReleaseQuarter : null as any;
        data["respondentExternalId"] = this.respondentExternalId !== undefined ? this.respondentExternalId : null as any;
        data["countOfItemsToProcess"] = this.countOfItemsToProcess !== undefined ? this.countOfItemsToProcess : null as any;
        return data;
    }
}

export interface ICheckScoreReassessmentMessage {
    messageId?: string;
    timestamp?: Date;
    siteIds?: number[] | null;
    oldReleaseYear?: number;
    oldReleaseQuarter?: number;
    newReleaseYear?: number;
    newReleaseQuarter?: number;
    respondentExternalId?: number;
    countOfItemsToProcess?: number;
}

export class Config implements IConfig {
    ownerID?: number | null;
    name!: string;
    value!: string;
    system!: boolean;
    enhancedLoginSecurity!: boolean;
    notes?: string | null;
    id?: number;

    constructor(data?: IConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.system = _data["system"] !== undefined ? _data["system"] : null as any;
            this.enhancedLoginSecurity = _data["enhancedLoginSecurity"] !== undefined ? _data["enhancedLoginSecurity"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): Config {
        data = typeof data === 'object' ? data : {};
        let result = new Config();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["system"] = this.system !== undefined ? this.system : null as any;
        data["enhancedLoginSecurity"] = this.enhancedLoginSecurity !== undefined ? this.enhancedLoginSecurity : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IConfig {
    ownerID?: number | null;
    name: string;
    value: string;
    system: boolean;
    enhancedLoginSecurity: boolean;
    notes?: string | null;
    id?: number;
}

export class ConfigOption implements IConfigOption {
    rowID?: number;
    configID?: number;
    reportID?: number;
    reportName?: string | null;
    reportTypeID?: number;
    reportTypeName?: string | null;
    reportTypeCode?: string | null;
    reportConfigOptionID?: number;
    reportConfigOptionName?: string | null;
    reportConfigOptionDescription?: string | null;
    reportConfigOptionDefault?: string | null;
    datatypeID?: number;
    datatypeName?: string | null;
    value?: string | null;
    seq?: number;

    constructor(data?: IConfigOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowID = _data["rowID"] !== undefined ? _data["rowID"] : null as any;
            this.configID = _data["configID"] !== undefined ? _data["configID"] : null as any;
            this.reportID = _data["reportID"] !== undefined ? _data["reportID"] : null as any;
            this.reportName = _data["reportName"] !== undefined ? _data["reportName"] : null as any;
            this.reportTypeID = _data["reportTypeID"] !== undefined ? _data["reportTypeID"] : null as any;
            this.reportTypeName = _data["reportTypeName"] !== undefined ? _data["reportTypeName"] : null as any;
            this.reportTypeCode = _data["reportTypeCode"] !== undefined ? _data["reportTypeCode"] : null as any;
            this.reportConfigOptionID = _data["reportConfigOptionID"] !== undefined ? _data["reportConfigOptionID"] : null as any;
            this.reportConfigOptionName = _data["reportConfigOptionName"] !== undefined ? _data["reportConfigOptionName"] : null as any;
            this.reportConfigOptionDescription = _data["reportConfigOptionDescription"] !== undefined ? _data["reportConfigOptionDescription"] : null as any;
            this.reportConfigOptionDefault = _data["reportConfigOptionDefault"] !== undefined ? _data["reportConfigOptionDefault"] : null as any;
            this.datatypeID = _data["datatypeID"] !== undefined ? _data["datatypeID"] : null as any;
            this.datatypeName = _data["datatypeName"] !== undefined ? _data["datatypeName"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.seq = _data["seq"] !== undefined ? _data["seq"] : null as any;
        }
    }

    static fromJS(data: any): ConfigOption {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowID"] = this.rowID !== undefined ? this.rowID : null as any;
        data["configID"] = this.configID !== undefined ? this.configID : null as any;
        data["reportID"] = this.reportID !== undefined ? this.reportID : null as any;
        data["reportName"] = this.reportName !== undefined ? this.reportName : null as any;
        data["reportTypeID"] = this.reportTypeID !== undefined ? this.reportTypeID : null as any;
        data["reportTypeName"] = this.reportTypeName !== undefined ? this.reportTypeName : null as any;
        data["reportTypeCode"] = this.reportTypeCode !== undefined ? this.reportTypeCode : null as any;
        data["reportConfigOptionID"] = this.reportConfigOptionID !== undefined ? this.reportConfigOptionID : null as any;
        data["reportConfigOptionName"] = this.reportConfigOptionName !== undefined ? this.reportConfigOptionName : null as any;
        data["reportConfigOptionDescription"] = this.reportConfigOptionDescription !== undefined ? this.reportConfigOptionDescription : null as any;
        data["reportConfigOptionDefault"] = this.reportConfigOptionDefault !== undefined ? this.reportConfigOptionDefault : null as any;
        data["datatypeID"] = this.datatypeID !== undefined ? this.datatypeID : null as any;
        data["datatypeName"] = this.datatypeName !== undefined ? this.datatypeName : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["seq"] = this.seq !== undefined ? this.seq : null as any;
        return data;
    }
}

export interface IConfigOption {
    rowID?: number;
    configID?: number;
    reportID?: number;
    reportName?: string | null;
    reportTypeID?: number;
    reportTypeName?: string | null;
    reportTypeCode?: string | null;
    reportConfigOptionID?: number;
    reportConfigOptionName?: string | null;
    reportConfigOptionDescription?: string | null;
    reportConfigOptionDefault?: string | null;
    datatypeID?: number;
    datatypeName?: string | null;
    value?: string | null;
    seq?: number;
}

export class ConfigOptionDefault implements IConfigOptionDefault {
    name?: string | null;
    datatypeName?: string | null;
    default?: string | null;

    constructor(data?: IConfigOptionDefault) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.datatypeName = _data["datatypeName"] !== undefined ? _data["datatypeName"] : null as any;
            this.default = _data["default"] !== undefined ? _data["default"] : null as any;
        }
    }

    static fromJS(data: any): ConfigOptionDefault {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigOptionDefault();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["datatypeName"] = this.datatypeName !== undefined ? this.datatypeName : null as any;
        data["default"] = this.default !== undefined ? this.default : null as any;
        return data;
    }
}

export interface IConfigOptionDefault {
    name?: string | null;
    datatypeName?: string | null;
    default?: string | null;
}

export class CreateAtmMonthlyDto implements ICreateAtmMonthlyDto {
    terminalId?: string | null;
    name?: string | null;
    atmEbk?: string | null;
    atmFunction?: string | null;
    atmOwner?: string | null;
    manufacturer?: string | null;
    atmModel?: string | null;
    onPremiseFlag?: boolean | null;
    assignedBranch?: number | null;
    siteAccess?: string | null;
    locationInformation?: string | null;
    locationType?: string | null;
    locationSubType?: string | null;
    address?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    county?: string | null;
    region?: string | null;
    retailMarket?: string | null;
    district?: string | null;
    lat?: number | null;
    long?: number | null;
    cbsaName?: string | null;
    fips?: number | null;
    countyFips?: number | null;
    stcnty?: number | null;
    locationId?: number | null;
    siteId?: number | null;
    retailerStoreNumber?: number | null;
    additionalInformation?: number | null;
    assetId?: number | null;
    serialNumber?: string | null;
    installDate?: string | null;
    voice?: string | null;
    languages?: string | null;
    cashVendor?: string | null;
    cbsaCd?: number | null;
    ipAddress?: number | null;
    mask?: number | null;
    defaultGateway?: number | null;
    groupId?: string | null;
    communicationType?: string | null;
    gredlId?: number | null;
    asof?: string | null;

    constructor(data?: ICreateAtmMonthlyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.terminalId = _data["terminalId"] !== undefined ? _data["terminalId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.atmEbk = _data["atmEbk"] !== undefined ? _data["atmEbk"] : null as any;
            this.atmFunction = _data["atmFunction"] !== undefined ? _data["atmFunction"] : null as any;
            this.atmOwner = _data["atmOwner"] !== undefined ? _data["atmOwner"] : null as any;
            this.manufacturer = _data["manufacturer"] !== undefined ? _data["manufacturer"] : null as any;
            this.atmModel = _data["atmModel"] !== undefined ? _data["atmModel"] : null as any;
            this.onPremiseFlag = _data["onPremiseFlag"] !== undefined ? _data["onPremiseFlag"] : null as any;
            this.assignedBranch = _data["assignedBranch"] !== undefined ? _data["assignedBranch"] : null as any;
            this.siteAccess = _data["siteAccess"] !== undefined ? _data["siteAccess"] : null as any;
            this.locationInformation = _data["locationInformation"] !== undefined ? _data["locationInformation"] : null as any;
            this.locationType = _data["locationType"] !== undefined ? _data["locationType"] : null as any;
            this.locationSubType = _data["locationSubType"] !== undefined ? _data["locationSubType"] : null as any;
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.county = _data["county"] !== undefined ? _data["county"] : null as any;
            this.region = _data["region"] !== undefined ? _data["region"] : null as any;
            this.retailMarket = _data["retailMarket"] !== undefined ? _data["retailMarket"] : null as any;
            this.district = _data["district"] !== undefined ? _data["district"] : null as any;
            this.lat = _data["lat"] !== undefined ? _data["lat"] : null as any;
            this.long = _data["long"] !== undefined ? _data["long"] : null as any;
            this.cbsaName = _data["cbsaName"] !== undefined ? _data["cbsaName"] : null as any;
            this.fips = _data["fips"] !== undefined ? _data["fips"] : null as any;
            this.countyFips = _data["countyFips"] !== undefined ? _data["countyFips"] : null as any;
            this.stcnty = _data["stcnty"] !== undefined ? _data["stcnty"] : null as any;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null as any;
            this.retailerStoreNumber = _data["retailerStoreNumber"] !== undefined ? _data["retailerStoreNumber"] : null as any;
            this.additionalInformation = _data["additionalInformation"] !== undefined ? _data["additionalInformation"] : null as any;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : null as any;
            this.serialNumber = _data["serialNumber"] !== undefined ? _data["serialNumber"] : null as any;
            this.installDate = _data["installDate"] !== undefined ? _data["installDate"] : null as any;
            this.voice = _data["voice"] !== undefined ? _data["voice"] : null as any;
            this.languages = _data["languages"] !== undefined ? _data["languages"] : null as any;
            this.cashVendor = _data["cashVendor"] !== undefined ? _data["cashVendor"] : null as any;
            this.cbsaCd = _data["cbsaCd"] !== undefined ? _data["cbsaCd"] : null as any;
            this.ipAddress = _data["ipAddress"] !== undefined ? _data["ipAddress"] : null as any;
            this.mask = _data["mask"] !== undefined ? _data["mask"] : null as any;
            this.defaultGateway = _data["defaultGateway"] !== undefined ? _data["defaultGateway"] : null as any;
            this.groupId = _data["groupId"] !== undefined ? _data["groupId"] : null as any;
            this.communicationType = _data["communicationType"] !== undefined ? _data["communicationType"] : null as any;
            this.gredlId = _data["gredlId"] !== undefined ? _data["gredlId"] : null as any;
            this.asof = _data["asof"] !== undefined ? _data["asof"] : null as any;
        }
    }

    static fromJS(data: any): CreateAtmMonthlyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAtmMonthlyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["terminalId"] = this.terminalId !== undefined ? this.terminalId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["atmEbk"] = this.atmEbk !== undefined ? this.atmEbk : null as any;
        data["atmFunction"] = this.atmFunction !== undefined ? this.atmFunction : null as any;
        data["atmOwner"] = this.atmOwner !== undefined ? this.atmOwner : null as any;
        data["manufacturer"] = this.manufacturer !== undefined ? this.manufacturer : null as any;
        data["atmModel"] = this.atmModel !== undefined ? this.atmModel : null as any;
        data["onPremiseFlag"] = this.onPremiseFlag !== undefined ? this.onPremiseFlag : null as any;
        data["assignedBranch"] = this.assignedBranch !== undefined ? this.assignedBranch : null as any;
        data["siteAccess"] = this.siteAccess !== undefined ? this.siteAccess : null as any;
        data["locationInformation"] = this.locationInformation !== undefined ? this.locationInformation : null as any;
        data["locationType"] = this.locationType !== undefined ? this.locationType : null as any;
        data["locationSubType"] = this.locationSubType !== undefined ? this.locationSubType : null as any;
        data["address"] = this.address !== undefined ? this.address : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["county"] = this.county !== undefined ? this.county : null as any;
        data["region"] = this.region !== undefined ? this.region : null as any;
        data["retailMarket"] = this.retailMarket !== undefined ? this.retailMarket : null as any;
        data["district"] = this.district !== undefined ? this.district : null as any;
        data["lat"] = this.lat !== undefined ? this.lat : null as any;
        data["long"] = this.long !== undefined ? this.long : null as any;
        data["cbsaName"] = this.cbsaName !== undefined ? this.cbsaName : null as any;
        data["fips"] = this.fips !== undefined ? this.fips : null as any;
        data["countyFips"] = this.countyFips !== undefined ? this.countyFips : null as any;
        data["stcnty"] = this.stcnty !== undefined ? this.stcnty : null as any;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null as any;
        data["retailerStoreNumber"] = this.retailerStoreNumber !== undefined ? this.retailerStoreNumber : null as any;
        data["additionalInformation"] = this.additionalInformation !== undefined ? this.additionalInformation : null as any;
        data["assetId"] = this.assetId !== undefined ? this.assetId : null as any;
        data["serialNumber"] = this.serialNumber !== undefined ? this.serialNumber : null as any;
        data["installDate"] = this.installDate !== undefined ? this.installDate : null as any;
        data["voice"] = this.voice !== undefined ? this.voice : null as any;
        data["languages"] = this.languages !== undefined ? this.languages : null as any;
        data["cashVendor"] = this.cashVendor !== undefined ? this.cashVendor : null as any;
        data["cbsaCd"] = this.cbsaCd !== undefined ? this.cbsaCd : null as any;
        data["ipAddress"] = this.ipAddress !== undefined ? this.ipAddress : null as any;
        data["mask"] = this.mask !== undefined ? this.mask : null as any;
        data["defaultGateway"] = this.defaultGateway !== undefined ? this.defaultGateway : null as any;
        data["groupId"] = this.groupId !== undefined ? this.groupId : null as any;
        data["communicationType"] = this.communicationType !== undefined ? this.communicationType : null as any;
        data["gredlId"] = this.gredlId !== undefined ? this.gredlId : null as any;
        data["asof"] = this.asof !== undefined ? this.asof : null as any;
        return data;
    }
}

export interface ICreateAtmMonthlyDto {
    terminalId?: string | null;
    name?: string | null;
    atmEbk?: string | null;
    atmFunction?: string | null;
    atmOwner?: string | null;
    manufacturer?: string | null;
    atmModel?: string | null;
    onPremiseFlag?: boolean | null;
    assignedBranch?: number | null;
    siteAccess?: string | null;
    locationInformation?: string | null;
    locationType?: string | null;
    locationSubType?: string | null;
    address?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    county?: string | null;
    region?: string | null;
    retailMarket?: string | null;
    district?: string | null;
    lat?: number | null;
    long?: number | null;
    cbsaName?: string | null;
    fips?: number | null;
    countyFips?: number | null;
    stcnty?: number | null;
    locationId?: number | null;
    siteId?: number | null;
    retailerStoreNumber?: number | null;
    additionalInformation?: number | null;
    assetId?: number | null;
    serialNumber?: string | null;
    installDate?: string | null;
    voice?: string | null;
    languages?: string | null;
    cashVendor?: string | null;
    cbsaCd?: number | null;
    ipAddress?: number | null;
    mask?: number | null;
    defaultGateway?: number | null;
    groupId?: string | null;
    communicationType?: string | null;
    gredlId?: number | null;
    asof?: string | null;
}

export class CreateGuardRequestMessage implements ICreateGuardRequestMessage {
    messageId?: string;
    timestamp?: Date;
    respondentExternalId?: number;
    requestReason?: string | null;
    buid?: string | null;
    incidentNumber?: string | null;
    incidentSubType?: string | null;
    incidentCategory?: string | null;
    incidentSubCategory?: string | null;
    incidentDate?: Date | null;
    incidentTime?: string | null;
    tmi?: string | null;
    tmI_SID?: string | null;
    tmI_FirstName?: string | null;
    tmI_LastName?: string | null;
    withdrawalAmount?: number | null;
    emergencyServicesRequested?: string | null;
    startDate?: Date;
    endDate?: Date;
    assignmentType?: GuardServiceType;
    assignmentDescription?: string | null;
    assignmentComment?: string | null;
    servicePosts?: ServicePost[] | null;
    supplierName?: string | null;
    serviceTypeExceptionComment?: string | null;
    durationExceptionComment?: string | null;
    approvalExceptionComment?: string | null;
    bulkRequestID?: DatasetKey;
    incompleteMobilePreference?: IncompleteMobilePreference;
    fromTVRAID?: DatasetKey;
    readonly countOfItemsToProcess?: number;

    constructor(data?: ICreateGuardRequestMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"] !== undefined ? _data["messageId"] : null as any;
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : null as any;
            this.respondentExternalId = _data["respondentExternalId"] !== undefined ? _data["respondentExternalId"] : null as any;
            this.requestReason = _data["requestReason"] !== undefined ? _data["requestReason"] : null as any;
            this.buid = _data["buid"] !== undefined ? _data["buid"] : null as any;
            this.incidentNumber = _data["incidentNumber"] !== undefined ? _data["incidentNumber"] : null as any;
            this.incidentSubType = _data["incidentSubType"] !== undefined ? _data["incidentSubType"] : null as any;
            this.incidentCategory = _data["incidentCategory"] !== undefined ? _data["incidentCategory"] : null as any;
            this.incidentSubCategory = _data["incidentSubCategory"] !== undefined ? _data["incidentSubCategory"] : null as any;
            this.incidentDate = _data["incidentDate"] ? new Date(_data["incidentDate"].toString()) : null as any;
            this.incidentTime = _data["incidentTime"] !== undefined ? _data["incidentTime"] : null as any;
            this.tmi = _data["tmi"] !== undefined ? _data["tmi"] : null as any;
            this.tmI_SID = _data["tmI_SID"] !== undefined ? _data["tmI_SID"] : null as any;
            this.tmI_FirstName = _data["tmI_FirstName"] !== undefined ? _data["tmI_FirstName"] : null as any;
            this.tmI_LastName = _data["tmI_LastName"] !== undefined ? _data["tmI_LastName"] : null as any;
            this.withdrawalAmount = _data["withdrawalAmount"] !== undefined ? _data["withdrawalAmount"] : null as any;
            this.emergencyServicesRequested = _data["emergencyServicesRequested"] !== undefined ? _data["emergencyServicesRequested"] : null as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            this.assignmentType = _data["assignmentType"] !== undefined ? _data["assignmentType"] : null as any;
            this.assignmentDescription = _data["assignmentDescription"] !== undefined ? _data["assignmentDescription"] : null as any;
            this.assignmentComment = _data["assignmentComment"] !== undefined ? _data["assignmentComment"] : null as any;
            if (Array.isArray(_data["servicePosts"])) {
                this.servicePosts = [] as any;
                for (let item of _data["servicePosts"])
                    this.servicePosts!.push(ServicePost.fromJS(item));
            }
            else {
                this.servicePosts = null as any;
            }
            this.supplierName = _data["supplierName"] !== undefined ? _data["supplierName"] : null as any;
            this.serviceTypeExceptionComment = _data["serviceTypeExceptionComment"] !== undefined ? _data["serviceTypeExceptionComment"] : null as any;
            this.durationExceptionComment = _data["durationExceptionComment"] !== undefined ? _data["durationExceptionComment"] : null as any;
            this.approvalExceptionComment = _data["approvalExceptionComment"] !== undefined ? _data["approvalExceptionComment"] : null as any;
            this.bulkRequestID = _data["bulkRequestID"] ? DatasetKey.fromJS(_data["bulkRequestID"]) : null as any;
            this.incompleteMobilePreference = _data["incompleteMobilePreference"] !== undefined ? _data["incompleteMobilePreference"] : null as any;
            this.fromTVRAID = _data["fromTVRAID"] ? DatasetKey.fromJS(_data["fromTVRAID"]) : null as any;
            (this as any).countOfItemsToProcess = _data["countOfItemsToProcess"] !== undefined ? _data["countOfItemsToProcess"] : null as any;
        }
    }

    static fromJS(data: any): CreateGuardRequestMessage {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGuardRequestMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId !== undefined ? this.messageId : null as any;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : null as any;
        data["respondentExternalId"] = this.respondentExternalId !== undefined ? this.respondentExternalId : null as any;
        data["requestReason"] = this.requestReason !== undefined ? this.requestReason : null as any;
        data["buid"] = this.buid !== undefined ? this.buid : null as any;
        data["incidentNumber"] = this.incidentNumber !== undefined ? this.incidentNumber : null as any;
        data["incidentSubType"] = this.incidentSubType !== undefined ? this.incidentSubType : null as any;
        data["incidentCategory"] = this.incidentCategory !== undefined ? this.incidentCategory : null as any;
        data["incidentSubCategory"] = this.incidentSubCategory !== undefined ? this.incidentSubCategory : null as any;
        data["incidentDate"] = this.incidentDate ? this.incidentDate.toISOString() : null as any;
        data["incidentTime"] = this.incidentTime !== undefined ? this.incidentTime : null as any;
        data["tmi"] = this.tmi !== undefined ? this.tmi : null as any;
        data["tmI_SID"] = this.tmI_SID !== undefined ? this.tmI_SID : null as any;
        data["tmI_FirstName"] = this.tmI_FirstName !== undefined ? this.tmI_FirstName : null as any;
        data["tmI_LastName"] = this.tmI_LastName !== undefined ? this.tmI_LastName : null as any;
        data["withdrawalAmount"] = this.withdrawalAmount !== undefined ? this.withdrawalAmount : null as any;
        data["emergencyServicesRequested"] = this.emergencyServicesRequested !== undefined ? this.emergencyServicesRequested : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["assignmentType"] = this.assignmentType !== undefined ? this.assignmentType : null as any;
        data["assignmentDescription"] = this.assignmentDescription !== undefined ? this.assignmentDescription : null as any;
        data["assignmentComment"] = this.assignmentComment !== undefined ? this.assignmentComment : null as any;
        if (Array.isArray(this.servicePosts)) {
            data["servicePosts"] = [];
            for (let item of this.servicePosts)
                data["servicePosts"].push(item ? item.toJSON() : null as any);
        }
        data["supplierName"] = this.supplierName !== undefined ? this.supplierName : null as any;
        data["serviceTypeExceptionComment"] = this.serviceTypeExceptionComment !== undefined ? this.serviceTypeExceptionComment : null as any;
        data["durationExceptionComment"] = this.durationExceptionComment !== undefined ? this.durationExceptionComment : null as any;
        data["approvalExceptionComment"] = this.approvalExceptionComment !== undefined ? this.approvalExceptionComment : null as any;
        data["bulkRequestID"] = this.bulkRequestID ? this.bulkRequestID.toJSON() : null as any;
        data["incompleteMobilePreference"] = this.incompleteMobilePreference !== undefined ? this.incompleteMobilePreference : null as any;
        data["fromTVRAID"] = this.fromTVRAID ? this.fromTVRAID.toJSON() : null as any;
        data["countOfItemsToProcess"] = this.countOfItemsToProcess !== undefined ? this.countOfItemsToProcess : null as any;
        return data;
    }
}

export interface ICreateGuardRequestMessage {
    messageId?: string;
    timestamp?: Date;
    respondentExternalId?: number;
    requestReason?: string | null;
    buid?: string | null;
    incidentNumber?: string | null;
    incidentSubType?: string | null;
    incidentCategory?: string | null;
    incidentSubCategory?: string | null;
    incidentDate?: Date | null;
    incidentTime?: string | null;
    tmi?: string | null;
    tmI_SID?: string | null;
    tmI_FirstName?: string | null;
    tmI_LastName?: string | null;
    withdrawalAmount?: number | null;
    emergencyServicesRequested?: string | null;
    startDate?: Date;
    endDate?: Date;
    assignmentType?: GuardServiceType;
    assignmentDescription?: string | null;
    assignmentComment?: string | null;
    servicePosts?: ServicePost[] | null;
    supplierName?: string | null;
    serviceTypeExceptionComment?: string | null;
    durationExceptionComment?: string | null;
    approvalExceptionComment?: string | null;
    bulkRequestID?: DatasetKey;
    incompleteMobilePreference?: IncompleteMobilePreference;
    fromTVRAID?: DatasetKey;
    countOfItemsToProcess?: number;
}

export class CreateInvoiceDto implements ICreateInvoiceDto {
    invoiceNumber?: string | null;
    invoiceDate?: Date;
    masterAgreementId?: string | null;
    purpose?: string | null;
    originalInvoiceNumber?: string | null;
    taxInLine?: string | null;
    shippingInLine?: string | null;
    supplierRemitAddressId?: string | null;
    supplierRemitName?: string | null;
    supplierId?: string | null;
    shipToAddressId?: string | null;
    shipToName?: string | null;
    shipToStreet?: string | null;
    shipToCity?: string | null;
    shipToState?: string | null;
    shipToPostalCode?: string | null;
    shipToCountry?: string | null;
    payInNumberOfDays?: number | null;
    percent?: number | null;
    discount?: number | null;
    billingStartDate?: Date | null;
    billingEndDate?: Date | null;
    workOrderNumber?: string | null;
    employeeId?: string | null;
    currency?: string | null;
    invoiceLineId?: string | null;
    orderLineId?: string | null;
    supplierPartNumber?: string | null;
    quantity?: number | null;
    unitOfMeasure?: string | null;
    unitPrice?: number | null;
    lineItemDescription?: string | null;
    lineTaxAmount?: number | null;
    lineTaxCategory?: string | null;
    lineShippingAmount?: number | null;
    businessUnit?: string | null;
    famisNumber?: string | null;
    summaryTaxAmount?: number | null;
    summaryTaxCategory?: string | null;
    summaryShippingAmount?: number | null;
    summaryGrossAmount?: number | null;
    summaryNetAmount?: number | null;
    summaryDueAmount?: number | null;

    constructor(data?: ICreateInvoiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceNumber = _data["invoiceNumber"] !== undefined ? _data["invoiceNumber"] : null as any;
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : null as any;
            this.masterAgreementId = _data["masterAgreementId"] !== undefined ? _data["masterAgreementId"] : null as any;
            this.purpose = _data["purpose"] !== undefined ? _data["purpose"] : null as any;
            this.originalInvoiceNumber = _data["originalInvoiceNumber"] !== undefined ? _data["originalInvoiceNumber"] : null as any;
            this.taxInLine = _data["taxInLine"] !== undefined ? _data["taxInLine"] : null as any;
            this.shippingInLine = _data["shippingInLine"] !== undefined ? _data["shippingInLine"] : null as any;
            this.supplierRemitAddressId = _data["supplierRemitAddressId"] !== undefined ? _data["supplierRemitAddressId"] : null as any;
            this.supplierRemitName = _data["supplierRemitName"] !== undefined ? _data["supplierRemitName"] : null as any;
            this.supplierId = _data["supplierId"] !== undefined ? _data["supplierId"] : null as any;
            this.shipToAddressId = _data["shipToAddressId"] !== undefined ? _data["shipToAddressId"] : null as any;
            this.shipToName = _data["shipToName"] !== undefined ? _data["shipToName"] : null as any;
            this.shipToStreet = _data["shipToStreet"] !== undefined ? _data["shipToStreet"] : null as any;
            this.shipToCity = _data["shipToCity"] !== undefined ? _data["shipToCity"] : null as any;
            this.shipToState = _data["shipToState"] !== undefined ? _data["shipToState"] : null as any;
            this.shipToPostalCode = _data["shipToPostalCode"] !== undefined ? _data["shipToPostalCode"] : null as any;
            this.shipToCountry = _data["shipToCountry"] !== undefined ? _data["shipToCountry"] : null as any;
            this.payInNumberOfDays = _data["payInNumberOfDays"] !== undefined ? _data["payInNumberOfDays"] : null as any;
            this.percent = _data["percent"] !== undefined ? _data["percent"] : null as any;
            this.discount = _data["discount"] !== undefined ? _data["discount"] : null as any;
            this.billingStartDate = _data["billingStartDate"] ? new Date(_data["billingStartDate"].toString()) : null as any;
            this.billingEndDate = _data["billingEndDate"] ? new Date(_data["billingEndDate"].toString()) : null as any;
            this.workOrderNumber = _data["workOrderNumber"] !== undefined ? _data["workOrderNumber"] : null as any;
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
            this.invoiceLineId = _data["invoiceLineId"] !== undefined ? _data["invoiceLineId"] : null as any;
            this.orderLineId = _data["orderLineId"] !== undefined ? _data["orderLineId"] : null as any;
            this.supplierPartNumber = _data["supplierPartNumber"] !== undefined ? _data["supplierPartNumber"] : null as any;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
            this.unitOfMeasure = _data["unitOfMeasure"] !== undefined ? _data["unitOfMeasure"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.lineItemDescription = _data["lineItemDescription"] !== undefined ? _data["lineItemDescription"] : null as any;
            this.lineTaxAmount = _data["lineTaxAmount"] !== undefined ? _data["lineTaxAmount"] : null as any;
            this.lineTaxCategory = _data["lineTaxCategory"] !== undefined ? _data["lineTaxCategory"] : null as any;
            this.lineShippingAmount = _data["lineShippingAmount"] !== undefined ? _data["lineShippingAmount"] : null as any;
            this.businessUnit = _data["businessUnit"] !== undefined ? _data["businessUnit"] : null as any;
            this.famisNumber = _data["famisNumber"] !== undefined ? _data["famisNumber"] : null as any;
            this.summaryTaxAmount = _data["summaryTaxAmount"] !== undefined ? _data["summaryTaxAmount"] : null as any;
            this.summaryTaxCategory = _data["summaryTaxCategory"] !== undefined ? _data["summaryTaxCategory"] : null as any;
            this.summaryShippingAmount = _data["summaryShippingAmount"] !== undefined ? _data["summaryShippingAmount"] : null as any;
            this.summaryGrossAmount = _data["summaryGrossAmount"] !== undefined ? _data["summaryGrossAmount"] : null as any;
            this.summaryNetAmount = _data["summaryNetAmount"] !== undefined ? _data["summaryNetAmount"] : null as any;
            this.summaryDueAmount = _data["summaryDueAmount"] !== undefined ? _data["summaryDueAmount"] : null as any;
        }
    }

    static fromJS(data: any): CreateInvoiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateInvoiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceNumber"] = this.invoiceNumber !== undefined ? this.invoiceNumber : null as any;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : null as any;
        data["masterAgreementId"] = this.masterAgreementId !== undefined ? this.masterAgreementId : null as any;
        data["purpose"] = this.purpose !== undefined ? this.purpose : null as any;
        data["originalInvoiceNumber"] = this.originalInvoiceNumber !== undefined ? this.originalInvoiceNumber : null as any;
        data["taxInLine"] = this.taxInLine !== undefined ? this.taxInLine : null as any;
        data["shippingInLine"] = this.shippingInLine !== undefined ? this.shippingInLine : null as any;
        data["supplierRemitAddressId"] = this.supplierRemitAddressId !== undefined ? this.supplierRemitAddressId : null as any;
        data["supplierRemitName"] = this.supplierRemitName !== undefined ? this.supplierRemitName : null as any;
        data["supplierId"] = this.supplierId !== undefined ? this.supplierId : null as any;
        data["shipToAddressId"] = this.shipToAddressId !== undefined ? this.shipToAddressId : null as any;
        data["shipToName"] = this.shipToName !== undefined ? this.shipToName : null as any;
        data["shipToStreet"] = this.shipToStreet !== undefined ? this.shipToStreet : null as any;
        data["shipToCity"] = this.shipToCity !== undefined ? this.shipToCity : null as any;
        data["shipToState"] = this.shipToState !== undefined ? this.shipToState : null as any;
        data["shipToPostalCode"] = this.shipToPostalCode !== undefined ? this.shipToPostalCode : null as any;
        data["shipToCountry"] = this.shipToCountry !== undefined ? this.shipToCountry : null as any;
        data["payInNumberOfDays"] = this.payInNumberOfDays !== undefined ? this.payInNumberOfDays : null as any;
        data["percent"] = this.percent !== undefined ? this.percent : null as any;
        data["discount"] = this.discount !== undefined ? this.discount : null as any;
        data["billingStartDate"] = this.billingStartDate ? this.billingStartDate.toISOString() : null as any;
        data["billingEndDate"] = this.billingEndDate ? this.billingEndDate.toISOString() : null as any;
        data["workOrderNumber"] = this.workOrderNumber !== undefined ? this.workOrderNumber : null as any;
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        data["invoiceLineId"] = this.invoiceLineId !== undefined ? this.invoiceLineId : null as any;
        data["orderLineId"] = this.orderLineId !== undefined ? this.orderLineId : null as any;
        data["supplierPartNumber"] = this.supplierPartNumber !== undefined ? this.supplierPartNumber : null as any;
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["unitOfMeasure"] = this.unitOfMeasure !== undefined ? this.unitOfMeasure : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["lineItemDescription"] = this.lineItemDescription !== undefined ? this.lineItemDescription : null as any;
        data["lineTaxAmount"] = this.lineTaxAmount !== undefined ? this.lineTaxAmount : null as any;
        data["lineTaxCategory"] = this.lineTaxCategory !== undefined ? this.lineTaxCategory : null as any;
        data["lineShippingAmount"] = this.lineShippingAmount !== undefined ? this.lineShippingAmount : null as any;
        data["businessUnit"] = this.businessUnit !== undefined ? this.businessUnit : null as any;
        data["famisNumber"] = this.famisNumber !== undefined ? this.famisNumber : null as any;
        data["summaryTaxAmount"] = this.summaryTaxAmount !== undefined ? this.summaryTaxAmount : null as any;
        data["summaryTaxCategory"] = this.summaryTaxCategory !== undefined ? this.summaryTaxCategory : null as any;
        data["summaryShippingAmount"] = this.summaryShippingAmount !== undefined ? this.summaryShippingAmount : null as any;
        data["summaryGrossAmount"] = this.summaryGrossAmount !== undefined ? this.summaryGrossAmount : null as any;
        data["summaryNetAmount"] = this.summaryNetAmount !== undefined ? this.summaryNetAmount : null as any;
        data["summaryDueAmount"] = this.summaryDueAmount !== undefined ? this.summaryDueAmount : null as any;
        return data;
    }
}

export interface ICreateInvoiceDto {
    invoiceNumber?: string | null;
    invoiceDate?: Date;
    masterAgreementId?: string | null;
    purpose?: string | null;
    originalInvoiceNumber?: string | null;
    taxInLine?: string | null;
    shippingInLine?: string | null;
    supplierRemitAddressId?: string | null;
    supplierRemitName?: string | null;
    supplierId?: string | null;
    shipToAddressId?: string | null;
    shipToName?: string | null;
    shipToStreet?: string | null;
    shipToCity?: string | null;
    shipToState?: string | null;
    shipToPostalCode?: string | null;
    shipToCountry?: string | null;
    payInNumberOfDays?: number | null;
    percent?: number | null;
    discount?: number | null;
    billingStartDate?: Date | null;
    billingEndDate?: Date | null;
    workOrderNumber?: string | null;
    employeeId?: string | null;
    currency?: string | null;
    invoiceLineId?: string | null;
    orderLineId?: string | null;
    supplierPartNumber?: string | null;
    quantity?: number | null;
    unitOfMeasure?: string | null;
    unitPrice?: number | null;
    lineItemDescription?: string | null;
    lineTaxAmount?: number | null;
    lineTaxCategory?: string | null;
    lineShippingAmount?: number | null;
    businessUnit?: string | null;
    famisNumber?: string | null;
    summaryTaxAmount?: number | null;
    summaryTaxCategory?: string | null;
    summaryShippingAmount?: number | null;
    summaryGrossAmount?: number | null;
    summaryNetAmount?: number | null;
    summaryDueAmount?: number | null;
}

export class CreateLocationDto implements ICreateLocationDto {
    action?: string | null;
    address?: string | null;
    bank?: number | null;
    bldgId?: number | null;
    branchName?: string | null;
    cc?: string | null;
    city?: string | null;
    closingDate?: Date | null;
    county?: string | null;
    division?: string | null;
    dndNumber?: number | null;
    estDate?: string | null;
    internalZip?: string | null;
    lat?: number | null;
    long?: number | null;
    name?: string | null;
    propertyId?: number | null;
    receiverAddress?: string | null;
    receiverCity?: string | null;
    receiverDndNumber?: number | null;
    receiverName?: string | null;
    receiverPropertyId?: number | null;
    region?: string | null;
    retailMarket?: string | null;
    service?: string | null;
    state?: string | null;
    subType?: string | null;
    type?: string | null;
    zip?: string | null;
    phone?: string | null;
    nightDrop?: boolean | null;
    sundayLobby?: string | null;
    mondayLobby?: string | null;
    tuesdayLobby?: string | null;
    wednesdayLobby?: string | null;
    thursdayLobby?: string | null;
    fridayLobby?: string | null;
    saturdayLobby?: string | null;

    constructor(data?: ICreateLocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"] !== undefined ? _data["action"] : null as any;
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
            this.bank = _data["bank"] !== undefined ? _data["bank"] : null as any;
            this.bldgId = _data["bldgId"] !== undefined ? _data["bldgId"] : null as any;
            this.branchName = _data["branchName"] !== undefined ? _data["branchName"] : null as any;
            this.cc = _data["cc"] !== undefined ? _data["cc"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.closingDate = _data["closingDate"] ? new Date(_data["closingDate"].toString()) : null as any;
            this.county = _data["county"] !== undefined ? _data["county"] : null as any;
            this.division = _data["division"] !== undefined ? _data["division"] : null as any;
            this.dndNumber = _data["dndNumber"] !== undefined ? _data["dndNumber"] : null as any;
            this.estDate = _data["estDate"] !== undefined ? _data["estDate"] : null as any;
            this.internalZip = _data["internalZip"] !== undefined ? _data["internalZip"] : null as any;
            this.lat = _data["lat"] !== undefined ? _data["lat"] : null as any;
            this.long = _data["long"] !== undefined ? _data["long"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.propertyId = _data["propertyId"] !== undefined ? _data["propertyId"] : null as any;
            this.receiverAddress = _data["receiverAddress"] !== undefined ? _data["receiverAddress"] : null as any;
            this.receiverCity = _data["receiverCity"] !== undefined ? _data["receiverCity"] : null as any;
            this.receiverDndNumber = _data["receiverDndNumber"] !== undefined ? _data["receiverDndNumber"] : null as any;
            this.receiverName = _data["receiverName"] !== undefined ? _data["receiverName"] : null as any;
            this.receiverPropertyId = _data["receiverPropertyId"] !== undefined ? _data["receiverPropertyId"] : null as any;
            this.region = _data["region"] !== undefined ? _data["region"] : null as any;
            this.retailMarket = _data["retailMarket"] !== undefined ? _data["retailMarket"] : null as any;
            this.service = _data["service"] !== undefined ? _data["service"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.subType = _data["subType"] !== undefined ? _data["subType"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.nightDrop = _data["nightDrop"] !== undefined ? _data["nightDrop"] : null as any;
            this.sundayLobby = _data["sundayLobby"] !== undefined ? _data["sundayLobby"] : null as any;
            this.mondayLobby = _data["mondayLobby"] !== undefined ? _data["mondayLobby"] : null as any;
            this.tuesdayLobby = _data["tuesdayLobby"] !== undefined ? _data["tuesdayLobby"] : null as any;
            this.wednesdayLobby = _data["wednesdayLobby"] !== undefined ? _data["wednesdayLobby"] : null as any;
            this.thursdayLobby = _data["thursdayLobby"] !== undefined ? _data["thursdayLobby"] : null as any;
            this.fridayLobby = _data["fridayLobby"] !== undefined ? _data["fridayLobby"] : null as any;
            this.saturdayLobby = _data["saturdayLobby"] !== undefined ? _data["saturdayLobby"] : null as any;
        }
    }

    static fromJS(data: any): CreateLocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateLocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action !== undefined ? this.action : null as any;
        data["address"] = this.address !== undefined ? this.address : null as any;
        data["bank"] = this.bank !== undefined ? this.bank : null as any;
        data["bldgId"] = this.bldgId !== undefined ? this.bldgId : null as any;
        data["branchName"] = this.branchName !== undefined ? this.branchName : null as any;
        data["cc"] = this.cc !== undefined ? this.cc : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["closingDate"] = this.closingDate ? this.closingDate.toISOString() : null as any;
        data["county"] = this.county !== undefined ? this.county : null as any;
        data["division"] = this.division !== undefined ? this.division : null as any;
        data["dndNumber"] = this.dndNumber !== undefined ? this.dndNumber : null as any;
        data["estDate"] = this.estDate !== undefined ? this.estDate : null as any;
        data["internalZip"] = this.internalZip !== undefined ? this.internalZip : null as any;
        data["lat"] = this.lat !== undefined ? this.lat : null as any;
        data["long"] = this.long !== undefined ? this.long : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["propertyId"] = this.propertyId !== undefined ? this.propertyId : null as any;
        data["receiverAddress"] = this.receiverAddress !== undefined ? this.receiverAddress : null as any;
        data["receiverCity"] = this.receiverCity !== undefined ? this.receiverCity : null as any;
        data["receiverDndNumber"] = this.receiverDndNumber !== undefined ? this.receiverDndNumber : null as any;
        data["receiverName"] = this.receiverName !== undefined ? this.receiverName : null as any;
        data["receiverPropertyId"] = this.receiverPropertyId !== undefined ? this.receiverPropertyId : null as any;
        data["region"] = this.region !== undefined ? this.region : null as any;
        data["retailMarket"] = this.retailMarket !== undefined ? this.retailMarket : null as any;
        data["service"] = this.service !== undefined ? this.service : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["subType"] = this.subType !== undefined ? this.subType : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["nightDrop"] = this.nightDrop !== undefined ? this.nightDrop : null as any;
        data["sundayLobby"] = this.sundayLobby !== undefined ? this.sundayLobby : null as any;
        data["mondayLobby"] = this.mondayLobby !== undefined ? this.mondayLobby : null as any;
        data["tuesdayLobby"] = this.tuesdayLobby !== undefined ? this.tuesdayLobby : null as any;
        data["wednesdayLobby"] = this.wednesdayLobby !== undefined ? this.wednesdayLobby : null as any;
        data["thursdayLobby"] = this.thursdayLobby !== undefined ? this.thursdayLobby : null as any;
        data["fridayLobby"] = this.fridayLobby !== undefined ? this.fridayLobby : null as any;
        data["saturdayLobby"] = this.saturdayLobby !== undefined ? this.saturdayLobby : null as any;
        return data;
    }
}

export interface ICreateLocationDto {
    action?: string | null;
    address?: string | null;
    bank?: number | null;
    bldgId?: number | null;
    branchName?: string | null;
    cc?: string | null;
    city?: string | null;
    closingDate?: Date | null;
    county?: string | null;
    division?: string | null;
    dndNumber?: number | null;
    estDate?: string | null;
    internalZip?: string | null;
    lat?: number | null;
    long?: number | null;
    name?: string | null;
    propertyId?: number | null;
    receiverAddress?: string | null;
    receiverCity?: string | null;
    receiverDndNumber?: number | null;
    receiverName?: string | null;
    receiverPropertyId?: number | null;
    region?: string | null;
    retailMarket?: string | null;
    service?: string | null;
    state?: string | null;
    subType?: string | null;
    type?: string | null;
    zip?: string | null;
    phone?: string | null;
    nightDrop?: boolean | null;
    sundayLobby?: string | null;
    mondayLobby?: string | null;
    tuesdayLobby?: string | null;
    wednesdayLobby?: string | null;
    thursdayLobby?: string | null;
    fridayLobby?: string | null;
    saturdayLobby?: string | null;
}

export class CreateVestibuleHourlyDto implements ICreateVestibuleHourlyDto {
    dndNumber?: number | null;
    division?: string | null;
    region?: string | null;
    retailMarket?: string | null;
    cc?: string | null;
    bldgId?: number | null;
    name?: string | null;
    address?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    type?: string | null;
    service?: string | null;
    property?: string | null;
    modifiedVestibuleHoursCategory?: string | null;
    effectiveDate?: string | null;
    mondayVestibuleHours?: string | null;
    tuesdayVestibuleHours?: string | null;
    wednesdayVestibuleHours?: string | null;
    thursdayVestibuleHours?: string | null;
    fridayVestibuleHours?: string | null;
    saturdayVestibuleHours?: string | null;
    sundayVestibuleHours?: string | null;

    constructor(data?: ICreateVestibuleHourlyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dndNumber = _data["dndNumber"] !== undefined ? _data["dndNumber"] : null as any;
            this.division = _data["division"] !== undefined ? _data["division"] : null as any;
            this.region = _data["region"] !== undefined ? _data["region"] : null as any;
            this.retailMarket = _data["retailMarket"] !== undefined ? _data["retailMarket"] : null as any;
            this.cc = _data["cc"] !== undefined ? _data["cc"] : null as any;
            this.bldgId = _data["bldgId"] !== undefined ? _data["bldgId"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.address = _data["address"] !== undefined ? _data["address"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.service = _data["service"] !== undefined ? _data["service"] : null as any;
            this.property = _data["property"] !== undefined ? _data["property"] : null as any;
            this.modifiedVestibuleHoursCategory = _data["modifiedVestibuleHoursCategory"] !== undefined ? _data["modifiedVestibuleHoursCategory"] : null as any;
            this.effectiveDate = _data["effectiveDate"] !== undefined ? _data["effectiveDate"] : null as any;
            this.mondayVestibuleHours = _data["mondayVestibuleHours"] !== undefined ? _data["mondayVestibuleHours"] : null as any;
            this.tuesdayVestibuleHours = _data["tuesdayVestibuleHours"] !== undefined ? _data["tuesdayVestibuleHours"] : null as any;
            this.wednesdayVestibuleHours = _data["wednesdayVestibuleHours"] !== undefined ? _data["wednesdayVestibuleHours"] : null as any;
            this.thursdayVestibuleHours = _data["thursdayVestibuleHours"] !== undefined ? _data["thursdayVestibuleHours"] : null as any;
            this.fridayVestibuleHours = _data["fridayVestibuleHours"] !== undefined ? _data["fridayVestibuleHours"] : null as any;
            this.saturdayVestibuleHours = _data["saturdayVestibuleHours"] !== undefined ? _data["saturdayVestibuleHours"] : null as any;
            this.sundayVestibuleHours = _data["sundayVestibuleHours"] !== undefined ? _data["sundayVestibuleHours"] : null as any;
        }
    }

    static fromJS(data: any): CreateVestibuleHourlyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateVestibuleHourlyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dndNumber"] = this.dndNumber !== undefined ? this.dndNumber : null as any;
        data["division"] = this.division !== undefined ? this.division : null as any;
        data["region"] = this.region !== undefined ? this.region : null as any;
        data["retailMarket"] = this.retailMarket !== undefined ? this.retailMarket : null as any;
        data["cc"] = this.cc !== undefined ? this.cc : null as any;
        data["bldgId"] = this.bldgId !== undefined ? this.bldgId : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["address"] = this.address !== undefined ? this.address : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["service"] = this.service !== undefined ? this.service : null as any;
        data["property"] = this.property !== undefined ? this.property : null as any;
        data["modifiedVestibuleHoursCategory"] = this.modifiedVestibuleHoursCategory !== undefined ? this.modifiedVestibuleHoursCategory : null as any;
        data["effectiveDate"] = this.effectiveDate !== undefined ? this.effectiveDate : null as any;
        data["mondayVestibuleHours"] = this.mondayVestibuleHours !== undefined ? this.mondayVestibuleHours : null as any;
        data["tuesdayVestibuleHours"] = this.tuesdayVestibuleHours !== undefined ? this.tuesdayVestibuleHours : null as any;
        data["wednesdayVestibuleHours"] = this.wednesdayVestibuleHours !== undefined ? this.wednesdayVestibuleHours : null as any;
        data["thursdayVestibuleHours"] = this.thursdayVestibuleHours !== undefined ? this.thursdayVestibuleHours : null as any;
        data["fridayVestibuleHours"] = this.fridayVestibuleHours !== undefined ? this.fridayVestibuleHours : null as any;
        data["saturdayVestibuleHours"] = this.saturdayVestibuleHours !== undefined ? this.saturdayVestibuleHours : null as any;
        data["sundayVestibuleHours"] = this.sundayVestibuleHours !== undefined ? this.sundayVestibuleHours : null as any;
        return data;
    }
}

export interface ICreateVestibuleHourlyDto {
    dndNumber?: number | null;
    division?: string | null;
    region?: string | null;
    retailMarket?: string | null;
    cc?: string | null;
    bldgId?: number | null;
    name?: string | null;
    address?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    type?: string | null;
    service?: string | null;
    property?: string | null;
    modifiedVestibuleHoursCategory?: string | null;
    effectiveDate?: string | null;
    mondayVestibuleHours?: string | null;
    tuesdayVestibuleHours?: string | null;
    wednesdayVestibuleHours?: string | null;
    thursdayVestibuleHours?: string | null;
    fridayVestibuleHours?: string | null;
    saturdayVestibuleHours?: string | null;
    sundayVestibuleHours?: string | null;
}

export class Dashboard implements IDashboard {
    ownerID?: number;
    owner?: Owner;
    seq!: number;
    name!: string;
    universal!: boolean;
    active!: boolean;
    createdBy!: string;
    createdDate!: Date;
    modifiedBy!: string;
    modifiedDate!: Date;
    description?: string | null;
    notes?: string | null;
    dashboardTargets?: DashboardTarget[] | null;
    dashboardRespondents?: DashboardRespondent[] | null;
    designerID!: string;
    ownerDesignerID!: string;
    id?: number;

    constructor(data?: IDashboard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : null as any;
            this.seq = _data["seq"] !== undefined ? _data["seq"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.universal = _data["universal"] !== undefined ? _data["universal"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.modifiedBy = _data["modifiedBy"] !== undefined ? _data["modifiedBy"] : null as any;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            if (Array.isArray(_data["dashboardTargets"])) {
                this.dashboardTargets = [] as any;
                for (let item of _data["dashboardTargets"])
                    this.dashboardTargets!.push(DashboardTarget.fromJS(item));
            }
            else {
                this.dashboardTargets = null as any;
            }
            if (Array.isArray(_data["dashboardRespondents"])) {
                this.dashboardRespondents = [] as any;
                for (let item of _data["dashboardRespondents"])
                    this.dashboardRespondents!.push(DashboardRespondent.fromJS(item));
            }
            else {
                this.dashboardRespondents = null as any;
            }
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.ownerDesignerID = _data["ownerDesignerID"] !== undefined ? _data["ownerDesignerID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): Dashboard {
        data = typeof data === 'object' ? data : {};
        let result = new Dashboard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["owner"] = this.owner ? this.owner.toJSON() : null as any;
        data["seq"] = this.seq !== undefined ? this.seq : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["universal"] = this.universal !== undefined ? this.universal : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["modifiedBy"] = this.modifiedBy !== undefined ? this.modifiedBy : null as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        if (Array.isArray(this.dashboardTargets)) {
            data["dashboardTargets"] = [];
            for (let item of this.dashboardTargets)
                data["dashboardTargets"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.dashboardRespondents)) {
            data["dashboardRespondents"] = [];
            for (let item of this.dashboardRespondents)
                data["dashboardRespondents"].push(item ? item.toJSON() : null as any);
        }
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["ownerDesignerID"] = this.ownerDesignerID !== undefined ? this.ownerDesignerID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IDashboard {
    ownerID?: number;
    owner?: Owner;
    seq: number;
    name: string;
    universal: boolean;
    active: boolean;
    createdBy: string;
    createdDate: Date;
    modifiedBy: string;
    modifiedDate: Date;
    description?: string | null;
    notes?: string | null;
    dashboardTargets?: DashboardTarget[] | null;
    dashboardRespondents?: DashboardRespondent[] | null;
    designerID: string;
    ownerDesignerID: string;
    id?: number;
}

export class DashboardRespondent implements IDashboardRespondent {
    dashboardID!: number;
    respondentID!: number;
    seq!: number;
    createdBy!: string;
    createdDate!: Date;
    modifiedBy!: string;
    modifiedDate!: Date;
    notes?: string | null;
    id?: number;

    constructor(data?: IDashboardRespondent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardID = _data["dashboardID"] !== undefined ? _data["dashboardID"] : null as any;
            this.respondentID = _data["respondentID"] !== undefined ? _data["respondentID"] : null as any;
            this.seq = _data["seq"] !== undefined ? _data["seq"] : null as any;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.modifiedBy = _data["modifiedBy"] !== undefined ? _data["modifiedBy"] : null as any;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): DashboardRespondent {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardRespondent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardID"] = this.dashboardID !== undefined ? this.dashboardID : null as any;
        data["respondentID"] = this.respondentID !== undefined ? this.respondentID : null as any;
        data["seq"] = this.seq !== undefined ? this.seq : null as any;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["modifiedBy"] = this.modifiedBy !== undefined ? this.modifiedBy : null as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IDashboardRespondent {
    dashboardID: number;
    respondentID: number;
    seq: number;
    createdBy: string;
    createdDate: Date;
    modifiedBy: string;
    modifiedDate: Date;
    notes?: string | null;
    id?: number;
}

export class DashboardTarget implements IDashboardTarget {
    dashboardID?: number;
    dashboard?: Dashboard;
    targetID?: number;
    target?: Target;
    seq!: number;
    createdBy!: string;
    createdDate!: Date;
    modifiedBy!: string;
    modifiedDate!: Date;
    notes?: string | null;
    designerID!: string;
    targetDesignerID!: string;
    dashboardDesignerID!: string;
    id?: number;

    constructor(data?: IDashboardTarget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dashboardID = _data["dashboardID"] !== undefined ? _data["dashboardID"] : null as any;
            this.dashboard = _data["dashboard"] ? Dashboard.fromJS(_data["dashboard"]) : null as any;
            this.targetID = _data["targetID"] !== undefined ? _data["targetID"] : null as any;
            this.target = _data["target"] ? Target.fromJS(_data["target"]) : null as any;
            this.seq = _data["seq"] !== undefined ? _data["seq"] : null as any;
            this.createdBy = _data["createdBy"] !== undefined ? _data["createdBy"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.modifiedBy = _data["modifiedBy"] !== undefined ? _data["modifiedBy"] : null as any;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.targetDesignerID = _data["targetDesignerID"] !== undefined ? _data["targetDesignerID"] : null as any;
            this.dashboardDesignerID = _data["dashboardDesignerID"] !== undefined ? _data["dashboardDesignerID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): DashboardTarget {
        data = typeof data === 'object' ? data : {};
        let result = new DashboardTarget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dashboardID"] = this.dashboardID !== undefined ? this.dashboardID : null as any;
        data["dashboard"] = this.dashboard ? this.dashboard.toJSON() : null as any;
        data["targetID"] = this.targetID !== undefined ? this.targetID : null as any;
        data["target"] = this.target ? this.target.toJSON() : null as any;
        data["seq"] = this.seq !== undefined ? this.seq : null as any;
        data["createdBy"] = this.createdBy !== undefined ? this.createdBy : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["modifiedBy"] = this.modifiedBy !== undefined ? this.modifiedBy : null as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["targetDesignerID"] = this.targetDesignerID !== undefined ? this.targetDesignerID : null as any;
        data["dashboardDesignerID"] = this.dashboardDesignerID !== undefined ? this.dashboardDesignerID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IDashboardTarget {
    dashboardID?: number;
    dashboard?: Dashboard;
    targetID?: number;
    target?: Target;
    seq: number;
    createdBy: string;
    createdDate: Date;
    modifiedBy: string;
    modifiedDate: Date;
    notes?: string | null;
    designerID: string;
    targetDesignerID: string;
    dashboardDesignerID: string;
    id?: number;
}

export class DataChunk implements IDataChunk {
    label?: string | null;
    count?: number;
    colorCode?: string | null;
    siteIDs?: number[] | null;

    constructor(data?: IDataChunk) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
            this.colorCode = _data["colorCode"] !== undefined ? _data["colorCode"] : null as any;
            if (Array.isArray(_data["siteIDs"])) {
                this.siteIDs = [] as any;
                for (let item of _data["siteIDs"])
                    this.siteIDs!.push(item);
            }
            else {
                this.siteIDs = null as any;
            }
        }
    }

    static fromJS(data: any): DataChunk {
        data = typeof data === 'object' ? data : {};
        let result = new DataChunk();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        data["colorCode"] = this.colorCode !== undefined ? this.colorCode : null as any;
        if (Array.isArray(this.siteIDs)) {
            data["siteIDs"] = [];
            for (let item of this.siteIDs)
                data["siteIDs"].push(item);
        }
        return data;
    }
}

export interface IDataChunk {
    label?: string | null;
    count?: number;
    colorCode?: string | null;
    siteIDs?: number[] | null;
}

export class Datapoint implements IDatapoint {
    readonly datapointID?: number;
    ownerID?: number | null;
    owner?: Owner;
    name!: string;
    description?: string | null;
    help?: string | null;
    comments?: string | null;
    valueConfigID?: number;
    multipleAnswer!: boolean;
    otherOption!: boolean;
    valueConfig?: ValueConfig;
    gridID?: string | null;
    gridName?: string | null;
    readonly label?: string | null;
    children?: Datapoint[] | null;
    names?: string[] | null;
    designerID!: string;
    valueConfigDesignerID!: string;
    ownerDesignerID!: string;
    id?: number;

    constructor(data?: IDatapoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).datapointID = _data["datapointID"] !== undefined ? _data["datapointID"] : null as any;
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.help = _data["help"] !== undefined ? _data["help"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.valueConfigID = _data["valueConfigID"] !== undefined ? _data["valueConfigID"] : null as any;
            this.multipleAnswer = _data["multipleAnswer"] !== undefined ? _data["multipleAnswer"] : null as any;
            this.otherOption = _data["otherOption"] !== undefined ? _data["otherOption"] : null as any;
            this.valueConfig = _data["valueConfig"] ? ValueConfig.fromJS(_data["valueConfig"]) : null as any;
            this.gridID = _data["gridID"] !== undefined ? _data["gridID"] : null as any;
            this.gridName = _data["gridName"] !== undefined ? _data["gridName"] : null as any;
            (this as any).label = _data["label"] !== undefined ? _data["label"] : null as any;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(Datapoint.fromJS(item));
            }
            else {
                this.children = null as any;
            }
            if (Array.isArray(_data["names"])) {
                this.names = [] as any;
                for (let item of _data["names"])
                    this.names!.push(item);
            }
            else {
                this.names = null as any;
            }
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.valueConfigDesignerID = _data["valueConfigDesignerID"] !== undefined ? _data["valueConfigDesignerID"] : null as any;
            this.ownerDesignerID = _data["ownerDesignerID"] !== undefined ? _data["ownerDesignerID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): Datapoint {
        data = typeof data === 'object' ? data : {};
        let result = new Datapoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datapointID"] = this.datapointID !== undefined ? this.datapointID : null as any;
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["owner"] = this.owner ? this.owner.toJSON() : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["help"] = this.help !== undefined ? this.help : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["valueConfigID"] = this.valueConfigID !== undefined ? this.valueConfigID : null as any;
        data["multipleAnswer"] = this.multipleAnswer !== undefined ? this.multipleAnswer : null as any;
        data["otherOption"] = this.otherOption !== undefined ? this.otherOption : null as any;
        data["valueConfig"] = this.valueConfig ? this.valueConfig.toJSON() : null as any;
        data["gridID"] = this.gridID !== undefined ? this.gridID : null as any;
        data["gridName"] = this.gridName !== undefined ? this.gridName : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.names)) {
            data["names"] = [];
            for (let item of this.names)
                data["names"].push(item);
        }
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["valueConfigDesignerID"] = this.valueConfigDesignerID !== undefined ? this.valueConfigDesignerID : null as any;
        data["ownerDesignerID"] = this.ownerDesignerID !== undefined ? this.ownerDesignerID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IDatapoint {
    datapointID?: number;
    ownerID?: number | null;
    owner?: Owner;
    name: string;
    description?: string | null;
    help?: string | null;
    comments?: string | null;
    valueConfigID?: number;
    multipleAnswer: boolean;
    otherOption: boolean;
    valueConfig?: ValueConfig;
    gridID?: string | null;
    gridName?: string | null;
    label?: string | null;
    children?: Datapoint[] | null;
    names?: string[] | null;
    designerID: string;
    valueConfigDesignerID: string;
    ownerDesignerID: string;
    id?: number;
}

export class DatapointTarget implements IDatapointTarget {
    readonly label?: string | null;
    ownerID?: number;
    owner?: Owner;
    targetID?: number;
    target?: Target;
    targetName?: string | null;
    datapointID?: number;
    datapoint?: Datapoint;
    datapointName?: string | null;
    parentID?: number | null;
    displayParentID?: number | null;
    rerenderID?: number | null;
    renderTypeID?: number | null;
    static!: boolean;
    active!: boolean;
    referenceNumber?: string | null;
    calculated?: boolean;
    applyImmediate?: boolean;
    defaultDisabled?: boolean;
    defaultHidden?: boolean;
    heading?: boolean;
    searchName?: string | null;
    collapsed!: boolean;
    designerCollapsed!: boolean;
    seq?: number;
    menuSeq?: number | null;
    menuLevel?: number | null;
    menuItem?: boolean;
    menuEnabled?: boolean;
    summaryItem?: boolean;
    cssClass?: string | null;
    createdDate!: Date;
    modifiedDate!: Date;
    notes?: string | null;
    designerID!: string;
    parentDesignerID?: string | null;
    rerenderDesignerID?: string | null;
    overrideExpression?: string | null;
    externalSearchable!: boolean;
    externalVisible!: boolean;
    allowNullification!: boolean;
    styleExpression?: string | null;
    summaryItemStyleExpression?: string | null;
    loadScriptID?: number | null;
    completeScriptID?: number | null;
    formGroupRoot!: boolean;
    formGroupMember!: boolean;
    formGroupAdd!: boolean;
    formGroupEdit!: boolean;
    formGroupDelete!: boolean;
    formGroupDeleteAll!: boolean;
    formGroupTabular!: boolean;
    formGroupDatatable!: boolean;
    requiredForCompletion!: boolean;
    required!: boolean;
    workflowExpression?: string | null;
    workflowActionExpression?: string | null;
    calculatedEditable!: boolean;
    formGroupColumns?: string | null;
    format?: string | null;
    captureResult!: boolean;
    buttonID?: number | null;
    button?: Button;
    tooltipDeleteAllRecords?: string | null;
    tooltipAddRecord?: string | null;
    tooltipDeleteRecord?: string | null;
    colName?: string | null;
    dataApiResponsePath?: string | null;
    disableOnUpdate?: boolean;
    fileTypeID?: number | null;
    fileType?: FileType;
    placeholder?: string | null;
    loadMenuOnChange!: boolean;
    externalKey?: string | null;
    asEntryText?: boolean;
    templateRender?: boolean;
    omitFromImport?: boolean;
    displayParentDesignerID?: string | null;
    targetDesignerID!: string;
    buttonDesignerID?: string | null;
    datapointDesignerID!: string;
    renderTypeDesignerID?: string | null;
    onFormGroupAddedExpression?: string | null;
    id?: number;

    constructor(data?: IDatapointTarget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (this as any).label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : null as any;
            this.targetID = _data["targetID"] !== undefined ? _data["targetID"] : null as any;
            this.target = _data["target"] ? Target.fromJS(_data["target"]) : null as any;
            this.targetName = _data["targetName"] !== undefined ? _data["targetName"] : null as any;
            this.datapointID = _data["datapointID"] !== undefined ? _data["datapointID"] : null as any;
            this.datapoint = _data["datapoint"] ? Datapoint.fromJS(_data["datapoint"]) : null as any;
            this.datapointName = _data["datapointName"] !== undefined ? _data["datapointName"] : null as any;
            this.parentID = _data["parentID"] !== undefined ? _data["parentID"] : null as any;
            this.displayParentID = _data["displayParentID"] !== undefined ? _data["displayParentID"] : null as any;
            this.rerenderID = _data["rerenderID"] !== undefined ? _data["rerenderID"] : null as any;
            this.renderTypeID = _data["renderTypeID"] !== undefined ? _data["renderTypeID"] : null as any;
            this.static = _data["static"] !== undefined ? _data["static"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
            this.calculated = _data["calculated"] !== undefined ? _data["calculated"] : null as any;
            this.applyImmediate = _data["applyImmediate"] !== undefined ? _data["applyImmediate"] : null as any;
            this.defaultDisabled = _data["defaultDisabled"] !== undefined ? _data["defaultDisabled"] : null as any;
            this.defaultHidden = _data["defaultHidden"] !== undefined ? _data["defaultHidden"] : null as any;
            this.heading = _data["heading"] !== undefined ? _data["heading"] : null as any;
            this.searchName = _data["searchName"] !== undefined ? _data["searchName"] : null as any;
            this.collapsed = _data["collapsed"] !== undefined ? _data["collapsed"] : null as any;
            this.designerCollapsed = _data["designerCollapsed"] !== undefined ? _data["designerCollapsed"] : null as any;
            this.seq = _data["seq"] !== undefined ? _data["seq"] : null as any;
            this.menuSeq = _data["menuSeq"] !== undefined ? _data["menuSeq"] : null as any;
            this.menuLevel = _data["menuLevel"] !== undefined ? _data["menuLevel"] : null as any;
            this.menuItem = _data["menuItem"] !== undefined ? _data["menuItem"] : null as any;
            this.menuEnabled = _data["menuEnabled"] !== undefined ? _data["menuEnabled"] : null as any;
            this.summaryItem = _data["summaryItem"] !== undefined ? _data["summaryItem"] : null as any;
            this.cssClass = _data["cssClass"] !== undefined ? _data["cssClass"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.parentDesignerID = _data["parentDesignerID"] !== undefined ? _data["parentDesignerID"] : null as any;
            this.rerenderDesignerID = _data["rerenderDesignerID"] !== undefined ? _data["rerenderDesignerID"] : null as any;
            this.overrideExpression = _data["overrideExpression"] !== undefined ? _data["overrideExpression"] : null as any;
            this.externalSearchable = _data["externalSearchable"] !== undefined ? _data["externalSearchable"] : null as any;
            this.externalVisible = _data["externalVisible"] !== undefined ? _data["externalVisible"] : null as any;
            this.allowNullification = _data["allowNullification"] !== undefined ? _data["allowNullification"] : null as any;
            this.styleExpression = _data["styleExpression"] !== undefined ? _data["styleExpression"] : null as any;
            this.summaryItemStyleExpression = _data["summaryItemStyleExpression"] !== undefined ? _data["summaryItemStyleExpression"] : null as any;
            this.loadScriptID = _data["loadScriptID"] !== undefined ? _data["loadScriptID"] : null as any;
            this.completeScriptID = _data["completeScriptID"] !== undefined ? _data["completeScriptID"] : null as any;
            this.formGroupRoot = _data["formGroupRoot"] !== undefined ? _data["formGroupRoot"] : null as any;
            this.formGroupMember = _data["formGroupMember"] !== undefined ? _data["formGroupMember"] : null as any;
            this.formGroupAdd = _data["formGroupAdd"] !== undefined ? _data["formGroupAdd"] : null as any;
            this.formGroupEdit = _data["formGroupEdit"] !== undefined ? _data["formGroupEdit"] : null as any;
            this.formGroupDelete = _data["formGroupDelete"] !== undefined ? _data["formGroupDelete"] : null as any;
            this.formGroupDeleteAll = _data["formGroupDeleteAll"] !== undefined ? _data["formGroupDeleteAll"] : null as any;
            this.formGroupTabular = _data["formGroupTabular"] !== undefined ? _data["formGroupTabular"] : null as any;
            this.formGroupDatatable = _data["formGroupDatatable"] !== undefined ? _data["formGroupDatatable"] : null as any;
            this.requiredForCompletion = _data["requiredForCompletion"] !== undefined ? _data["requiredForCompletion"] : null as any;
            this.required = _data["required"] !== undefined ? _data["required"] : null as any;
            this.workflowExpression = _data["workflowExpression"] !== undefined ? _data["workflowExpression"] : null as any;
            this.workflowActionExpression = _data["workflowActionExpression"] !== undefined ? _data["workflowActionExpression"] : null as any;
            this.calculatedEditable = _data["calculatedEditable"] !== undefined ? _data["calculatedEditable"] : null as any;
            this.formGroupColumns = _data["formGroupColumns"] !== undefined ? _data["formGroupColumns"] : null as any;
            this.format = _data["format"] !== undefined ? _data["format"] : null as any;
            this.captureResult = _data["captureResult"] !== undefined ? _data["captureResult"] : null as any;
            this.buttonID = _data["buttonID"] !== undefined ? _data["buttonID"] : null as any;
            this.button = _data["button"] ? Button.fromJS(_data["button"]) : null as any;
            this.tooltipDeleteAllRecords = _data["tooltipDeleteAllRecords"] !== undefined ? _data["tooltipDeleteAllRecords"] : null as any;
            this.tooltipAddRecord = _data["tooltipAddRecord"] !== undefined ? _data["tooltipAddRecord"] : null as any;
            this.tooltipDeleteRecord = _data["tooltipDeleteRecord"] !== undefined ? _data["tooltipDeleteRecord"] : null as any;
            this.colName = _data["colName"] !== undefined ? _data["colName"] : null as any;
            this.dataApiResponsePath = _data["dataApiResponsePath"] !== undefined ? _data["dataApiResponsePath"] : null as any;
            this.disableOnUpdate = _data["disableOnUpdate"] !== undefined ? _data["disableOnUpdate"] : null as any;
            this.fileTypeID = _data["fileTypeID"] !== undefined ? _data["fileTypeID"] : null as any;
            this.fileType = _data["fileType"] ? FileType.fromJS(_data["fileType"]) : null as any;
            this.placeholder = _data["placeholder"] !== undefined ? _data["placeholder"] : null as any;
            this.loadMenuOnChange = _data["loadMenuOnChange"] !== undefined ? _data["loadMenuOnChange"] : null as any;
            this.externalKey = _data["externalKey"] !== undefined ? _data["externalKey"] : null as any;
            this.asEntryText = _data["asEntryText"] !== undefined ? _data["asEntryText"] : null as any;
            this.templateRender = _data["templateRender"] !== undefined ? _data["templateRender"] : null as any;
            this.omitFromImport = _data["omitFromImport"] !== undefined ? _data["omitFromImport"] : null as any;
            this.displayParentDesignerID = _data["displayParentDesignerID"] !== undefined ? _data["displayParentDesignerID"] : null as any;
            this.targetDesignerID = _data["targetDesignerID"] !== undefined ? _data["targetDesignerID"] : null as any;
            this.buttonDesignerID = _data["buttonDesignerID"] !== undefined ? _data["buttonDesignerID"] : null as any;
            this.datapointDesignerID = _data["datapointDesignerID"] !== undefined ? _data["datapointDesignerID"] : null as any;
            this.renderTypeDesignerID = _data["renderTypeDesignerID"] !== undefined ? _data["renderTypeDesignerID"] : null as any;
            this.onFormGroupAddedExpression = _data["onFormGroupAddedExpression"] !== undefined ? _data["onFormGroupAddedExpression"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): DatapointTarget {
        data = typeof data === 'object' ? data : {};
        let result = new DatapointTarget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["owner"] = this.owner ? this.owner.toJSON() : null as any;
        data["targetID"] = this.targetID !== undefined ? this.targetID : null as any;
        data["target"] = this.target ? this.target.toJSON() : null as any;
        data["targetName"] = this.targetName !== undefined ? this.targetName : null as any;
        data["datapointID"] = this.datapointID !== undefined ? this.datapointID : null as any;
        data["datapoint"] = this.datapoint ? this.datapoint.toJSON() : null as any;
        data["datapointName"] = this.datapointName !== undefined ? this.datapointName : null as any;
        data["parentID"] = this.parentID !== undefined ? this.parentID : null as any;
        data["displayParentID"] = this.displayParentID !== undefined ? this.displayParentID : null as any;
        data["rerenderID"] = this.rerenderID !== undefined ? this.rerenderID : null as any;
        data["renderTypeID"] = this.renderTypeID !== undefined ? this.renderTypeID : null as any;
        data["static"] = this.static !== undefined ? this.static : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        data["calculated"] = this.calculated !== undefined ? this.calculated : null as any;
        data["applyImmediate"] = this.applyImmediate !== undefined ? this.applyImmediate : null as any;
        data["defaultDisabled"] = this.defaultDisabled !== undefined ? this.defaultDisabled : null as any;
        data["defaultHidden"] = this.defaultHidden !== undefined ? this.defaultHidden : null as any;
        data["heading"] = this.heading !== undefined ? this.heading : null as any;
        data["searchName"] = this.searchName !== undefined ? this.searchName : null as any;
        data["collapsed"] = this.collapsed !== undefined ? this.collapsed : null as any;
        data["designerCollapsed"] = this.designerCollapsed !== undefined ? this.designerCollapsed : null as any;
        data["seq"] = this.seq !== undefined ? this.seq : null as any;
        data["menuSeq"] = this.menuSeq !== undefined ? this.menuSeq : null as any;
        data["menuLevel"] = this.menuLevel !== undefined ? this.menuLevel : null as any;
        data["menuItem"] = this.menuItem !== undefined ? this.menuItem : null as any;
        data["menuEnabled"] = this.menuEnabled !== undefined ? this.menuEnabled : null as any;
        data["summaryItem"] = this.summaryItem !== undefined ? this.summaryItem : null as any;
        data["cssClass"] = this.cssClass !== undefined ? this.cssClass : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["parentDesignerID"] = this.parentDesignerID !== undefined ? this.parentDesignerID : null as any;
        data["rerenderDesignerID"] = this.rerenderDesignerID !== undefined ? this.rerenderDesignerID : null as any;
        data["overrideExpression"] = this.overrideExpression !== undefined ? this.overrideExpression : null as any;
        data["externalSearchable"] = this.externalSearchable !== undefined ? this.externalSearchable : null as any;
        data["externalVisible"] = this.externalVisible !== undefined ? this.externalVisible : null as any;
        data["allowNullification"] = this.allowNullification !== undefined ? this.allowNullification : null as any;
        data["styleExpression"] = this.styleExpression !== undefined ? this.styleExpression : null as any;
        data["summaryItemStyleExpression"] = this.summaryItemStyleExpression !== undefined ? this.summaryItemStyleExpression : null as any;
        data["loadScriptID"] = this.loadScriptID !== undefined ? this.loadScriptID : null as any;
        data["completeScriptID"] = this.completeScriptID !== undefined ? this.completeScriptID : null as any;
        data["formGroupRoot"] = this.formGroupRoot !== undefined ? this.formGroupRoot : null as any;
        data["formGroupMember"] = this.formGroupMember !== undefined ? this.formGroupMember : null as any;
        data["formGroupAdd"] = this.formGroupAdd !== undefined ? this.formGroupAdd : null as any;
        data["formGroupEdit"] = this.formGroupEdit !== undefined ? this.formGroupEdit : null as any;
        data["formGroupDelete"] = this.formGroupDelete !== undefined ? this.formGroupDelete : null as any;
        data["formGroupDeleteAll"] = this.formGroupDeleteAll !== undefined ? this.formGroupDeleteAll : null as any;
        data["formGroupTabular"] = this.formGroupTabular !== undefined ? this.formGroupTabular : null as any;
        data["formGroupDatatable"] = this.formGroupDatatable !== undefined ? this.formGroupDatatable : null as any;
        data["requiredForCompletion"] = this.requiredForCompletion !== undefined ? this.requiredForCompletion : null as any;
        data["required"] = this.required !== undefined ? this.required : null as any;
        data["workflowExpression"] = this.workflowExpression !== undefined ? this.workflowExpression : null as any;
        data["workflowActionExpression"] = this.workflowActionExpression !== undefined ? this.workflowActionExpression : null as any;
        data["calculatedEditable"] = this.calculatedEditable !== undefined ? this.calculatedEditable : null as any;
        data["formGroupColumns"] = this.formGroupColumns !== undefined ? this.formGroupColumns : null as any;
        data["format"] = this.format !== undefined ? this.format : null as any;
        data["captureResult"] = this.captureResult !== undefined ? this.captureResult : null as any;
        data["buttonID"] = this.buttonID !== undefined ? this.buttonID : null as any;
        data["button"] = this.button ? this.button.toJSON() : null as any;
        data["tooltipDeleteAllRecords"] = this.tooltipDeleteAllRecords !== undefined ? this.tooltipDeleteAllRecords : null as any;
        data["tooltipAddRecord"] = this.tooltipAddRecord !== undefined ? this.tooltipAddRecord : null as any;
        data["tooltipDeleteRecord"] = this.tooltipDeleteRecord !== undefined ? this.tooltipDeleteRecord : null as any;
        data["colName"] = this.colName !== undefined ? this.colName : null as any;
        data["dataApiResponsePath"] = this.dataApiResponsePath !== undefined ? this.dataApiResponsePath : null as any;
        data["disableOnUpdate"] = this.disableOnUpdate !== undefined ? this.disableOnUpdate : null as any;
        data["fileTypeID"] = this.fileTypeID !== undefined ? this.fileTypeID : null as any;
        data["fileType"] = this.fileType ? this.fileType.toJSON() : null as any;
        data["placeholder"] = this.placeholder !== undefined ? this.placeholder : null as any;
        data["loadMenuOnChange"] = this.loadMenuOnChange !== undefined ? this.loadMenuOnChange : null as any;
        data["externalKey"] = this.externalKey !== undefined ? this.externalKey : null as any;
        data["asEntryText"] = this.asEntryText !== undefined ? this.asEntryText : null as any;
        data["templateRender"] = this.templateRender !== undefined ? this.templateRender : null as any;
        data["omitFromImport"] = this.omitFromImport !== undefined ? this.omitFromImport : null as any;
        data["displayParentDesignerID"] = this.displayParentDesignerID !== undefined ? this.displayParentDesignerID : null as any;
        data["targetDesignerID"] = this.targetDesignerID !== undefined ? this.targetDesignerID : null as any;
        data["buttonDesignerID"] = this.buttonDesignerID !== undefined ? this.buttonDesignerID : null as any;
        data["datapointDesignerID"] = this.datapointDesignerID !== undefined ? this.datapointDesignerID : null as any;
        data["renderTypeDesignerID"] = this.renderTypeDesignerID !== undefined ? this.renderTypeDesignerID : null as any;
        data["onFormGroupAddedExpression"] = this.onFormGroupAddedExpression !== undefined ? this.onFormGroupAddedExpression : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IDatapointTarget {
    label?: string | null;
    ownerID?: number;
    owner?: Owner;
    targetID?: number;
    target?: Target;
    targetName?: string | null;
    datapointID?: number;
    datapoint?: Datapoint;
    datapointName?: string | null;
    parentID?: number | null;
    displayParentID?: number | null;
    rerenderID?: number | null;
    renderTypeID?: number | null;
    static: boolean;
    active: boolean;
    referenceNumber?: string | null;
    calculated?: boolean;
    applyImmediate?: boolean;
    defaultDisabled?: boolean;
    defaultHidden?: boolean;
    heading?: boolean;
    searchName?: string | null;
    collapsed: boolean;
    designerCollapsed: boolean;
    seq?: number;
    menuSeq?: number | null;
    menuLevel?: number | null;
    menuItem?: boolean;
    menuEnabled?: boolean;
    summaryItem?: boolean;
    cssClass?: string | null;
    createdDate: Date;
    modifiedDate: Date;
    notes?: string | null;
    designerID: string;
    parentDesignerID?: string | null;
    rerenderDesignerID?: string | null;
    overrideExpression?: string | null;
    externalSearchable: boolean;
    externalVisible: boolean;
    allowNullification: boolean;
    styleExpression?: string | null;
    summaryItemStyleExpression?: string | null;
    loadScriptID?: number | null;
    completeScriptID?: number | null;
    formGroupRoot: boolean;
    formGroupMember: boolean;
    formGroupAdd: boolean;
    formGroupEdit: boolean;
    formGroupDelete: boolean;
    formGroupDeleteAll: boolean;
    formGroupTabular: boolean;
    formGroupDatatable: boolean;
    requiredForCompletion: boolean;
    required: boolean;
    workflowExpression?: string | null;
    workflowActionExpression?: string | null;
    calculatedEditable: boolean;
    formGroupColumns?: string | null;
    format?: string | null;
    captureResult: boolean;
    buttonID?: number | null;
    button?: Button;
    tooltipDeleteAllRecords?: string | null;
    tooltipAddRecord?: string | null;
    tooltipDeleteRecord?: string | null;
    colName?: string | null;
    dataApiResponsePath?: string | null;
    disableOnUpdate?: boolean;
    fileTypeID?: number | null;
    fileType?: FileType;
    placeholder?: string | null;
    loadMenuOnChange: boolean;
    externalKey?: string | null;
    asEntryText?: boolean;
    templateRender?: boolean;
    omitFromImport?: boolean;
    displayParentDesignerID?: string | null;
    targetDesignerID: string;
    buttonDesignerID?: string | null;
    datapointDesignerID: string;
    renderTypeDesignerID?: string | null;
    onFormGroupAddedExpression?: string | null;
    id?: number;
}

export class DatapointTargetPrereq implements IDatapointTargetPrereq {
    typeID?: number;
    datapointTargetPrereqType?: DatapointTargetPrereqType;
    operatorTypeID?: number;
    operatorType?: OperatorType;
    datapointTargetID?: number;
    datapointTarget?: DatapointTarget;
    active?: boolean;
    prereqDatapointTargetID?: number | null;
    prereqDatapointTarget?: DatapointTarget;
    prereqValueTypeOptionID?: number | null;
    valueTypeOption?: ValueConfigOption;
    prereqRoleID?: number | null;
    prereqGroupName?: string | null;
    prereqCompleteByTagID?: number | null;
    prereqCompleteByOperatorID?: number | null;
    prereqCompleteByOperatorType?: OperatorType;
    invert?: boolean;
    notes?: string | null;
    prereqWorkflowStateID?: number | null;
    prereqValueText?: string | null;
    datapointTargetDesignerID?: string | null;
    prereqDatapointTargetDesignerID?: string | null;
    prereqValueTypeOptionDesignerID?: string | null;
    prereqWorkflowStateDesignerID?: string | null;
    prereqCompleteByTagDesignerID?: string | null;
    id?: number;

    constructor(data?: IDatapointTargetPrereq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.typeID = _data["typeID"] !== undefined ? _data["typeID"] : null as any;
            this.datapointTargetPrereqType = _data["datapointTargetPrereqType"] ? DatapointTargetPrereqType.fromJS(_data["datapointTargetPrereqType"]) : null as any;
            this.operatorTypeID = _data["operatorTypeID"] !== undefined ? _data["operatorTypeID"] : null as any;
            this.operatorType = _data["operatorType"] ? OperatorType.fromJS(_data["operatorType"]) : null as any;
            this.datapointTargetID = _data["datapointTargetID"] !== undefined ? _data["datapointTargetID"] : null as any;
            this.datapointTarget = _data["datapointTarget"] ? DatapointTarget.fromJS(_data["datapointTarget"]) : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.prereqDatapointTargetID = _data["prereqDatapointTargetID"] !== undefined ? _data["prereqDatapointTargetID"] : null as any;
            this.prereqDatapointTarget = _data["prereqDatapointTarget"] ? DatapointTarget.fromJS(_data["prereqDatapointTarget"]) : null as any;
            this.prereqValueTypeOptionID = _data["prereqValueTypeOptionID"] !== undefined ? _data["prereqValueTypeOptionID"] : null as any;
            this.valueTypeOption = _data["valueTypeOption"] ? ValueConfigOption.fromJS(_data["valueTypeOption"]) : null as any;
            this.prereqRoleID = _data["prereqRoleID"] !== undefined ? _data["prereqRoleID"] : null as any;
            this.prereqGroupName = _data["prereqGroupName"] !== undefined ? _data["prereqGroupName"] : null as any;
            this.prereqCompleteByTagID = _data["prereqCompleteByTagID"] !== undefined ? _data["prereqCompleteByTagID"] : null as any;
            this.prereqCompleteByOperatorID = _data["prereqCompleteByOperatorID"] !== undefined ? _data["prereqCompleteByOperatorID"] : null as any;
            this.prereqCompleteByOperatorType = _data["prereqCompleteByOperatorType"] ? OperatorType.fromJS(_data["prereqCompleteByOperatorType"]) : null as any;
            this.invert = _data["invert"] !== undefined ? _data["invert"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.prereqWorkflowStateID = _data["prereqWorkflowStateID"] !== undefined ? _data["prereqWorkflowStateID"] : null as any;
            this.prereqValueText = _data["prereqValueText"] !== undefined ? _data["prereqValueText"] : null as any;
            this.datapointTargetDesignerID = _data["datapointTargetDesignerID"] !== undefined ? _data["datapointTargetDesignerID"] : null as any;
            this.prereqDatapointTargetDesignerID = _data["prereqDatapointTargetDesignerID"] !== undefined ? _data["prereqDatapointTargetDesignerID"] : null as any;
            this.prereqValueTypeOptionDesignerID = _data["prereqValueTypeOptionDesignerID"] !== undefined ? _data["prereqValueTypeOptionDesignerID"] : null as any;
            this.prereqWorkflowStateDesignerID = _data["prereqWorkflowStateDesignerID"] !== undefined ? _data["prereqWorkflowStateDesignerID"] : null as any;
            this.prereqCompleteByTagDesignerID = _data["prereqCompleteByTagDesignerID"] !== undefined ? _data["prereqCompleteByTagDesignerID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): DatapointTargetPrereq {
        data = typeof data === 'object' ? data : {};
        let result = new DatapointTargetPrereq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["typeID"] = this.typeID !== undefined ? this.typeID : null as any;
        data["datapointTargetPrereqType"] = this.datapointTargetPrereqType ? this.datapointTargetPrereqType.toJSON() : null as any;
        data["operatorTypeID"] = this.operatorTypeID !== undefined ? this.operatorTypeID : null as any;
        data["operatorType"] = this.operatorType ? this.operatorType.toJSON() : null as any;
        data["datapointTargetID"] = this.datapointTargetID !== undefined ? this.datapointTargetID : null as any;
        data["datapointTarget"] = this.datapointTarget ? this.datapointTarget.toJSON() : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["prereqDatapointTargetID"] = this.prereqDatapointTargetID !== undefined ? this.prereqDatapointTargetID : null as any;
        data["prereqDatapointTarget"] = this.prereqDatapointTarget ? this.prereqDatapointTarget.toJSON() : null as any;
        data["prereqValueTypeOptionID"] = this.prereqValueTypeOptionID !== undefined ? this.prereqValueTypeOptionID : null as any;
        data["valueTypeOption"] = this.valueTypeOption ? this.valueTypeOption.toJSON() : null as any;
        data["prereqRoleID"] = this.prereqRoleID !== undefined ? this.prereqRoleID : null as any;
        data["prereqGroupName"] = this.prereqGroupName !== undefined ? this.prereqGroupName : null as any;
        data["prereqCompleteByTagID"] = this.prereqCompleteByTagID !== undefined ? this.prereqCompleteByTagID : null as any;
        data["prereqCompleteByOperatorID"] = this.prereqCompleteByOperatorID !== undefined ? this.prereqCompleteByOperatorID : null as any;
        data["prereqCompleteByOperatorType"] = this.prereqCompleteByOperatorType ? this.prereqCompleteByOperatorType.toJSON() : null as any;
        data["invert"] = this.invert !== undefined ? this.invert : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["prereqWorkflowStateID"] = this.prereqWorkflowStateID !== undefined ? this.prereqWorkflowStateID : null as any;
        data["prereqValueText"] = this.prereqValueText !== undefined ? this.prereqValueText : null as any;
        data["datapointTargetDesignerID"] = this.datapointTargetDesignerID !== undefined ? this.datapointTargetDesignerID : null as any;
        data["prereqDatapointTargetDesignerID"] = this.prereqDatapointTargetDesignerID !== undefined ? this.prereqDatapointTargetDesignerID : null as any;
        data["prereqValueTypeOptionDesignerID"] = this.prereqValueTypeOptionDesignerID !== undefined ? this.prereqValueTypeOptionDesignerID : null as any;
        data["prereqWorkflowStateDesignerID"] = this.prereqWorkflowStateDesignerID !== undefined ? this.prereqWorkflowStateDesignerID : null as any;
        data["prereqCompleteByTagDesignerID"] = this.prereqCompleteByTagDesignerID !== undefined ? this.prereqCompleteByTagDesignerID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IDatapointTargetPrereq {
    typeID?: number;
    datapointTargetPrereqType?: DatapointTargetPrereqType;
    operatorTypeID?: number;
    operatorType?: OperatorType;
    datapointTargetID?: number;
    datapointTarget?: DatapointTarget;
    active?: boolean;
    prereqDatapointTargetID?: number | null;
    prereqDatapointTarget?: DatapointTarget;
    prereqValueTypeOptionID?: number | null;
    valueTypeOption?: ValueConfigOption;
    prereqRoleID?: number | null;
    prereqGroupName?: string | null;
    prereqCompleteByTagID?: number | null;
    prereqCompleteByOperatorID?: number | null;
    prereqCompleteByOperatorType?: OperatorType;
    invert?: boolean;
    notes?: string | null;
    prereqWorkflowStateID?: number | null;
    prereqValueText?: string | null;
    datapointTargetDesignerID?: string | null;
    prereqDatapointTargetDesignerID?: string | null;
    prereqValueTypeOptionDesignerID?: string | null;
    prereqWorkflowStateDesignerID?: string | null;
    prereqCompleteByTagDesignerID?: string | null;
    id?: number;
}

export class DatapointTargetPrereqInfo implements IDatapointTargetPrereqInfo {
    id?: number;
    datapointName?: string | null;
    attributeName?: string | null;
    operatorName?: string | null;
    whereCompleteByTagName?: string | null;
    whereCompleteByOperatorName?: string | null;
    wherePrereqDatapointName?: string | null;
    wherePrereqAnswerText?: string | null;
    whereRespondentRoleID?: number | null;
    invert?: boolean;
    active?: boolean;
    prereqDatapointTargetID?: number | null;
    datapointID?: number;
    attributeTypeID?: number;
    operatorID?: number;
    whereCompleteByTagID?: number | null;
    whereCompleteByOperatorID?: number | null;
    wherePrereqDatapointID?: number | null;
    wherePrereqAnswerID?: number | null;
    datapointTargetSeq?: number;
    wherePrereqAnswerTextLike?: string | null;

    constructor(data?: IDatapointTargetPrereqInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.datapointName = _data["datapointName"] !== undefined ? _data["datapointName"] : null as any;
            this.attributeName = _data["attributeName"] !== undefined ? _data["attributeName"] : null as any;
            this.operatorName = _data["operatorName"] !== undefined ? _data["operatorName"] : null as any;
            this.whereCompleteByTagName = _data["whereCompleteByTagName"] !== undefined ? _data["whereCompleteByTagName"] : null as any;
            this.whereCompleteByOperatorName = _data["whereCompleteByOperatorName"] !== undefined ? _data["whereCompleteByOperatorName"] : null as any;
            this.wherePrereqDatapointName = _data["wherePrereqDatapointName"] !== undefined ? _data["wherePrereqDatapointName"] : null as any;
            this.wherePrereqAnswerText = _data["wherePrereqAnswerText"] !== undefined ? _data["wherePrereqAnswerText"] : null as any;
            this.whereRespondentRoleID = _data["whereRespondentRoleID"] !== undefined ? _data["whereRespondentRoleID"] : null as any;
            this.invert = _data["invert"] !== undefined ? _data["invert"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.prereqDatapointTargetID = _data["prereqDatapointTargetID"] !== undefined ? _data["prereqDatapointTargetID"] : null as any;
            this.datapointID = _data["datapointID"] !== undefined ? _data["datapointID"] : null as any;
            this.attributeTypeID = _data["attributeTypeID"] !== undefined ? _data["attributeTypeID"] : null as any;
            this.operatorID = _data["operatorID"] !== undefined ? _data["operatorID"] : null as any;
            this.whereCompleteByTagID = _data["whereCompleteByTagID"] !== undefined ? _data["whereCompleteByTagID"] : null as any;
            this.whereCompleteByOperatorID = _data["whereCompleteByOperatorID"] !== undefined ? _data["whereCompleteByOperatorID"] : null as any;
            this.wherePrereqDatapointID = _data["wherePrereqDatapointID"] !== undefined ? _data["wherePrereqDatapointID"] : null as any;
            this.wherePrereqAnswerID = _data["wherePrereqAnswerID"] !== undefined ? _data["wherePrereqAnswerID"] : null as any;
            this.datapointTargetSeq = _data["datapointTargetSeq"] !== undefined ? _data["datapointTargetSeq"] : null as any;
            this.wherePrereqAnswerTextLike = _data["wherePrereqAnswerTextLike"] !== undefined ? _data["wherePrereqAnswerTextLike"] : null as any;
        }
    }

    static fromJS(data: any): DatapointTargetPrereqInfo {
        data = typeof data === 'object' ? data : {};
        let result = new DatapointTargetPrereqInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["datapointName"] = this.datapointName !== undefined ? this.datapointName : null as any;
        data["attributeName"] = this.attributeName !== undefined ? this.attributeName : null as any;
        data["operatorName"] = this.operatorName !== undefined ? this.operatorName : null as any;
        data["whereCompleteByTagName"] = this.whereCompleteByTagName !== undefined ? this.whereCompleteByTagName : null as any;
        data["whereCompleteByOperatorName"] = this.whereCompleteByOperatorName !== undefined ? this.whereCompleteByOperatorName : null as any;
        data["wherePrereqDatapointName"] = this.wherePrereqDatapointName !== undefined ? this.wherePrereqDatapointName : null as any;
        data["wherePrereqAnswerText"] = this.wherePrereqAnswerText !== undefined ? this.wherePrereqAnswerText : null as any;
        data["whereRespondentRoleID"] = this.whereRespondentRoleID !== undefined ? this.whereRespondentRoleID : null as any;
        data["invert"] = this.invert !== undefined ? this.invert : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["prereqDatapointTargetID"] = this.prereqDatapointTargetID !== undefined ? this.prereqDatapointTargetID : null as any;
        data["datapointID"] = this.datapointID !== undefined ? this.datapointID : null as any;
        data["attributeTypeID"] = this.attributeTypeID !== undefined ? this.attributeTypeID : null as any;
        data["operatorID"] = this.operatorID !== undefined ? this.operatorID : null as any;
        data["whereCompleteByTagID"] = this.whereCompleteByTagID !== undefined ? this.whereCompleteByTagID : null as any;
        data["whereCompleteByOperatorID"] = this.whereCompleteByOperatorID !== undefined ? this.whereCompleteByOperatorID : null as any;
        data["wherePrereqDatapointID"] = this.wherePrereqDatapointID !== undefined ? this.wherePrereqDatapointID : null as any;
        data["wherePrereqAnswerID"] = this.wherePrereqAnswerID !== undefined ? this.wherePrereqAnswerID : null as any;
        data["datapointTargetSeq"] = this.datapointTargetSeq !== undefined ? this.datapointTargetSeq : null as any;
        data["wherePrereqAnswerTextLike"] = this.wherePrereqAnswerTextLike !== undefined ? this.wherePrereqAnswerTextLike : null as any;
        return data;
    }
}

export interface IDatapointTargetPrereqInfo {
    id?: number;
    datapointName?: string | null;
    attributeName?: string | null;
    operatorName?: string | null;
    whereCompleteByTagName?: string | null;
    whereCompleteByOperatorName?: string | null;
    wherePrereqDatapointName?: string | null;
    wherePrereqAnswerText?: string | null;
    whereRespondentRoleID?: number | null;
    invert?: boolean;
    active?: boolean;
    prereqDatapointTargetID?: number | null;
    datapointID?: number;
    attributeTypeID?: number;
    operatorID?: number;
    whereCompleteByTagID?: number | null;
    whereCompleteByOperatorID?: number | null;
    wherePrereqDatapointID?: number | null;
    wherePrereqAnswerID?: number | null;
    datapointTargetSeq?: number;
    wherePrereqAnswerTextLike?: string | null;
}

export class DatapointTargetPrereqType implements IDatapointTargetPrereqType {
    name!: string;
    notes?: string | null;
    id?: number;

    constructor(data?: IDatapointTargetPrereqType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): DatapointTargetPrereqType {
        data = typeof data === 'object' ? data : {};
        let result = new DatapointTargetPrereqType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IDatapointTargetPrereqType {
    name: string;
    notes?: string | null;
    id?: number;
}

export class DatapointTargetScript implements IDatapointTargetScript {
    ownerID?: number;
    owner?: Owner;
    datapointTargetID?: number;
    datapointTarget?: DatapointTarget;
    scriptID?: number;
    script?: Script;
    summaryItem!: boolean;
    active?: boolean;
    notes?: string | null;
    designerID!: string;
    datapointTargetDesignerID!: string;
    scriptDesignerID!: string;
    id?: number;

    constructor(data?: IDatapointTargetScript) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : null as any;
            this.datapointTargetID = _data["datapointTargetID"] !== undefined ? _data["datapointTargetID"] : null as any;
            this.datapointTarget = _data["datapointTarget"] ? DatapointTarget.fromJS(_data["datapointTarget"]) : null as any;
            this.scriptID = _data["scriptID"] !== undefined ? _data["scriptID"] : null as any;
            this.script = _data["script"] ? Script.fromJS(_data["script"]) : null as any;
            this.summaryItem = _data["summaryItem"] !== undefined ? _data["summaryItem"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.datapointTargetDesignerID = _data["datapointTargetDesignerID"] !== undefined ? _data["datapointTargetDesignerID"] : null as any;
            this.scriptDesignerID = _data["scriptDesignerID"] !== undefined ? _data["scriptDesignerID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): DatapointTargetScript {
        data = typeof data === 'object' ? data : {};
        let result = new DatapointTargetScript();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["owner"] = this.owner ? this.owner.toJSON() : null as any;
        data["datapointTargetID"] = this.datapointTargetID !== undefined ? this.datapointTargetID : null as any;
        data["datapointTarget"] = this.datapointTarget ? this.datapointTarget.toJSON() : null as any;
        data["scriptID"] = this.scriptID !== undefined ? this.scriptID : null as any;
        data["script"] = this.script ? this.script.toJSON() : null as any;
        data["summaryItem"] = this.summaryItem !== undefined ? this.summaryItem : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["datapointTargetDesignerID"] = this.datapointTargetDesignerID !== undefined ? this.datapointTargetDesignerID : null as any;
        data["scriptDesignerID"] = this.scriptDesignerID !== undefined ? this.scriptDesignerID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IDatapointTargetScript {
    ownerID?: number;
    owner?: Owner;
    datapointTargetID?: number;
    datapointTarget?: DatapointTarget;
    scriptID?: number;
    script?: Script;
    summaryItem: boolean;
    active?: boolean;
    notes?: string | null;
    designerID: string;
    datapointTargetDesignerID: string;
    scriptDesignerID: string;
    id?: number;
}

export class DatapointTargetTag implements IDatapointTargetTag {
    datapointTargetID?: number;
    datapointTarget?: DatapointTarget;
    tagID?: number;
    tag?: Tag;
    notes?: string | null;
    id?: number;

    constructor(data?: IDatapointTargetTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datapointTargetID = _data["datapointTargetID"] !== undefined ? _data["datapointTargetID"] : null as any;
            this.datapointTarget = _data["datapointTarget"] ? DatapointTarget.fromJS(_data["datapointTarget"]) : null as any;
            this.tagID = _data["tagID"] !== undefined ? _data["tagID"] : null as any;
            this.tag = _data["tag"] ? Tag.fromJS(_data["tag"]) : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): DatapointTargetTag {
        data = typeof data === 'object' ? data : {};
        let result = new DatapointTargetTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datapointTargetID"] = this.datapointTargetID !== undefined ? this.datapointTargetID : null as any;
        data["datapointTarget"] = this.datapointTarget ? this.datapointTarget.toJSON() : null as any;
        data["tagID"] = this.tagID !== undefined ? this.tagID : null as any;
        data["tag"] = this.tag ? this.tag.toJSON() : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IDatapointTargetTag {
    datapointTargetID?: number;
    datapointTarget?: DatapointTarget;
    tagID?: number;
    tag?: Tag;
    notes?: string | null;
    id?: number;
}

export class DatapointValue implements IDatapointValue {
    id?: number;
    values?: string[] | null;
    comparators?: string[] | null;
    datatype?: string | null;
    includeNulls?: boolean;

    constructor(data?: IDatapointValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            else {
                this.values = null as any;
            }
            if (Array.isArray(_data["comparators"])) {
                this.comparators = [] as any;
                for (let item of _data["comparators"])
                    this.comparators!.push(item);
            }
            else {
                this.comparators = null as any;
            }
            this.datatype = _data["datatype"] !== undefined ? _data["datatype"] : null as any;
            this.includeNulls = _data["includeNulls"] !== undefined ? _data["includeNulls"] : null as any;
        }
    }

    static fromJS(data: any): DatapointValue {
        data = typeof data === 'object' ? data : {};
        let result = new DatapointValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        if (Array.isArray(this.comparators)) {
            data["comparators"] = [];
            for (let item of this.comparators)
                data["comparators"].push(item);
        }
        data["datatype"] = this.datatype !== undefined ? this.datatype : null as any;
        data["includeNulls"] = this.includeNulls !== undefined ? this.includeNulls : null as any;
        return data;
    }
}

export interface IDatapointValue {
    id?: number;
    values?: string[] | null;
    comparators?: string[] | null;
    datatype?: string | null;
    includeNulls?: boolean;
}

export class DatapointValueRequest implements IDatapointValueRequest {
    datasetID?: number;
    respondentID?: number;
    iteration?: number;
    datapointTargetID?: number;
    groupByValueIndex?: number;
    returnRerenders?: boolean;
    valueText?: string | null;
    referenceNumber?: string | null;
    displayParentDatapointTargetID?: number | null;
    expressionExternalParams?: string | null;
    fileBase64URL?: string | null;
    returnDatapoints?: boolean;
    bulk?: boolean;
    bulkTargetID?: string | null;

    constructor(data?: IDatapointValueRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.datasetID = _data["datasetID"] !== undefined ? _data["datasetID"] : null as any;
            this.respondentID = _data["respondentID"] !== undefined ? _data["respondentID"] : null as any;
            this.iteration = _data["iteration"] !== undefined ? _data["iteration"] : null as any;
            this.datapointTargetID = _data["datapointTargetID"] !== undefined ? _data["datapointTargetID"] : null as any;
            this.groupByValueIndex = _data["groupByValueIndex"] !== undefined ? _data["groupByValueIndex"] : null as any;
            this.returnRerenders = _data["returnRerenders"] !== undefined ? _data["returnRerenders"] : null as any;
            this.valueText = _data["valueText"] !== undefined ? _data["valueText"] : null as any;
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
            this.displayParentDatapointTargetID = _data["displayParentDatapointTargetID"] !== undefined ? _data["displayParentDatapointTargetID"] : null as any;
            this.expressionExternalParams = _data["expressionExternalParams"] !== undefined ? _data["expressionExternalParams"] : null as any;
            this.fileBase64URL = _data["fileBase64URL"] !== undefined ? _data["fileBase64URL"] : null as any;
            this.returnDatapoints = _data["returnDatapoints"] !== undefined ? _data["returnDatapoints"] : null as any;
            this.bulk = _data["bulk"] !== undefined ? _data["bulk"] : null as any;
            this.bulkTargetID = _data["bulkTargetID"] !== undefined ? _data["bulkTargetID"] : null as any;
        }
    }

    static fromJS(data: any): DatapointValueRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DatapointValueRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["datasetID"] = this.datasetID !== undefined ? this.datasetID : null as any;
        data["respondentID"] = this.respondentID !== undefined ? this.respondentID : null as any;
        data["iteration"] = this.iteration !== undefined ? this.iteration : null as any;
        data["datapointTargetID"] = this.datapointTargetID !== undefined ? this.datapointTargetID : null as any;
        data["groupByValueIndex"] = this.groupByValueIndex !== undefined ? this.groupByValueIndex : null as any;
        data["returnRerenders"] = this.returnRerenders !== undefined ? this.returnRerenders : null as any;
        data["valueText"] = this.valueText !== undefined ? this.valueText : null as any;
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        data["displayParentDatapointTargetID"] = this.displayParentDatapointTargetID !== undefined ? this.displayParentDatapointTargetID : null as any;
        data["expressionExternalParams"] = this.expressionExternalParams !== undefined ? this.expressionExternalParams : null as any;
        data["fileBase64URL"] = this.fileBase64URL !== undefined ? this.fileBase64URL : null as any;
        data["returnDatapoints"] = this.returnDatapoints !== undefined ? this.returnDatapoints : null as any;
        data["bulk"] = this.bulk !== undefined ? this.bulk : null as any;
        data["bulkTargetID"] = this.bulkTargetID !== undefined ? this.bulkTargetID : null as any;
        return data;
    }
}

export interface IDatapointValueRequest {
    datasetID?: number;
    respondentID?: number;
    iteration?: number;
    datapointTargetID?: number;
    groupByValueIndex?: number;
    returnRerenders?: boolean;
    valueText?: string | null;
    referenceNumber?: string | null;
    displayParentDatapointTargetID?: number | null;
    expressionExternalParams?: string | null;
    fileBase64URL?: string | null;
    returnDatapoints?: boolean;
    bulk?: boolean;
    bulkTargetID?: string | null;
}

export class DatapointValuesRequest implements IDatapointValuesRequest {
    targetID?: number;
    datasetID?: number;
    respondentID?: number;
    iteration?: number;
    displayParentID?: number;
    datapointTargetValues?: { [key: string]: string; } | null;
    expressionExternalParams?: string | null;
    priorPage?: number;
    groupByValueIndex?: number;
    currentPage?: number;
    referenceNumber?: string | null;

    constructor(data?: IDatapointValuesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetID = _data["targetID"] !== undefined ? _data["targetID"] : null as any;
            this.datasetID = _data["datasetID"] !== undefined ? _data["datasetID"] : null as any;
            this.respondentID = _data["respondentID"] !== undefined ? _data["respondentID"] : null as any;
            this.iteration = _data["iteration"] !== undefined ? _data["iteration"] : null as any;
            this.displayParentID = _data["displayParentID"] !== undefined ? _data["displayParentID"] : null as any;
            if (_data["datapointTargetValues"]) {
                this.datapointTargetValues = {} as any;
                for (let key in _data["datapointTargetValues"]) {
                    if (_data["datapointTargetValues"].hasOwnProperty(key))
                        (this.datapointTargetValues as any)![key] = _data["datapointTargetValues"][key] !== undefined ? _data["datapointTargetValues"][key] : null as any;
                }
            }
            else {
                this.datapointTargetValues = null as any;
            }
            this.expressionExternalParams = _data["expressionExternalParams"] !== undefined ? _data["expressionExternalParams"] : null as any;
            this.priorPage = _data["priorPage"] !== undefined ? _data["priorPage"] : null as any;
            this.groupByValueIndex = _data["groupByValueIndex"] !== undefined ? _data["groupByValueIndex"] : null as any;
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
        }
    }

    static fromJS(data: any): DatapointValuesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DatapointValuesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetID"] = this.targetID !== undefined ? this.targetID : null as any;
        data["datasetID"] = this.datasetID !== undefined ? this.datasetID : null as any;
        data["respondentID"] = this.respondentID !== undefined ? this.respondentID : null as any;
        data["iteration"] = this.iteration !== undefined ? this.iteration : null as any;
        data["displayParentID"] = this.displayParentID !== undefined ? this.displayParentID : null as any;
        if (this.datapointTargetValues) {
            data["datapointTargetValues"] = {};
            for (let key in this.datapointTargetValues) {
                if (this.datapointTargetValues.hasOwnProperty(key))
                    (data["datapointTargetValues"] as any)[key] = this.datapointTargetValues[key] !== undefined ? this.datapointTargetValues[key] : null as any;
            }
        }
        data["expressionExternalParams"] = this.expressionExternalParams !== undefined ? this.expressionExternalParams : null as any;
        data["priorPage"] = this.priorPage !== undefined ? this.priorPage : null as any;
        data["groupByValueIndex"] = this.groupByValueIndex !== undefined ? this.groupByValueIndex : null as any;
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        return data;
    }
}

export interface IDatapointValuesRequest {
    targetID?: number;
    datasetID?: number;
    respondentID?: number;
    iteration?: number;
    displayParentID?: number;
    datapointTargetValues?: { [key: string]: string; } | null;
    expressionExternalParams?: string | null;
    priorPage?: number;
    groupByValueIndex?: number;
    currentPage?: number;
    referenceNumber?: string | null;
}

export class DatasetDatapoint implements IDatasetDatapoint {
    rownum?: number;
    requiredForCompletionCount?: number | null;
    requiredForCompletionComplete?: number | null;
    seqTemp?: number | null;
    subDatapointTargetID?: number | null;
    subTargetID?: number | null;
    ownerID?: number;
    datapointTargetID?: number;
    targetID?: number;
    name?: string | null;
    gridName?: string | null;
    gridID?: string | null;
    description?: string | null;
    valueText?: string | null;
    valueJSON?: string | null;
    datatype?: string | null;
    width?: number;
    precision?: number;
    step?: number | null;
    datapointID?: number;
    parentDatapointTargetID?: number | null;
    displayParentDatapointTargetID?: number | null;
    valueDate?: Date | null;
    valueCreatedDate?: Date | null;
    valueModifiedDate?: Date | null;
    valueNumeric?: number | null;
    valueBool?: boolean;
    valueBit?: boolean | null;
    valueID?: number | null;
    valueTypeID?: number | null;
    calculated?: boolean;
    collapsed?: boolean;
    heading?: boolean;
    seq?: number;
    menuSeq?: number | null;
    cssClass?: string | null;
    cssClassIDsAsString?: string | null;
    childDesignerIDsAsString?: string | null;
    cssClassSummaryItem?: string | null;
    cssClassSummaryItemIDsAsString?: string | null;
    visible?: boolean;
    applicable?: boolean;
    enabled?: boolean;
    menuItem?: boolean;
    menuLevel?: number | null;
    menuEnabled?: boolean;
    summaryItem?: boolean;
    required?: boolean;
    applyImmediate?: boolean;
    valueModifiedBy?: string | null;
    referenceNumber?: string | null;
    defaultDisabled?: boolean;
    defaultHidden?: boolean;
    validated?: boolean;
    renderAs?: string | null;
    renderTypeID?: number | null;
    pattern?: string | null;
    failMessage?: string | null;
    help?: string | null;
    expression?: string | null;
    defaultExpression?: string | null;
    overrideExpression?: string | null;
    isExpressionOverride?: boolean;
    styleExpression?: string | null;
    summaryItemStyleExpression?: string | null;
    searchName?: string | null;
    workflowActionExpression?: string | null;
    workflowExpression?: string | null;
    format?: string | null;
    isStatic?: boolean;
    designerID?: string | null;
    rerenderDesignerID?: string | null;
    rerenderID?: number | null;
    externalSearchable!: boolean;
    externalVisible!: boolean;
    multipleAnswer!: boolean;
    otherOption!: boolean;
    allowNullification!: boolean;
    designerCollapsed!: boolean;
    groupByValueIndex?: number;
    loadScriptID?: number | null;
    completeScriptID?: number | null;
    loadScript?: string | null;
    completeScript?: string | null;
    formGroupRoot!: boolean;
    formGroupMember!: boolean;
    formGroupAdd!: boolean;
    formGroupEdit!: boolean;
    formGroupDelete!: boolean;
    formGroupDeleteAll!: boolean;
    formGroupTabular!: boolean;
    formGroupDatatable!: boolean;
    requiredForCompletion!: boolean;
    iteration!: number;
    calculatedEditable!: boolean;
    buttonID?: number | null;
    buttonMarkup?: string | null;
    buttonSQL?: string | null;
    formGroupColumns?: string | null;
    captureResult!: boolean;
    tooltipDeleteAllRecords?: string | null;
    tooltipAddRecord?: string | null;
    tooltipDeleteRecord?: string | null;
    colName?: string | null;
    dataApiResponsePath?: string | null;
    disableOnUpdate?: boolean;
    fileTypeID?: number | null;
    fileName?: string | null;
    fileTypeMimeType?: string | null;
    fileTypeExtension?: string | null;
    placeholder?: string | null;
    loadMenuOnChange!: boolean;
    externalKey?: string | null;
    asEntryText?: boolean;
    templateRender?: boolean;
    onFormGroupAddedExpression?: string | null;
    addPrereq?: boolean | null;
    prereqType?: string | null;
    prereqValue?: boolean | null;
    prereqPredicate?: string | null;
    prereqTag?: string | null;
    prereqTargetDatapoint?: DatasetDatapoint;
    prereqValueOptionID?: number | null;
    prereqValueText?: string | null;
    prereqCompleteByOperator?: string | null;
    forUpdate?: boolean;
    maxReferenceNumber?: string | null;
    maxPriorReferenceNumber?: string | null;
    questionNumberTypeCode?: string | null;
    readonly id?: number;
    readonly label?: string | null;
    inputForDesignerID?: string | null;
    isDynamicRoot?: boolean;
    depth?: number;
    children?: DatasetDatapoint[] | null;
    historicResponses?: DatasetDatapoint[] | null;
    valueOptions?: ValueConfigOption[] | null;
    cssClassIDs?: number[] | null;
    cssClassSummaryItemIDs?: number[] | null;
    inputDesignerIDs?: string[] | null;
    datapointTargetScripts?: DatapointTargetScript[] | null;
    datapointTargetPrereqs?: DatapointTargetPrereq[] | null;
    datapointTargetTags?: DatapointTargetTag[] | null;
    optionWeight?: number | null;
    weight?: number | null;
    score?: number | null;
    readonly valueDatas?: ValueData[] | null;
    gridRoot?: boolean;
    renderEditPanel?: boolean;
    isLastGridRow?: boolean;
    isFirstValueGroupRecord?: boolean;
    isLastValueGroupRecord?: boolean;
    interTargetDesignerIDs?: string[] | null;
    valueFormat?: string | null;
    datapointTargetPrereqInfos?: DatapointTargetPrereqInfo[] | null;

    constructor(data?: IDatasetDatapoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rownum = _data["rownum"] !== undefined ? _data["rownum"] : null as any;
            this.requiredForCompletionCount = _data["requiredForCompletionCount"] !== undefined ? _data["requiredForCompletionCount"] : null as any;
            this.requiredForCompletionComplete = _data["requiredForCompletionComplete"] !== undefined ? _data["requiredForCompletionComplete"] : null as any;
            this.seqTemp = _data["seqTemp"] !== undefined ? _data["seqTemp"] : null as any;
            this.subDatapointTargetID = _data["subDatapointTargetID"] !== undefined ? _data["subDatapointTargetID"] : null as any;
            this.subTargetID = _data["subTargetID"] !== undefined ? _data["subTargetID"] : null as any;
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.datapointTargetID = _data["datapointTargetID"] !== undefined ? _data["datapointTargetID"] : null as any;
            this.targetID = _data["targetID"] !== undefined ? _data["targetID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.gridName = _data["gridName"] !== undefined ? _data["gridName"] : null as any;
            this.gridID = _data["gridID"] !== undefined ? _data["gridID"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.valueText = _data["valueText"] !== undefined ? _data["valueText"] : null as any;
            this.valueJSON = _data["valueJSON"] !== undefined ? _data["valueJSON"] : null as any;
            this.datatype = _data["datatype"] !== undefined ? _data["datatype"] : null as any;
            this.width = _data["width"] !== undefined ? _data["width"] : null as any;
            this.precision = _data["precision"] !== undefined ? _data["precision"] : null as any;
            this.step = _data["step"] !== undefined ? _data["step"] : null as any;
            this.datapointID = _data["datapointID"] !== undefined ? _data["datapointID"] : null as any;
            this.parentDatapointTargetID = _data["parentDatapointTargetID"] !== undefined ? _data["parentDatapointTargetID"] : null as any;
            this.displayParentDatapointTargetID = _data["displayParentDatapointTargetID"] !== undefined ? _data["displayParentDatapointTargetID"] : null as any;
            this.valueDate = _data["valueDate"] ? new Date(_data["valueDate"].toString()) : null as any;
            this.valueCreatedDate = _data["valueCreatedDate"] ? new Date(_data["valueCreatedDate"].toString()) : null as any;
            this.valueModifiedDate = _data["valueModifiedDate"] ? new Date(_data["valueModifiedDate"].toString()) : null as any;
            this.valueNumeric = _data["valueNumeric"] !== undefined ? _data["valueNumeric"] : null as any;
            this.valueBool = _data["valueBool"] !== undefined ? _data["valueBool"] : null as any;
            this.valueBit = _data["valueBit"] !== undefined ? _data["valueBit"] : null as any;
            this.valueID = _data["valueID"] !== undefined ? _data["valueID"] : null as any;
            this.valueTypeID = _data["valueTypeID"] !== undefined ? _data["valueTypeID"] : null as any;
            this.calculated = _data["calculated"] !== undefined ? _data["calculated"] : null as any;
            this.collapsed = _data["collapsed"] !== undefined ? _data["collapsed"] : null as any;
            this.heading = _data["heading"] !== undefined ? _data["heading"] : null as any;
            this.seq = _data["seq"] !== undefined ? _data["seq"] : null as any;
            this.menuSeq = _data["menuSeq"] !== undefined ? _data["menuSeq"] : null as any;
            this.cssClass = _data["cssClass"] !== undefined ? _data["cssClass"] : null as any;
            this.cssClassIDsAsString = _data["cssClassIDsAsString"] !== undefined ? _data["cssClassIDsAsString"] : null as any;
            this.childDesignerIDsAsString = _data["childDesignerIDsAsString"] !== undefined ? _data["childDesignerIDsAsString"] : null as any;
            this.cssClassSummaryItem = _data["cssClassSummaryItem"] !== undefined ? _data["cssClassSummaryItem"] : null as any;
            this.cssClassSummaryItemIDsAsString = _data["cssClassSummaryItemIDsAsString"] !== undefined ? _data["cssClassSummaryItemIDsAsString"] : null as any;
            this.visible = _data["visible"] !== undefined ? _data["visible"] : null as any;
            this.applicable = _data["applicable"] !== undefined ? _data["applicable"] : null as any;
            this.enabled = _data["enabled"] !== undefined ? _data["enabled"] : null as any;
            this.menuItem = _data["menuItem"] !== undefined ? _data["menuItem"] : null as any;
            this.menuLevel = _data["menuLevel"] !== undefined ? _data["menuLevel"] : null as any;
            this.menuEnabled = _data["menuEnabled"] !== undefined ? _data["menuEnabled"] : null as any;
            this.summaryItem = _data["summaryItem"] !== undefined ? _data["summaryItem"] : null as any;
            this.required = _data["required"] !== undefined ? _data["required"] : null as any;
            this.applyImmediate = _data["applyImmediate"] !== undefined ? _data["applyImmediate"] : null as any;
            this.valueModifiedBy = _data["valueModifiedBy"] !== undefined ? _data["valueModifiedBy"] : null as any;
            this.referenceNumber = _data["referenceNumber"] !== undefined ? _data["referenceNumber"] : null as any;
            this.defaultDisabled = _data["defaultDisabled"] !== undefined ? _data["defaultDisabled"] : null as any;
            this.defaultHidden = _data["defaultHidden"] !== undefined ? _data["defaultHidden"] : null as any;
            this.validated = _data["validated"] !== undefined ? _data["validated"] : null as any;
            this.renderAs = _data["renderAs"] !== undefined ? _data["renderAs"] : null as any;
            this.renderTypeID = _data["renderTypeID"] !== undefined ? _data["renderTypeID"] : null as any;
            this.pattern = _data["pattern"] !== undefined ? _data["pattern"] : null as any;
            this.failMessage = _data["failMessage"] !== undefined ? _data["failMessage"] : null as any;
            this.help = _data["help"] !== undefined ? _data["help"] : null as any;
            this.expression = _data["expression"] !== undefined ? _data["expression"] : null as any;
            this.defaultExpression = _data["defaultExpression"] !== undefined ? _data["defaultExpression"] : null as any;
            this.overrideExpression = _data["overrideExpression"] !== undefined ? _data["overrideExpression"] : null as any;
            this.isExpressionOverride = _data["isExpressionOverride"] !== undefined ? _data["isExpressionOverride"] : null as any;
            this.styleExpression = _data["styleExpression"] !== undefined ? _data["styleExpression"] : null as any;
            this.summaryItemStyleExpression = _data["summaryItemStyleExpression"] !== undefined ? _data["summaryItemStyleExpression"] : null as any;
            this.searchName = _data["searchName"] !== undefined ? _data["searchName"] : null as any;
            this.workflowActionExpression = _data["workflowActionExpression"] !== undefined ? _data["workflowActionExpression"] : null as any;
            this.workflowExpression = _data["workflowExpression"] !== undefined ? _data["workflowExpression"] : null as any;
            this.format = _data["format"] !== undefined ? _data["format"] : null as any;
            this.isStatic = _data["isStatic"] !== undefined ? _data["isStatic"] : null as any;
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.rerenderDesignerID = _data["rerenderDesignerID"] !== undefined ? _data["rerenderDesignerID"] : null as any;
            this.rerenderID = _data["rerenderID"] !== undefined ? _data["rerenderID"] : null as any;
            this.externalSearchable = _data["externalSearchable"] !== undefined ? _data["externalSearchable"] : null as any;
            this.externalVisible = _data["externalVisible"] !== undefined ? _data["externalVisible"] : null as any;
            this.multipleAnswer = _data["multipleAnswer"] !== undefined ? _data["multipleAnswer"] : null as any;
            this.otherOption = _data["otherOption"] !== undefined ? _data["otherOption"] : null as any;
            this.allowNullification = _data["allowNullification"] !== undefined ? _data["allowNullification"] : null as any;
            this.designerCollapsed = _data["designerCollapsed"] !== undefined ? _data["designerCollapsed"] : null as any;
            this.groupByValueIndex = _data["groupByValueIndex"] !== undefined ? _data["groupByValueIndex"] : null as any;
            this.loadScriptID = _data["loadScriptID"] !== undefined ? _data["loadScriptID"] : null as any;
            this.completeScriptID = _data["completeScriptID"] !== undefined ? _data["completeScriptID"] : null as any;
            this.loadScript = _data["loadScript"] !== undefined ? _data["loadScript"] : null as any;
            this.completeScript = _data["completeScript"] !== undefined ? _data["completeScript"] : null as any;
            this.formGroupRoot = _data["formGroupRoot"] !== undefined ? _data["formGroupRoot"] : null as any;
            this.formGroupMember = _data["formGroupMember"] !== undefined ? _data["formGroupMember"] : null as any;
            this.formGroupAdd = _data["formGroupAdd"] !== undefined ? _data["formGroupAdd"] : null as any;
            this.formGroupEdit = _data["formGroupEdit"] !== undefined ? _data["formGroupEdit"] : null as any;
            this.formGroupDelete = _data["formGroupDelete"] !== undefined ? _data["formGroupDelete"] : null as any;
            this.formGroupDeleteAll = _data["formGroupDeleteAll"] !== undefined ? _data["formGroupDeleteAll"] : null as any;
            this.formGroupTabular = _data["formGroupTabular"] !== undefined ? _data["formGroupTabular"] : null as any;
            this.formGroupDatatable = _data["formGroupDatatable"] !== undefined ? _data["formGroupDatatable"] : null as any;
            this.requiredForCompletion = _data["requiredForCompletion"] !== undefined ? _data["requiredForCompletion"] : null as any;
            this.iteration = _data["iteration"] !== undefined ? _data["iteration"] : null as any;
            this.calculatedEditable = _data["calculatedEditable"] !== undefined ? _data["calculatedEditable"] : null as any;
            this.buttonID = _data["buttonID"] !== undefined ? _data["buttonID"] : null as any;
            this.buttonMarkup = _data["buttonMarkup"] !== undefined ? _data["buttonMarkup"] : null as any;
            this.buttonSQL = _data["buttonSQL"] !== undefined ? _data["buttonSQL"] : null as any;
            this.formGroupColumns = _data["formGroupColumns"] !== undefined ? _data["formGroupColumns"] : null as any;
            this.captureResult = _data["captureResult"] !== undefined ? _data["captureResult"] : null as any;
            this.tooltipDeleteAllRecords = _data["tooltipDeleteAllRecords"] !== undefined ? _data["tooltipDeleteAllRecords"] : null as any;
            this.tooltipAddRecord = _data["tooltipAddRecord"] !== undefined ? _data["tooltipAddRecord"] : null as any;
            this.tooltipDeleteRecord = _data["tooltipDeleteRecord"] !== undefined ? _data["tooltipDeleteRecord"] : null as any;
            this.colName = _data["colName"] !== undefined ? _data["colName"] : null as any;
            this.dataApiResponsePath = _data["dataApiResponsePath"] !== undefined ? _data["dataApiResponsePath"] : null as any;
            this.disableOnUpdate = _data["disableOnUpdate"] !== undefined ? _data["disableOnUpdate"] : null as any;
            this.fileTypeID = _data["fileTypeID"] !== undefined ? _data["fileTypeID"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.fileTypeMimeType = _data["fileTypeMimeType"] !== undefined ? _data["fileTypeMimeType"] : null as any;
            this.fileTypeExtension = _data["fileTypeExtension"] !== undefined ? _data["fileTypeExtension"] : null as any;
            this.placeholder = _data["placeholder"] !== undefined ? _data["placeholder"] : null as any;
            this.loadMenuOnChange = _data["loadMenuOnChange"] !== undefined ? _data["loadMenuOnChange"] : null as any;
            this.externalKey = _data["externalKey"] !== undefined ? _data["externalKey"] : null as any;
            this.asEntryText = _data["asEntryText"] !== undefined ? _data["asEntryText"] : null as any;
            this.templateRender = _data["templateRender"] !== undefined ? _data["templateRender"] : null as any;
            this.onFormGroupAddedExpression = _data["onFormGroupAddedExpression"] !== undefined ? _data["onFormGroupAddedExpression"] : null as any;
            this.addPrereq = _data["addPrereq"] !== undefined ? _data["addPrereq"] : null as any;
            this.prereqType = _data["prereqType"] !== undefined ? _data["prereqType"] : null as any;
            this.prereqValue = _data["prereqValue"] !== undefined ? _data["prereqValue"] : null as any;
            this.prereqPredicate = _data["prereqPredicate"] !== undefined ? _data["prereqPredicate"] : null as any;
            this.prereqTag = _data["prereqTag"] !== undefined ? _data["prereqTag"] : null as any;
            this.prereqTargetDatapoint = _data["prereqTargetDatapoint"] ? DatasetDatapoint.fromJS(_data["prereqTargetDatapoint"]) : null as any;
            this.prereqValueOptionID = _data["prereqValueOptionID"] !== undefined ? _data["prereqValueOptionID"] : null as any;
            this.prereqValueText = _data["prereqValueText"] !== undefined ? _data["prereqValueText"] : null as any;
            this.prereqCompleteByOperator = _data["prereqCompleteByOperator"] !== undefined ? _data["prereqCompleteByOperator"] : null as any;
            this.forUpdate = _data["forUpdate"] !== undefined ? _data["forUpdate"] : null as any;
            this.maxReferenceNumber = _data["maxReferenceNumber"] !== undefined ? _data["maxReferenceNumber"] : null as any;
            this.maxPriorReferenceNumber = _data["maxPriorReferenceNumber"] !== undefined ? _data["maxPriorReferenceNumber"] : null as any;
            this.questionNumberTypeCode = _data["questionNumberTypeCode"] !== undefined ? _data["questionNumberTypeCode"] : null as any;
            (this as any).id = _data["id"] !== undefined ? _data["id"] : null as any;
            (this as any).label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.inputForDesignerID = _data["inputForDesignerID"] !== undefined ? _data["inputForDesignerID"] : null as any;
            this.isDynamicRoot = _data["isDynamicRoot"] !== undefined ? _data["isDynamicRoot"] : null as any;
            this.depth = _data["depth"] !== undefined ? _data["depth"] : null as any;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(DatasetDatapoint.fromJS(item));
            }
            else {
                this.children = null as any;
            }
            if (Array.isArray(_data["historicResponses"])) {
                this.historicResponses = [] as any;
                for (let item of _data["historicResponses"])
                    this.historicResponses!.push(DatasetDatapoint.fromJS(item));
            }
            else {
                this.historicResponses = null as any;
            }
            if (Array.isArray(_data["valueOptions"])) {
                this.valueOptions = [] as any;
                for (let item of _data["valueOptions"])
                    this.valueOptions!.push(ValueConfigOption.fromJS(item));
            }
            else {
                this.valueOptions = null as any;
            }
            if (Array.isArray(_data["cssClassIDs"])) {
                this.cssClassIDs = [] as any;
                for (let item of _data["cssClassIDs"])
                    this.cssClassIDs!.push(item);
            }
            else {
                this.cssClassIDs = null as any;
            }
            if (Array.isArray(_data["cssClassSummaryItemIDs"])) {
                this.cssClassSummaryItemIDs = [] as any;
                for (let item of _data["cssClassSummaryItemIDs"])
                    this.cssClassSummaryItemIDs!.push(item);
            }
            else {
                this.cssClassSummaryItemIDs = null as any;
            }
            if (Array.isArray(_data["inputDesignerIDs"])) {
                this.inputDesignerIDs = [] as any;
                for (let item of _data["inputDesignerIDs"])
                    this.inputDesignerIDs!.push(item);
            }
            else {
                this.inputDesignerIDs = null as any;
            }
            if (Array.isArray(_data["datapointTargetScripts"])) {
                this.datapointTargetScripts = [] as any;
                for (let item of _data["datapointTargetScripts"])
                    this.datapointTargetScripts!.push(DatapointTargetScript.fromJS(item));
            }
            else {
                this.datapointTargetScripts = null as any;
            }
            if (Array.isArray(_data["datapointTargetPrereqs"])) {
                this.datapointTargetPrereqs = [] as any;
                for (let item of _data["datapointTargetPrereqs"])
                    this.datapointTargetPrereqs!.push(DatapointTargetPrereq.fromJS(item));
            }
            else {
                this.datapointTargetPrereqs = null as any;
            }
            if (Array.isArray(_data["datapointTargetTags"])) {
                this.datapointTargetTags = [] as any;
                for (let item of _data["datapointTargetTags"])
                    this.datapointTargetTags!.push(DatapointTargetTag.fromJS(item));
            }
            else {
                this.datapointTargetTags = null as any;
            }
            this.optionWeight = _data["optionWeight"] !== undefined ? _data["optionWeight"] : null as any;
            this.weight = _data["weight"] !== undefined ? _data["weight"] : null as any;
            this.score = _data["score"] !== undefined ? _data["score"] : null as any;
            if (Array.isArray(_data["valueDatas"])) {
                (this as any).valueDatas = [] as any;
                for (let item of _data["valueDatas"])
                    (this as any).valueDatas!.push(ValueData.fromJS(item));
            }
            else {
                (this as any).valueDatas = null as any;
            }
            this.gridRoot = _data["gridRoot"] !== undefined ? _data["gridRoot"] : null as any;
            this.renderEditPanel = _data["renderEditPanel"] !== undefined ? _data["renderEditPanel"] : null as any;
            this.isLastGridRow = _data["isLastGridRow"] !== undefined ? _data["isLastGridRow"] : null as any;
            this.isFirstValueGroupRecord = _data["isFirstValueGroupRecord"] !== undefined ? _data["isFirstValueGroupRecord"] : null as any;
            this.isLastValueGroupRecord = _data["isLastValueGroupRecord"] !== undefined ? _data["isLastValueGroupRecord"] : null as any;
            if (Array.isArray(_data["interTargetDesignerIDs"])) {
                this.interTargetDesignerIDs = [] as any;
                for (let item of _data["interTargetDesignerIDs"])
                    this.interTargetDesignerIDs!.push(item);
            }
            else {
                this.interTargetDesignerIDs = null as any;
            }
            this.valueFormat = _data["valueFormat"] !== undefined ? _data["valueFormat"] : null as any;
            if (Array.isArray(_data["datapointTargetPrereqInfos"])) {
                this.datapointTargetPrereqInfos = [] as any;
                for (let item of _data["datapointTargetPrereqInfos"])
                    this.datapointTargetPrereqInfos!.push(DatapointTargetPrereqInfo.fromJS(item));
            }
            else {
                this.datapointTargetPrereqInfos = null as any;
            }
        }
    }

    static fromJS(data: any): DatasetDatapoint {
        data = typeof data === 'object' ? data : {};
        let result = new DatasetDatapoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rownum"] = this.rownum !== undefined ? this.rownum : null as any;
        data["requiredForCompletionCount"] = this.requiredForCompletionCount !== undefined ? this.requiredForCompletionCount : null as any;
        data["requiredForCompletionComplete"] = this.requiredForCompletionComplete !== undefined ? this.requiredForCompletionComplete : null as any;
        data["seqTemp"] = this.seqTemp !== undefined ? this.seqTemp : null as any;
        data["subDatapointTargetID"] = this.subDatapointTargetID !== undefined ? this.subDatapointTargetID : null as any;
        data["subTargetID"] = this.subTargetID !== undefined ? this.subTargetID : null as any;
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["datapointTargetID"] = this.datapointTargetID !== undefined ? this.datapointTargetID : null as any;
        data["targetID"] = this.targetID !== undefined ? this.targetID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["gridName"] = this.gridName !== undefined ? this.gridName : null as any;
        data["gridID"] = this.gridID !== undefined ? this.gridID : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["valueText"] = this.valueText !== undefined ? this.valueText : null as any;
        data["valueJSON"] = this.valueJSON !== undefined ? this.valueJSON : null as any;
        data["datatype"] = this.datatype !== undefined ? this.datatype : null as any;
        data["width"] = this.width !== undefined ? this.width : null as any;
        data["precision"] = this.precision !== undefined ? this.precision : null as any;
        data["step"] = this.step !== undefined ? this.step : null as any;
        data["datapointID"] = this.datapointID !== undefined ? this.datapointID : null as any;
        data["parentDatapointTargetID"] = this.parentDatapointTargetID !== undefined ? this.parentDatapointTargetID : null as any;
        data["displayParentDatapointTargetID"] = this.displayParentDatapointTargetID !== undefined ? this.displayParentDatapointTargetID : null as any;
        data["valueDate"] = this.valueDate ? this.valueDate.toISOString() : null as any;
        data["valueCreatedDate"] = this.valueCreatedDate ? this.valueCreatedDate.toISOString() : null as any;
        data["valueModifiedDate"] = this.valueModifiedDate ? this.valueModifiedDate.toISOString() : null as any;
        data["valueNumeric"] = this.valueNumeric !== undefined ? this.valueNumeric : null as any;
        data["valueBool"] = this.valueBool !== undefined ? this.valueBool : null as any;
        data["valueBit"] = this.valueBit !== undefined ? this.valueBit : null as any;
        data["valueID"] = this.valueID !== undefined ? this.valueID : null as any;
        data["valueTypeID"] = this.valueTypeID !== undefined ? this.valueTypeID : null as any;
        data["calculated"] = this.calculated !== undefined ? this.calculated : null as any;
        data["collapsed"] = this.collapsed !== undefined ? this.collapsed : null as any;
        data["heading"] = this.heading !== undefined ? this.heading : null as any;
        data["seq"] = this.seq !== undefined ? this.seq : null as any;
        data["menuSeq"] = this.menuSeq !== undefined ? this.menuSeq : null as any;
        data["cssClass"] = this.cssClass !== undefined ? this.cssClass : null as any;
        data["cssClassIDsAsString"] = this.cssClassIDsAsString !== undefined ? this.cssClassIDsAsString : null as any;
        data["childDesignerIDsAsString"] = this.childDesignerIDsAsString !== undefined ? this.childDesignerIDsAsString : null as any;
        data["cssClassSummaryItem"] = this.cssClassSummaryItem !== undefined ? this.cssClassSummaryItem : null as any;
        data["cssClassSummaryItemIDsAsString"] = this.cssClassSummaryItemIDsAsString !== undefined ? this.cssClassSummaryItemIDsAsString : null as any;
        data["visible"] = this.visible !== undefined ? this.visible : null as any;
        data["applicable"] = this.applicable !== undefined ? this.applicable : null as any;
        data["enabled"] = this.enabled !== undefined ? this.enabled : null as any;
        data["menuItem"] = this.menuItem !== undefined ? this.menuItem : null as any;
        data["menuLevel"] = this.menuLevel !== undefined ? this.menuLevel : null as any;
        data["menuEnabled"] = this.menuEnabled !== undefined ? this.menuEnabled : null as any;
        data["summaryItem"] = this.summaryItem !== undefined ? this.summaryItem : null as any;
        data["required"] = this.required !== undefined ? this.required : null as any;
        data["applyImmediate"] = this.applyImmediate !== undefined ? this.applyImmediate : null as any;
        data["valueModifiedBy"] = this.valueModifiedBy !== undefined ? this.valueModifiedBy : null as any;
        data["referenceNumber"] = this.referenceNumber !== undefined ? this.referenceNumber : null as any;
        data["defaultDisabled"] = this.defaultDisabled !== undefined ? this.defaultDisabled : null as any;
        data["defaultHidden"] = this.defaultHidden !== undefined ? this.defaultHidden : null as any;
        data["validated"] = this.validated !== undefined ? this.validated : null as any;
        data["renderAs"] = this.renderAs !== undefined ? this.renderAs : null as any;
        data["renderTypeID"] = this.renderTypeID !== undefined ? this.renderTypeID : null as any;
        data["pattern"] = this.pattern !== undefined ? this.pattern : null as any;
        data["failMessage"] = this.failMessage !== undefined ? this.failMessage : null as any;
        data["help"] = this.help !== undefined ? this.help : null as any;
        data["expression"] = this.expression !== undefined ? this.expression : null as any;
        data["defaultExpression"] = this.defaultExpression !== undefined ? this.defaultExpression : null as any;
        data["overrideExpression"] = this.overrideExpression !== undefined ? this.overrideExpression : null as any;
        data["isExpressionOverride"] = this.isExpressionOverride !== undefined ? this.isExpressionOverride : null as any;
        data["styleExpression"] = this.styleExpression !== undefined ? this.styleExpression : null as any;
        data["summaryItemStyleExpression"] = this.summaryItemStyleExpression !== undefined ? this.summaryItemStyleExpression : null as any;
        data["searchName"] = this.searchName !== undefined ? this.searchName : null as any;
        data["workflowActionExpression"] = this.workflowActionExpression !== undefined ? this.workflowActionExpression : null as any;
        data["workflowExpression"] = this.workflowExpression !== undefined ? this.workflowExpression : null as any;
        data["format"] = this.format !== undefined ? this.format : null as any;
        data["isStatic"] = this.isStatic !== undefined ? this.isStatic : null as any;
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["rerenderDesignerID"] = this.rerenderDesignerID !== undefined ? this.rerenderDesignerID : null as any;
        data["rerenderID"] = this.rerenderID !== undefined ? this.rerenderID : null as any;
        data["externalSearchable"] = this.externalSearchable !== undefined ? this.externalSearchable : null as any;
        data["externalVisible"] = this.externalVisible !== undefined ? this.externalVisible : null as any;
        data["multipleAnswer"] = this.multipleAnswer !== undefined ? this.multipleAnswer : null as any;
        data["otherOption"] = this.otherOption !== undefined ? this.otherOption : null as any;
        data["allowNullification"] = this.allowNullification !== undefined ? this.allowNullification : null as any;
        data["designerCollapsed"] = this.designerCollapsed !== undefined ? this.designerCollapsed : null as any;
        data["groupByValueIndex"] = this.groupByValueIndex !== undefined ? this.groupByValueIndex : null as any;
        data["loadScriptID"] = this.loadScriptID !== undefined ? this.loadScriptID : null as any;
        data["completeScriptID"] = this.completeScriptID !== undefined ? this.completeScriptID : null as any;
        data["loadScript"] = this.loadScript !== undefined ? this.loadScript : null as any;
        data["completeScript"] = this.completeScript !== undefined ? this.completeScript : null as any;
        data["formGroupRoot"] = this.formGroupRoot !== undefined ? this.formGroupRoot : null as any;
        data["formGroupMember"] = this.formGroupMember !== undefined ? this.formGroupMember : null as any;
        data["formGroupAdd"] = this.formGroupAdd !== undefined ? this.formGroupAdd : null as any;
        data["formGroupEdit"] = this.formGroupEdit !== undefined ? this.formGroupEdit : null as any;
        data["formGroupDelete"] = this.formGroupDelete !== undefined ? this.formGroupDelete : null as any;
        data["formGroupDeleteAll"] = this.formGroupDeleteAll !== undefined ? this.formGroupDeleteAll : null as any;
        data["formGroupTabular"] = this.formGroupTabular !== undefined ? this.formGroupTabular : null as any;
        data["formGroupDatatable"] = this.formGroupDatatable !== undefined ? this.formGroupDatatable : null as any;
        data["requiredForCompletion"] = this.requiredForCompletion !== undefined ? this.requiredForCompletion : null as any;
        data["iteration"] = this.iteration !== undefined ? this.iteration : null as any;
        data["calculatedEditable"] = this.calculatedEditable !== undefined ? this.calculatedEditable : null as any;
        data["buttonID"] = this.buttonID !== undefined ? this.buttonID : null as any;
        data["buttonMarkup"] = this.buttonMarkup !== undefined ? this.buttonMarkup : null as any;
        data["buttonSQL"] = this.buttonSQL !== undefined ? this.buttonSQL : null as any;
        data["formGroupColumns"] = this.formGroupColumns !== undefined ? this.formGroupColumns : null as any;
        data["captureResult"] = this.captureResult !== undefined ? this.captureResult : null as any;
        data["tooltipDeleteAllRecords"] = this.tooltipDeleteAllRecords !== undefined ? this.tooltipDeleteAllRecords : null as any;
        data["tooltipAddRecord"] = this.tooltipAddRecord !== undefined ? this.tooltipAddRecord : null as any;
        data["tooltipDeleteRecord"] = this.tooltipDeleteRecord !== undefined ? this.tooltipDeleteRecord : null as any;
        data["colName"] = this.colName !== undefined ? this.colName : null as any;
        data["dataApiResponsePath"] = this.dataApiResponsePath !== undefined ? this.dataApiResponsePath : null as any;
        data["disableOnUpdate"] = this.disableOnUpdate !== undefined ? this.disableOnUpdate : null as any;
        data["fileTypeID"] = this.fileTypeID !== undefined ? this.fileTypeID : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileTypeMimeType"] = this.fileTypeMimeType !== undefined ? this.fileTypeMimeType : null as any;
        data["fileTypeExtension"] = this.fileTypeExtension !== undefined ? this.fileTypeExtension : null as any;
        data["placeholder"] = this.placeholder !== undefined ? this.placeholder : null as any;
        data["loadMenuOnChange"] = this.loadMenuOnChange !== undefined ? this.loadMenuOnChange : null as any;
        data["externalKey"] = this.externalKey !== undefined ? this.externalKey : null as any;
        data["asEntryText"] = this.asEntryText !== undefined ? this.asEntryText : null as any;
        data["templateRender"] = this.templateRender !== undefined ? this.templateRender : null as any;
        data["onFormGroupAddedExpression"] = this.onFormGroupAddedExpression !== undefined ? this.onFormGroupAddedExpression : null as any;
        data["addPrereq"] = this.addPrereq !== undefined ? this.addPrereq : null as any;
        data["prereqType"] = this.prereqType !== undefined ? this.prereqType : null as any;
        data["prereqValue"] = this.prereqValue !== undefined ? this.prereqValue : null as any;
        data["prereqPredicate"] = this.prereqPredicate !== undefined ? this.prereqPredicate : null as any;
        data["prereqTag"] = this.prereqTag !== undefined ? this.prereqTag : null as any;
        data["prereqTargetDatapoint"] = this.prereqTargetDatapoint ? this.prereqTargetDatapoint.toJSON() : null as any;
        data["prereqValueOptionID"] = this.prereqValueOptionID !== undefined ? this.prereqValueOptionID : null as any;
        data["prereqValueText"] = this.prereqValueText !== undefined ? this.prereqValueText : null as any;
        data["prereqCompleteByOperator"] = this.prereqCompleteByOperator !== undefined ? this.prereqCompleteByOperator : null as any;
        data["forUpdate"] = this.forUpdate !== undefined ? this.forUpdate : null as any;
        data["maxReferenceNumber"] = this.maxReferenceNumber !== undefined ? this.maxReferenceNumber : null as any;
        data["maxPriorReferenceNumber"] = this.maxPriorReferenceNumber !== undefined ? this.maxPriorReferenceNumber : null as any;
        data["questionNumberTypeCode"] = this.questionNumberTypeCode !== undefined ? this.questionNumberTypeCode : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["inputForDesignerID"] = this.inputForDesignerID !== undefined ? this.inputForDesignerID : null as any;
        data["isDynamicRoot"] = this.isDynamicRoot !== undefined ? this.isDynamicRoot : null as any;
        data["depth"] = this.depth !== undefined ? this.depth : null as any;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.historicResponses)) {
            data["historicResponses"] = [];
            for (let item of this.historicResponses)
                data["historicResponses"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.valueOptions)) {
            data["valueOptions"] = [];
            for (let item of this.valueOptions)
                data["valueOptions"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.cssClassIDs)) {
            data["cssClassIDs"] = [];
            for (let item of this.cssClassIDs)
                data["cssClassIDs"].push(item);
        }
        if (Array.isArray(this.cssClassSummaryItemIDs)) {
            data["cssClassSummaryItemIDs"] = [];
            for (let item of this.cssClassSummaryItemIDs)
                data["cssClassSummaryItemIDs"].push(item);
        }
        if (Array.isArray(this.inputDesignerIDs)) {
            data["inputDesignerIDs"] = [];
            for (let item of this.inputDesignerIDs)
                data["inputDesignerIDs"].push(item);
        }
        if (Array.isArray(this.datapointTargetScripts)) {
            data["datapointTargetScripts"] = [];
            for (let item of this.datapointTargetScripts)
                data["datapointTargetScripts"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.datapointTargetPrereqs)) {
            data["datapointTargetPrereqs"] = [];
            for (let item of this.datapointTargetPrereqs)
                data["datapointTargetPrereqs"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.datapointTargetTags)) {
            data["datapointTargetTags"] = [];
            for (let item of this.datapointTargetTags)
                data["datapointTargetTags"].push(item ? item.toJSON() : null as any);
        }
        data["optionWeight"] = this.optionWeight !== undefined ? this.optionWeight : null as any;
        data["weight"] = this.weight !== undefined ? this.weight : null as any;
        data["score"] = this.score !== undefined ? this.score : null as any;
        if (Array.isArray(this.valueDatas)) {
            data["valueDatas"] = [];
            for (let item of this.valueDatas)
                data["valueDatas"].push(item ? item.toJSON() : null as any);
        }
        data["gridRoot"] = this.gridRoot !== undefined ? this.gridRoot : null as any;
        data["renderEditPanel"] = this.renderEditPanel !== undefined ? this.renderEditPanel : null as any;
        data["isLastGridRow"] = this.isLastGridRow !== undefined ? this.isLastGridRow : null as any;
        data["isFirstValueGroupRecord"] = this.isFirstValueGroupRecord !== undefined ? this.isFirstValueGroupRecord : null as any;
        data["isLastValueGroupRecord"] = this.isLastValueGroupRecord !== undefined ? this.isLastValueGroupRecord : null as any;
        if (Array.isArray(this.interTargetDesignerIDs)) {
            data["interTargetDesignerIDs"] = [];
            for (let item of this.interTargetDesignerIDs)
                data["interTargetDesignerIDs"].push(item);
        }
        data["valueFormat"] = this.valueFormat !== undefined ? this.valueFormat : null as any;
        if (Array.isArray(this.datapointTargetPrereqInfos)) {
            data["datapointTargetPrereqInfos"] = [];
            for (let item of this.datapointTargetPrereqInfos)
                data["datapointTargetPrereqInfos"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IDatasetDatapoint {
    rownum?: number;
    requiredForCompletionCount?: number | null;
    requiredForCompletionComplete?: number | null;
    seqTemp?: number | null;
    subDatapointTargetID?: number | null;
    subTargetID?: number | null;
    ownerID?: number;
    datapointTargetID?: number;
    targetID?: number;
    name?: string | null;
    gridName?: string | null;
    gridID?: string | null;
    description?: string | null;
    valueText?: string | null;
    valueJSON?: string | null;
    datatype?: string | null;
    width?: number;
    precision?: number;
    step?: number | null;
    datapointID?: number;
    parentDatapointTargetID?: number | null;
    displayParentDatapointTargetID?: number | null;
    valueDate?: Date | null;
    valueCreatedDate?: Date | null;
    valueModifiedDate?: Date | null;
    valueNumeric?: number | null;
    valueBool?: boolean;
    valueBit?: boolean | null;
    valueID?: number | null;
    valueTypeID?: number | null;
    calculated?: boolean;
    collapsed?: boolean;
    heading?: boolean;
    seq?: number;
    menuSeq?: number | null;
    cssClass?: string | null;
    cssClassIDsAsString?: string | null;
    childDesignerIDsAsString?: string | null;
    cssClassSummaryItem?: string | null;
    cssClassSummaryItemIDsAsString?: string | null;
    visible?: boolean;
    applicable?: boolean;
    enabled?: boolean;
    menuItem?: boolean;
    menuLevel?: number | null;
    menuEnabled?: boolean;
    summaryItem?: boolean;
    required?: boolean;
    applyImmediate?: boolean;
    valueModifiedBy?: string | null;
    referenceNumber?: string | null;
    defaultDisabled?: boolean;
    defaultHidden?: boolean;
    validated?: boolean;
    renderAs?: string | null;
    renderTypeID?: number | null;
    pattern?: string | null;
    failMessage?: string | null;
    help?: string | null;
    expression?: string | null;
    defaultExpression?: string | null;
    overrideExpression?: string | null;
    isExpressionOverride?: boolean;
    styleExpression?: string | null;
    summaryItemStyleExpression?: string | null;
    searchName?: string | null;
    workflowActionExpression?: string | null;
    workflowExpression?: string | null;
    format?: string | null;
    isStatic?: boolean;
    designerID?: string | null;
    rerenderDesignerID?: string | null;
    rerenderID?: number | null;
    externalSearchable: boolean;
    externalVisible: boolean;
    multipleAnswer: boolean;
    otherOption: boolean;
    allowNullification: boolean;
    designerCollapsed: boolean;
    groupByValueIndex?: number;
    loadScriptID?: number | null;
    completeScriptID?: number | null;
    loadScript?: string | null;
    completeScript?: string | null;
    formGroupRoot: boolean;
    formGroupMember: boolean;
    formGroupAdd: boolean;
    formGroupEdit: boolean;
    formGroupDelete: boolean;
    formGroupDeleteAll: boolean;
    formGroupTabular: boolean;
    formGroupDatatable: boolean;
    requiredForCompletion: boolean;
    iteration: number;
    calculatedEditable: boolean;
    buttonID?: number | null;
    buttonMarkup?: string | null;
    buttonSQL?: string | null;
    formGroupColumns?: string | null;
    captureResult: boolean;
    tooltipDeleteAllRecords?: string | null;
    tooltipAddRecord?: string | null;
    tooltipDeleteRecord?: string | null;
    colName?: string | null;
    dataApiResponsePath?: string | null;
    disableOnUpdate?: boolean;
    fileTypeID?: number | null;
    fileName?: string | null;
    fileTypeMimeType?: string | null;
    fileTypeExtension?: string | null;
    placeholder?: string | null;
    loadMenuOnChange: boolean;
    externalKey?: string | null;
    asEntryText?: boolean;
    templateRender?: boolean;
    onFormGroupAddedExpression?: string | null;
    addPrereq?: boolean | null;
    prereqType?: string | null;
    prereqValue?: boolean | null;
    prereqPredicate?: string | null;
    prereqTag?: string | null;
    prereqTargetDatapoint?: DatasetDatapoint;
    prereqValueOptionID?: number | null;
    prereqValueText?: string | null;
    prereqCompleteByOperator?: string | null;
    forUpdate?: boolean;
    maxReferenceNumber?: string | null;
    maxPriorReferenceNumber?: string | null;
    questionNumberTypeCode?: string | null;
    id?: number;
    label?: string | null;
    inputForDesignerID?: string | null;
    isDynamicRoot?: boolean;
    depth?: number;
    children?: DatasetDatapoint[] | null;
    historicResponses?: DatasetDatapoint[] | null;
    valueOptions?: ValueConfigOption[] | null;
    cssClassIDs?: number[] | null;
    cssClassSummaryItemIDs?: number[] | null;
    inputDesignerIDs?: string[] | null;
    datapointTargetScripts?: DatapointTargetScript[] | null;
    datapointTargetPrereqs?: DatapointTargetPrereq[] | null;
    datapointTargetTags?: DatapointTargetTag[] | null;
    optionWeight?: number | null;
    weight?: number | null;
    score?: number | null;
    valueDatas?: ValueData[] | null;
    gridRoot?: boolean;
    renderEditPanel?: boolean;
    isLastGridRow?: boolean;
    isFirstValueGroupRecord?: boolean;
    isLastValueGroupRecord?: boolean;
    interTargetDesignerIDs?: string[] | null;
    valueFormat?: string | null;
    datapointTargetPrereqInfos?: DatapointTargetPrereqInfo[] | null;
}

export class DatasetKey implements IDatasetKey {
    id?: number;
    iteration?: number;

    constructor(data?: IDatasetKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.iteration = _data["iteration"] !== undefined ? _data["iteration"] : null as any;
        }
    }

    static fromJS(data: any): DatasetKey {
        data = typeof data === 'object' ? data : {};
        let result = new DatasetKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["iteration"] = this.iteration !== undefined ? this.iteration : null as any;
        return data;
    }
}

export interface IDatasetKey {
    id?: number;
    iteration?: number;
}

export class Datatype implements IDatatype {
    designerID!: string;
    name!: string;
    description!: string;
    notes?: string | null;
    id?: number;

    constructor(data?: IDatatype) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): Datatype {
        data = typeof data === 'object' ? data : {};
        let result = new Datatype();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IDatatype {
    designerID: string;
    name: string;
    description: string;
    notes?: string | null;
    id?: number;
}

export class ETKAction implements IETKAction {
    action?: string | null;
    displayName?: string | null;
    commentRequired?: boolean;
    possibleReasons?: ETKActionReason[] | null;

    constructor(data?: IETKAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"] !== undefined ? _data["action"] : null as any;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null as any;
            this.commentRequired = _data["commentRequired"] !== undefined ? _data["commentRequired"] : null as any;
            if (Array.isArray(_data["possibleReasons"])) {
                this.possibleReasons = [] as any;
                for (let item of _data["possibleReasons"])
                    this.possibleReasons!.push(ETKActionReason.fromJS(item));
            }
            else {
                this.possibleReasons = null as any;
            }
        }
    }

    static fromJS(data: any): ETKAction {
        data = typeof data === 'object' ? data : {};
        let result = new ETKAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action !== undefined ? this.action : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        data["commentRequired"] = this.commentRequired !== undefined ? this.commentRequired : null as any;
        if (Array.isArray(this.possibleReasons)) {
            data["possibleReasons"] = [];
            for (let item of this.possibleReasons)
                data["possibleReasons"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IETKAction {
    action?: string | null;
    displayName?: string | null;
    commentRequired?: boolean;
    possibleReasons?: ETKActionReason[] | null;
}

export class ETKActionContext implements IETKActionContext {
    possibleActions?: ETKAction[] | null;
    lastAction?: ETKActionResponse;

    constructor(data?: IETKActionContext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["possibleActions"])) {
                this.possibleActions = [] as any;
                for (let item of _data["possibleActions"])
                    this.possibleActions!.push(ETKAction.fromJS(item));
            }
            else {
                this.possibleActions = null as any;
            }
            this.lastAction = _data["lastAction"] ? ETKActionResponse.fromJS(_data["lastAction"]) : null as any;
        }
    }

    static fromJS(data: any): ETKActionContext {
        data = typeof data === 'object' ? data : {};
        let result = new ETKActionContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.possibleActions)) {
            data["possibleActions"] = [];
            for (let item of this.possibleActions)
                data["possibleActions"].push(item ? item.toJSON() : null as any);
        }
        data["lastAction"] = this.lastAction ? this.lastAction.toJSON() : null as any;
        return data;
    }
}

export interface IETKActionContext {
    possibleActions?: ETKAction[] | null;
    lastAction?: ETKActionResponse;
}

export class ETKActionReason implements IETKActionReason {
    reason?: string | null;
    displayName?: string | null;

    constructor(data?: IETKActionReason) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.displayName = _data["displayName"] !== undefined ? _data["displayName"] : null as any;
        }
    }

    static fromJS(data: any): ETKActionReason {
        data = typeof data === 'object' ? data : {};
        let result = new ETKActionReason();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["displayName"] = this.displayName !== undefined ? this.displayName : null as any;
        return data;
    }
}

export interface IETKActionReason {
    reason?: string | null;
    displayName?: string | null;
}

export class ETKActionResponse implements IETKActionResponse {
    action?: string | null;
    actionUserName?: string | null;
    actionDate?: Date;
    reason?: string | null;
    reasonDisplayName?: string | null;
    reasons?: ETKActionReason[] | null;
    notes?: string | null;

    constructor(data?: IETKActionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"] !== undefined ? _data["action"] : null as any;
            this.actionUserName = _data["actionUserName"] !== undefined ? _data["actionUserName"] : null as any;
            this.actionDate = _data["actionDate"] ? new Date(_data["actionDate"].toString()) : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
            this.reasonDisplayName = _data["reasonDisplayName"] !== undefined ? _data["reasonDisplayName"] : null as any;
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(ETKActionReason.fromJS(item));
            }
            else {
                this.reasons = null as any;
            }
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
        }
    }

    static fromJS(data: any): ETKActionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ETKActionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action !== undefined ? this.action : null as any;
        data["actionUserName"] = this.actionUserName !== undefined ? this.actionUserName : null as any;
        data["actionDate"] = this.actionDate ? this.actionDate.toISOString() : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        data["reasonDisplayName"] = this.reasonDisplayName !== undefined ? this.reasonDisplayName : null as any;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item ? item.toJSON() : null as any);
        }
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        return data;
    }
}

export interface IETKActionResponse {
    action?: string | null;
    actionUserName?: string | null;
    actionDate?: Date;
    reason?: string | null;
    reasonDisplayName?: string | null;
    reasons?: ETKActionReason[] | null;
    notes?: string | null;
}

export class ETKDTO implements IETKDTO {
    supplierID?: string | null;
    supplierLookupName?: string | null;
    needsReview?: string | null;
    locationType?: string | null;
    vestibule?: string | null;
    jobNumber?: string | null;
    gmpRequestId?: string | null;
    buId?: string | null;
    matchedRequestID?: string | null;
    matchedBUID?: string | null;
    gmpExpectedStart?: Date | null;
    gmpExpectedEnd?: Date | null;
    buildingId?: number | null;
    locationName?: string | null;
    empdetailkey?: string | null;
    fullName?: string | null;
    scheduledIn?: Date | null;
    scheduledOut?: Date | null;
    reconciledIn?: Date | null;
    reconciledOut?: Date | null;
    collectedIn?: Date | null;
    reasonForBlankPunchIn?: string | null;
    collectedOut?: Date | null;
    reasonForBlankPunchOut?: string | null;
    guardPayRate?: number | null;
    guardBillRate?: number | null;
    guardType?: string | null;
    jobLatitude?: number | null;
    jobLongitude?: number | null;
    geoFenceRadius?: string | null;
    scheduledPings?: number | null;
    pingsReceived?: number | null;
    outsideGeofence?: number | null;
    pingType?: string | null;
    reviewerSid?: string | null;
    videoCheckIn?: string | null;
    videoCheckOut?: string | null;
    comments?: string | null;
    secondaryReviewSid?: string | null;
    secondaryReviewCheckIn?: string | null;
    secondaryReviewCheckOut?: string | null;
    secondaryReviewCompleted?: string | null;
    secondaryReviewComments?: string | null;
    timeSlot?: string | null;
    reviewType?: string | null;
    vendor?: string | null;
    reasonForOfficer?: string | null;
    typeOfIssue?: string | null;
    vendorComments?: string | null;
    creditProcessed?: string | null;
    jpmcBilled?: string | null;

    constructor(data?: IETKDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierID = _data["supplierID"] !== undefined ? _data["supplierID"] : null as any;
            this.supplierLookupName = _data["supplierLookupName"] !== undefined ? _data["supplierLookupName"] : null as any;
            this.needsReview = _data["needsReview"] !== undefined ? _data["needsReview"] : null as any;
            this.locationType = _data["locationType"] !== undefined ? _data["locationType"] : null as any;
            this.vestibule = _data["vestibule"] !== undefined ? _data["vestibule"] : null as any;
            this.jobNumber = _data["jobNumber"] !== undefined ? _data["jobNumber"] : null as any;
            this.gmpRequestId = _data["gmpRequestId"] !== undefined ? _data["gmpRequestId"] : null as any;
            this.buId = _data["buId"] !== undefined ? _data["buId"] : null as any;
            this.matchedRequestID = _data["matchedRequestID"] !== undefined ? _data["matchedRequestID"] : null as any;
            this.matchedBUID = _data["matchedBUID"] !== undefined ? _data["matchedBUID"] : null as any;
            this.gmpExpectedStart = _data["gmpExpectedStart"] ? new Date(_data["gmpExpectedStart"].toString()) : null as any;
            this.gmpExpectedEnd = _data["gmpExpectedEnd"] ? new Date(_data["gmpExpectedEnd"].toString()) : null as any;
            this.buildingId = _data["buildingId"] !== undefined ? _data["buildingId"] : null as any;
            this.locationName = _data["locationName"] !== undefined ? _data["locationName"] : null as any;
            this.empdetailkey = _data["empdetailkey"] !== undefined ? _data["empdetailkey"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.scheduledIn = _data["scheduledIn"] ? new Date(_data["scheduledIn"].toString()) : null as any;
            this.scheduledOut = _data["scheduledOut"] ? new Date(_data["scheduledOut"].toString()) : null as any;
            this.reconciledIn = _data["reconciledIn"] ? new Date(_data["reconciledIn"].toString()) : null as any;
            this.reconciledOut = _data["reconciledOut"] ? new Date(_data["reconciledOut"].toString()) : null as any;
            this.collectedIn = _data["collectedIn"] ? new Date(_data["collectedIn"].toString()) : null as any;
            this.reasonForBlankPunchIn = _data["reasonForBlankPunchIn"] !== undefined ? _data["reasonForBlankPunchIn"] : null as any;
            this.collectedOut = _data["collectedOut"] ? new Date(_data["collectedOut"].toString()) : null as any;
            this.reasonForBlankPunchOut = _data["reasonForBlankPunchOut"] !== undefined ? _data["reasonForBlankPunchOut"] : null as any;
            this.guardPayRate = _data["guardPayRate"] !== undefined ? _data["guardPayRate"] : null as any;
            this.guardBillRate = _data["guardBillRate"] !== undefined ? _data["guardBillRate"] : null as any;
            this.guardType = _data["guardType"] !== undefined ? _data["guardType"] : null as any;
            this.jobLatitude = _data["jobLatitude"] !== undefined ? _data["jobLatitude"] : null as any;
            this.jobLongitude = _data["jobLongitude"] !== undefined ? _data["jobLongitude"] : null as any;
            this.geoFenceRadius = _data["geoFenceRadius"] !== undefined ? _data["geoFenceRadius"] : null as any;
            this.scheduledPings = _data["scheduledPings"] !== undefined ? _data["scheduledPings"] : null as any;
            this.pingsReceived = _data["pingsReceived"] !== undefined ? _data["pingsReceived"] : null as any;
            this.outsideGeofence = _data["outsideGeofence"] !== undefined ? _data["outsideGeofence"] : null as any;
            this.pingType = _data["pingType"] !== undefined ? _data["pingType"] : null as any;
            this.reviewerSid = _data["reviewerSid"] !== undefined ? _data["reviewerSid"] : null as any;
            this.videoCheckIn = _data["videoCheckIn"] !== undefined ? _data["videoCheckIn"] : null as any;
            this.videoCheckOut = _data["videoCheckOut"] !== undefined ? _data["videoCheckOut"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.secondaryReviewSid = _data["secondaryReviewSid"] !== undefined ? _data["secondaryReviewSid"] : null as any;
            this.secondaryReviewCheckIn = _data["secondaryReviewCheckIn"] !== undefined ? _data["secondaryReviewCheckIn"] : null as any;
            this.secondaryReviewCheckOut = _data["secondaryReviewCheckOut"] !== undefined ? _data["secondaryReviewCheckOut"] : null as any;
            this.secondaryReviewCompleted = _data["secondaryReviewCompleted"] !== undefined ? _data["secondaryReviewCompleted"] : null as any;
            this.secondaryReviewComments = _data["secondaryReviewComments"] !== undefined ? _data["secondaryReviewComments"] : null as any;
            this.timeSlot = _data["timeSlot"] !== undefined ? _data["timeSlot"] : null as any;
            this.reviewType = _data["reviewType"] !== undefined ? _data["reviewType"] : null as any;
            this.vendor = _data["vendor"] !== undefined ? _data["vendor"] : null as any;
            this.reasonForOfficer = _data["reasonForOfficer"] !== undefined ? _data["reasonForOfficer"] : null as any;
            this.typeOfIssue = _data["typeOfIssue"] !== undefined ? _data["typeOfIssue"] : null as any;
            this.vendorComments = _data["vendorComments"] !== undefined ? _data["vendorComments"] : null as any;
            this.creditProcessed = _data["creditProcessed"] !== undefined ? _data["creditProcessed"] : null as any;
            this.jpmcBilled = _data["jpmcBilled"] !== undefined ? _data["jpmcBilled"] : null as any;
        }
    }

    static fromJS(data: any): ETKDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ETKDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierID"] = this.supplierID !== undefined ? this.supplierID : null as any;
        data["supplierLookupName"] = this.supplierLookupName !== undefined ? this.supplierLookupName : null as any;
        data["needsReview"] = this.needsReview !== undefined ? this.needsReview : null as any;
        data["locationType"] = this.locationType !== undefined ? this.locationType : null as any;
        data["vestibule"] = this.vestibule !== undefined ? this.vestibule : null as any;
        data["jobNumber"] = this.jobNumber !== undefined ? this.jobNumber : null as any;
        data["gmpRequestId"] = this.gmpRequestId !== undefined ? this.gmpRequestId : null as any;
        data["buId"] = this.buId !== undefined ? this.buId : null as any;
        data["matchedRequestID"] = this.matchedRequestID !== undefined ? this.matchedRequestID : null as any;
        data["matchedBUID"] = this.matchedBUID !== undefined ? this.matchedBUID : null as any;
        data["gmpExpectedStart"] = this.gmpExpectedStart ? this.gmpExpectedStart.toISOString() : null as any;
        data["gmpExpectedEnd"] = this.gmpExpectedEnd ? this.gmpExpectedEnd.toISOString() : null as any;
        data["buildingId"] = this.buildingId !== undefined ? this.buildingId : null as any;
        data["locationName"] = this.locationName !== undefined ? this.locationName : null as any;
        data["empdetailkey"] = this.empdetailkey !== undefined ? this.empdetailkey : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["scheduledIn"] = this.scheduledIn ? this.scheduledIn.toISOString() : null as any;
        data["scheduledOut"] = this.scheduledOut ? this.scheduledOut.toISOString() : null as any;
        data["reconciledIn"] = this.reconciledIn ? this.reconciledIn.toISOString() : null as any;
        data["reconciledOut"] = this.reconciledOut ? this.reconciledOut.toISOString() : null as any;
        data["collectedIn"] = this.collectedIn ? this.collectedIn.toISOString() : null as any;
        data["reasonForBlankPunchIn"] = this.reasonForBlankPunchIn !== undefined ? this.reasonForBlankPunchIn : null as any;
        data["collectedOut"] = this.collectedOut ? this.collectedOut.toISOString() : null as any;
        data["reasonForBlankPunchOut"] = this.reasonForBlankPunchOut !== undefined ? this.reasonForBlankPunchOut : null as any;
        data["guardPayRate"] = this.guardPayRate !== undefined ? this.guardPayRate : null as any;
        data["guardBillRate"] = this.guardBillRate !== undefined ? this.guardBillRate : null as any;
        data["guardType"] = this.guardType !== undefined ? this.guardType : null as any;
        data["jobLatitude"] = this.jobLatitude !== undefined ? this.jobLatitude : null as any;
        data["jobLongitude"] = this.jobLongitude !== undefined ? this.jobLongitude : null as any;
        data["geoFenceRadius"] = this.geoFenceRadius !== undefined ? this.geoFenceRadius : null as any;
        data["scheduledPings"] = this.scheduledPings !== undefined ? this.scheduledPings : null as any;
        data["pingsReceived"] = this.pingsReceived !== undefined ? this.pingsReceived : null as any;
        data["outsideGeofence"] = this.outsideGeofence !== undefined ? this.outsideGeofence : null as any;
        data["pingType"] = this.pingType !== undefined ? this.pingType : null as any;
        data["reviewerSid"] = this.reviewerSid !== undefined ? this.reviewerSid : null as any;
        data["videoCheckIn"] = this.videoCheckIn !== undefined ? this.videoCheckIn : null as any;
        data["videoCheckOut"] = this.videoCheckOut !== undefined ? this.videoCheckOut : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["secondaryReviewSid"] = this.secondaryReviewSid !== undefined ? this.secondaryReviewSid : null as any;
        data["secondaryReviewCheckIn"] = this.secondaryReviewCheckIn !== undefined ? this.secondaryReviewCheckIn : null as any;
        data["secondaryReviewCheckOut"] = this.secondaryReviewCheckOut !== undefined ? this.secondaryReviewCheckOut : null as any;
        data["secondaryReviewCompleted"] = this.secondaryReviewCompleted !== undefined ? this.secondaryReviewCompleted : null as any;
        data["secondaryReviewComments"] = this.secondaryReviewComments !== undefined ? this.secondaryReviewComments : null as any;
        data["timeSlot"] = this.timeSlot !== undefined ? this.timeSlot : null as any;
        data["reviewType"] = this.reviewType !== undefined ? this.reviewType : null as any;
        data["vendor"] = this.vendor !== undefined ? this.vendor : null as any;
        data["reasonForOfficer"] = this.reasonForOfficer !== undefined ? this.reasonForOfficer : null as any;
        data["typeOfIssue"] = this.typeOfIssue !== undefined ? this.typeOfIssue : null as any;
        data["vendorComments"] = this.vendorComments !== undefined ? this.vendorComments : null as any;
        data["creditProcessed"] = this.creditProcessed !== undefined ? this.creditProcessed : null as any;
        data["jpmcBilled"] = this.jpmcBilled !== undefined ? this.jpmcBilled : null as any;
        return data;
    }
}

export interface IETKDTO {
    supplierID?: string | null;
    supplierLookupName?: string | null;
    needsReview?: string | null;
    locationType?: string | null;
    vestibule?: string | null;
    jobNumber?: string | null;
    gmpRequestId?: string | null;
    buId?: string | null;
    matchedRequestID?: string | null;
    matchedBUID?: string | null;
    gmpExpectedStart?: Date | null;
    gmpExpectedEnd?: Date | null;
    buildingId?: number | null;
    locationName?: string | null;
    empdetailkey?: string | null;
    fullName?: string | null;
    scheduledIn?: Date | null;
    scheduledOut?: Date | null;
    reconciledIn?: Date | null;
    reconciledOut?: Date | null;
    collectedIn?: Date | null;
    reasonForBlankPunchIn?: string | null;
    collectedOut?: Date | null;
    reasonForBlankPunchOut?: string | null;
    guardPayRate?: number | null;
    guardBillRate?: number | null;
    guardType?: string | null;
    jobLatitude?: number | null;
    jobLongitude?: number | null;
    geoFenceRadius?: string | null;
    scheduledPings?: number | null;
    pingsReceived?: number | null;
    outsideGeofence?: number | null;
    pingType?: string | null;
    reviewerSid?: string | null;
    videoCheckIn?: string | null;
    videoCheckOut?: string | null;
    comments?: string | null;
    secondaryReviewSid?: string | null;
    secondaryReviewCheckIn?: string | null;
    secondaryReviewCheckOut?: string | null;
    secondaryReviewCompleted?: string | null;
    secondaryReviewComments?: string | null;
    timeSlot?: string | null;
    reviewType?: string | null;
    vendor?: string | null;
    reasonForOfficer?: string | null;
    typeOfIssue?: string | null;
    vendorComments?: string | null;
    creditProcessed?: string | null;
    jpmcBilled?: string | null;
}

export class ETKSiteReportResponse implements IETKSiteReportResponse {
    siteId?: number;
    siteName?: string | null;
    etkRows?: ETKSiteReportRowResponse[] | null;

    constructor(data?: IETKSiteReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null as any;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null as any;
            if (Array.isArray(_data["etkRows"])) {
                this.etkRows = [] as any;
                for (let item of _data["etkRows"])
                    this.etkRows!.push(ETKSiteReportRowResponse.fromJS(item));
            }
            else {
                this.etkRows = null as any;
            }
        }
    }

    static fromJS(data: any): ETKSiteReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ETKSiteReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId !== undefined ? this.siteId : null as any;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null as any;
        if (Array.isArray(this.etkRows)) {
            data["etkRows"] = [];
            for (let item of this.etkRows)
                data["etkRows"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IETKSiteReportResponse {
    siteId?: number;
    siteName?: string | null;
    etkRows?: ETKSiteReportRowResponse[] | null;
}

export class ETKSiteReportRowResponse implements IETKSiteReportRowResponse {
    etkId?: string;
    supplierName?: string | null;
    needsReview?: boolean;
    requestedCoverageDate?: Date;
    requestedCoverageTime?: string | null;
    hoursRequested?: number;
    hoursProvided?: number;
    hoursVarianceMinutes?: number;
    guardCount?: number;
    requestID?: string | null;
    invoiceNumber?: string | null;
    coverageCostRequested?: number | null;
    coverageCostProvided?: number | null;
    lastAction?: ETKActionResponse;

    constructor(data?: IETKSiteReportRowResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.etkId = _data["etkId"] !== undefined ? _data["etkId"] : null as any;
            this.supplierName = _data["supplierName"] !== undefined ? _data["supplierName"] : null as any;
            this.needsReview = _data["needsReview"] !== undefined ? _data["needsReview"] : null as any;
            this.requestedCoverageDate = _data["requestedCoverageDate"] ? new Date(_data["requestedCoverageDate"].toString()) : null as any;
            this.requestedCoverageTime = _data["requestedCoverageTime"] !== undefined ? _data["requestedCoverageTime"] : null as any;
            this.hoursRequested = _data["hoursRequested"] !== undefined ? _data["hoursRequested"] : null as any;
            this.hoursProvided = _data["hoursProvided"] !== undefined ? _data["hoursProvided"] : null as any;
            this.hoursVarianceMinutes = _data["hoursVarianceMinutes"] !== undefined ? _data["hoursVarianceMinutes"] : null as any;
            this.guardCount = _data["guardCount"] !== undefined ? _data["guardCount"] : null as any;
            this.requestID = _data["requestID"] !== undefined ? _data["requestID"] : null as any;
            this.invoiceNumber = _data["invoiceNumber"] !== undefined ? _data["invoiceNumber"] : null as any;
            this.coverageCostRequested = _data["coverageCostRequested"] !== undefined ? _data["coverageCostRequested"] : null as any;
            this.coverageCostProvided = _data["coverageCostProvided"] !== undefined ? _data["coverageCostProvided"] : null as any;
            this.lastAction = _data["lastAction"] ? ETKActionResponse.fromJS(_data["lastAction"]) : null as any;
        }
    }

    static fromJS(data: any): ETKSiteReportRowResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ETKSiteReportRowResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["etkId"] = this.etkId !== undefined ? this.etkId : null as any;
        data["supplierName"] = this.supplierName !== undefined ? this.supplierName : null as any;
        data["needsReview"] = this.needsReview !== undefined ? this.needsReview : null as any;
        data["requestedCoverageDate"] = this.requestedCoverageDate ? formatDate(this.requestedCoverageDate) : null as any;
        data["requestedCoverageTime"] = this.requestedCoverageTime !== undefined ? this.requestedCoverageTime : null as any;
        data["hoursRequested"] = this.hoursRequested !== undefined ? this.hoursRequested : null as any;
        data["hoursProvided"] = this.hoursProvided !== undefined ? this.hoursProvided : null as any;
        data["hoursVarianceMinutes"] = this.hoursVarianceMinutes !== undefined ? this.hoursVarianceMinutes : null as any;
        data["guardCount"] = this.guardCount !== undefined ? this.guardCount : null as any;
        data["requestID"] = this.requestID !== undefined ? this.requestID : null as any;
        data["invoiceNumber"] = this.invoiceNumber !== undefined ? this.invoiceNumber : null as any;
        data["coverageCostRequested"] = this.coverageCostRequested !== undefined ? this.coverageCostRequested : null as any;
        data["coverageCostProvided"] = this.coverageCostProvided !== undefined ? this.coverageCostProvided : null as any;
        data["lastAction"] = this.lastAction ? this.lastAction.toJSON() : null as any;
        return data;
    }
}

export interface IETKSiteReportRowResponse {
    etkId?: string;
    supplierName?: string | null;
    needsReview?: boolean;
    requestedCoverageDate?: Date;
    requestedCoverageTime?: string | null;
    hoursRequested?: number;
    hoursProvided?: number;
    hoursVarianceMinutes?: number;
    guardCount?: number;
    requestID?: string | null;
    invoiceNumber?: string | null;
    coverageCostRequested?: number | null;
    coverageCostProvided?: number | null;
    lastAction?: ETKActionResponse;
}

export class EmailLog implements IEmailLog {
    id?: number;
    live?: boolean;
    debug?: boolean;
    success?: boolean;
    from?: string | null;
    to?: string | null;
    cc?: string | null;
    subject?: string | null;
    textBody?: string | null;
    htmlBody?: string | null;
    attachments?: string | null;
    intervalExpressionID?: number;
    exceptionString?: string | null;
    jsonRequest?: string | null;
    jsonResponse?: string | null;
    statusCode?: string | null;
    viaCCS?: boolean;
    ownerID?: number | null;
    exception?: any | null;

    constructor(data?: IEmailLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.live = _data["live"] !== undefined ? _data["live"] : null as any;
            this.debug = _data["debug"] !== undefined ? _data["debug"] : null as any;
            this.success = _data["success"] !== undefined ? _data["success"] : null as any;
            this.from = _data["from"] !== undefined ? _data["from"] : null as any;
            this.to = _data["to"] !== undefined ? _data["to"] : null as any;
            this.cc = _data["cc"] !== undefined ? _data["cc"] : null as any;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null as any;
            this.textBody = _data["textBody"] !== undefined ? _data["textBody"] : null as any;
            this.htmlBody = _data["htmlBody"] !== undefined ? _data["htmlBody"] : null as any;
            this.attachments = _data["attachments"] !== undefined ? _data["attachments"] : null as any;
            this.intervalExpressionID = _data["intervalExpressionID"] !== undefined ? _data["intervalExpressionID"] : null as any;
            this.exceptionString = _data["exceptionString"] !== undefined ? _data["exceptionString"] : null as any;
            this.jsonRequest = _data["jsonRequest"] !== undefined ? _data["jsonRequest"] : null as any;
            this.jsonResponse = _data["jsonResponse"] !== undefined ? _data["jsonResponse"] : null as any;
            this.statusCode = _data["statusCode"] !== undefined ? _data["statusCode"] : null as any;
            this.viaCCS = _data["viaCCS"] !== undefined ? _data["viaCCS"] : null as any;
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.exception = _data["exception"] !== undefined ? _data["exception"] : null as any;
        }
    }

    static fromJS(data: any): EmailLog {
        data = typeof data === 'object' ? data : {};
        let result = new EmailLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["live"] = this.live !== undefined ? this.live : null as any;
        data["debug"] = this.debug !== undefined ? this.debug : null as any;
        data["success"] = this.success !== undefined ? this.success : null as any;
        data["from"] = this.from !== undefined ? this.from : null as any;
        data["to"] = this.to !== undefined ? this.to : null as any;
        data["cc"] = this.cc !== undefined ? this.cc : null as any;
        data["subject"] = this.subject !== undefined ? this.subject : null as any;
        data["textBody"] = this.textBody !== undefined ? this.textBody : null as any;
        data["htmlBody"] = this.htmlBody !== undefined ? this.htmlBody : null as any;
        data["attachments"] = this.attachments !== undefined ? this.attachments : null as any;
        data["intervalExpressionID"] = this.intervalExpressionID !== undefined ? this.intervalExpressionID : null as any;
        data["exceptionString"] = this.exceptionString !== undefined ? this.exceptionString : null as any;
        data["jsonRequest"] = this.jsonRequest !== undefined ? this.jsonRequest : null as any;
        data["jsonResponse"] = this.jsonResponse !== undefined ? this.jsonResponse : null as any;
        data["statusCode"] = this.statusCode !== undefined ? this.statusCode : null as any;
        data["viaCCS"] = this.viaCCS !== undefined ? this.viaCCS : null as any;
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["exception"] = this.exception !== undefined ? this.exception : null as any;
        return data;
    }
}

export interface IEmailLog {
    id?: number;
    live?: boolean;
    debug?: boolean;
    success?: boolean;
    from?: string | null;
    to?: string | null;
    cc?: string | null;
    subject?: string | null;
    textBody?: string | null;
    htmlBody?: string | null;
    attachments?: string | null;
    intervalExpressionID?: number;
    exceptionString?: string | null;
    jsonRequest?: string | null;
    jsonResponse?: string | null;
    statusCode?: string | null;
    viaCCS?: boolean;
    ownerID?: number | null;
    exception?: any | null;
}

export enum ErrorHandlingLogic {
    Skip = "Skip",
    MoveToPreviousBusinessDay = "MoveToPreviousBusinessDay",
    MoveToNextBusinessDay = "MoveToNextBusinessDay",
}

export class ErrorLog implements IErrorLog {
    ownerID?: number | null;
    createdDate!: Date;
    source!: string;
    type!: string;
    message!: string;
    stackTrace?: string | null;
    respondentID?: number | null;
    sendEmail?: boolean;
    emailLogID?: number | null;
    messageOnly?: boolean;
    id?: number;

    constructor(data?: IErrorLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.stackTrace = _data["stackTrace"] !== undefined ? _data["stackTrace"] : null as any;
            this.respondentID = _data["respondentID"] !== undefined ? _data["respondentID"] : null as any;
            this.sendEmail = _data["sendEmail"] !== undefined ? _data["sendEmail"] : null as any;
            this.emailLogID = _data["emailLogID"] !== undefined ? _data["emailLogID"] : null as any;
            this.messageOnly = _data["messageOnly"] !== undefined ? _data["messageOnly"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): ErrorLog {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["stackTrace"] = this.stackTrace !== undefined ? this.stackTrace : null as any;
        data["respondentID"] = this.respondentID !== undefined ? this.respondentID : null as any;
        data["sendEmail"] = this.sendEmail !== undefined ? this.sendEmail : null as any;
        data["emailLogID"] = this.emailLogID !== undefined ? this.emailLogID : null as any;
        data["messageOnly"] = this.messageOnly !== undefined ? this.messageOnly : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IErrorLog {
    ownerID?: number | null;
    createdDate: Date;
    source: string;
    type: string;
    message: string;
    stackTrace?: string | null;
    respondentID?: number | null;
    sendEmail?: boolean;
    emailLogID?: number | null;
    messageOnly?: boolean;
    id?: number;
}

export class ExtendGuardServiceMessage implements IExtendGuardServiceMessage {
    messageId?: string;
    timestamp?: Date;
    respondentExternalId?: number;
    guardServiceIds?: DatasetKey[] | null;
    extendEndDate?: Date;
    effectiveDate?: Date;
    bulkRequestID?: DatasetKey;
    submissionId?: string;
    readonly countOfItemsToProcess?: number;

    constructor(data?: IExtendGuardServiceMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.messageId = _data["messageId"] !== undefined ? _data["messageId"] : null as any;
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : null as any;
            this.respondentExternalId = _data["respondentExternalId"] !== undefined ? _data["respondentExternalId"] : null as any;
            if (Array.isArray(_data["guardServiceIds"])) {
                this.guardServiceIds = [] as any;
                for (let item of _data["guardServiceIds"])
                    this.guardServiceIds!.push(DatasetKey.fromJS(item));
            }
            else {
                this.guardServiceIds = null as any;
            }
            this.extendEndDate = _data["extendEndDate"] ? new Date(_data["extendEndDate"].toString()) : null as any;
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : null as any;
            this.bulkRequestID = _data["bulkRequestID"] ? DatasetKey.fromJS(_data["bulkRequestID"]) : null as any;
            this.submissionId = _data["submissionId"] !== undefined ? _data["submissionId"] : null as any;
            (this as any).countOfItemsToProcess = _data["countOfItemsToProcess"] !== undefined ? _data["countOfItemsToProcess"] : null as any;
        }
    }

    static fromJS(data: any): ExtendGuardServiceMessage {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendGuardServiceMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["messageId"] = this.messageId !== undefined ? this.messageId : null as any;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : null as any;
        data["respondentExternalId"] = this.respondentExternalId !== undefined ? this.respondentExternalId : null as any;
        if (Array.isArray(this.guardServiceIds)) {
            data["guardServiceIds"] = [];
            for (let item of this.guardServiceIds)
                data["guardServiceIds"].push(item ? item.toJSON() : null as any);
        }
        data["extendEndDate"] = this.extendEndDate ? this.extendEndDate.toISOString() : null as any;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : null as any;
        data["bulkRequestID"] = this.bulkRequestID ? this.bulkRequestID.toJSON() : null as any;
        data["submissionId"] = this.submissionId !== undefined ? this.submissionId : null as any;
        data["countOfItemsToProcess"] = this.countOfItemsToProcess !== undefined ? this.countOfItemsToProcess : null as any;
        return data;
    }
}

export interface IExtendGuardServiceMessage {
    messageId?: string;
    timestamp?: Date;
    respondentExternalId?: number;
    guardServiceIds?: DatasetKey[] | null;
    extendEndDate?: Date;
    effectiveDate?: Date;
    bulkRequestID?: DatasetKey;
    submissionId?: string;
    countOfItemsToProcess?: number;
}

export class ExtendGuardServiceRequest implements IExtendGuardServiceRequest {
    respondentExternalId?: number;
    guardServiceId?: DatasetKey;
    extendDate?: Date;
    bulkRequestID?: DatasetKey;
    effectiveDate?: Date;

    constructor(data?: IExtendGuardServiceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.respondentExternalId = _data["respondentExternalId"] !== undefined ? _data["respondentExternalId"] : null as any;
            this.guardServiceId = _data["guardServiceId"] ? DatasetKey.fromJS(_data["guardServiceId"]) : null as any;
            this.extendDate = _data["extendDate"] ? new Date(_data["extendDate"].toString()) : null as any;
            this.bulkRequestID = _data["bulkRequestID"] ? DatasetKey.fromJS(_data["bulkRequestID"]) : null as any;
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): ExtendGuardServiceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExtendGuardServiceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["respondentExternalId"] = this.respondentExternalId !== undefined ? this.respondentExternalId : null as any;
        data["guardServiceId"] = this.guardServiceId ? this.guardServiceId.toJSON() : null as any;
        data["extendDate"] = this.extendDate ? this.extendDate.toISOString() : null as any;
        data["bulkRequestID"] = this.bulkRequestID ? this.bulkRequestID.toJSON() : null as any;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : null as any;
        return data;
    }
}

export interface IExtendGuardServiceRequest {
    respondentExternalId?: number;
    guardServiceId?: DatasetKey;
    extendDate?: Date;
    bulkRequestID?: DatasetKey;
    effectiveDate?: Date;
}

export class ExternalDataParamsRequest implements IExternalDataParamsRequest {
    targetID?: number;
    datasetExternalID?: number;
    datasetExternalSourceTable?: string | null;
    respondentExternalID?: number;
    respondentExternalSourceTable?: string | null;
    respondentRoleID?: number;
    respondentRoleSourceTable?: string | null;

    constructor(data?: IExternalDataParamsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetID = _data["targetID"] !== undefined ? _data["targetID"] : null as any;
            this.datasetExternalID = _data["datasetExternalID"] !== undefined ? _data["datasetExternalID"] : null as any;
            this.datasetExternalSourceTable = _data["datasetExternalSourceTable"] !== undefined ? _data["datasetExternalSourceTable"] : null as any;
            this.respondentExternalID = _data["respondentExternalID"] !== undefined ? _data["respondentExternalID"] : null as any;
            this.respondentExternalSourceTable = _data["respondentExternalSourceTable"] !== undefined ? _data["respondentExternalSourceTable"] : null as any;
            this.respondentRoleID = _data["respondentRoleID"] !== undefined ? _data["respondentRoleID"] : null as any;
            this.respondentRoleSourceTable = _data["respondentRoleSourceTable"] !== undefined ? _data["respondentRoleSourceTable"] : null as any;
        }
    }

    static fromJS(data: any): ExternalDataParamsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalDataParamsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetID"] = this.targetID !== undefined ? this.targetID : null as any;
        data["datasetExternalID"] = this.datasetExternalID !== undefined ? this.datasetExternalID : null as any;
        data["datasetExternalSourceTable"] = this.datasetExternalSourceTable !== undefined ? this.datasetExternalSourceTable : null as any;
        data["respondentExternalID"] = this.respondentExternalID !== undefined ? this.respondentExternalID : null as any;
        data["respondentExternalSourceTable"] = this.respondentExternalSourceTable !== undefined ? this.respondentExternalSourceTable : null as any;
        data["respondentRoleID"] = this.respondentRoleID !== undefined ? this.respondentRoleID : null as any;
        data["respondentRoleSourceTable"] = this.respondentRoleSourceTable !== undefined ? this.respondentRoleSourceTable : null as any;
        return data;
    }
}

export interface IExternalDataParamsRequest {
    targetID?: number;
    datasetExternalID?: number;
    datasetExternalSourceTable?: string | null;
    respondentExternalID?: number;
    respondentExternalSourceTable?: string | null;
    respondentRoleID?: number;
    respondentRoleSourceTable?: string | null;
}

export class FileDownloadRequest implements IFileDownloadRequest {
    fileID?: number;
    fileName?: string | null;
    system?: string | null;

    constructor(data?: IFileDownloadRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileID = _data["fileID"] !== undefined ? _data["fileID"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.system = _data["system"] !== undefined ? _data["system"] : null as any;
        }
    }

    static fromJS(data: any): FileDownloadRequest {
        data = typeof data === 'object' ? data : {};
        let result = new FileDownloadRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileID"] = this.fileID !== undefined ? this.fileID : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["system"] = this.system !== undefined ? this.system : null as any;
        return data;
    }
}

export interface IFileDownloadRequest {
    fileID?: number;
    fileName?: string | null;
    system?: string | null;
}

export class FileType implements IFileType {
    name!: string;
    mimeType!: string;
    extension!: string;
    notes?: string | null;
    id?: number;

    constructor(data?: IFileType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.mimeType = _data["mimeType"] !== undefined ? _data["mimeType"] : null as any;
            this.extension = _data["extension"] !== undefined ? _data["extension"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): FileType {
        data = typeof data === 'object' ? data : {};
        let result = new FileType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["mimeType"] = this.mimeType !== undefined ? this.mimeType : null as any;
        data["extension"] = this.extension !== undefined ? this.extension : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IFileType {
    name: string;
    mimeType: string;
    extension: string;
    notes?: string | null;
    id?: number;
}

export class FlowchartLink implements IFlowchartLink {
    source?: string | null;
    target?: string | null;
    label?: string | null;
    transitionID?: number;
    transitionDesignerID?: string;
    actionID?: number | null;
    actionDesignerID?: string | null;
    transitionActionID?: number;
    transitionActionDesignerID?: string;
    triggerTargetID?: number | null;
    triggerTargetDesignerID?: string | null;
    triggerDatapointTargetID?: number | null;
    triggerDatapointTargetDesignerID?: string | null;
    triggerValueTypeOptionID?: number | null;
    triggerValueTypeOptionDesignerID?: string | null;

    constructor(data?: IFlowchartLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.target = _data["target"] !== undefined ? _data["target"] : null as any;
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.transitionID = _data["transitionID"] !== undefined ? _data["transitionID"] : null as any;
            this.transitionDesignerID = _data["transitionDesignerID"] !== undefined ? _data["transitionDesignerID"] : null as any;
            this.actionID = _data["actionID"] !== undefined ? _data["actionID"] : null as any;
            this.actionDesignerID = _data["actionDesignerID"] !== undefined ? _data["actionDesignerID"] : null as any;
            this.transitionActionID = _data["transitionActionID"] !== undefined ? _data["transitionActionID"] : null as any;
            this.transitionActionDesignerID = _data["transitionActionDesignerID"] !== undefined ? _data["transitionActionDesignerID"] : null as any;
            this.triggerTargetID = _data["triggerTargetID"] !== undefined ? _data["triggerTargetID"] : null as any;
            this.triggerTargetDesignerID = _data["triggerTargetDesignerID"] !== undefined ? _data["triggerTargetDesignerID"] : null as any;
            this.triggerDatapointTargetID = _data["triggerDatapointTargetID"] !== undefined ? _data["triggerDatapointTargetID"] : null as any;
            this.triggerDatapointTargetDesignerID = _data["triggerDatapointTargetDesignerID"] !== undefined ? _data["triggerDatapointTargetDesignerID"] : null as any;
            this.triggerValueTypeOptionID = _data["triggerValueTypeOptionID"] !== undefined ? _data["triggerValueTypeOptionID"] : null as any;
            this.triggerValueTypeOptionDesignerID = _data["triggerValueTypeOptionDesignerID"] !== undefined ? _data["triggerValueTypeOptionDesignerID"] : null as any;
        }
    }

    static fromJS(data: any): FlowchartLink {
        data = typeof data === 'object' ? data : {};
        let result = new FlowchartLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["target"] = this.target !== undefined ? this.target : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["transitionID"] = this.transitionID !== undefined ? this.transitionID : null as any;
        data["transitionDesignerID"] = this.transitionDesignerID !== undefined ? this.transitionDesignerID : null as any;
        data["actionID"] = this.actionID !== undefined ? this.actionID : null as any;
        data["actionDesignerID"] = this.actionDesignerID !== undefined ? this.actionDesignerID : null as any;
        data["transitionActionID"] = this.transitionActionID !== undefined ? this.transitionActionID : null as any;
        data["transitionActionDesignerID"] = this.transitionActionDesignerID !== undefined ? this.transitionActionDesignerID : null as any;
        data["triggerTargetID"] = this.triggerTargetID !== undefined ? this.triggerTargetID : null as any;
        data["triggerTargetDesignerID"] = this.triggerTargetDesignerID !== undefined ? this.triggerTargetDesignerID : null as any;
        data["triggerDatapointTargetID"] = this.triggerDatapointTargetID !== undefined ? this.triggerDatapointTargetID : null as any;
        data["triggerDatapointTargetDesignerID"] = this.triggerDatapointTargetDesignerID !== undefined ? this.triggerDatapointTargetDesignerID : null as any;
        data["triggerValueTypeOptionID"] = this.triggerValueTypeOptionID !== undefined ? this.triggerValueTypeOptionID : null as any;
        data["triggerValueTypeOptionDesignerID"] = this.triggerValueTypeOptionDesignerID !== undefined ? this.triggerValueTypeOptionDesignerID : null as any;
        return data;
    }
}

export interface IFlowchartLink {
    source?: string | null;
    target?: string | null;
    label?: string | null;
    transitionID?: number;
    transitionDesignerID?: string;
    actionID?: number | null;
    actionDesignerID?: string | null;
    transitionActionID?: number;
    transitionActionDesignerID?: string;
    triggerTargetID?: number | null;
    triggerTargetDesignerID?: string | null;
    triggerDatapointTargetID?: number | null;
    triggerDatapointTargetDesignerID?: string | null;
    triggerValueTypeOptionID?: number | null;
    triggerValueTypeOptionDesignerID?: string | null;
}

export class FlowchartNode implements IFlowchartNode {
    id?: string | null;
    label?: string | null;
    friendlyLabel?: string | null;
    position?: string | null;
    color?: string | null;

    constructor(data?: IFlowchartNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.friendlyLabel = _data["friendlyLabel"] !== undefined ? _data["friendlyLabel"] : null as any;
            this.position = _data["position"] !== undefined ? _data["position"] : null as any;
            this.color = _data["color"] !== undefined ? _data["color"] : null as any;
        }
    }

    static fromJS(data: any): FlowchartNode {
        data = typeof data === 'object' ? data : {};
        let result = new FlowchartNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["friendlyLabel"] = this.friendlyLabel !== undefined ? this.friendlyLabel : null as any;
        data["position"] = this.position !== undefined ? this.position : null as any;
        data["color"] = this.color !== undefined ? this.color : null as any;
        return data;
    }
}

export interface IFlowchartNode {
    id?: string | null;
    label?: string | null;
    friendlyLabel?: string | null;
    position?: string | null;
    color?: string | null;
}

export class Group implements IGroup {
    userGroupID?: string | null;
    name?: string | null;

    constructor(data?: IGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userGroupID = _data["userGroupID"] !== undefined ? _data["userGroupID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): Group {
        data = typeof data === 'object' ? data : {};
        let result = new Group();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userGroupID"] = this.userGroupID !== undefined ? this.userGroupID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }
}

export interface IGroup {
    userGroupID?: string | null;
    name?: string | null;
}

export class GuardInvoiceResponse implements IGuardInvoiceResponse {
    guardName?: string | null;
    guardServiceType?: string | null;
    rate?: number | null;
    scheduledHours?: number | null;
    actualHours?: number | null;
    projectedCost?: number | null;
    actualCost?: number | null;
    costVariance?: number | null;
    costVariancePercentage?: number | null;
    flag?: string | null;

    constructor(data?: IGuardInvoiceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guardName = _data["guardName"] !== undefined ? _data["guardName"] : null as any;
            this.guardServiceType = _data["guardServiceType"] !== undefined ? _data["guardServiceType"] : null as any;
            this.rate = _data["rate"] !== undefined ? _data["rate"] : null as any;
            this.scheduledHours = _data["scheduledHours"] !== undefined ? _data["scheduledHours"] : null as any;
            this.actualHours = _data["actualHours"] !== undefined ? _data["actualHours"] : null as any;
            this.projectedCost = _data["projectedCost"] !== undefined ? _data["projectedCost"] : null as any;
            this.actualCost = _data["actualCost"] !== undefined ? _data["actualCost"] : null as any;
            this.costVariance = _data["costVariance"] !== undefined ? _data["costVariance"] : null as any;
            this.costVariancePercentage = _data["costVariancePercentage"] !== undefined ? _data["costVariancePercentage"] : null as any;
            this.flag = _data["flag"] !== undefined ? _data["flag"] : null as any;
        }
    }

    static fromJS(data: any): GuardInvoiceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GuardInvoiceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guardName"] = this.guardName !== undefined ? this.guardName : null as any;
        data["guardServiceType"] = this.guardServiceType !== undefined ? this.guardServiceType : null as any;
        data["rate"] = this.rate !== undefined ? this.rate : null as any;
        data["scheduledHours"] = this.scheduledHours !== undefined ? this.scheduledHours : null as any;
        data["actualHours"] = this.actualHours !== undefined ? this.actualHours : null as any;
        data["projectedCost"] = this.projectedCost !== undefined ? this.projectedCost : null as any;
        data["actualCost"] = this.actualCost !== undefined ? this.actualCost : null as any;
        data["costVariance"] = this.costVariance !== undefined ? this.costVariance : null as any;
        data["costVariancePercentage"] = this.costVariancePercentage !== undefined ? this.costVariancePercentage : null as any;
        data["flag"] = this.flag !== undefined ? this.flag : null as any;
        return data;
    }
}

export interface IGuardInvoiceResponse {
    guardName?: string | null;
    guardServiceType?: string | null;
    rate?: number | null;
    scheduledHours?: number | null;
    actualHours?: number | null;
    projectedCost?: number | null;
    actualCost?: number | null;
    costVariance?: number | null;
    costVariancePercentage?: number | null;
    flag?: string | null;
}

export class GuardRequest implements IGuardRequest {
    guardRequestID?: string;
    createdDate?: Date;
    lastModificationDate?: Date | null;
    approvalDate?: Date | null;
    minStartDate?: Date | null;
    maxEndDate?: Date | null;
    submissionDate?: Date | null;
    duration?: string | null;
    requestType?: string | null;
    requestReason?: string | null;
    assignmentType?: string | null;
    billingType?: string | null;
    billingPeriod?: string | null;
    dataset?: number;
    iteration?: number;
    primarySiteID?: number | null;
    accountSiteExternalID?: string | null;
    accountSiteBillingID?: string | null;
    division?: string | null;
    region?: string | null;
    requestorUserID?: number | null;
    supplierID?: string;
    workflowStatusID?: string;
    assignmentCancelationDate?: Date | null;
    cancelationRequestID?: string | null;
    canceledByUserID?: number | null;
    cancellationRequestDate?: Date | null;
    ownerDesignerID?: string;
    isApproved?: boolean;
    guardRequestPerStopOccurrences?: GuardRequestPerStopOccurrence[] | null;
    guardRequestShiftOccurrences?: GuardRequestShiftOccurrence[] | null;
    guardRequestSiteServices?: GuardRequestSiteService[] | null;
    guardRequestFulfillments?: GuardRequestFulfillment[] | null;
    supplier?: Supplier;
    workflowStatus?: WorkflowStatus;
    requestor?: Respondent;

    constructor(data?: IGuardRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guardRequestID = _data["guardRequestID"] !== undefined ? _data["guardRequestID"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.lastModificationDate = _data["lastModificationDate"] ? new Date(_data["lastModificationDate"].toString()) : null as any;
            this.approvalDate = _data["approvalDate"] ? new Date(_data["approvalDate"].toString()) : null as any;
            this.minStartDate = _data["minStartDate"] ? new Date(_data["minStartDate"].toString()) : null as any;
            this.maxEndDate = _data["maxEndDate"] ? new Date(_data["maxEndDate"].toString()) : null as any;
            this.submissionDate = _data["submissionDate"] ? new Date(_data["submissionDate"].toString()) : null as any;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : null as any;
            this.requestType = _data["requestType"] !== undefined ? _data["requestType"] : null as any;
            this.requestReason = _data["requestReason"] !== undefined ? _data["requestReason"] : null as any;
            this.assignmentType = _data["assignmentType"] !== undefined ? _data["assignmentType"] : null as any;
            this.billingType = _data["billingType"] !== undefined ? _data["billingType"] : null as any;
            this.billingPeriod = _data["billingPeriod"] !== undefined ? _data["billingPeriod"] : null as any;
            this.dataset = _data["dataset"] !== undefined ? _data["dataset"] : null as any;
            this.iteration = _data["iteration"] !== undefined ? _data["iteration"] : null as any;
            this.primarySiteID = _data["primarySiteID"] !== undefined ? _data["primarySiteID"] : null as any;
            this.accountSiteExternalID = _data["accountSiteExternalID"] !== undefined ? _data["accountSiteExternalID"] : null as any;
            this.accountSiteBillingID = _data["accountSiteBillingID"] !== undefined ? _data["accountSiteBillingID"] : null as any;
            this.division = _data["division"] !== undefined ? _data["division"] : null as any;
            this.region = _data["region"] !== undefined ? _data["region"] : null as any;
            this.requestorUserID = _data["requestorUserID"] !== undefined ? _data["requestorUserID"] : null as any;
            this.supplierID = _data["supplierID"] !== undefined ? _data["supplierID"] : null as any;
            this.workflowStatusID = _data["workflowStatusID"] !== undefined ? _data["workflowStatusID"] : null as any;
            this.assignmentCancelationDate = _data["assignmentCancelationDate"] ? new Date(_data["assignmentCancelationDate"].toString()) : null as any;
            this.cancelationRequestID = _data["cancelationRequestID"] !== undefined ? _data["cancelationRequestID"] : null as any;
            this.canceledByUserID = _data["canceledByUserID"] !== undefined ? _data["canceledByUserID"] : null as any;
            this.cancellationRequestDate = _data["cancellationRequestDate"] ? new Date(_data["cancellationRequestDate"].toString()) : null as any;
            this.ownerDesignerID = _data["ownerDesignerID"] !== undefined ? _data["ownerDesignerID"] : null as any;
            this.isApproved = _data["isApproved"] !== undefined ? _data["isApproved"] : null as any;
            if (Array.isArray(_data["guardRequestPerStopOccurrences"])) {
                this.guardRequestPerStopOccurrences = [] as any;
                for (let item of _data["guardRequestPerStopOccurrences"])
                    this.guardRequestPerStopOccurrences!.push(GuardRequestPerStopOccurrence.fromJS(item));
            }
            else {
                this.guardRequestPerStopOccurrences = null as any;
            }
            if (Array.isArray(_data["guardRequestShiftOccurrences"])) {
                this.guardRequestShiftOccurrences = [] as any;
                for (let item of _data["guardRequestShiftOccurrences"])
                    this.guardRequestShiftOccurrences!.push(GuardRequestShiftOccurrence.fromJS(item));
            }
            else {
                this.guardRequestShiftOccurrences = null as any;
            }
            if (Array.isArray(_data["guardRequestSiteServices"])) {
                this.guardRequestSiteServices = [] as any;
                for (let item of _data["guardRequestSiteServices"])
                    this.guardRequestSiteServices!.push(GuardRequestSiteService.fromJS(item));
            }
            else {
                this.guardRequestSiteServices = null as any;
            }
            if (Array.isArray(_data["guardRequestFulfillments"])) {
                this.guardRequestFulfillments = [] as any;
                for (let item of _data["guardRequestFulfillments"])
                    this.guardRequestFulfillments!.push(GuardRequestFulfillment.fromJS(item));
            }
            else {
                this.guardRequestFulfillments = null as any;
            }
            this.supplier = _data["supplier"] ? Supplier.fromJS(_data["supplier"]) : null as any;
            this.workflowStatus = _data["workflowStatus"] ? WorkflowStatus.fromJS(_data["workflowStatus"]) : null as any;
            this.requestor = _data["requestor"] ? Respondent.fromJS(_data["requestor"]) : null as any;
        }
    }

    static fromJS(data: any): GuardRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GuardRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guardRequestID"] = this.guardRequestID !== undefined ? this.guardRequestID : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["lastModificationDate"] = this.lastModificationDate ? this.lastModificationDate.toISOString() : null as any;
        data["approvalDate"] = this.approvalDate ? this.approvalDate.toISOString() : null as any;
        data["minStartDate"] = this.minStartDate ? this.minStartDate.toISOString() : null as any;
        data["maxEndDate"] = this.maxEndDate ? this.maxEndDate.toISOString() : null as any;
        data["submissionDate"] = this.submissionDate ? this.submissionDate.toISOString() : null as any;
        data["duration"] = this.duration !== undefined ? this.duration : null as any;
        data["requestType"] = this.requestType !== undefined ? this.requestType : null as any;
        data["requestReason"] = this.requestReason !== undefined ? this.requestReason : null as any;
        data["assignmentType"] = this.assignmentType !== undefined ? this.assignmentType : null as any;
        data["billingType"] = this.billingType !== undefined ? this.billingType : null as any;
        data["billingPeriod"] = this.billingPeriod !== undefined ? this.billingPeriod : null as any;
        data["dataset"] = this.dataset !== undefined ? this.dataset : null as any;
        data["iteration"] = this.iteration !== undefined ? this.iteration : null as any;
        data["primarySiteID"] = this.primarySiteID !== undefined ? this.primarySiteID : null as any;
        data["accountSiteExternalID"] = this.accountSiteExternalID !== undefined ? this.accountSiteExternalID : null as any;
        data["accountSiteBillingID"] = this.accountSiteBillingID !== undefined ? this.accountSiteBillingID : null as any;
        data["division"] = this.division !== undefined ? this.division : null as any;
        data["region"] = this.region !== undefined ? this.region : null as any;
        data["requestorUserID"] = this.requestorUserID !== undefined ? this.requestorUserID : null as any;
        data["supplierID"] = this.supplierID !== undefined ? this.supplierID : null as any;
        data["workflowStatusID"] = this.workflowStatusID !== undefined ? this.workflowStatusID : null as any;
        data["assignmentCancelationDate"] = this.assignmentCancelationDate ? this.assignmentCancelationDate.toISOString() : null as any;
        data["cancelationRequestID"] = this.cancelationRequestID !== undefined ? this.cancelationRequestID : null as any;
        data["canceledByUserID"] = this.canceledByUserID !== undefined ? this.canceledByUserID : null as any;
        data["cancellationRequestDate"] = this.cancellationRequestDate ? this.cancellationRequestDate.toISOString() : null as any;
        data["ownerDesignerID"] = this.ownerDesignerID !== undefined ? this.ownerDesignerID : null as any;
        data["isApproved"] = this.isApproved !== undefined ? this.isApproved : null as any;
        if (Array.isArray(this.guardRequestPerStopOccurrences)) {
            data["guardRequestPerStopOccurrences"] = [];
            for (let item of this.guardRequestPerStopOccurrences)
                data["guardRequestPerStopOccurrences"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.guardRequestShiftOccurrences)) {
            data["guardRequestShiftOccurrences"] = [];
            for (let item of this.guardRequestShiftOccurrences)
                data["guardRequestShiftOccurrences"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.guardRequestSiteServices)) {
            data["guardRequestSiteServices"] = [];
            for (let item of this.guardRequestSiteServices)
                data["guardRequestSiteServices"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.guardRequestFulfillments)) {
            data["guardRequestFulfillments"] = [];
            for (let item of this.guardRequestFulfillments)
                data["guardRequestFulfillments"].push(item ? item.toJSON() : null as any);
        }
        data["supplier"] = this.supplier ? this.supplier.toJSON() : null as any;
        data["workflowStatus"] = this.workflowStatus ? this.workflowStatus.toJSON() : null as any;
        data["requestor"] = this.requestor ? this.requestor.toJSON() : null as any;
        return data;
    }
}

export interface IGuardRequest {
    guardRequestID?: string;
    createdDate?: Date;
    lastModificationDate?: Date | null;
    approvalDate?: Date | null;
    minStartDate?: Date | null;
    maxEndDate?: Date | null;
    submissionDate?: Date | null;
    duration?: string | null;
    requestType?: string | null;
    requestReason?: string | null;
    assignmentType?: string | null;
    billingType?: string | null;
    billingPeriod?: string | null;
    dataset?: number;
    iteration?: number;
    primarySiteID?: number | null;
    accountSiteExternalID?: string | null;
    accountSiteBillingID?: string | null;
    division?: string | null;
    region?: string | null;
    requestorUserID?: number | null;
    supplierID?: string;
    workflowStatusID?: string;
    assignmentCancelationDate?: Date | null;
    cancelationRequestID?: string | null;
    canceledByUserID?: number | null;
    cancellationRequestDate?: Date | null;
    ownerDesignerID?: string;
    isApproved?: boolean;
    guardRequestPerStopOccurrences?: GuardRequestPerStopOccurrence[] | null;
    guardRequestShiftOccurrences?: GuardRequestShiftOccurrence[] | null;
    guardRequestSiteServices?: GuardRequestSiteService[] | null;
    guardRequestFulfillments?: GuardRequestFulfillment[] | null;
    supplier?: Supplier;
    workflowStatus?: WorkflowStatus;
    requestor?: Respondent;
}

export enum GuardRequestAction {
    BeginForm = "BeginForm",
    CancelRequest = "CancelRequest",
    DoesNotRequireIA = "DoesNotRequireIA",
    FinalRateIAApproved = "FinalRateIAApproved",
    FinalRateIADenied = "FinalRateIADenied",
    IAApproved = "IAApproved",
    IADenied = "IADenied",
    RequiresIA = "RequiresIA",
    VAApproved = "VAApproved",
    VADenied = "VADenied",
    VendorSelected = "VendorSelected",
    VendorSelectedRequiresIA = "VendorSelectedRequiresIA",
}

export class GuardRequestActionRequest implements IGuardRequestActionRequest {
    userId?: number;
    guardRequestId?: DatasetKey;
    guardRequestState?: GuardRequestState;

    constructor(data?: IGuardRequestActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.guardRequestId = _data["guardRequestId"] ? DatasetKey.fromJS(_data["guardRequestId"]) : null as any;
            this.guardRequestState = _data["guardRequestState"] !== undefined ? _data["guardRequestState"] : null as any;
        }
    }

    static fromJS(data: any): GuardRequestActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GuardRequestActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["guardRequestId"] = this.guardRequestId ? this.guardRequestId.toJSON() : null as any;
        data["guardRequestState"] = this.guardRequestState !== undefined ? this.guardRequestState : null as any;
        return data;
    }
}

export interface IGuardRequestActionRequest {
    userId?: number;
    guardRequestId?: DatasetKey;
    guardRequestState?: GuardRequestState;
}

export class GuardRequestForm implements IGuardRequestForm {
    respondentExternalId?: number;
    guardServiceIds?: DatasetKey[] | null;
    guardRequestAction?: GuardRequestAction;

    constructor(data?: IGuardRequestForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.respondentExternalId = _data["respondentExternalId"] !== undefined ? _data["respondentExternalId"] : null as any;
            if (Array.isArray(_data["guardServiceIds"])) {
                this.guardServiceIds = [] as any;
                for (let item of _data["guardServiceIds"])
                    this.guardServiceIds!.push(DatasetKey.fromJS(item));
            }
            else {
                this.guardServiceIds = null as any;
            }
            this.guardRequestAction = _data["guardRequestAction"] !== undefined ? _data["guardRequestAction"] : null as any;
        }
    }

    static fromJS(data: any): GuardRequestForm {
        data = typeof data === 'object' ? data : {};
        let result = new GuardRequestForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["respondentExternalId"] = this.respondentExternalId !== undefined ? this.respondentExternalId : null as any;
        if (Array.isArray(this.guardServiceIds)) {
            data["guardServiceIds"] = [];
            for (let item of this.guardServiceIds)
                data["guardServiceIds"].push(item ? item.toJSON() : null as any);
        }
        data["guardRequestAction"] = this.guardRequestAction !== undefined ? this.guardRequestAction : null as any;
        return data;
    }
}

export interface IGuardRequestForm {
    respondentExternalId?: number;
    guardServiceIds?: DatasetKey[] | null;
    guardRequestAction?: GuardRequestAction;
}

export class GuardRequestFulfillment implements IGuardRequestFulfillment {
    guardRequestFulfillmentId?: string;
    guardRequestId?: string;
    fulfillmentResponderUserId?: number | null;
    fulfillmentResponderName?: string | null;
    fulfillmentResponse?: SupplierFulfillmentResponse;
    fulfillmentComment?: string | null;
    fulfillmentResponseDate?: Date;
    fulfillmentNewStartDate?: Date | null;
    fulfillmentPartialEndDate?: Date | null;
    fulfillmentPartialOption?: string | null;
    fulfillmentPartialGuardType?: string | null;
    guardRequest?: GuardRequest;

    constructor(data?: IGuardRequestFulfillment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guardRequestFulfillmentId = _data["guardRequestFulfillmentId"] !== undefined ? _data["guardRequestFulfillmentId"] : null as any;
            this.guardRequestId = _data["guardRequestId"] !== undefined ? _data["guardRequestId"] : null as any;
            this.fulfillmentResponderUserId = _data["fulfillmentResponderUserId"] !== undefined ? _data["fulfillmentResponderUserId"] : null as any;
            this.fulfillmentResponderName = _data["fulfillmentResponderName"] !== undefined ? _data["fulfillmentResponderName"] : null as any;
            this.fulfillmentResponse = _data["fulfillmentResponse"] !== undefined ? _data["fulfillmentResponse"] : null as any;
            this.fulfillmentComment = _data["fulfillmentComment"] !== undefined ? _data["fulfillmentComment"] : null as any;
            this.fulfillmentResponseDate = _data["fulfillmentResponseDate"] ? new Date(_data["fulfillmentResponseDate"].toString()) : null as any;
            this.fulfillmentNewStartDate = _data["fulfillmentNewStartDate"] ? new Date(_data["fulfillmentNewStartDate"].toString()) : null as any;
            this.fulfillmentPartialEndDate = _data["fulfillmentPartialEndDate"] ? new Date(_data["fulfillmentPartialEndDate"].toString()) : null as any;
            this.fulfillmentPartialOption = _data["fulfillmentPartialOption"] !== undefined ? _data["fulfillmentPartialOption"] : null as any;
            this.fulfillmentPartialGuardType = _data["fulfillmentPartialGuardType"] !== undefined ? _data["fulfillmentPartialGuardType"] : null as any;
            this.guardRequest = _data["guardRequest"] ? GuardRequest.fromJS(_data["guardRequest"]) : null as any;
        }
    }

    static fromJS(data: any): GuardRequestFulfillment {
        data = typeof data === 'object' ? data : {};
        let result = new GuardRequestFulfillment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guardRequestFulfillmentId"] = this.guardRequestFulfillmentId !== undefined ? this.guardRequestFulfillmentId : null as any;
        data["guardRequestId"] = this.guardRequestId !== undefined ? this.guardRequestId : null as any;
        data["fulfillmentResponderUserId"] = this.fulfillmentResponderUserId !== undefined ? this.fulfillmentResponderUserId : null as any;
        data["fulfillmentResponderName"] = this.fulfillmentResponderName !== undefined ? this.fulfillmentResponderName : null as any;
        data["fulfillmentResponse"] = this.fulfillmentResponse !== undefined ? this.fulfillmentResponse : null as any;
        data["fulfillmentComment"] = this.fulfillmentComment !== undefined ? this.fulfillmentComment : null as any;
        data["fulfillmentResponseDate"] = this.fulfillmentResponseDate ? this.fulfillmentResponseDate.toISOString() : null as any;
        data["fulfillmentNewStartDate"] = this.fulfillmentNewStartDate ? this.fulfillmentNewStartDate.toISOString() : null as any;
        data["fulfillmentPartialEndDate"] = this.fulfillmentPartialEndDate ? this.fulfillmentPartialEndDate.toISOString() : null as any;
        data["fulfillmentPartialOption"] = this.fulfillmentPartialOption !== undefined ? this.fulfillmentPartialOption : null as any;
        data["fulfillmentPartialGuardType"] = this.fulfillmentPartialGuardType !== undefined ? this.fulfillmentPartialGuardType : null as any;
        data["guardRequest"] = this.guardRequest ? this.guardRequest.toJSON() : null as any;
        return data;
    }
}

export interface IGuardRequestFulfillment {
    guardRequestFulfillmentId?: string;
    guardRequestId?: string;
    fulfillmentResponderUserId?: number | null;
    fulfillmentResponderName?: string | null;
    fulfillmentResponse?: SupplierFulfillmentResponse;
    fulfillmentComment?: string | null;
    fulfillmentResponseDate?: Date;
    fulfillmentNewStartDate?: Date | null;
    fulfillmentPartialEndDate?: Date | null;
    fulfillmentPartialOption?: string | null;
    fulfillmentPartialGuardType?: string | null;
    guardRequest?: GuardRequest;
}

export class GuardRequestInfo implements IGuardRequestInfo {
    requestId?: string | null;
    primaryLocation?: SiteLocation;
    buid?: string | null;
    buildingId?: string | null;
    division?: string | null;
    region?: string | null;
    market?: string | null;
    type?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    totalRequestHours?: number | null;
    duration?: string | null;
    requestReason?: string | null;
    postDescription?: string | null;
    retiredAcceptable?: boolean | null;
    effectiveDate?: Date | null;
    modificationOptions?: string | null;
    contractedRates?: SiteVendorInfo[] | null;
    weeklyServiceSchedules?: WeeklyShiftDetail[] | null;
    monthlyServiceSchedules?: MonthlyShiftDetail[] | null;

    constructor(data?: IGuardRequestInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestId = _data["requestId"] !== undefined ? _data["requestId"] : null as any;
            this.primaryLocation = _data["primaryLocation"] ? SiteLocation.fromJS(_data["primaryLocation"]) : null as any;
            this.buid = _data["buid"] !== undefined ? _data["buid"] : null as any;
            this.buildingId = _data["buildingId"] !== undefined ? _data["buildingId"] : null as any;
            this.division = _data["division"] !== undefined ? _data["division"] : null as any;
            this.region = _data["region"] !== undefined ? _data["region"] : null as any;
            this.market = _data["market"] !== undefined ? _data["market"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            this.totalRequestHours = _data["totalRequestHours"] !== undefined ? _data["totalRequestHours"] : null as any;
            this.duration = _data["duration"] !== undefined ? _data["duration"] : null as any;
            this.requestReason = _data["requestReason"] !== undefined ? _data["requestReason"] : null as any;
            this.postDescription = _data["postDescription"] !== undefined ? _data["postDescription"] : null as any;
            this.retiredAcceptable = _data["retiredAcceptable"] !== undefined ? _data["retiredAcceptable"] : null as any;
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : null as any;
            this.modificationOptions = _data["modificationOptions"] !== undefined ? _data["modificationOptions"] : null as any;
            if (Array.isArray(_data["contractedRates"])) {
                this.contractedRates = [] as any;
                for (let item of _data["contractedRates"])
                    this.contractedRates!.push(SiteVendorInfo.fromJS(item));
            }
            else {
                this.contractedRates = null as any;
            }
            if (Array.isArray(_data["weeklyServiceSchedules"])) {
                this.weeklyServiceSchedules = [] as any;
                for (let item of _data["weeklyServiceSchedules"])
                    this.weeklyServiceSchedules!.push(WeeklyShiftDetail.fromJS(item));
            }
            else {
                this.weeklyServiceSchedules = null as any;
            }
            if (Array.isArray(_data["monthlyServiceSchedules"])) {
                this.monthlyServiceSchedules = [] as any;
                for (let item of _data["monthlyServiceSchedules"])
                    this.monthlyServiceSchedules!.push(MonthlyShiftDetail.fromJS(item));
            }
            else {
                this.monthlyServiceSchedules = null as any;
            }
        }
    }

    static fromJS(data: any): GuardRequestInfo {
        data = typeof data === 'object' ? data : {};
        let result = new GuardRequestInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestId"] = this.requestId !== undefined ? this.requestId : null as any;
        data["primaryLocation"] = this.primaryLocation ? this.primaryLocation.toJSON() : null as any;
        data["buid"] = this.buid !== undefined ? this.buid : null as any;
        data["buildingId"] = this.buildingId !== undefined ? this.buildingId : null as any;
        data["division"] = this.division !== undefined ? this.division : null as any;
        data["region"] = this.region !== undefined ? this.region : null as any;
        data["market"] = this.market !== undefined ? this.market : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["totalRequestHours"] = this.totalRequestHours !== undefined ? this.totalRequestHours : null as any;
        data["duration"] = this.duration !== undefined ? this.duration : null as any;
        data["requestReason"] = this.requestReason !== undefined ? this.requestReason : null as any;
        data["postDescription"] = this.postDescription !== undefined ? this.postDescription : null as any;
        data["retiredAcceptable"] = this.retiredAcceptable !== undefined ? this.retiredAcceptable : null as any;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : null as any;
        data["modificationOptions"] = this.modificationOptions !== undefined ? this.modificationOptions : null as any;
        if (Array.isArray(this.contractedRates)) {
            data["contractedRates"] = [];
            for (let item of this.contractedRates)
                data["contractedRates"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.weeklyServiceSchedules)) {
            data["weeklyServiceSchedules"] = [];
            for (let item of this.weeklyServiceSchedules)
                data["weeklyServiceSchedules"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.monthlyServiceSchedules)) {
            data["monthlyServiceSchedules"] = [];
            for (let item of this.monthlyServiceSchedules)
                data["monthlyServiceSchedules"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGuardRequestInfo {
    requestId?: string | null;
    primaryLocation?: SiteLocation;
    buid?: string | null;
    buildingId?: string | null;
    division?: string | null;
    region?: string | null;
    market?: string | null;
    type?: string | null;
    startDate?: Date | null;
    endDate?: Date | null;
    totalRequestHours?: number | null;
    duration?: string | null;
    requestReason?: string | null;
    postDescription?: string | null;
    retiredAcceptable?: boolean | null;
    effectiveDate?: Date | null;
    modificationOptions?: string | null;
    contractedRates?: SiteVendorInfo[] | null;
    weeklyServiceSchedules?: WeeklyShiftDetail[] | null;
    monthlyServiceSchedules?: MonthlyShiftDetail[] | null;
}

export class GuardRequestModel implements IGuardRequestModel {
    guardRequestId?: string;
    requestId?: string | null;
    primarySiteId?: number | null;
    primarySiteExternalId?: string | null;
    billingId?: string | null;
    billingType?: BillingType;
    billingPeriod?: BillingPeriod;
    requestReason?: string | null;
    assignmentType?: GuardServiceType;
    division?: string | null;
    region?: string | null;
    supplierName?: string | null;
    minStartDate?: Date | null;
    maxEndDate?: Date | null;
    durationType?: ServiceDurationType;
    createdDate?: Date;
    requestStatus?: string | null;
    requestType?: string | null;
    requestorUserId?: number | null;
    requestorInfo?: RespondentInfo;
    primaryLocation?: SiteLocation;
    siteServices?: GuardRequestSiteServiceModel[] | null;

    constructor(data?: IGuardRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guardRequestId = _data["guardRequestId"] !== undefined ? _data["guardRequestId"] : null as any;
            this.requestId = _data["requestId"] !== undefined ? _data["requestId"] : null as any;
            this.primarySiteId = _data["primarySiteId"] !== undefined ? _data["primarySiteId"] : null as any;
            this.primarySiteExternalId = _data["primarySiteExternalId"] !== undefined ? _data["primarySiteExternalId"] : null as any;
            this.billingId = _data["billingId"] !== undefined ? _data["billingId"] : null as any;
            this.billingType = _data["billingType"] !== undefined ? _data["billingType"] : null as any;
            this.billingPeriod = _data["billingPeriod"] !== undefined ? _data["billingPeriod"] : null as any;
            this.requestReason = _data["requestReason"] !== undefined ? _data["requestReason"] : null as any;
            this.assignmentType = _data["assignmentType"] !== undefined ? _data["assignmentType"] : null as any;
            this.division = _data["division"] !== undefined ? _data["division"] : null as any;
            this.region = _data["region"] !== undefined ? _data["region"] : null as any;
            this.supplierName = _data["supplierName"] !== undefined ? _data["supplierName"] : null as any;
            this.minStartDate = _data["minStartDate"] ? new Date(_data["minStartDate"].toString()) : null as any;
            this.maxEndDate = _data["maxEndDate"] ? new Date(_data["maxEndDate"].toString()) : null as any;
            this.durationType = _data["durationType"] !== undefined ? _data["durationType"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.requestStatus = _data["requestStatus"] !== undefined ? _data["requestStatus"] : null as any;
            this.requestType = _data["requestType"] !== undefined ? _data["requestType"] : null as any;
            this.requestorUserId = _data["requestorUserId"] !== undefined ? _data["requestorUserId"] : null as any;
            this.requestorInfo = _data["requestorInfo"] ? RespondentInfo.fromJS(_data["requestorInfo"]) : null as any;
            this.primaryLocation = _data["primaryLocation"] ? SiteLocation.fromJS(_data["primaryLocation"]) : null as any;
            if (Array.isArray(_data["siteServices"])) {
                this.siteServices = [] as any;
                for (let item of _data["siteServices"])
                    this.siteServices!.push(GuardRequestSiteServiceModel.fromJS(item));
            }
            else {
                this.siteServices = null as any;
            }
        }
    }

    static fromJS(data: any): GuardRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new GuardRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guardRequestId"] = this.guardRequestId !== undefined ? this.guardRequestId : null as any;
        data["requestId"] = this.requestId !== undefined ? this.requestId : null as any;
        data["primarySiteId"] = this.primarySiteId !== undefined ? this.primarySiteId : null as any;
        data["primarySiteExternalId"] = this.primarySiteExternalId !== undefined ? this.primarySiteExternalId : null as any;
        data["billingId"] = this.billingId !== undefined ? this.billingId : null as any;
        data["billingType"] = this.billingType !== undefined ? this.billingType : null as any;
        data["billingPeriod"] = this.billingPeriod !== undefined ? this.billingPeriod : null as any;
        data["requestReason"] = this.requestReason !== undefined ? this.requestReason : null as any;
        data["assignmentType"] = this.assignmentType !== undefined ? this.assignmentType : null as any;
        data["division"] = this.division !== undefined ? this.division : null as any;
        data["region"] = this.region !== undefined ? this.region : null as any;
        data["supplierName"] = this.supplierName !== undefined ? this.supplierName : null as any;
        data["minStartDate"] = this.minStartDate ? formatDate(this.minStartDate) : null as any;
        data["maxEndDate"] = this.maxEndDate ? formatDate(this.maxEndDate) : null as any;
        data["durationType"] = this.durationType !== undefined ? this.durationType : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["requestStatus"] = this.requestStatus !== undefined ? this.requestStatus : null as any;
        data["requestType"] = this.requestType !== undefined ? this.requestType : null as any;
        data["requestorUserId"] = this.requestorUserId !== undefined ? this.requestorUserId : null as any;
        data["requestorInfo"] = this.requestorInfo ? this.requestorInfo.toJSON() : null as any;
        data["primaryLocation"] = this.primaryLocation ? this.primaryLocation.toJSON() : null as any;
        if (Array.isArray(this.siteServices)) {
            data["siteServices"] = [];
            for (let item of this.siteServices)
                data["siteServices"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGuardRequestModel {
    guardRequestId?: string;
    requestId?: string | null;
    primarySiteId?: number | null;
    primarySiteExternalId?: string | null;
    billingId?: string | null;
    billingType?: BillingType;
    billingPeriod?: BillingPeriod;
    requestReason?: string | null;
    assignmentType?: GuardServiceType;
    division?: string | null;
    region?: string | null;
    supplierName?: string | null;
    minStartDate?: Date | null;
    maxEndDate?: Date | null;
    durationType?: ServiceDurationType;
    createdDate?: Date;
    requestStatus?: string | null;
    requestType?: string | null;
    requestorUserId?: number | null;
    requestorInfo?: RespondentInfo;
    primaryLocation?: SiteLocation;
    siteServices?: GuardRequestSiteServiceModel[] | null;
}

export class GuardRequestModelPagedResult implements IGuardRequestModelPagedResult {
    items?: GuardRequestModel[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;

    constructor(data?: IGuardRequestModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(GuardRequestModel.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.page = _data["page"] !== undefined ? _data["page"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): GuardRequestModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GuardRequestModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["page"] = this.page !== undefined ? this.page : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export interface IGuardRequestModelPagedResult {
    items?: GuardRequestModel[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export class GuardRequestPerStopOccurrence implements IGuardRequestPerStopOccurrence {
    perStopOccurrenceID?: string;
    shiftDetailID?: string;
    guardRequestID?: string;
    shiftStartDate?: Date;
    shiftEndDate?: Date;
    stopCount?: number;
    guardRequest?: GuardRequest;
    shiftDetail?: GuardRequestShiftDetail;

    constructor(data?: IGuardRequestPerStopOccurrence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.perStopOccurrenceID = _data["perStopOccurrenceID"] !== undefined ? _data["perStopOccurrenceID"] : null as any;
            this.shiftDetailID = _data["shiftDetailID"] !== undefined ? _data["shiftDetailID"] : null as any;
            this.guardRequestID = _data["guardRequestID"] !== undefined ? _data["guardRequestID"] : null as any;
            this.shiftStartDate = _data["shiftStartDate"] ? new Date(_data["shiftStartDate"].toString()) : null as any;
            this.shiftEndDate = _data["shiftEndDate"] ? new Date(_data["shiftEndDate"].toString()) : null as any;
            this.stopCount = _data["stopCount"] !== undefined ? _data["stopCount"] : null as any;
            this.guardRequest = _data["guardRequest"] ? GuardRequest.fromJS(_data["guardRequest"]) : null as any;
            this.shiftDetail = _data["shiftDetail"] ? GuardRequestShiftDetail.fromJS(_data["shiftDetail"]) : null as any;
        }
    }

    static fromJS(data: any): GuardRequestPerStopOccurrence {
        data = typeof data === 'object' ? data : {};
        let result = new GuardRequestPerStopOccurrence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["perStopOccurrenceID"] = this.perStopOccurrenceID !== undefined ? this.perStopOccurrenceID : null as any;
        data["shiftDetailID"] = this.shiftDetailID !== undefined ? this.shiftDetailID : null as any;
        data["guardRequestID"] = this.guardRequestID !== undefined ? this.guardRequestID : null as any;
        data["shiftStartDate"] = this.shiftStartDate ? this.shiftStartDate.toISOString() : null as any;
        data["shiftEndDate"] = this.shiftEndDate ? this.shiftEndDate.toISOString() : null as any;
        data["stopCount"] = this.stopCount !== undefined ? this.stopCount : null as any;
        data["guardRequest"] = this.guardRequest ? this.guardRequest.toJSON() : null as any;
        data["shiftDetail"] = this.shiftDetail ? this.shiftDetail.toJSON() : null as any;
        return data;
    }
}

export interface IGuardRequestPerStopOccurrence {
    perStopOccurrenceID?: string;
    shiftDetailID?: string;
    guardRequestID?: string;
    shiftStartDate?: Date;
    shiftEndDate?: Date;
    stopCount?: number;
    guardRequest?: GuardRequest;
    shiftDetail?: GuardRequestShiftDetail;
}

export class GuardRequestShiftDetail implements IGuardRequestShiftDetail {
    shiftDetailID?: string;
    siteServiceID?: string;
    siteID?: number;
    startTime?: string;
    endTime?: string;
    shiftRecurrenceType?: string | null;
    errorHandlingLogic?: string | null;
    weekOfMonth?: number | null;
    dayOfMonth?: number | null;
    dayOfWeek?: number | null;
    weeklyInterval?: number | null;
    perStopFrequency?: number | null;
    guardRequestPerStopOccurrences?: GuardRequestPerStopOccurrence[] | null;
    guardRequestShiftOccurrences?: GuardRequestShiftOccurrence[] | null;
    siteService?: GuardRequestSiteService;

    constructor(data?: IGuardRequestShiftDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftDetailID = _data["shiftDetailID"] !== undefined ? _data["shiftDetailID"] : null as any;
            this.siteServiceID = _data["siteServiceID"] !== undefined ? _data["siteServiceID"] : null as any;
            this.siteID = _data["siteID"] !== undefined ? _data["siteID"] : null as any;
            this.startTime = _data["startTime"] !== undefined ? _data["startTime"] : null as any;
            this.endTime = _data["endTime"] !== undefined ? _data["endTime"] : null as any;
            this.shiftRecurrenceType = _data["shiftRecurrenceType"] !== undefined ? _data["shiftRecurrenceType"] : null as any;
            this.errorHandlingLogic = _data["errorHandlingLogic"] !== undefined ? _data["errorHandlingLogic"] : null as any;
            this.weekOfMonth = _data["weekOfMonth"] !== undefined ? _data["weekOfMonth"] : null as any;
            this.dayOfMonth = _data["dayOfMonth"] !== undefined ? _data["dayOfMonth"] : null as any;
            this.dayOfWeek = _data["dayOfWeek"] !== undefined ? _data["dayOfWeek"] : null as any;
            this.weeklyInterval = _data["weeklyInterval"] !== undefined ? _data["weeklyInterval"] : null as any;
            this.perStopFrequency = _data["perStopFrequency"] !== undefined ? _data["perStopFrequency"] : null as any;
            if (Array.isArray(_data["guardRequestPerStopOccurrences"])) {
                this.guardRequestPerStopOccurrences = [] as any;
                for (let item of _data["guardRequestPerStopOccurrences"])
                    this.guardRequestPerStopOccurrences!.push(GuardRequestPerStopOccurrence.fromJS(item));
            }
            else {
                this.guardRequestPerStopOccurrences = null as any;
            }
            if (Array.isArray(_data["guardRequestShiftOccurrences"])) {
                this.guardRequestShiftOccurrences = [] as any;
                for (let item of _data["guardRequestShiftOccurrences"])
                    this.guardRequestShiftOccurrences!.push(GuardRequestShiftOccurrence.fromJS(item));
            }
            else {
                this.guardRequestShiftOccurrences = null as any;
            }
            this.siteService = _data["siteService"] ? GuardRequestSiteService.fromJS(_data["siteService"]) : null as any;
        }
    }

    static fromJS(data: any): GuardRequestShiftDetail {
        data = typeof data === 'object' ? data : {};
        let result = new GuardRequestShiftDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftDetailID"] = this.shiftDetailID !== undefined ? this.shiftDetailID : null as any;
        data["siteServiceID"] = this.siteServiceID !== undefined ? this.siteServiceID : null as any;
        data["siteID"] = this.siteID !== undefined ? this.siteID : null as any;
        data["startTime"] = this.startTime !== undefined ? this.startTime : null as any;
        data["endTime"] = this.endTime !== undefined ? this.endTime : null as any;
        data["shiftRecurrenceType"] = this.shiftRecurrenceType !== undefined ? this.shiftRecurrenceType : null as any;
        data["errorHandlingLogic"] = this.errorHandlingLogic !== undefined ? this.errorHandlingLogic : null as any;
        data["weekOfMonth"] = this.weekOfMonth !== undefined ? this.weekOfMonth : null as any;
        data["dayOfMonth"] = this.dayOfMonth !== undefined ? this.dayOfMonth : null as any;
        data["dayOfWeek"] = this.dayOfWeek !== undefined ? this.dayOfWeek : null as any;
        data["weeklyInterval"] = this.weeklyInterval !== undefined ? this.weeklyInterval : null as any;
        data["perStopFrequency"] = this.perStopFrequency !== undefined ? this.perStopFrequency : null as any;
        if (Array.isArray(this.guardRequestPerStopOccurrences)) {
            data["guardRequestPerStopOccurrences"] = [];
            for (let item of this.guardRequestPerStopOccurrences)
                data["guardRequestPerStopOccurrences"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.guardRequestShiftOccurrences)) {
            data["guardRequestShiftOccurrences"] = [];
            for (let item of this.guardRequestShiftOccurrences)
                data["guardRequestShiftOccurrences"].push(item ? item.toJSON() : null as any);
        }
        data["siteService"] = this.siteService ? this.siteService.toJSON() : null as any;
        return data;
    }
}

export interface IGuardRequestShiftDetail {
    shiftDetailID?: string;
    siteServiceID?: string;
    siteID?: number;
    startTime?: string;
    endTime?: string;
    shiftRecurrenceType?: string | null;
    errorHandlingLogic?: string | null;
    weekOfMonth?: number | null;
    dayOfMonth?: number | null;
    dayOfWeek?: number | null;
    weeklyInterval?: number | null;
    perStopFrequency?: number | null;
    guardRequestPerStopOccurrences?: GuardRequestPerStopOccurrence[] | null;
    guardRequestShiftOccurrences?: GuardRequestShiftOccurrence[] | null;
    siteService?: GuardRequestSiteService;
}

export class GuardRequestShiftDetailModel implements IGuardRequestShiftDetailModel {
    shiftDetailId?: string;
    startTime?: string;
    endTime?: string;
    recurrenceType?: ShiftRecurrenceType;
    perStopFrequency?: number | null;
    weekOfMonth?: number | null;
    dayOfMonth?: number | null;
    dayOfWeek?: number | null;
    weeklyInterval?: number | null;

    constructor(data?: IGuardRequestShiftDetailModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftDetailId = _data["shiftDetailId"] !== undefined ? _data["shiftDetailId"] : null as any;
            this.startTime = _data["startTime"] !== undefined ? _data["startTime"] : null as any;
            this.endTime = _data["endTime"] !== undefined ? _data["endTime"] : null as any;
            this.recurrenceType = _data["recurrenceType"] !== undefined ? _data["recurrenceType"] : null as any;
            this.perStopFrequency = _data["perStopFrequency"] !== undefined ? _data["perStopFrequency"] : null as any;
            this.weekOfMonth = _data["weekOfMonth"] !== undefined ? _data["weekOfMonth"] : null as any;
            this.dayOfMonth = _data["dayOfMonth"] !== undefined ? _data["dayOfMonth"] : null as any;
            this.dayOfWeek = _data["dayOfWeek"] !== undefined ? _data["dayOfWeek"] : null as any;
            this.weeklyInterval = _data["weeklyInterval"] !== undefined ? _data["weeklyInterval"] : null as any;
        }
    }

    static fromJS(data: any): GuardRequestShiftDetailModel {
        data = typeof data === 'object' ? data : {};
        let result = new GuardRequestShiftDetailModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftDetailId"] = this.shiftDetailId !== undefined ? this.shiftDetailId : null as any;
        data["startTime"] = this.startTime !== undefined ? this.startTime : null as any;
        data["endTime"] = this.endTime !== undefined ? this.endTime : null as any;
        data["recurrenceType"] = this.recurrenceType !== undefined ? this.recurrenceType : null as any;
        data["perStopFrequency"] = this.perStopFrequency !== undefined ? this.perStopFrequency : null as any;
        data["weekOfMonth"] = this.weekOfMonth !== undefined ? this.weekOfMonth : null as any;
        data["dayOfMonth"] = this.dayOfMonth !== undefined ? this.dayOfMonth : null as any;
        data["dayOfWeek"] = this.dayOfWeek !== undefined ? this.dayOfWeek : null as any;
        data["weeklyInterval"] = this.weeklyInterval !== undefined ? this.weeklyInterval : null as any;
        return data;
    }
}

export interface IGuardRequestShiftDetailModel {
    shiftDetailId?: string;
    startTime?: string;
    endTime?: string;
    recurrenceType?: ShiftRecurrenceType;
    perStopFrequency?: number | null;
    weekOfMonth?: number | null;
    dayOfMonth?: number | null;
    dayOfWeek?: number | null;
    weeklyInterval?: number | null;
}

export class GuardRequestShiftOccurrence implements IGuardRequestShiftOccurrence {
    shiftOccurrenceID?: string;
    shiftDetailID?: string;
    guardRequestID?: string;
    shiftDate?: Date;
    startTime?: string;
    endTime?: string;
    durationHours?: number;
    guardRequest?: GuardRequest;
    shiftDetail?: GuardRequestShiftDetail;

    constructor(data?: IGuardRequestShiftOccurrence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftOccurrenceID = _data["shiftOccurrenceID"] !== undefined ? _data["shiftOccurrenceID"] : null as any;
            this.shiftDetailID = _data["shiftDetailID"] !== undefined ? _data["shiftDetailID"] : null as any;
            this.guardRequestID = _data["guardRequestID"] !== undefined ? _data["guardRequestID"] : null as any;
            this.shiftDate = _data["shiftDate"] ? new Date(_data["shiftDate"].toString()) : null as any;
            this.startTime = _data["startTime"] !== undefined ? _data["startTime"] : null as any;
            this.endTime = _data["endTime"] !== undefined ? _data["endTime"] : null as any;
            this.durationHours = _data["durationHours"] !== undefined ? _data["durationHours"] : null as any;
            this.guardRequest = _data["guardRequest"] ? GuardRequest.fromJS(_data["guardRequest"]) : null as any;
            this.shiftDetail = _data["shiftDetail"] ? GuardRequestShiftDetail.fromJS(_data["shiftDetail"]) : null as any;
        }
    }

    static fromJS(data: any): GuardRequestShiftOccurrence {
        data = typeof data === 'object' ? data : {};
        let result = new GuardRequestShiftOccurrence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftOccurrenceID"] = this.shiftOccurrenceID !== undefined ? this.shiftOccurrenceID : null as any;
        data["shiftDetailID"] = this.shiftDetailID !== undefined ? this.shiftDetailID : null as any;
        data["guardRequestID"] = this.guardRequestID !== undefined ? this.guardRequestID : null as any;
        data["shiftDate"] = this.shiftDate ? this.shiftDate.toISOString() : null as any;
        data["startTime"] = this.startTime !== undefined ? this.startTime : null as any;
        data["endTime"] = this.endTime !== undefined ? this.endTime : null as any;
        data["durationHours"] = this.durationHours !== undefined ? this.durationHours : null as any;
        data["guardRequest"] = this.guardRequest ? this.guardRequest.toJSON() : null as any;
        data["shiftDetail"] = this.shiftDetail ? this.shiftDetail.toJSON() : null as any;
        return data;
    }
}

export interface IGuardRequestShiftOccurrence {
    shiftOccurrenceID?: string;
    shiftDetailID?: string;
    guardRequestID?: string;
    shiftDate?: Date;
    startTime?: string;
    endTime?: string;
    durationHours?: number;
    guardRequest?: GuardRequest;
    shiftDetail?: GuardRequestShiftDetail;
}

export class GuardRequestShiftOccurrenceModel implements IGuardRequestShiftOccurrenceModel {
    shiftOccurrenceId?: string;
    shiftDate?: Date;
    startTime?: string;
    endTime?: string;
    durationHours?: number;

    constructor(data?: IGuardRequestShiftOccurrenceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.shiftOccurrenceId = _data["shiftOccurrenceId"] !== undefined ? _data["shiftOccurrenceId"] : null as any;
            this.shiftDate = _data["shiftDate"] ? new Date(_data["shiftDate"].toString()) : null as any;
            this.startTime = _data["startTime"] !== undefined ? _data["startTime"] : null as any;
            this.endTime = _data["endTime"] !== undefined ? _data["endTime"] : null as any;
            this.durationHours = _data["durationHours"] !== undefined ? _data["durationHours"] : null as any;
        }
    }

    static fromJS(data: any): GuardRequestShiftOccurrenceModel {
        data = typeof data === 'object' ? data : {};
        let result = new GuardRequestShiftOccurrenceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["shiftOccurrenceId"] = this.shiftOccurrenceId !== undefined ? this.shiftOccurrenceId : null as any;
        data["shiftDate"] = this.shiftDate ? formatDate(this.shiftDate) : null as any;
        data["startTime"] = this.startTime !== undefined ? this.startTime : null as any;
        data["endTime"] = this.endTime !== undefined ? this.endTime : null as any;
        data["durationHours"] = this.durationHours !== undefined ? this.durationHours : null as any;
        return data;
    }
}

export interface IGuardRequestShiftOccurrenceModel {
    shiftOccurrenceId?: string;
    shiftDate?: Date;
    startTime?: string;
    endTime?: string;
    durationHours?: number;
}

export class GuardRequestSiteService implements IGuardRequestSiteService {
    siteServiceID?: string;
    guardRequestID?: string;
    siteId?: number;
    accountSiteBillingID?: string | null;
    patrolType?: string | null;
    requestType?: string | null;
    startDateOverride?: Date | null;
    endDateOverride?: Date | null;
    guardRequest?: GuardRequest;
    guardRequestShiftDetails?: GuardRequestShiftDetail[] | null;

    constructor(data?: IGuardRequestSiteService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteServiceID = _data["siteServiceID"] !== undefined ? _data["siteServiceID"] : null as any;
            this.guardRequestID = _data["guardRequestID"] !== undefined ? _data["guardRequestID"] : null as any;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null as any;
            this.accountSiteBillingID = _data["accountSiteBillingID"] !== undefined ? _data["accountSiteBillingID"] : null as any;
            this.patrolType = _data["patrolType"] !== undefined ? _data["patrolType"] : null as any;
            this.requestType = _data["requestType"] !== undefined ? _data["requestType"] : null as any;
            this.startDateOverride = _data["startDateOverride"] ? new Date(_data["startDateOverride"].toString()) : null as any;
            this.endDateOverride = _data["endDateOverride"] ? new Date(_data["endDateOverride"].toString()) : null as any;
            this.guardRequest = _data["guardRequest"] ? GuardRequest.fromJS(_data["guardRequest"]) : null as any;
            if (Array.isArray(_data["guardRequestShiftDetails"])) {
                this.guardRequestShiftDetails = [] as any;
                for (let item of _data["guardRequestShiftDetails"])
                    this.guardRequestShiftDetails!.push(GuardRequestShiftDetail.fromJS(item));
            }
            else {
                this.guardRequestShiftDetails = null as any;
            }
        }
    }

    static fromJS(data: any): GuardRequestSiteService {
        data = typeof data === 'object' ? data : {};
        let result = new GuardRequestSiteService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteServiceID"] = this.siteServiceID !== undefined ? this.siteServiceID : null as any;
        data["guardRequestID"] = this.guardRequestID !== undefined ? this.guardRequestID : null as any;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null as any;
        data["accountSiteBillingID"] = this.accountSiteBillingID !== undefined ? this.accountSiteBillingID : null as any;
        data["patrolType"] = this.patrolType !== undefined ? this.patrolType : null as any;
        data["requestType"] = this.requestType !== undefined ? this.requestType : null as any;
        data["startDateOverride"] = this.startDateOverride ? formatDate(this.startDateOverride) : null as any;
        data["endDateOverride"] = this.endDateOverride ? formatDate(this.endDateOverride) : null as any;
        data["guardRequest"] = this.guardRequest ? this.guardRequest.toJSON() : null as any;
        if (Array.isArray(this.guardRequestShiftDetails)) {
            data["guardRequestShiftDetails"] = [];
            for (let item of this.guardRequestShiftDetails)
                data["guardRequestShiftDetails"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGuardRequestSiteService {
    siteServiceID?: string;
    guardRequestID?: string;
    siteId?: number;
    accountSiteBillingID?: string | null;
    patrolType?: string | null;
    requestType?: string | null;
    startDateOverride?: Date | null;
    endDateOverride?: Date | null;
    guardRequest?: GuardRequest;
    guardRequestShiftDetails?: GuardRequestShiftDetail[] | null;
}

export class GuardRequestSiteServiceModel implements IGuardRequestSiteServiceModel {
    siteServiceId?: string;
    billingId?: string | null;
    siteId?: number;
    startDateOverride?: Date | null;
    endDateOverride?: Date | null;
    patrolType?: PatrolType;
    shiftDetails?: GuardRequestShiftDetailModel[] | null;
    occurrences?: GuardRequestShiftOccurrenceModel[] | null;

    constructor(data?: IGuardRequestSiteServiceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteServiceId = _data["siteServiceId"] !== undefined ? _data["siteServiceId"] : null as any;
            this.billingId = _data["billingId"] !== undefined ? _data["billingId"] : null as any;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null as any;
            this.startDateOverride = _data["startDateOverride"] ? new Date(_data["startDateOverride"].toString()) : null as any;
            this.endDateOverride = _data["endDateOverride"] ? new Date(_data["endDateOverride"].toString()) : null as any;
            this.patrolType = _data["patrolType"] !== undefined ? _data["patrolType"] : null as any;
            if (Array.isArray(_data["shiftDetails"])) {
                this.shiftDetails = [] as any;
                for (let item of _data["shiftDetails"])
                    this.shiftDetails!.push(GuardRequestShiftDetailModel.fromJS(item));
            }
            else {
                this.shiftDetails = null as any;
            }
            if (Array.isArray(_data["occurrences"])) {
                this.occurrences = [] as any;
                for (let item of _data["occurrences"])
                    this.occurrences!.push(GuardRequestShiftOccurrenceModel.fromJS(item));
            }
            else {
                this.occurrences = null as any;
            }
        }
    }

    static fromJS(data: any): GuardRequestSiteServiceModel {
        data = typeof data === 'object' ? data : {};
        let result = new GuardRequestSiteServiceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteServiceId"] = this.siteServiceId !== undefined ? this.siteServiceId : null as any;
        data["billingId"] = this.billingId !== undefined ? this.billingId : null as any;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null as any;
        data["startDateOverride"] = this.startDateOverride ? formatDate(this.startDateOverride) : null as any;
        data["endDateOverride"] = this.endDateOverride ? formatDate(this.endDateOverride) : null as any;
        data["patrolType"] = this.patrolType !== undefined ? this.patrolType : null as any;
        if (Array.isArray(this.shiftDetails)) {
            data["shiftDetails"] = [];
            for (let item of this.shiftDetails)
                data["shiftDetails"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.occurrences)) {
            data["occurrences"] = [];
            for (let item of this.occurrences)
                data["occurrences"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGuardRequestSiteServiceModel {
    siteServiceId?: string;
    billingId?: string | null;
    siteId?: number;
    startDateOverride?: Date | null;
    endDateOverride?: Date | null;
    patrolType?: PatrolType;
    shiftDetails?: GuardRequestShiftDetailModel[] | null;
    occurrences?: GuardRequestShiftOccurrenceModel[] | null;
}

export enum GuardRequestState {
    Created = "Created",
    InProgress = "InProgress",
    AwaitingInternalApproval = "AwaitingInternalApproval",
    RequestDenied = "RequestDenied",
    AwaitingSupplierApproval = "AwaitingSupplierApproval",
    AwaitingFinalRateInternalApproval = "AwaitingFinalRateInternalApproval",
    AwaitingSupplierSelection = "AwaitingSupplierSelection",
    RequestApproved = "RequestApproved",
    Canceled = "Canceled",
}

export enum GuardResultMode {
    Services = "Services",
    Requests = "Requests",
}

export class GuardServiceDetails implements IGuardServiceDetails {
    guardRequestId?: string | null;
    datasetId?: number | null;
    iteration?: number | null;
    formIndex?: number | null;
    siteId?: number | null;
    assignmentStartDate?: Date | null;
    assignmentEndDate?: Date | null;
    supplierName?: string | null;
    serviceType?: string | null;
    shiftDetails?: ShiftDetail[] | null;
    workflowExceptions?: WorkflowException[] | null;
    duration?: string | null;
    modification?: string | null;
    site?: Site;
    guardRequestState?: GuardRequestState;

    constructor(data?: IGuardServiceDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guardRequestId = _data["guardRequestId"] !== undefined ? _data["guardRequestId"] : null as any;
            this.datasetId = _data["datasetId"] !== undefined ? _data["datasetId"] : null as any;
            this.iteration = _data["iteration"] !== undefined ? _data["iteration"] : null as any;
            this.formIndex = _data["formIndex"] !== undefined ? _data["formIndex"] : null as any;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null as any;
            this.assignmentStartDate = _data["assignmentStartDate"] ? new Date(_data["assignmentStartDate"].toString()) : null as any;
            this.assignmentEndDate = _data["assignmentEndDate"] ? new Date(_data["assignmentEndDate"].toString()) : null as any;
            this.supplierName = _data["supplierName"] !== undefined ? _data["supplierName"] : null as any;
            this.serviceType = _data["serviceType"] !== undefined ? _data["serviceType"] : null as any;
            if (Array.isArray(_data["shiftDetails"])) {
                this.shiftDetails = [] as any;
                for (let item of _data["shiftDetails"])
                    this.shiftDetails!.push(ShiftDetail.fromJS(item));
            }
            else {
                this.shiftDetails = null as any;
            }
            if (Array.isArray(_data["workflowExceptions"])) {
                this.workflowExceptions = [] as any;
                for (let item of _data["workflowExceptions"])
                    this.workflowExceptions!.push(WorkflowException.fromJS(item));
            }
            else {
                this.workflowExceptions = null as any;
            }
            this.duration = _data["duration"] !== undefined ? _data["duration"] : null as any;
            this.modification = _data["modification"] !== undefined ? _data["modification"] : null as any;
            this.site = _data["site"] ? Site.fromJS(_data["site"]) : null as any;
            this.guardRequestState = _data["guardRequestState"] !== undefined ? _data["guardRequestState"] : null as any;
        }
    }

    static fromJS(data: any): GuardServiceDetails {
        data = typeof data === 'object' ? data : {};
        let result = new GuardServiceDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guardRequestId"] = this.guardRequestId !== undefined ? this.guardRequestId : null as any;
        data["datasetId"] = this.datasetId !== undefined ? this.datasetId : null as any;
        data["iteration"] = this.iteration !== undefined ? this.iteration : null as any;
        data["formIndex"] = this.formIndex !== undefined ? this.formIndex : null as any;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null as any;
        data["assignmentStartDate"] = this.assignmentStartDate ? this.assignmentStartDate.toISOString() : null as any;
        data["assignmentEndDate"] = this.assignmentEndDate ? this.assignmentEndDate.toISOString() : null as any;
        data["supplierName"] = this.supplierName !== undefined ? this.supplierName : null as any;
        data["serviceType"] = this.serviceType !== undefined ? this.serviceType : null as any;
        if (Array.isArray(this.shiftDetails)) {
            data["shiftDetails"] = [];
            for (let item of this.shiftDetails)
                data["shiftDetails"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.workflowExceptions)) {
            data["workflowExceptions"] = [];
            for (let item of this.workflowExceptions)
                data["workflowExceptions"].push(item ? item.toJSON() : null as any);
        }
        data["duration"] = this.duration !== undefined ? this.duration : null as any;
        data["modification"] = this.modification !== undefined ? this.modification : null as any;
        data["site"] = this.site ? this.site.toJSON() : null as any;
        data["guardRequestState"] = this.guardRequestState !== undefined ? this.guardRequestState : null as any;
        return data;
    }
}

export interface IGuardServiceDetails {
    guardRequestId?: string | null;
    datasetId?: number | null;
    iteration?: number | null;
    formIndex?: number | null;
    siteId?: number | null;
    assignmentStartDate?: Date | null;
    assignmentEndDate?: Date | null;
    supplierName?: string | null;
    serviceType?: string | null;
    shiftDetails?: ShiftDetail[] | null;
    workflowExceptions?: WorkflowException[] | null;
    duration?: string | null;
    modification?: string | null;
    site?: Site;
    guardRequestState?: GuardRequestState;
}

export class GuardServiceDetailsListPagedResult implements IGuardServiceDetailsListPagedResult {
    items?: GuardServiceDetails[][] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;

    constructor(data?: IGuardServiceDetailsListPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(item);
            }
            else {
                this.items = null as any;
            }
            this.page = _data["page"] !== undefined ? _data["page"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): GuardServiceDetailsListPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new GuardServiceDetailsListPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        data["page"] = this.page !== undefined ? this.page : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export interface IGuardServiceDetailsListPagedResult {
    items?: GuardServiceDetails[][] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export class GuardServiceModificationRequest implements IGuardServiceModificationRequest {
    modificationType!: ServiceModificationType;
    messageId?: string;
    submissionId?: string;
    timestamp?: Date;
    respondentExternalId?: number;
    guardServiceIds?: DatasetKey[] | null;
    fromTVRAID?: DatasetKey;
    startDate?: Date | null;
    endDate?: Date | null;
    effectiveDate?: Date | null;
    shiftDetails?: ShiftDetail[] | null;
    requestReason?: string | null;
    guardServiceType?: GuardServiceType;
    bulkRequestID?: DatasetKey;
    guardType?: PatrolType;
    billingType?: BillingType;
    rateChange?: boolean | null;

    constructor(data?: IGuardServiceModificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.modificationType = _data["modificationType"] !== undefined ? _data["modificationType"] : null as any;
            this.messageId = _data["messageId"] !== undefined ? _data["messageId"] : null as any;
            this.submissionId = _data["submissionId"] !== undefined ? _data["submissionId"] : null as any;
            this.timestamp = _data["timestamp"] ? new Date(_data["timestamp"].toString()) : null as any;
            this.respondentExternalId = _data["respondentExternalId"] !== undefined ? _data["respondentExternalId"] : null as any;
            if (Array.isArray(_data["guardServiceIds"])) {
                this.guardServiceIds = [] as any;
                for (let item of _data["guardServiceIds"])
                    this.guardServiceIds!.push(DatasetKey.fromJS(item));
            }
            else {
                this.guardServiceIds = null as any;
            }
            this.fromTVRAID = _data["fromTVRAID"] ? DatasetKey.fromJS(_data["fromTVRAID"]) : null as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            this.effectiveDate = _data["effectiveDate"] ? new Date(_data["effectiveDate"].toString()) : null as any;
            if (Array.isArray(_data["shiftDetails"])) {
                this.shiftDetails = [] as any;
                for (let item of _data["shiftDetails"])
                    this.shiftDetails!.push(ShiftDetail.fromJS(item));
            }
            else {
                this.shiftDetails = null as any;
            }
            this.requestReason = _data["requestReason"] !== undefined ? _data["requestReason"] : null as any;
            this.guardServiceType = _data["guardServiceType"] !== undefined ? _data["guardServiceType"] : null as any;
            this.bulkRequestID = _data["bulkRequestID"] ? DatasetKey.fromJS(_data["bulkRequestID"]) : null as any;
            this.guardType = _data["guardType"] !== undefined ? _data["guardType"] : null as any;
            this.billingType = _data["billingType"] !== undefined ? _data["billingType"] : null as any;
            this.rateChange = _data["rateChange"] !== undefined ? _data["rateChange"] : null as any;
        }
    }

    static fromJS(data: any): GuardServiceModificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GuardServiceModificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["modificationType"] = this.modificationType !== undefined ? this.modificationType : null as any;
        data["messageId"] = this.messageId !== undefined ? this.messageId : null as any;
        data["submissionId"] = this.submissionId !== undefined ? this.submissionId : null as any;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : null as any;
        data["respondentExternalId"] = this.respondentExternalId !== undefined ? this.respondentExternalId : null as any;
        if (Array.isArray(this.guardServiceIds)) {
            data["guardServiceIds"] = [];
            for (let item of this.guardServiceIds)
                data["guardServiceIds"].push(item ? item.toJSON() : null as any);
        }
        data["fromTVRAID"] = this.fromTVRAID ? this.fromTVRAID.toJSON() : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["effectiveDate"] = this.effectiveDate ? this.effectiveDate.toISOString() : null as any;
        if (Array.isArray(this.shiftDetails)) {
            data["shiftDetails"] = [];
            for (let item of this.shiftDetails)
                data["shiftDetails"].push(item ? item.toJSON() : null as any);
        }
        data["requestReason"] = this.requestReason !== undefined ? this.requestReason : null as any;
        data["guardServiceType"] = this.guardServiceType !== undefined ? this.guardServiceType : null as any;
        data["bulkRequestID"] = this.bulkRequestID ? this.bulkRequestID.toJSON() : null as any;
        data["guardType"] = this.guardType !== undefined ? this.guardType : null as any;
        data["billingType"] = this.billingType !== undefined ? this.billingType : null as any;
        data["rateChange"] = this.rateChange !== undefined ? this.rateChange : null as any;
        return data;
    }
}

export interface IGuardServiceModificationRequest {
    modificationType: ServiceModificationType;
    messageId?: string;
    submissionId?: string;
    timestamp?: Date;
    respondentExternalId?: number;
    guardServiceIds?: DatasetKey[] | null;
    fromTVRAID?: DatasetKey;
    startDate?: Date | null;
    endDate?: Date | null;
    effectiveDate?: Date | null;
    shiftDetails?: ShiftDetail[] | null;
    requestReason?: string | null;
    guardServiceType?: GuardServiceType;
    bulkRequestID?: DatasetKey;
    guardType?: PatrolType;
    billingType?: BillingType;
    rateChange?: boolean | null;
}

export class GuardServiceSupplierAcknowledgeRequest implements IGuardServiceSupplierAcknowledgeRequest {
    guardRequestId?: string | null;

    constructor(data?: IGuardServiceSupplierAcknowledgeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guardRequestId = _data["guardRequestId"] !== undefined ? _data["guardRequestId"] : null as any;
        }
    }

    static fromJS(data: any): GuardServiceSupplierAcknowledgeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GuardServiceSupplierAcknowledgeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guardRequestId"] = this.guardRequestId !== undefined ? this.guardRequestId : null as any;
        return data;
    }
}

export interface IGuardServiceSupplierAcknowledgeRequest {
    guardRequestId?: string | null;
}

export class GuardServiceSupplierActionRequest implements IGuardServiceSupplierActionRequest {
    respondentId?: number;
    guardRequestId?: string | null;
    acknowledged?: boolean | null;
    disposition?: SupplierApprovalDisposition;
    dateAcknowledged?: Date | null;
    tempPay?: number | null;
    tempBill?: number | null;
    permPay?: number | null;
    permBill?: number | null;
    tempPerStopRate?: number | null;
    permPerStopRate?: number | null;
    tempMonthlyPayRate?: number | null;
    permMonthlyPayRate?: number | null;
    odoHolidayPay?: number | null;
    odoHolidayBill?: number | null;
    isUnion?: boolean | null;
    isOvertime?: boolean | null;
    supplierComment?: string | null;

    constructor(data?: IGuardServiceSupplierActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.respondentId = _data["respondentId"] !== undefined ? _data["respondentId"] : null as any;
            this.guardRequestId = _data["guardRequestId"] !== undefined ? _data["guardRequestId"] : null as any;
            this.acknowledged = _data["acknowledged"] !== undefined ? _data["acknowledged"] : null as any;
            this.disposition = _data["disposition"] !== undefined ? _data["disposition"] : null as any;
            this.dateAcknowledged = _data["dateAcknowledged"] ? new Date(_data["dateAcknowledged"].toString()) : null as any;
            this.tempPay = _data["tempPay"] !== undefined ? _data["tempPay"] : null as any;
            this.tempBill = _data["tempBill"] !== undefined ? _data["tempBill"] : null as any;
            this.permPay = _data["permPay"] !== undefined ? _data["permPay"] : null as any;
            this.permBill = _data["permBill"] !== undefined ? _data["permBill"] : null as any;
            this.tempPerStopRate = _data["tempPerStopRate"] !== undefined ? _data["tempPerStopRate"] : null as any;
            this.permPerStopRate = _data["permPerStopRate"] !== undefined ? _data["permPerStopRate"] : null as any;
            this.tempMonthlyPayRate = _data["tempMonthlyPayRate"] !== undefined ? _data["tempMonthlyPayRate"] : null as any;
            this.permMonthlyPayRate = _data["permMonthlyPayRate"] !== undefined ? _data["permMonthlyPayRate"] : null as any;
            this.odoHolidayPay = _data["odoHolidayPay"] !== undefined ? _data["odoHolidayPay"] : null as any;
            this.odoHolidayBill = _data["odoHolidayBill"] !== undefined ? _data["odoHolidayBill"] : null as any;
            this.isUnion = _data["isUnion"] !== undefined ? _data["isUnion"] : null as any;
            this.isOvertime = _data["isOvertime"] !== undefined ? _data["isOvertime"] : null as any;
            this.supplierComment = _data["supplierComment"] !== undefined ? _data["supplierComment"] : null as any;
        }
    }

    static fromJS(data: any): GuardServiceSupplierActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GuardServiceSupplierActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["respondentId"] = this.respondentId !== undefined ? this.respondentId : null as any;
        data["guardRequestId"] = this.guardRequestId !== undefined ? this.guardRequestId : null as any;
        data["acknowledged"] = this.acknowledged !== undefined ? this.acknowledged : null as any;
        data["disposition"] = this.disposition !== undefined ? this.disposition : null as any;
        data["dateAcknowledged"] = this.dateAcknowledged ? this.dateAcknowledged.toISOString() : null as any;
        data["tempPay"] = this.tempPay !== undefined ? this.tempPay : null as any;
        data["tempBill"] = this.tempBill !== undefined ? this.tempBill : null as any;
        data["permPay"] = this.permPay !== undefined ? this.permPay : null as any;
        data["permBill"] = this.permBill !== undefined ? this.permBill : null as any;
        data["tempPerStopRate"] = this.tempPerStopRate !== undefined ? this.tempPerStopRate : null as any;
        data["permPerStopRate"] = this.permPerStopRate !== undefined ? this.permPerStopRate : null as any;
        data["tempMonthlyPayRate"] = this.tempMonthlyPayRate !== undefined ? this.tempMonthlyPayRate : null as any;
        data["permMonthlyPayRate"] = this.permMonthlyPayRate !== undefined ? this.permMonthlyPayRate : null as any;
        data["odoHolidayPay"] = this.odoHolidayPay !== undefined ? this.odoHolidayPay : null as any;
        data["odoHolidayBill"] = this.odoHolidayBill !== undefined ? this.odoHolidayBill : null as any;
        data["isUnion"] = this.isUnion !== undefined ? this.isUnion : null as any;
        data["isOvertime"] = this.isOvertime !== undefined ? this.isOvertime : null as any;
        data["supplierComment"] = this.supplierComment !== undefined ? this.supplierComment : null as any;
        return data;
    }
}

export interface IGuardServiceSupplierActionRequest {
    respondentId?: number;
    guardRequestId?: string | null;
    acknowledged?: boolean | null;
    disposition?: SupplierApprovalDisposition;
    dateAcknowledged?: Date | null;
    tempPay?: number | null;
    tempBill?: number | null;
    permPay?: number | null;
    permBill?: number | null;
    tempPerStopRate?: number | null;
    permPerStopRate?: number | null;
    tempMonthlyPayRate?: number | null;
    permMonthlyPayRate?: number | null;
    odoHolidayPay?: number | null;
    odoHolidayBill?: number | null;
    isUnion?: boolean | null;
    isOvertime?: boolean | null;
    supplierComment?: string | null;
}

export class GuardServiceSupplierActionSubmitResponse implements IGuardServiceSupplierActionSubmitResponse {
    success?: boolean;
    workflowStateBefore?: string | null;
    workflowStateChanged?: boolean;

    constructor(data?: IGuardServiceSupplierActionSubmitResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : null as any;
            this.workflowStateBefore = _data["workflowStateBefore"] !== undefined ? _data["workflowStateBefore"] : null as any;
            this.workflowStateChanged = _data["workflowStateChanged"] !== undefined ? _data["workflowStateChanged"] : null as any;
        }
    }

    static fromJS(data: any): GuardServiceSupplierActionSubmitResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GuardServiceSupplierActionSubmitResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : null as any;
        data["workflowStateBefore"] = this.workflowStateBefore !== undefined ? this.workflowStateBefore : null as any;
        data["workflowStateChanged"] = this.workflowStateChanged !== undefined ? this.workflowStateChanged : null as any;
        return data;
    }
}

export interface IGuardServiceSupplierActionSubmitResponse {
    success?: boolean;
    workflowStateBefore?: string | null;
    workflowStateChanged?: boolean;
}

export class GuardServiceSupplierFulfillmentRequest implements IGuardServiceSupplierFulfillmentRequest {
    respondentId?: number;
    guardServiceId?: DatasetKey;
    fulfillmentResponse?: SupplierFulfillmentResponse;
    fulfillmentUser?: string | null;
    fulfillmentComment?: string | null;
    newStartDate?: Date | null;
    partialEndDate?: Date | null;
    partialOption?: SupplierFulfillmentPartialOption;
    partialGuardType?: PatrolType;

    constructor(data?: IGuardServiceSupplierFulfillmentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.respondentId = _data["respondentId"] !== undefined ? _data["respondentId"] : null as any;
            this.guardServiceId = _data["guardServiceId"] ? DatasetKey.fromJS(_data["guardServiceId"]) : null as any;
            this.fulfillmentResponse = _data["fulfillmentResponse"] !== undefined ? _data["fulfillmentResponse"] : null as any;
            this.fulfillmentUser = _data["fulfillmentUser"] !== undefined ? _data["fulfillmentUser"] : null as any;
            this.fulfillmentComment = _data["fulfillmentComment"] !== undefined ? _data["fulfillmentComment"] : null as any;
            this.newStartDate = _data["newStartDate"] ? new Date(_data["newStartDate"].toString()) : null as any;
            this.partialEndDate = _data["partialEndDate"] ? new Date(_data["partialEndDate"].toString()) : null as any;
            this.partialOption = _data["partialOption"] !== undefined ? _data["partialOption"] : null as any;
            this.partialGuardType = _data["partialGuardType"] !== undefined ? _data["partialGuardType"] : null as any;
        }
    }

    static fromJS(data: any): GuardServiceSupplierFulfillmentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GuardServiceSupplierFulfillmentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["respondentId"] = this.respondentId !== undefined ? this.respondentId : null as any;
        data["guardServiceId"] = this.guardServiceId ? this.guardServiceId.toJSON() : null as any;
        data["fulfillmentResponse"] = this.fulfillmentResponse !== undefined ? this.fulfillmentResponse : null as any;
        data["fulfillmentUser"] = this.fulfillmentUser !== undefined ? this.fulfillmentUser : null as any;
        data["fulfillmentComment"] = this.fulfillmentComment !== undefined ? this.fulfillmentComment : null as any;
        data["newStartDate"] = this.newStartDate ? this.newStartDate.toISOString() : null as any;
        data["partialEndDate"] = this.partialEndDate ? this.partialEndDate.toISOString() : null as any;
        data["partialOption"] = this.partialOption !== undefined ? this.partialOption : null as any;
        data["partialGuardType"] = this.partialGuardType !== undefined ? this.partialGuardType : null as any;
        return data;
    }
}

export interface IGuardServiceSupplierFulfillmentRequest {
    respondentId?: number;
    guardServiceId?: DatasetKey;
    fulfillmentResponse?: SupplierFulfillmentResponse;
    fulfillmentUser?: string | null;
    fulfillmentComment?: string | null;
    newStartDate?: Date | null;
    partialEndDate?: Date | null;
    partialOption?: SupplierFulfillmentPartialOption;
    partialGuardType?: PatrolType;
}

export enum GuardServiceType {
    Armed_Guard = "Armed Guard",
    Unarmed_Guard = "Unarmed Guard",
    Mobile_Patrol = "Mobile Patrol",
    OffDuty_Law_Enforcement = "Off-Duty Law Enforcement",
}

export class GuardServicesForSitesQuery implements IGuardServicesForSitesQuery {
    siteIds?: number[] | null;
    page?: number | null;
    pageSize?: number;
    includeSite?: boolean;
    isActive?: boolean | null;
    mode?: GuardResultMode;

    constructor(data?: IGuardServicesForSitesQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["siteIds"])) {
                this.siteIds = [] as any;
                for (let item of _data["siteIds"])
                    this.siteIds!.push(item);
            }
            else {
                this.siteIds = null as any;
            }
            this.page = _data["page"] !== undefined ? _data["page"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.includeSite = _data["includeSite"] !== undefined ? _data["includeSite"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            this.mode = _data["mode"] !== undefined ? _data["mode"] : null as any;
        }
    }

    static fromJS(data: any): GuardServicesForSitesQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GuardServicesForSitesQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.siteIds)) {
            data["siteIds"] = [];
            for (let item of this.siteIds)
                data["siteIds"].push(item);
        }
        data["page"] = this.page !== undefined ? this.page : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["includeSite"] = this.includeSite !== undefined ? this.includeSite : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        data["mode"] = this.mode !== undefined ? this.mode : null as any;
        return data;
    }
}

export interface IGuardServicesForSitesQuery {
    siteIds?: number[] | null;
    page?: number | null;
    pageSize?: number;
    includeSite?: boolean;
    isActive?: boolean | null;
    mode?: GuardResultMode;
}

export class Image implements IImage {
    ownerID?: number;
    owner?: Owner;
    name!: string;
    extension!: string;
    data!: string;
    base64Full?: string | null;
    base64Mid?: string | null;
    base64Small?: string | null;
    createdDate!: Date;
    modifiedDate!: Date;
    description?: string | null;
    notes?: string | null;
    designerID!: string;
    ownerDesignerID!: string;
    id?: number;

    constructor(data?: IImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.extension = _data["extension"] !== undefined ? _data["extension"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.base64Full = _data["base64Full"] !== undefined ? _data["base64Full"] : null as any;
            this.base64Mid = _data["base64Mid"] !== undefined ? _data["base64Mid"] : null as any;
            this.base64Small = _data["base64Small"] !== undefined ? _data["base64Small"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.ownerDesignerID = _data["ownerDesignerID"] !== undefined ? _data["ownerDesignerID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): Image {
        data = typeof data === 'object' ? data : {};
        let result = new Image();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["owner"] = this.owner ? this.owner.toJSON() : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["extension"] = this.extension !== undefined ? this.extension : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["base64Full"] = this.base64Full !== undefined ? this.base64Full : null as any;
        data["base64Mid"] = this.base64Mid !== undefined ? this.base64Mid : null as any;
        data["base64Small"] = this.base64Small !== undefined ? this.base64Small : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["ownerDesignerID"] = this.ownerDesignerID !== undefined ? this.ownerDesignerID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IImage {
    ownerID?: number;
    owner?: Owner;
    name: string;
    extension: string;
    data: string;
    base64Full?: string | null;
    base64Mid?: string | null;
    base64Small?: string | null;
    createdDate: Date;
    modifiedDate: Date;
    description?: string | null;
    notes?: string | null;
    designerID: string;
    ownerDesignerID: string;
    id?: number;
}

export class ImportDataRequest implements IImportDataRequest {
    targetID?: number;
    fileName?: string | null;
    processGUID?: string | null;
    columnMap?: { [key: string]: string; } | null;
    fromStatus?: number;

    constructor(data?: IImportDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.targetID = _data["targetID"] !== undefined ? _data["targetID"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.processGUID = _data["processGUID"] !== undefined ? _data["processGUID"] : null as any;
            if (_data["columnMap"]) {
                this.columnMap = {} as any;
                for (let key in _data["columnMap"]) {
                    if (_data["columnMap"].hasOwnProperty(key))
                        (this.columnMap as any)![key] = _data["columnMap"][key] !== undefined ? _data["columnMap"][key] : null as any;
                }
            }
            else {
                this.columnMap = null as any;
            }
            this.fromStatus = _data["fromStatus"] !== undefined ? _data["fromStatus"] : null as any;
        }
    }

    static fromJS(data: any): ImportDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ImportDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["targetID"] = this.targetID !== undefined ? this.targetID : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["processGUID"] = this.processGUID !== undefined ? this.processGUID : null as any;
        if (this.columnMap) {
            data["columnMap"] = {};
            for (let key in this.columnMap) {
                if (this.columnMap.hasOwnProperty(key))
                    (data["columnMap"] as any)[key] = this.columnMap[key] !== undefined ? this.columnMap[key] : null as any;
            }
        }
        data["fromStatus"] = this.fromStatus !== undefined ? this.fromStatus : null as any;
        return data;
    }
}

export interface IImportDataRequest {
    targetID?: number;
    fileName?: string | null;
    processGUID?: string | null;
    columnMap?: { [key: string]: string; } | null;
    fromStatus?: number;
}

export class IncidentDTO implements IIncidentDTO {
    buildingCode?: string | null;
    incidentType?: string | null;
    incidentDate?: Date | null;
    incidentTime?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;

    constructor(data?: IIncidentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.buildingCode = _data["buildingCode"] !== undefined ? _data["buildingCode"] : null as any;
            this.incidentType = _data["incidentType"] !== undefined ? _data["incidentType"] : null as any;
            this.incidentDate = _data["incidentDate"] ? new Date(_data["incidentDate"].toString()) : null as any;
            this.incidentTime = _data["incidentTime"] !== undefined ? _data["incidentTime"] : null as any;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : null as any;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : null as any;
            this.metadata = _data["metadata"] !== undefined ? _data["metadata"] : null as any;
        }
    }

    static fromJS(data: any): IncidentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buildingCode"] = this.buildingCode !== undefined ? this.buildingCode : null as any;
        data["incidentType"] = this.incidentType !== undefined ? this.incidentType : null as any;
        data["incidentDate"] = this.incidentDate ? this.incidentDate.toISOString() : null as any;
        data["incidentTime"] = this.incidentTime !== undefined ? this.incidentTime : null as any;
        data["latitude"] = this.latitude !== undefined ? this.latitude : null as any;
        data["longitude"] = this.longitude !== undefined ? this.longitude : null as any;
        data["metadata"] = this.metadata !== undefined ? this.metadata : null as any;
        return data;
    }
}

export interface IIncidentDTO {
    buildingCode?: string | null;
    incidentType?: string | null;
    incidentDate?: Date | null;
    incidentTime?: string | null;
    latitude?: number | null;
    longitude?: number | null;
    metadata?: string | null;
}

export class IncidentQuery implements IIncidentQuery {
    ownerId?: number;
    startDate?: Date | null;
    endDate?: Date | null;

    constructor(data?: IIncidentQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerId = _data["ownerId"] !== undefined ? _data["ownerId"] : null as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): IncidentQuery {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerId"] = this.ownerId !== undefined ? this.ownerId : null as any;
        data["startDate"] = this.startDate ? formatDate(this.startDate) : null as any;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : null as any;
        return data;
    }
}

export interface IIncidentQuery {
    ownerId?: number;
    startDate?: Date | null;
    endDate?: Date | null;
}

export class IncidentsByPeriod implements IIncidentsByPeriod {
    period?: RiskModelRelease;
    incidents?: RiskModelIncident[] | null;

    constructor(data?: IIncidentsByPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.period = _data["period"] ? RiskModelRelease.fromJS(_data["period"]) : null as any;
            if (Array.isArray(_data["incidents"])) {
                this.incidents = [] as any;
                for (let item of _data["incidents"])
                    this.incidents!.push(RiskModelIncident.fromJS(item));
            }
            else {
                this.incidents = null as any;
            }
        }
    }

    static fromJS(data: any): IncidentsByPeriod {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentsByPeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["period"] = this.period ? this.period.toJSON() : null as any;
        if (Array.isArray(this.incidents)) {
            data["incidents"] = [];
            for (let item of this.incidents)
                data["incidents"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IIncidentsByPeriod {
    period?: RiskModelRelease;
    incidents?: RiskModelIncident[] | null;
}

export enum IncompleteMobilePreference {
    Start_the_route_in_reverse_order = "Start the route in reverse order",
    Pick_up_where_the_route_left_off = "Pick up where the route left off",
}

export class IntervalExpression implements IIntervalExpression {
    ownerID?: number;
    name!: string;
    active!: boolean;
    expression?: string | null;
    isDML!: boolean;
    startDateTime!: Date;
    lastProcessDateTime?: Date | null;
    intervalTypeID!: number;
    interval!: number;
    maxRepeats!: number;
    repeats?: number | null;
    processStatus?: string | null;
    startProcessDateTime?: Date | null;
    endProcessDateTime?: Date | null;
    isDebug!: boolean;
    notes?: string | null;
    designerID!: string;
    ownerDesignerID!: string;
    id?: number;

    constructor(data?: IIntervalExpression) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.expression = _data["expression"] !== undefined ? _data["expression"] : null as any;
            this.isDML = _data["isDML"] !== undefined ? _data["isDML"] : null as any;
            this.startDateTime = _data["startDateTime"] ? new Date(_data["startDateTime"].toString()) : null as any;
            this.lastProcessDateTime = _data["lastProcessDateTime"] ? new Date(_data["lastProcessDateTime"].toString()) : null as any;
            this.intervalTypeID = _data["intervalTypeID"] !== undefined ? _data["intervalTypeID"] : null as any;
            this.interval = _data["interval"] !== undefined ? _data["interval"] : null as any;
            this.maxRepeats = _data["maxRepeats"] !== undefined ? _data["maxRepeats"] : null as any;
            this.repeats = _data["repeats"] !== undefined ? _data["repeats"] : null as any;
            this.processStatus = _data["processStatus"] !== undefined ? _data["processStatus"] : null as any;
            this.startProcessDateTime = _data["startProcessDateTime"] ? new Date(_data["startProcessDateTime"].toString()) : null as any;
            this.endProcessDateTime = _data["endProcessDateTime"] ? new Date(_data["endProcessDateTime"].toString()) : null as any;
            this.isDebug = _data["isDebug"] !== undefined ? _data["isDebug"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.ownerDesignerID = _data["ownerDesignerID"] !== undefined ? _data["ownerDesignerID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): IntervalExpression {
        data = typeof data === 'object' ? data : {};
        let result = new IntervalExpression();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["expression"] = this.expression !== undefined ? this.expression : null as any;
        data["isDML"] = this.isDML !== undefined ? this.isDML : null as any;
        data["startDateTime"] = this.startDateTime ? this.startDateTime.toISOString() : null as any;
        data["lastProcessDateTime"] = this.lastProcessDateTime ? this.lastProcessDateTime.toISOString() : null as any;
        data["intervalTypeID"] = this.intervalTypeID !== undefined ? this.intervalTypeID : null as any;
        data["interval"] = this.interval !== undefined ? this.interval : null as any;
        data["maxRepeats"] = this.maxRepeats !== undefined ? this.maxRepeats : null as any;
        data["repeats"] = this.repeats !== undefined ? this.repeats : null as any;
        data["processStatus"] = this.processStatus !== undefined ? this.processStatus : null as any;
        data["startProcessDateTime"] = this.startProcessDateTime ? this.startProcessDateTime.toISOString() : null as any;
        data["endProcessDateTime"] = this.endProcessDateTime ? this.endProcessDateTime.toISOString() : null as any;
        data["isDebug"] = this.isDebug !== undefined ? this.isDebug : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["ownerDesignerID"] = this.ownerDesignerID !== undefined ? this.ownerDesignerID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IIntervalExpression {
    ownerID?: number;
    name: string;
    active: boolean;
    expression?: string | null;
    isDML: boolean;
    startDateTime: Date;
    lastProcessDateTime?: Date | null;
    intervalTypeID: number;
    interval: number;
    maxRepeats: number;
    repeats?: number | null;
    processStatus?: string | null;
    startProcessDateTime?: Date | null;
    endProcessDateTime?: Date | null;
    isDebug: boolean;
    notes?: string | null;
    designerID: string;
    ownerDesignerID: string;
    id?: number;
}

export class InvoiceAction implements IInvoiceAction {
    workflowState?: InvoiceWorkflowState;
    possibleActions?: ActionContext[] | null;
    actionHistory?: Response[] | null;

    constructor(data?: IInvoiceAction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowState = _data["workflowState"] ? InvoiceWorkflowState.fromJS(_data["workflowState"]) : null as any;
            if (Array.isArray(_data["possibleActions"])) {
                this.possibleActions = [] as any;
                for (let item of _data["possibleActions"])
                    this.possibleActions!.push(ActionContext.fromJS(item));
            }
            else {
                this.possibleActions = null as any;
            }
            if (Array.isArray(_data["actionHistory"])) {
                this.actionHistory = [] as any;
                for (let item of _data["actionHistory"])
                    this.actionHistory!.push(Response.fromJS(item));
            }
            else {
                this.actionHistory = null as any;
            }
        }
    }

    static fromJS(data: any): InvoiceAction {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceAction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowState"] = this.workflowState ? this.workflowState.toJSON() : null as any;
        if (Array.isArray(this.possibleActions)) {
            data["possibleActions"] = [];
            for (let item of this.possibleActions)
                data["possibleActions"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.actionHistory)) {
            data["actionHistory"] = [];
            for (let item of this.actionHistory)
                data["actionHistory"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IInvoiceAction {
    workflowState?: InvoiceWorkflowState;
    possibleActions?: ActionContext[] | null;
    actionHistory?: Response[] | null;
}

export class InvoiceActionHistoryPageResponse implements IInvoiceActionHistoryPageResponse {
    items?: Response[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;

    constructor(data?: IInvoiceActionHistoryPageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Response.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.page = _data["page"] !== undefined ? _data["page"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): InvoiceActionHistoryPageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceActionHistoryPageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["page"] = this.page !== undefined ? this.page : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export interface IInvoiceActionHistoryPageResponse {
    items?: Response[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export enum InvoiceEtkCostStatus {
    NoMatchingEtkRows = "NoMatchingEtkRows",
    Unpriceable = "Unpriceable",
    PartiallyPriced = "PartiallyPriced",
    FullyPriced = "FullyPriced",
}

export class InvoiceLatestActionResponse implements IInvoiceLatestActionResponse {
    action?: string | null;
    actionUserName?: string | null;
    actionDate?: Date;

    constructor(data?: IInvoiceLatestActionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"] !== undefined ? _data["action"] : null as any;
            this.actionUserName = _data["actionUserName"] !== undefined ? _data["actionUserName"] : null as any;
            this.actionDate = _data["actionDate"] ? new Date(_data["actionDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): InvoiceLatestActionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceLatestActionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action !== undefined ? this.action : null as any;
        data["actionUserName"] = this.actionUserName !== undefined ? this.actionUserName : null as any;
        data["actionDate"] = this.actionDate ? this.actionDate.toISOString() : null as any;
        return data;
    }
}

export interface IInvoiceLatestActionResponse {
    action?: string | null;
    actionUserName?: string | null;
    actionDate?: Date;
}

export class InvoiceLineItemResponse implements IInvoiceLineItemResponse {
    id?: number;
    invoiceId?: number;
    invoiceLineId?: string | null;
    orderLineId?: string | null;
    supplierPartNumber?: string | null;
    quantity?: number | null;
    unitOfMeasure?: string | null;
    unitPrice?: number | null;
    lineItemDescription?: string | null;
    lineTaxAmount?: number | null;
    lineTaxCategory?: string | null;
    lineShippingAmount?: number | null;
    insertedTs?: Date | null;
    updatedTs?: Date | null;

    constructor(data?: IInvoiceLineItemResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : null as any;
            this.invoiceLineId = _data["invoiceLineId"] !== undefined ? _data["invoiceLineId"] : null as any;
            this.orderLineId = _data["orderLineId"] !== undefined ? _data["orderLineId"] : null as any;
            this.supplierPartNumber = _data["supplierPartNumber"] !== undefined ? _data["supplierPartNumber"] : null as any;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
            this.unitOfMeasure = _data["unitOfMeasure"] !== undefined ? _data["unitOfMeasure"] : null as any;
            this.unitPrice = _data["unitPrice"] !== undefined ? _data["unitPrice"] : null as any;
            this.lineItemDescription = _data["lineItemDescription"] !== undefined ? _data["lineItemDescription"] : null as any;
            this.lineTaxAmount = _data["lineTaxAmount"] !== undefined ? _data["lineTaxAmount"] : null as any;
            this.lineTaxCategory = _data["lineTaxCategory"] !== undefined ? _data["lineTaxCategory"] : null as any;
            this.lineShippingAmount = _data["lineShippingAmount"] !== undefined ? _data["lineShippingAmount"] : null as any;
            this.insertedTs = _data["insertedTs"] ? new Date(_data["insertedTs"].toString()) : null as any;
            this.updatedTs = _data["updatedTs"] ? new Date(_data["updatedTs"].toString()) : null as any;
        }
    }

    static fromJS(data: any): InvoiceLineItemResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceLineItemResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : null as any;
        data["invoiceLineId"] = this.invoiceLineId !== undefined ? this.invoiceLineId : null as any;
        data["orderLineId"] = this.orderLineId !== undefined ? this.orderLineId : null as any;
        data["supplierPartNumber"] = this.supplierPartNumber !== undefined ? this.supplierPartNumber : null as any;
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["unitOfMeasure"] = this.unitOfMeasure !== undefined ? this.unitOfMeasure : null as any;
        data["unitPrice"] = this.unitPrice !== undefined ? this.unitPrice : null as any;
        data["lineItemDescription"] = this.lineItemDescription !== undefined ? this.lineItemDescription : null as any;
        data["lineTaxAmount"] = this.lineTaxAmount !== undefined ? this.lineTaxAmount : null as any;
        data["lineTaxCategory"] = this.lineTaxCategory !== undefined ? this.lineTaxCategory : null as any;
        data["lineShippingAmount"] = this.lineShippingAmount !== undefined ? this.lineShippingAmount : null as any;
        data["insertedTs"] = this.insertedTs ? this.insertedTs.toISOString() : null as any;
        data["updatedTs"] = this.updatedTs ? this.updatedTs.toISOString() : null as any;
        return data;
    }
}

export interface IInvoiceLineItemResponse {
    id?: number;
    invoiceId?: number;
    invoiceLineId?: string | null;
    orderLineId?: string | null;
    supplierPartNumber?: string | null;
    quantity?: number | null;
    unitOfMeasure?: string | null;
    unitPrice?: number | null;
    lineItemDescription?: string | null;
    lineTaxAmount?: number | null;
    lineTaxCategory?: string | null;
    lineShippingAmount?: number | null;
    insertedTs?: Date | null;
    updatedTs?: Date | null;
}

export class InvoiceSiteReportResponse implements IInvoiceSiteReportResponse {
    siteId?: number;
    siteName?: string | null;
    suppliers?: InvoiceSiteSupplierSummaryResponse[] | null;

    constructor(data?: IInvoiceSiteReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null as any;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null as any;
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(InvoiceSiteSupplierSummaryResponse.fromJS(item));
            }
            else {
                this.suppliers = null as any;
            }
        }
    }

    static fromJS(data: any): InvoiceSiteReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSiteReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId !== undefined ? this.siteId : null as any;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null as any;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IInvoiceSiteReportResponse {
    siteId?: number;
    siteName?: string | null;
    suppliers?: InvoiceSiteSupplierSummaryResponse[] | null;
}

export class InvoiceSiteSupplierReportResponse implements IInvoiceSiteSupplierReportResponse {
    supplierName?: string | null;
    invoiceNumber?: string | null;
    invoiceId?: number;
    invoiceStartDate?: Date | null;
    invoiceEndDate?: Date | null;
    etkProjectedCost?: number | null;
    etkCostStatus?: InvoiceEtkCostStatus;
    guardProjectedCost?: number | null;
    actualCost?: number;
    costVarianceInvoiceToGmpAmount?: number | null;
    costVarianceInvoiceToGmpPercentage?: number | null;
    etkCostVariance?: number | null;
    etkCostVariancePercentage?: number | null;
    scheduledHours?: number | null;
    billedInvoiceHours?: number | null;
    etkHours?: number | null;
    actualHours?: number | null;
    actualHoursVarianceMinutes?: number | null;
    invoiceToGmpVarianceMinutes?: number | null;
    autoApprovalCostVariancePercentage?: number | null;
    lineItems?: InvoiceLineItemResponse[] | null;
    guards?: GuardInvoiceResponse[] | null;

    constructor(data?: IInvoiceSiteSupplierReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierName = _data["supplierName"] !== undefined ? _data["supplierName"] : null as any;
            this.invoiceNumber = _data["invoiceNumber"] !== undefined ? _data["invoiceNumber"] : null as any;
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : null as any;
            this.invoiceStartDate = _data["invoiceStartDate"] ? new Date(_data["invoiceStartDate"].toString()) : null as any;
            this.invoiceEndDate = _data["invoiceEndDate"] ? new Date(_data["invoiceEndDate"].toString()) : null as any;
            this.etkProjectedCost = _data["etkProjectedCost"] !== undefined ? _data["etkProjectedCost"] : null as any;
            this.etkCostStatus = _data["etkCostStatus"] !== undefined ? _data["etkCostStatus"] : null as any;
            this.guardProjectedCost = _data["guardProjectedCost"] !== undefined ? _data["guardProjectedCost"] : null as any;
            this.actualCost = _data["actualCost"] !== undefined ? _data["actualCost"] : null as any;
            this.costVarianceInvoiceToGmpAmount = _data["costVarianceInvoiceToGmpAmount"] !== undefined ? _data["costVarianceInvoiceToGmpAmount"] : null as any;
            this.costVarianceInvoiceToGmpPercentage = _data["costVarianceInvoiceToGmpPercentage"] !== undefined ? _data["costVarianceInvoiceToGmpPercentage"] : null as any;
            this.etkCostVariance = _data["etkCostVariance"] !== undefined ? _data["etkCostVariance"] : null as any;
            this.etkCostVariancePercentage = _data["etkCostVariancePercentage"] !== undefined ? _data["etkCostVariancePercentage"] : null as any;
            this.scheduledHours = _data["scheduledHours"] !== undefined ? _data["scheduledHours"] : null as any;
            this.billedInvoiceHours = _data["billedInvoiceHours"] !== undefined ? _data["billedInvoiceHours"] : null as any;
            this.etkHours = _data["etkHours"] !== undefined ? _data["etkHours"] : null as any;
            this.actualHours = _data["actualHours"] !== undefined ? _data["actualHours"] : null as any;
            this.actualHoursVarianceMinutes = _data["actualHoursVarianceMinutes"] !== undefined ? _data["actualHoursVarianceMinutes"] : null as any;
            this.invoiceToGmpVarianceMinutes = _data["invoiceToGmpVarianceMinutes"] !== undefined ? _data["invoiceToGmpVarianceMinutes"] : null as any;
            this.autoApprovalCostVariancePercentage = _data["autoApprovalCostVariancePercentage"] !== undefined ? _data["autoApprovalCostVariancePercentage"] : null as any;
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(InvoiceLineItemResponse.fromJS(item));
            }
            else {
                this.lineItems = null as any;
            }
            if (Array.isArray(_data["guards"])) {
                this.guards = [] as any;
                for (let item of _data["guards"])
                    this.guards!.push(GuardInvoiceResponse.fromJS(item));
            }
            else {
                this.guards = null as any;
            }
        }
    }

    static fromJS(data: any): InvoiceSiteSupplierReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSiteSupplierReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierName"] = this.supplierName !== undefined ? this.supplierName : null as any;
        data["invoiceNumber"] = this.invoiceNumber !== undefined ? this.invoiceNumber : null as any;
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : null as any;
        data["invoiceStartDate"] = this.invoiceStartDate ? formatDate(this.invoiceStartDate) : null as any;
        data["invoiceEndDate"] = this.invoiceEndDate ? formatDate(this.invoiceEndDate) : null as any;
        data["etkProjectedCost"] = this.etkProjectedCost !== undefined ? this.etkProjectedCost : null as any;
        data["etkCostStatus"] = this.etkCostStatus !== undefined ? this.etkCostStatus : null as any;
        data["guardProjectedCost"] = this.guardProjectedCost !== undefined ? this.guardProjectedCost : null as any;
        data["actualCost"] = this.actualCost !== undefined ? this.actualCost : null as any;
        data["costVarianceInvoiceToGmpAmount"] = this.costVarianceInvoiceToGmpAmount !== undefined ? this.costVarianceInvoiceToGmpAmount : null as any;
        data["costVarianceInvoiceToGmpPercentage"] = this.costVarianceInvoiceToGmpPercentage !== undefined ? this.costVarianceInvoiceToGmpPercentage : null as any;
        data["etkCostVariance"] = this.etkCostVariance !== undefined ? this.etkCostVariance : null as any;
        data["etkCostVariancePercentage"] = this.etkCostVariancePercentage !== undefined ? this.etkCostVariancePercentage : null as any;
        data["scheduledHours"] = this.scheduledHours !== undefined ? this.scheduledHours : null as any;
        data["billedInvoiceHours"] = this.billedInvoiceHours !== undefined ? this.billedInvoiceHours : null as any;
        data["etkHours"] = this.etkHours !== undefined ? this.etkHours : null as any;
        data["actualHours"] = this.actualHours !== undefined ? this.actualHours : null as any;
        data["actualHoursVarianceMinutes"] = this.actualHoursVarianceMinutes !== undefined ? this.actualHoursVarianceMinutes : null as any;
        data["invoiceToGmpVarianceMinutes"] = this.invoiceToGmpVarianceMinutes !== undefined ? this.invoiceToGmpVarianceMinutes : null as any;
        data["autoApprovalCostVariancePercentage"] = this.autoApprovalCostVariancePercentage !== undefined ? this.autoApprovalCostVariancePercentage : null as any;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.guards)) {
            data["guards"] = [];
            for (let item of this.guards)
                data["guards"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IInvoiceSiteSupplierReportResponse {
    supplierName?: string | null;
    invoiceNumber?: string | null;
    invoiceId?: number;
    invoiceStartDate?: Date | null;
    invoiceEndDate?: Date | null;
    etkProjectedCost?: number | null;
    etkCostStatus?: InvoiceEtkCostStatus;
    guardProjectedCost?: number | null;
    actualCost?: number;
    costVarianceInvoiceToGmpAmount?: number | null;
    costVarianceInvoiceToGmpPercentage?: number | null;
    etkCostVariance?: number | null;
    etkCostVariancePercentage?: number | null;
    scheduledHours?: number | null;
    billedInvoiceHours?: number | null;
    etkHours?: number | null;
    actualHours?: number | null;
    actualHoursVarianceMinutes?: number | null;
    invoiceToGmpVarianceMinutes?: number | null;
    autoApprovalCostVariancePercentage?: number | null;
    lineItems?: InvoiceLineItemResponse[] | null;
    guards?: GuardInvoiceResponse[] | null;
}

export class InvoiceSiteSupplierSummaryResponse implements IInvoiceSiteSupplierSummaryResponse {
    supplierName?: string | null;
    invoiceNumber?: string | null;
    invoiceId?: number;
    invoiceStartDate?: Date | null;
    invoiceEndDate?: Date | null;
    projectedCostGmp?: number | null;
    projectedCostEtk?: number | null;
    etkCostStatus?: InvoiceEtkCostStatus;
    actualCostInvoice?: number;
    costVarianceInvoiceToGmpAmount?: number | null;
    costVarianceInvoiceToGmpPercentage?: number | null;
    timeVarianceInvoiceToGmpMinutes?: number | null;
    actualHoursEtk?: number | null;
    billedHoursInvoice?: number | null;
    scheduledHoursGmp?: number | null;
    timeVarianceGmpToEtkMinutes?: number | null;
    lineItems?: InvoiceLineItemResponse[] | null;
    workflow?: InvoiceWorkflowSummaryResponse;

    constructor(data?: IInvoiceSiteSupplierSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierName = _data["supplierName"] !== undefined ? _data["supplierName"] : null as any;
            this.invoiceNumber = _data["invoiceNumber"] !== undefined ? _data["invoiceNumber"] : null as any;
            this.invoiceId = _data["invoiceId"] !== undefined ? _data["invoiceId"] : null as any;
            this.invoiceStartDate = _data["invoiceStartDate"] ? new Date(_data["invoiceStartDate"].toString()) : null as any;
            this.invoiceEndDate = _data["invoiceEndDate"] ? new Date(_data["invoiceEndDate"].toString()) : null as any;
            this.projectedCostGmp = _data["projectedCostGmp"] !== undefined ? _data["projectedCostGmp"] : null as any;
            this.projectedCostEtk = _data["projectedCostEtk"] !== undefined ? _data["projectedCostEtk"] : null as any;
            this.etkCostStatus = _data["etkCostStatus"] !== undefined ? _data["etkCostStatus"] : null as any;
            this.actualCostInvoice = _data["actualCostInvoice"] !== undefined ? _data["actualCostInvoice"] : null as any;
            this.costVarianceInvoiceToGmpAmount = _data["costVarianceInvoiceToGmpAmount"] !== undefined ? _data["costVarianceInvoiceToGmpAmount"] : null as any;
            this.costVarianceInvoiceToGmpPercentage = _data["costVarianceInvoiceToGmpPercentage"] !== undefined ? _data["costVarianceInvoiceToGmpPercentage"] : null as any;
            this.timeVarianceInvoiceToGmpMinutes = _data["timeVarianceInvoiceToGmpMinutes"] !== undefined ? _data["timeVarianceInvoiceToGmpMinutes"] : null as any;
            this.actualHoursEtk = _data["actualHoursEtk"] !== undefined ? _data["actualHoursEtk"] : null as any;
            this.billedHoursInvoice = _data["billedHoursInvoice"] !== undefined ? _data["billedHoursInvoice"] : null as any;
            this.scheduledHoursGmp = _data["scheduledHoursGmp"] !== undefined ? _data["scheduledHoursGmp"] : null as any;
            this.timeVarianceGmpToEtkMinutes = _data["timeVarianceGmpToEtkMinutes"] !== undefined ? _data["timeVarianceGmpToEtkMinutes"] : null as any;
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(InvoiceLineItemResponse.fromJS(item));
            }
            else {
                this.lineItems = null as any;
            }
            this.workflow = _data["workflow"] ? InvoiceWorkflowSummaryResponse.fromJS(_data["workflow"]) : null as any;
        }
    }

    static fromJS(data: any): InvoiceSiteSupplierSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceSiteSupplierSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierName"] = this.supplierName !== undefined ? this.supplierName : null as any;
        data["invoiceNumber"] = this.invoiceNumber !== undefined ? this.invoiceNumber : null as any;
        data["invoiceId"] = this.invoiceId !== undefined ? this.invoiceId : null as any;
        data["invoiceStartDate"] = this.invoiceStartDate ? formatDate(this.invoiceStartDate) : null as any;
        data["invoiceEndDate"] = this.invoiceEndDate ? formatDate(this.invoiceEndDate) : null as any;
        data["projectedCostGmp"] = this.projectedCostGmp !== undefined ? this.projectedCostGmp : null as any;
        data["projectedCostEtk"] = this.projectedCostEtk !== undefined ? this.projectedCostEtk : null as any;
        data["etkCostStatus"] = this.etkCostStatus !== undefined ? this.etkCostStatus : null as any;
        data["actualCostInvoice"] = this.actualCostInvoice !== undefined ? this.actualCostInvoice : null as any;
        data["costVarianceInvoiceToGmpAmount"] = this.costVarianceInvoiceToGmpAmount !== undefined ? this.costVarianceInvoiceToGmpAmount : null as any;
        data["costVarianceInvoiceToGmpPercentage"] = this.costVarianceInvoiceToGmpPercentage !== undefined ? this.costVarianceInvoiceToGmpPercentage : null as any;
        data["timeVarianceInvoiceToGmpMinutes"] = this.timeVarianceInvoiceToGmpMinutes !== undefined ? this.timeVarianceInvoiceToGmpMinutes : null as any;
        data["actualHoursEtk"] = this.actualHoursEtk !== undefined ? this.actualHoursEtk : null as any;
        data["billedHoursInvoice"] = this.billedHoursInvoice !== undefined ? this.billedHoursInvoice : null as any;
        data["scheduledHoursGmp"] = this.scheduledHoursGmp !== undefined ? this.scheduledHoursGmp : null as any;
        data["timeVarianceGmpToEtkMinutes"] = this.timeVarianceGmpToEtkMinutes !== undefined ? this.timeVarianceGmpToEtkMinutes : null as any;
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item ? item.toJSON() : null as any);
        }
        data["workflow"] = this.workflow ? this.workflow.toJSON() : null as any;
        return data;
    }
}

export interface IInvoiceSiteSupplierSummaryResponse {
    supplierName?: string | null;
    invoiceNumber?: string | null;
    invoiceId?: number;
    invoiceStartDate?: Date | null;
    invoiceEndDate?: Date | null;
    projectedCostGmp?: number | null;
    projectedCostEtk?: number | null;
    etkCostStatus?: InvoiceEtkCostStatus;
    actualCostInvoice?: number;
    costVarianceInvoiceToGmpAmount?: number | null;
    costVarianceInvoiceToGmpPercentage?: number | null;
    timeVarianceInvoiceToGmpMinutes?: number | null;
    actualHoursEtk?: number | null;
    billedHoursInvoice?: number | null;
    scheduledHoursGmp?: number | null;
    timeVarianceGmpToEtkMinutes?: number | null;
    lineItems?: InvoiceLineItemResponse[] | null;
    workflow?: InvoiceWorkflowSummaryResponse;
}

export class InvoiceWorkflowState implements IInvoiceWorkflowState {
    workflowStateName?: string | null;
    workflowStateDisplayName?: string | null;
    isTerminal?: boolean;

    constructor(data?: IInvoiceWorkflowState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowStateName = _data["workflowStateName"] !== undefined ? _data["workflowStateName"] : null as any;
            this.workflowStateDisplayName = _data["workflowStateDisplayName"] !== undefined ? _data["workflowStateDisplayName"] : null as any;
            this.isTerminal = _data["isTerminal"] !== undefined ? _data["isTerminal"] : null as any;
        }
    }

    static fromJS(data: any): InvoiceWorkflowState {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceWorkflowState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowStateName"] = this.workflowStateName !== undefined ? this.workflowStateName : null as any;
        data["workflowStateDisplayName"] = this.workflowStateDisplayName !== undefined ? this.workflowStateDisplayName : null as any;
        data["isTerminal"] = this.isTerminal !== undefined ? this.isTerminal : null as any;
        return data;
    }
}

export interface IInvoiceWorkflowState {
    workflowStateName?: string | null;
    workflowStateDisplayName?: string | null;
    isTerminal?: boolean;
}

export class InvoiceWorkflowSummaryResponse implements IInvoiceWorkflowSummaryResponse {
    state?: InvoiceWorkflowState;
    latestAction?: InvoiceLatestActionResponse;
    actionCount?: number;

    constructor(data?: IInvoiceWorkflowSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.state = _data["state"] ? InvoiceWorkflowState.fromJS(_data["state"]) : null as any;
            this.latestAction = _data["latestAction"] ? InvoiceLatestActionResponse.fromJS(_data["latestAction"]) : null as any;
            this.actionCount = _data["actionCount"] !== undefined ? _data["actionCount"] : null as any;
        }
    }

    static fromJS(data: any): InvoiceWorkflowSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceWorkflowSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state ? this.state.toJSON() : null as any;
        data["latestAction"] = this.latestAction ? this.latestAction.toJSON() : null as any;
        data["actionCount"] = this.actionCount !== undefined ? this.actionCount : null as any;
        return data;
    }
}

export interface IInvoiceWorkflowSummaryResponse {
    state?: InvoiceWorkflowState;
    latestAction?: InvoiceLatestActionResponse;
    actionCount?: number;
}

export enum MobilePatrolRequestType {
    Single = "Single",
    Cluster = "Cluster",
    EntireCity = "EntireCity",
}

export class MonthlyShiftDetail implements IMonthlyShiftDetail {
    siteName?: string | null;
    siteAddress?: string | null;
    siteBUID?: string | null;
    billingType?: string | null;
    dayOfWeekLabel?: number | null;
    weeklyInterval?: number | null;
    dayOfMonth?: number | null;
    weekOfMonth?: number | null;
    startTime?: string;
    endTime?: string;

    constructor(data?: IMonthlyShiftDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null as any;
            this.siteAddress = _data["siteAddress"] !== undefined ? _data["siteAddress"] : null as any;
            this.siteBUID = _data["siteBUID"] !== undefined ? _data["siteBUID"] : null as any;
            this.billingType = _data["billingType"] !== undefined ? _data["billingType"] : null as any;
            this.dayOfWeekLabel = _data["dayOfWeekLabel"] !== undefined ? _data["dayOfWeekLabel"] : null as any;
            this.weeklyInterval = _data["weeklyInterval"] !== undefined ? _data["weeklyInterval"] : null as any;
            this.dayOfMonth = _data["dayOfMonth"] !== undefined ? _data["dayOfMonth"] : null as any;
            this.weekOfMonth = _data["weekOfMonth"] !== undefined ? _data["weekOfMonth"] : null as any;
            this.startTime = _data["startTime"] !== undefined ? _data["startTime"] : null as any;
            this.endTime = _data["endTime"] !== undefined ? _data["endTime"] : null as any;
        }
    }

    static fromJS(data: any): MonthlyShiftDetail {
        data = typeof data === 'object' ? data : {};
        let result = new MonthlyShiftDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteName"] = this.siteName !== undefined ? this.siteName : null as any;
        data["siteAddress"] = this.siteAddress !== undefined ? this.siteAddress : null as any;
        data["siteBUID"] = this.siteBUID !== undefined ? this.siteBUID : null as any;
        data["billingType"] = this.billingType !== undefined ? this.billingType : null as any;
        data["dayOfWeekLabel"] = this.dayOfWeekLabel !== undefined ? this.dayOfWeekLabel : null as any;
        data["weeklyInterval"] = this.weeklyInterval !== undefined ? this.weeklyInterval : null as any;
        data["dayOfMonth"] = this.dayOfMonth !== undefined ? this.dayOfMonth : null as any;
        data["weekOfMonth"] = this.weekOfMonth !== undefined ? this.weekOfMonth : null as any;
        data["startTime"] = this.startTime !== undefined ? this.startTime : null as any;
        data["endTime"] = this.endTime !== undefined ? this.endTime : null as any;
        return data;
    }
}

export interface IMonthlyShiftDetail {
    siteName?: string | null;
    siteAddress?: string | null;
    siteBUID?: string | null;
    billingType?: string | null;
    dayOfWeekLabel?: number | null;
    weeklyInterval?: number | null;
    dayOfMonth?: number | null;
    weekOfMonth?: number | null;
    startTime?: string;
    endTime?: string;
}

export class ObjectGroup implements IObjectGroup {
    objectID?: number;
    objectTypeID?: number;
    objectType?: ObjectType;
    objectType_?: string | null;
    objectSubtypeID?: number | null;
    objectSubtype?: ObjectType;
    objectSubtype_?: string | null;
    groupName?: string | null;
    accessTypeID?: number;
    accessType?: ObjectGroupAccessType;
    accessType_?: string | null;
    workflowStateID?: number | null;
    state?: State;
    workflowState?: string | null;
    notes?: string | null;
    ownerID?: number | null;
    id?: number;

    constructor(data?: IObjectGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.objectID = _data["objectID"] !== undefined ? _data["objectID"] : null as any;
            this.objectTypeID = _data["objectTypeID"] !== undefined ? _data["objectTypeID"] : null as any;
            this.objectType = _data["objectType"] ? ObjectType.fromJS(_data["objectType"]) : null as any;
            this.objectType_ = _data["objectType_"] !== undefined ? _data["objectType_"] : null as any;
            this.objectSubtypeID = _data["objectSubtypeID"] !== undefined ? _data["objectSubtypeID"] : null as any;
            this.objectSubtype = _data["objectSubtype"] ? ObjectType.fromJS(_data["objectSubtype"]) : null as any;
            this.objectSubtype_ = _data["objectSubtype_"] !== undefined ? _data["objectSubtype_"] : null as any;
            this.groupName = _data["groupName"] !== undefined ? _data["groupName"] : null as any;
            this.accessTypeID = _data["accessTypeID"] !== undefined ? _data["accessTypeID"] : null as any;
            this.accessType = _data["accessType"] ? ObjectGroupAccessType.fromJS(_data["accessType"]) : null as any;
            this.accessType_ = _data["accessType_"] !== undefined ? _data["accessType_"] : null as any;
            this.workflowStateID = _data["workflowStateID"] !== undefined ? _data["workflowStateID"] : null as any;
            this.state = _data["state"] ? State.fromJS(_data["state"]) : null as any;
            this.workflowState = _data["workflowState"] !== undefined ? _data["workflowState"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): ObjectGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["objectID"] = this.objectID !== undefined ? this.objectID : null as any;
        data["objectTypeID"] = this.objectTypeID !== undefined ? this.objectTypeID : null as any;
        data["objectType"] = this.objectType ? this.objectType.toJSON() : null as any;
        data["objectType_"] = this.objectType_ !== undefined ? this.objectType_ : null as any;
        data["objectSubtypeID"] = this.objectSubtypeID !== undefined ? this.objectSubtypeID : null as any;
        data["objectSubtype"] = this.objectSubtype ? this.objectSubtype.toJSON() : null as any;
        data["objectSubtype_"] = this.objectSubtype_ !== undefined ? this.objectSubtype_ : null as any;
        data["groupName"] = this.groupName !== undefined ? this.groupName : null as any;
        data["accessTypeID"] = this.accessTypeID !== undefined ? this.accessTypeID : null as any;
        data["accessType"] = this.accessType ? this.accessType.toJSON() : null as any;
        data["accessType_"] = this.accessType_ !== undefined ? this.accessType_ : null as any;
        data["workflowStateID"] = this.workflowStateID !== undefined ? this.workflowStateID : null as any;
        data["state"] = this.state ? this.state.toJSON() : null as any;
        data["workflowState"] = this.workflowState !== undefined ? this.workflowState : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IObjectGroup {
    objectID?: number;
    objectTypeID?: number;
    objectType?: ObjectType;
    objectType_?: string | null;
    objectSubtypeID?: number | null;
    objectSubtype?: ObjectType;
    objectSubtype_?: string | null;
    groupName?: string | null;
    accessTypeID?: number;
    accessType?: ObjectGroupAccessType;
    accessType_?: string | null;
    workflowStateID?: number | null;
    state?: State;
    workflowState?: string | null;
    notes?: string | null;
    ownerID?: number | null;
    id?: number;
}

export class ObjectGroupAccessType implements IObjectGroupAccessType {
    name!: string;
    notes?: string | null;
    id?: number;

    constructor(data?: IObjectGroupAccessType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): ObjectGroupAccessType {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectGroupAccessType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IObjectGroupAccessType {
    name: string;
    notes?: string | null;
    id?: number;
}

export class ObjectType implements IObjectType {
    name?: string | null;
    sourceTable?: string | null;
    id?: number;

    constructor(data?: IObjectType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.sourceTable = _data["sourceTable"] !== undefined ? _data["sourceTable"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): ObjectType {
        data = typeof data === 'object' ? data : {};
        let result = new ObjectType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["sourceTable"] = this.sourceTable !== undefined ? this.sourceTable : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IObjectType {
    name?: string | null;
    sourceTable?: string | null;
    id?: number;
}

export class OperatorType implements IOperatorType {
    id?: number;
    name!: string;
    notes?: string | null;

    constructor(data?: IOperatorType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
        }
    }

    static fromJS(data: any): OperatorType {
        data = typeof data === 'object' ? data : {};
        let result = new OperatorType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        return data;
    }
}

export interface IOperatorType {
    id?: number;
    name: string;
    notes?: string | null;
}

export class Owner implements IOwner {
    name!: string;
    externalID?: number | null;
    externalSourceTable?: string | null;
    externalConfigID?: number | null;
    designerRespondentID?: number | null;
    login?: string | null;
    passwordHash?: string | null;
    saltSupplement?: string | null;
    hideUniversal!: boolean;
    roleID!: number;
    role?: Role;
    notes?: string | null;
    email?: string | null;
    config?: Config;
    passwordResetToken?: string | null;
    externalSearchable!: boolean;
    externalVisible!: boolean;
    createdDate!: Date;
    modifiedDate!: Date;
    lockoutExpiry?: Date | null;
    resetRequired?: boolean;
    passwordResetTokenCreated?: Date | null;
    retentionPolicyID?: number | null;
    retentionPolicy?: RetentionPolicy;
    system?: string | null;
    emailFrom?: string | null;
    emailFromName?: string | null;
    maintenance!: boolean;
    maintenanceHtml?: string | null;
    limitWidgetsByRespondent!: boolean;
    designerID!: string;
    id?: number;

    constructor(data?: IOwner) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.externalID = _data["externalID"] !== undefined ? _data["externalID"] : null as any;
            this.externalSourceTable = _data["externalSourceTable"] !== undefined ? _data["externalSourceTable"] : null as any;
            this.externalConfigID = _data["externalConfigID"] !== undefined ? _data["externalConfigID"] : null as any;
            this.designerRespondentID = _data["designerRespondentID"] !== undefined ? _data["designerRespondentID"] : null as any;
            this.login = _data["login"] !== undefined ? _data["login"] : null as any;
            this.passwordHash = _data["passwordHash"] !== undefined ? _data["passwordHash"] : null as any;
            this.saltSupplement = _data["saltSupplement"] !== undefined ? _data["saltSupplement"] : null as any;
            this.hideUniversal = _data["hideUniversal"] !== undefined ? _data["hideUniversal"] : null as any;
            this.roleID = _data["roleID"] !== undefined ? _data["roleID"] : null as any;
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.config = _data["config"] ? Config.fromJS(_data["config"]) : null as any;
            this.passwordResetToken = _data["passwordResetToken"] !== undefined ? _data["passwordResetToken"] : null as any;
            this.externalSearchable = _data["externalSearchable"] !== undefined ? _data["externalSearchable"] : null as any;
            this.externalVisible = _data["externalVisible"] !== undefined ? _data["externalVisible"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : null as any;
            this.lockoutExpiry = _data["lockoutExpiry"] ? new Date(_data["lockoutExpiry"].toString()) : null as any;
            this.resetRequired = _data["resetRequired"] !== undefined ? _data["resetRequired"] : null as any;
            this.passwordResetTokenCreated = _data["passwordResetTokenCreated"] ? new Date(_data["passwordResetTokenCreated"].toString()) : null as any;
            this.retentionPolicyID = _data["retentionPolicyID"] !== undefined ? _data["retentionPolicyID"] : null as any;
            this.retentionPolicy = _data["retentionPolicy"] ? RetentionPolicy.fromJS(_data["retentionPolicy"]) : null as any;
            this.system = _data["system"] !== undefined ? _data["system"] : null as any;
            this.emailFrom = _data["emailFrom"] !== undefined ? _data["emailFrom"] : null as any;
            this.emailFromName = _data["emailFromName"] !== undefined ? _data["emailFromName"] : null as any;
            this.maintenance = _data["maintenance"] !== undefined ? _data["maintenance"] : null as any;
            this.maintenanceHtml = _data["maintenanceHtml"] !== undefined ? _data["maintenanceHtml"] : null as any;
            this.limitWidgetsByRespondent = _data["limitWidgetsByRespondent"] !== undefined ? _data["limitWidgetsByRespondent"] : null as any;
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): Owner {
        data = typeof data === 'object' ? data : {};
        let result = new Owner();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["externalID"] = this.externalID !== undefined ? this.externalID : null as any;
        data["externalSourceTable"] = this.externalSourceTable !== undefined ? this.externalSourceTable : null as any;
        data["externalConfigID"] = this.externalConfigID !== undefined ? this.externalConfigID : null as any;
        data["designerRespondentID"] = this.designerRespondentID !== undefined ? this.designerRespondentID : null as any;
        data["login"] = this.login !== undefined ? this.login : null as any;
        data["passwordHash"] = this.passwordHash !== undefined ? this.passwordHash : null as any;
        data["saltSupplement"] = this.saltSupplement !== undefined ? this.saltSupplement : null as any;
        data["hideUniversal"] = this.hideUniversal !== undefined ? this.hideUniversal : null as any;
        data["roleID"] = this.roleID !== undefined ? this.roleID : null as any;
        data["role"] = this.role ? this.role.toJSON() : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["config"] = this.config ? this.config.toJSON() : null as any;
        data["passwordResetToken"] = this.passwordResetToken !== undefined ? this.passwordResetToken : null as any;
        data["externalSearchable"] = this.externalSearchable !== undefined ? this.externalSearchable : null as any;
        data["externalVisible"] = this.externalVisible !== undefined ? this.externalVisible : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : null as any;
        data["lockoutExpiry"] = this.lockoutExpiry ? this.lockoutExpiry.toISOString() : null as any;
        data["resetRequired"] = this.resetRequired !== undefined ? this.resetRequired : null as any;
        data["passwordResetTokenCreated"] = this.passwordResetTokenCreated ? this.passwordResetTokenCreated.toISOString() : null as any;
        data["retentionPolicyID"] = this.retentionPolicyID !== undefined ? this.retentionPolicyID : null as any;
        data["retentionPolicy"] = this.retentionPolicy ? this.retentionPolicy.toJSON() : null as any;
        data["system"] = this.system !== undefined ? this.system : null as any;
        data["emailFrom"] = this.emailFrom !== undefined ? this.emailFrom : null as any;
        data["emailFromName"] = this.emailFromName !== undefined ? this.emailFromName : null as any;
        data["maintenance"] = this.maintenance !== undefined ? this.maintenance : null as any;
        data["maintenanceHtml"] = this.maintenanceHtml !== undefined ? this.maintenanceHtml : null as any;
        data["limitWidgetsByRespondent"] = this.limitWidgetsByRespondent !== undefined ? this.limitWidgetsByRespondent : null as any;
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IOwner {
    name: string;
    externalID?: number | null;
    externalSourceTable?: string | null;
    externalConfigID?: number | null;
    designerRespondentID?: number | null;
    login?: string | null;
    passwordHash?: string | null;
    saltSupplement?: string | null;
    hideUniversal: boolean;
    roleID: number;
    role?: Role;
    notes?: string | null;
    email?: string | null;
    config?: Config;
    passwordResetToken?: string | null;
    externalSearchable: boolean;
    externalVisible: boolean;
    createdDate: Date;
    modifiedDate: Date;
    lockoutExpiry?: Date | null;
    resetRequired?: boolean;
    passwordResetTokenCreated?: Date | null;
    retentionPolicyID?: number | null;
    retentionPolicy?: RetentionPolicy;
    system?: string | null;
    emailFrom?: string | null;
    emailFromName?: string | null;
    maintenance: boolean;
    maintenanceHtml?: string | null;
    limitWidgetsByRespondent: boolean;
    designerID: string;
    id?: number;
}

export enum PatrolType {
    Armed = "Armed",
    Unarmed = "Unarmed",
}

export class PerformActionRequest implements IPerformActionRequest {
    userId?: number;
    accountId?: number;
    actionId?: number;
    siteIds?: number[] | null;
    answers?: ActionQuestionAnswer[] | null;

    constructor(data?: IPerformActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.actionId = _data["actionId"] !== undefined ? _data["actionId"] : null as any;
            if (Array.isArray(_data["siteIds"])) {
                this.siteIds = [] as any;
                for (let item of _data["siteIds"])
                    this.siteIds!.push(item);
            }
            else {
                this.siteIds = null as any;
            }
            if (Array.isArray(_data["answers"])) {
                this.answers = [] as any;
                for (let item of _data["answers"])
                    this.answers!.push(ActionQuestionAnswer.fromJS(item));
            }
            else {
                this.answers = null as any;
            }
        }
    }

    static fromJS(data: any): PerformActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PerformActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["actionId"] = this.actionId !== undefined ? this.actionId : null as any;
        if (Array.isArray(this.siteIds)) {
            data["siteIds"] = [];
            for (let item of this.siteIds)
                data["siteIds"].push(item);
        }
        if (Array.isArray(this.answers)) {
            data["answers"] = [];
            for (let item of this.answers)
                data["answers"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPerformActionRequest {
    userId?: number;
    accountId?: number;
    actionId?: number;
    siteIds?: number[] | null;
    answers?: ActionQuestionAnswer[] | null;
}

export class PermitVetting implements IPermitVetting {
    caseNumber?: string | null;
    screeningType?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    dateReceived?: Date;
    datePrinted?: Date;
    fpStatus?: string | null;
    statusDate?: Date;
    subjectEmailAddress?: string | null;
    agencyName?: string | null;
    branchAssignment?: string | null;

    constructor(data?: IPermitVetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.caseNumber = _data["caseNumber"] !== undefined ? _data["caseNumber"] : null as any;
            this.screeningType = _data["screeningType"] !== undefined ? _data["screeningType"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.dateReceived = _data["dateReceived"] ? new Date(_data["dateReceived"].toString()) : null as any;
            this.datePrinted = _data["datePrinted"] ? new Date(_data["datePrinted"].toString()) : null as any;
            this.fpStatus = _data["fpStatus"] !== undefined ? _data["fpStatus"] : null as any;
            this.statusDate = _data["statusDate"] ? new Date(_data["statusDate"].toString()) : null as any;
            this.subjectEmailAddress = _data["subjectEmailAddress"] !== undefined ? _data["subjectEmailAddress"] : null as any;
            this.agencyName = _data["agencyName"] !== undefined ? _data["agencyName"] : null as any;
            this.branchAssignment = _data["branchAssignment"] !== undefined ? _data["branchAssignment"] : null as any;
        }
    }

    static fromJS(data: any): PermitVetting {
        data = typeof data === 'object' ? data : {};
        let result = new PermitVetting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["caseNumber"] = this.caseNumber !== undefined ? this.caseNumber : null as any;
        data["screeningType"] = this.screeningType !== undefined ? this.screeningType : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["dateReceived"] = this.dateReceived ? formatDate(this.dateReceived) : null as any;
        data["datePrinted"] = this.datePrinted ? formatDate(this.datePrinted) : null as any;
        data["fpStatus"] = this.fpStatus !== undefined ? this.fpStatus : null as any;
        data["statusDate"] = this.statusDate ? formatDate(this.statusDate) : null as any;
        data["subjectEmailAddress"] = this.subjectEmailAddress !== undefined ? this.subjectEmailAddress : null as any;
        data["agencyName"] = this.agencyName !== undefined ? this.agencyName : null as any;
        data["branchAssignment"] = this.branchAssignment !== undefined ? this.branchAssignment : null as any;
        return data;
    }
}

export interface IPermitVetting {
    caseNumber?: string | null;
    screeningType?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    dateReceived?: Date;
    datePrinted?: Date;
    fpStatus?: string | null;
    statusDate?: Date;
    subjectEmailAddress?: string | null;
    agencyName?: string | null;
    branchAssignment?: string | null;
}

export class PostToExternalRequest implements IPostToExternalRequest {
    engineID?: number | null;
    instanceID?: number | null;
    siteID?: number | null;
    currentPage?: string | null;
    siteIDs?: number[] | null;
    sessionID?: number | null;
    respondentExternalID?: number | null;
    reportID?: number | null;
    reportName?: string | null;
    dashboardID?: number | null;

    constructor(data?: IPostToExternalRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.engineID = _data["engineID"] !== undefined ? _data["engineID"] : null as any;
            this.instanceID = _data["instanceID"] !== undefined ? _data["instanceID"] : null as any;
            this.siteID = _data["siteID"] !== undefined ? _data["siteID"] : null as any;
            this.currentPage = _data["currentPage"] !== undefined ? _data["currentPage"] : null as any;
            if (Array.isArray(_data["siteIDs"])) {
                this.siteIDs = [] as any;
                for (let item of _data["siteIDs"])
                    this.siteIDs!.push(item);
            }
            else {
                this.siteIDs = null as any;
            }
            this.sessionID = _data["sessionID"] !== undefined ? _data["sessionID"] : null as any;
            this.respondentExternalID = _data["respondentExternalID"] !== undefined ? _data["respondentExternalID"] : null as any;
            this.reportID = _data["reportID"] !== undefined ? _data["reportID"] : null as any;
            this.reportName = _data["reportName"] !== undefined ? _data["reportName"] : null as any;
            this.dashboardID = _data["dashboardID"] !== undefined ? _data["dashboardID"] : null as any;
        }
    }

    static fromJS(data: any): PostToExternalRequest {
        data = typeof data === 'object' ? data : {};
        let result = new PostToExternalRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["engineID"] = this.engineID !== undefined ? this.engineID : null as any;
        data["instanceID"] = this.instanceID !== undefined ? this.instanceID : null as any;
        data["siteID"] = this.siteID !== undefined ? this.siteID : null as any;
        data["currentPage"] = this.currentPage !== undefined ? this.currentPage : null as any;
        if (Array.isArray(this.siteIDs)) {
            data["siteIDs"] = [];
            for (let item of this.siteIDs)
                data["siteIDs"].push(item);
        }
        data["sessionID"] = this.sessionID !== undefined ? this.sessionID : null as any;
        data["respondentExternalID"] = this.respondentExternalID !== undefined ? this.respondentExternalID : null as any;
        data["reportID"] = this.reportID !== undefined ? this.reportID : null as any;
        data["reportName"] = this.reportName !== undefined ? this.reportName : null as any;
        data["dashboardID"] = this.dashboardID !== undefined ? this.dashboardID : null as any;
        return data;
    }
}

export interface IPostToExternalRequest {
    engineID?: number | null;
    instanceID?: number | null;
    siteID?: number | null;
    currentPage?: string | null;
    siteIDs?: number[] | null;
    sessionID?: number | null;
    respondentExternalID?: number | null;
    reportID?: number | null;
    reportName?: string | null;
    dashboardID?: number | null;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : null as any;
            this.instance = _data["instance"] !== undefined ? _data["instance"] : null as any;
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["detail"] = this.detail !== undefined ? this.detail : null as any;
        data["instance"] = this.instance !== undefined ? this.instance : null as any;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;

    [key: string]: any;
}

export class Process implements IProcess {
    ownerID?: number;
    owner?: Owner;
    name!: string;
    description?: string | null;
    createdDate!: Date;
    modifiedDate!: Date;
    nodes?: FlowchartNode;
    links?: FlowchartLink;
    designerID!: string;
    ownerDesignerID!: string;
    stateProcessDesigners?: State[] | null;
    stateProcesses?: State[] | null;
    id?: number;

    constructor(data?: IProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : null as any;
            this.nodes = _data["nodes"] ? FlowchartNode.fromJS(_data["nodes"]) : null as any;
            this.links = _data["links"] ? FlowchartLink.fromJS(_data["links"]) : null as any;
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.ownerDesignerID = _data["ownerDesignerID"] !== undefined ? _data["ownerDesignerID"] : null as any;
            if (Array.isArray(_data["stateProcessDesigners"])) {
                this.stateProcessDesigners = [] as any;
                for (let item of _data["stateProcessDesigners"])
                    this.stateProcessDesigners!.push(State.fromJS(item));
            }
            else {
                this.stateProcessDesigners = null as any;
            }
            if (Array.isArray(_data["stateProcesses"])) {
                this.stateProcesses = [] as any;
                for (let item of _data["stateProcesses"])
                    this.stateProcesses!.push(State.fromJS(item));
            }
            else {
                this.stateProcesses = null as any;
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): Process {
        data = typeof data === 'object' ? data : {};
        let result = new Process();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["owner"] = this.owner ? this.owner.toJSON() : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : null as any;
        data["nodes"] = this.nodes ? this.nodes.toJSON() : null as any;
        data["links"] = this.links ? this.links.toJSON() : null as any;
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["ownerDesignerID"] = this.ownerDesignerID !== undefined ? this.ownerDesignerID : null as any;
        if (Array.isArray(this.stateProcessDesigners)) {
            data["stateProcessDesigners"] = [];
            for (let item of this.stateProcessDesigners)
                data["stateProcessDesigners"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.stateProcesses)) {
            data["stateProcesses"] = [];
            for (let item of this.stateProcesses)
                data["stateProcesses"].push(item ? item.toJSON() : null as any);
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IProcess {
    ownerID?: number;
    owner?: Owner;
    name: string;
    description?: string | null;
    createdDate: Date;
    modifiedDate: Date;
    nodes?: FlowchartNode;
    links?: FlowchartLink;
    designerID: string;
    ownerDesignerID: string;
    stateProcessDesigners?: State[] | null;
    stateProcesses?: State[] | null;
    id?: number;
}

export class QuestionNumberType implements IQuestionNumberType {
    code?: string | null;
    name?: string | null;
    description?: string | null;
    index?: number;
    id?: number;

    constructor(data?: IQuestionNumberType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.index = _data["index"] !== undefined ? _data["index"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): QuestionNumberType {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionNumberType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["index"] = this.index !== undefined ? this.index : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IQuestionNumberType {
    code?: string | null;
    name?: string | null;
    description?: string | null;
    index?: number;
    id?: number;
}

export class RateCardV2UpsertResult implements IRateCardV2UpsertResult {
    processedRowCount?: number;
    insertedCount?: number;
    updatedCount?: number;
    duplicateRowCount?: number;
    reviewOnly?: boolean;
    warnings?: string[] | null;

    constructor(data?: IRateCardV2UpsertResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processedRowCount = _data["processedRowCount"] !== undefined ? _data["processedRowCount"] : null as any;
            this.insertedCount = _data["insertedCount"] !== undefined ? _data["insertedCount"] : null as any;
            this.updatedCount = _data["updatedCount"] !== undefined ? _data["updatedCount"] : null as any;
            this.duplicateRowCount = _data["duplicateRowCount"] !== undefined ? _data["duplicateRowCount"] : null as any;
            this.reviewOnly = _data["reviewOnly"] !== undefined ? _data["reviewOnly"] : null as any;
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(item);
            }
            else {
                this.warnings = null as any;
            }
        }
    }

    static fromJS(data: any): RateCardV2UpsertResult {
        data = typeof data === 'object' ? data : {};
        let result = new RateCardV2UpsertResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processedRowCount"] = this.processedRowCount !== undefined ? this.processedRowCount : null as any;
        data["insertedCount"] = this.insertedCount !== undefined ? this.insertedCount : null as any;
        data["updatedCount"] = this.updatedCount !== undefined ? this.updatedCount : null as any;
        data["duplicateRowCount"] = this.duplicateRowCount !== undefined ? this.duplicateRowCount : null as any;
        data["reviewOnly"] = this.reviewOnly !== undefined ? this.reviewOnly : null as any;
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item);
        }
        return data;
    }
}

export interface IRateCardV2UpsertResult {
    processedRowCount?: number;
    insertedCount?: number;
    updatedCount?: number;
    duplicateRowCount?: number;
    reviewOnly?: boolean;
    warnings?: string[] | null;
}

export class Regex implements IRegex {
    ownerID?: number;
    owner?: Owner;
    name!: string;
    description?: string | null;
    pattern!: string;
    failMessage?: string | null;
    designerID!: string;
    ownerDesignerID!: string;
    id?: number;

    constructor(data?: IRegex) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.pattern = _data["pattern"] !== undefined ? _data["pattern"] : null as any;
            this.failMessage = _data["failMessage"] !== undefined ? _data["failMessage"] : null as any;
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.ownerDesignerID = _data["ownerDesignerID"] !== undefined ? _data["ownerDesignerID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): Regex {
        data = typeof data === 'object' ? data : {};
        let result = new Regex();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["owner"] = this.owner ? this.owner.toJSON() : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["pattern"] = this.pattern !== undefined ? this.pattern : null as any;
        data["failMessage"] = this.failMessage !== undefined ? this.failMessage : null as any;
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["ownerDesignerID"] = this.ownerDesignerID !== undefined ? this.ownerDesignerID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IRegex {
    ownerID?: number;
    owner?: Owner;
    name: string;
    description?: string | null;
    pattern: string;
    failMessage?: string | null;
    designerID: string;
    ownerDesignerID: string;
    id?: number;
}

export class RenderType implements IRenderType {
    designerID!: string;
    renderAs!: string;
    forDatatype!: string;
    notes?: string | null;
    id?: number;

    constructor(data?: IRenderType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.renderAs = _data["renderAs"] !== undefined ? _data["renderAs"] : null as any;
            this.forDatatype = _data["forDatatype"] !== undefined ? _data["forDatatype"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): RenderType {
        data = typeof data === 'object' ? data : {};
        let result = new RenderType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["renderAs"] = this.renderAs !== undefined ? this.renderAs : null as any;
        data["forDatatype"] = this.forDatatype !== undefined ? this.forDatatype : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IRenderType {
    designerID: string;
    renderAs: string;
    forDatatype: string;
    notes?: string | null;
    id?: number;
}

export class Report implements IReport {
    reportTypeID?: number;
    reportType?: ReportType;
    ownerID?: number;
    owner?: Owner;
    externalID?: number | null;
    name!: string;
    sql!: string;
    drillDownSQL?: string | null;
    downloadSQL?: string | null;
    postToExternalSQL?: string | null;
    postToExternal!: boolean;
    description?: string | null;
    notes?: string | null;
    active!: boolean;
    drillDownActive!: boolean;
    externalVisible!: boolean;
    externalSearchable!: boolean;
    templateID?: number | null;
    menuReport?: boolean;
    rerenderPeriod?: number;
    template?: Template;
    scriptOwnerVar?: string | null;
    script?: string | null;
    configOptions?: ConfigOption[] | null;
    isBundle?: boolean;
    fromBundle?: boolean;
    bundleReports?: Report[] | null;
    prefetchTargetIDs?: string | null;
    readonly prefetchTargetIDList?: number[] | null;
    universal!: boolean;
    downloadOnly!: boolean;
    libraryItem!: boolean;
    designerID!: string;
    templateDesignerID?: string | null;
    ownerDesignerID!: string;
    reportTypeDesignerID!: string;
    reportMacros?: ReportMacro[] | null;
    id?: number;

    constructor(data?: IReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportTypeID = _data["reportTypeID"] !== undefined ? _data["reportTypeID"] : null as any;
            this.reportType = _data["reportType"] ? ReportType.fromJS(_data["reportType"]) : null as any;
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : null as any;
            this.externalID = _data["externalID"] !== undefined ? _data["externalID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.sql = _data["sql"] !== undefined ? _data["sql"] : null as any;
            this.drillDownSQL = _data["drillDownSQL"] !== undefined ? _data["drillDownSQL"] : null as any;
            this.downloadSQL = _data["downloadSQL"] !== undefined ? _data["downloadSQL"] : null as any;
            this.postToExternalSQL = _data["postToExternalSQL"] !== undefined ? _data["postToExternalSQL"] : null as any;
            this.postToExternal = _data["postToExternal"] !== undefined ? _data["postToExternal"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.drillDownActive = _data["drillDownActive"] !== undefined ? _data["drillDownActive"] : null as any;
            this.externalVisible = _data["externalVisible"] !== undefined ? _data["externalVisible"] : null as any;
            this.externalSearchable = _data["externalSearchable"] !== undefined ? _data["externalSearchable"] : null as any;
            this.templateID = _data["templateID"] !== undefined ? _data["templateID"] : null as any;
            this.menuReport = _data["menuReport"] !== undefined ? _data["menuReport"] : null as any;
            this.rerenderPeriod = _data["rerenderPeriod"] !== undefined ? _data["rerenderPeriod"] : null as any;
            this.template = _data["template"] ? Template.fromJS(_data["template"]) : null as any;
            this.scriptOwnerVar = _data["scriptOwnerVar"] !== undefined ? _data["scriptOwnerVar"] : null as any;
            this.script = _data["script"] !== undefined ? _data["script"] : null as any;
            if (Array.isArray(_data["configOptions"])) {
                this.configOptions = [] as any;
                for (let item of _data["configOptions"])
                    this.configOptions!.push(ConfigOption.fromJS(item));
            }
            else {
                this.configOptions = null as any;
            }
            this.isBundle = _data["isBundle"] !== undefined ? _data["isBundle"] : null as any;
            this.fromBundle = _data["fromBundle"] !== undefined ? _data["fromBundle"] : null as any;
            if (Array.isArray(_data["bundleReports"])) {
                this.bundleReports = [] as any;
                for (let item of _data["bundleReports"])
                    this.bundleReports!.push(Report.fromJS(item));
            }
            else {
                this.bundleReports = null as any;
            }
            this.prefetchTargetIDs = _data["prefetchTargetIDs"] !== undefined ? _data["prefetchTargetIDs"] : null as any;
            if (Array.isArray(_data["prefetchTargetIDList"])) {
                (this as any).prefetchTargetIDList = [] as any;
                for (let item of _data["prefetchTargetIDList"])
                    (this as any).prefetchTargetIDList!.push(item);
            }
            else {
                (this as any).prefetchTargetIDList = null as any;
            }
            this.universal = _data["universal"] !== undefined ? _data["universal"] : null as any;
            this.downloadOnly = _data["downloadOnly"] !== undefined ? _data["downloadOnly"] : null as any;
            this.libraryItem = _data["libraryItem"] !== undefined ? _data["libraryItem"] : null as any;
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.templateDesignerID = _data["templateDesignerID"] !== undefined ? _data["templateDesignerID"] : null as any;
            this.ownerDesignerID = _data["ownerDesignerID"] !== undefined ? _data["ownerDesignerID"] : null as any;
            this.reportTypeDesignerID = _data["reportTypeDesignerID"] !== undefined ? _data["reportTypeDesignerID"] : null as any;
            if (Array.isArray(_data["reportMacros"])) {
                this.reportMacros = [] as any;
                for (let item of _data["reportMacros"])
                    this.reportMacros!.push(ReportMacro.fromJS(item));
            }
            else {
                this.reportMacros = null as any;
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): Report {
        data = typeof data === 'object' ? data : {};
        let result = new Report();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportTypeID"] = this.reportTypeID !== undefined ? this.reportTypeID : null as any;
        data["reportType"] = this.reportType ? this.reportType.toJSON() : null as any;
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["owner"] = this.owner ? this.owner.toJSON() : null as any;
        data["externalID"] = this.externalID !== undefined ? this.externalID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["sql"] = this.sql !== undefined ? this.sql : null as any;
        data["drillDownSQL"] = this.drillDownSQL !== undefined ? this.drillDownSQL : null as any;
        data["downloadSQL"] = this.downloadSQL !== undefined ? this.downloadSQL : null as any;
        data["postToExternalSQL"] = this.postToExternalSQL !== undefined ? this.postToExternalSQL : null as any;
        data["postToExternal"] = this.postToExternal !== undefined ? this.postToExternal : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["drillDownActive"] = this.drillDownActive !== undefined ? this.drillDownActive : null as any;
        data["externalVisible"] = this.externalVisible !== undefined ? this.externalVisible : null as any;
        data["externalSearchable"] = this.externalSearchable !== undefined ? this.externalSearchable : null as any;
        data["templateID"] = this.templateID !== undefined ? this.templateID : null as any;
        data["menuReport"] = this.menuReport !== undefined ? this.menuReport : null as any;
        data["rerenderPeriod"] = this.rerenderPeriod !== undefined ? this.rerenderPeriod : null as any;
        data["template"] = this.template ? this.template.toJSON() : null as any;
        data["scriptOwnerVar"] = this.scriptOwnerVar !== undefined ? this.scriptOwnerVar : null as any;
        data["script"] = this.script !== undefined ? this.script : null as any;
        if (Array.isArray(this.configOptions)) {
            data["configOptions"] = [];
            for (let item of this.configOptions)
                data["configOptions"].push(item ? item.toJSON() : null as any);
        }
        data["isBundle"] = this.isBundle !== undefined ? this.isBundle : null as any;
        data["fromBundle"] = this.fromBundle !== undefined ? this.fromBundle : null as any;
        if (Array.isArray(this.bundleReports)) {
            data["bundleReports"] = [];
            for (let item of this.bundleReports)
                data["bundleReports"].push(item ? item.toJSON() : null as any);
        }
        data["prefetchTargetIDs"] = this.prefetchTargetIDs !== undefined ? this.prefetchTargetIDs : null as any;
        if (Array.isArray(this.prefetchTargetIDList)) {
            data["prefetchTargetIDList"] = [];
            for (let item of this.prefetchTargetIDList)
                data["prefetchTargetIDList"].push(item);
        }
        data["universal"] = this.universal !== undefined ? this.universal : null as any;
        data["downloadOnly"] = this.downloadOnly !== undefined ? this.downloadOnly : null as any;
        data["libraryItem"] = this.libraryItem !== undefined ? this.libraryItem : null as any;
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["templateDesignerID"] = this.templateDesignerID !== undefined ? this.templateDesignerID : null as any;
        data["ownerDesignerID"] = this.ownerDesignerID !== undefined ? this.ownerDesignerID : null as any;
        data["reportTypeDesignerID"] = this.reportTypeDesignerID !== undefined ? this.reportTypeDesignerID : null as any;
        if (Array.isArray(this.reportMacros)) {
            data["reportMacros"] = [];
            for (let item of this.reportMacros)
                data["reportMacros"].push(item ? item.toJSON() : null as any);
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IReport {
    reportTypeID?: number;
    reportType?: ReportType;
    ownerID?: number;
    owner?: Owner;
    externalID?: number | null;
    name: string;
    sql: string;
    drillDownSQL?: string | null;
    downloadSQL?: string | null;
    postToExternalSQL?: string | null;
    postToExternal: boolean;
    description?: string | null;
    notes?: string | null;
    active: boolean;
    drillDownActive: boolean;
    externalVisible: boolean;
    externalSearchable: boolean;
    templateID?: number | null;
    menuReport?: boolean;
    rerenderPeriod?: number;
    template?: Template;
    scriptOwnerVar?: string | null;
    script?: string | null;
    configOptions?: ConfigOption[] | null;
    isBundle?: boolean;
    fromBundle?: boolean;
    bundleReports?: Report[] | null;
    prefetchTargetIDs?: string | null;
    prefetchTargetIDList?: number[] | null;
    universal: boolean;
    downloadOnly: boolean;
    libraryItem: boolean;
    designerID: string;
    templateDesignerID?: string | null;
    ownerDesignerID: string;
    reportTypeDesignerID: string;
    reportMacros?: ReportMacro[] | null;
    id?: number;
}

export class ReportConfigOption implements IReportConfigOption {
    id?: number;
    name!: string;
    datatypeID!: number;
    datatype?: Datatype;
    default?: string | null;
    description?: string | null;
    seq?: number;
    notes?: string | null;
    value?: string | null;

    constructor(data?: IReportConfigOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.datatypeID = _data["datatypeID"] !== undefined ? _data["datatypeID"] : null as any;
            this.datatype = _data["datatype"] ? Datatype.fromJS(_data["datatype"]) : null as any;
            this.default = _data["default"] !== undefined ? _data["default"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.seq = _data["seq"] !== undefined ? _data["seq"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static fromJS(data: any): ReportConfigOption {
        data = typeof data === 'object' ? data : {};
        let result = new ReportConfigOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["datatypeID"] = this.datatypeID !== undefined ? this.datatypeID : null as any;
        data["datatype"] = this.datatype ? this.datatype.toJSON() : null as any;
        data["default"] = this.default !== undefined ? this.default : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["seq"] = this.seq !== undefined ? this.seq : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }
}

export interface IReportConfigOption {
    id?: number;
    name: string;
    datatypeID: number;
    datatype?: Datatype;
    default?: string | null;
    description?: string | null;
    seq?: number;
    notes?: string | null;
    value?: string | null;
}

export class ReportData implements IReportData {
    name?: string | null;
    chartTypeCode?: string | null;
    dataChunks?: DataChunk[] | null;
    configOptionDefaults?: ConfigOptionDefault[] | null;

    constructor(data?: IReportData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.chartTypeCode = _data["chartTypeCode"] !== undefined ? _data["chartTypeCode"] : null as any;
            if (Array.isArray(_data["dataChunks"])) {
                this.dataChunks = [] as any;
                for (let item of _data["dataChunks"])
                    this.dataChunks!.push(DataChunk.fromJS(item));
            }
            else {
                this.dataChunks = null as any;
            }
            if (Array.isArray(_data["configOptionDefaults"])) {
                this.configOptionDefaults = [] as any;
                for (let item of _data["configOptionDefaults"])
                    this.configOptionDefaults!.push(ConfigOptionDefault.fromJS(item));
            }
            else {
                this.configOptionDefaults = null as any;
            }
        }
    }

    static fromJS(data: any): ReportData {
        data = typeof data === 'object' ? data : {};
        let result = new ReportData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["chartTypeCode"] = this.chartTypeCode !== undefined ? this.chartTypeCode : null as any;
        if (Array.isArray(this.dataChunks)) {
            data["dataChunks"] = [];
            for (let item of this.dataChunks)
                data["dataChunks"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.configOptionDefaults)) {
            data["configOptionDefaults"] = [];
            for (let item of this.configOptionDefaults)
                data["configOptionDefaults"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IReportData {
    name?: string | null;
    chartTypeCode?: string | null;
    dataChunks?: DataChunk[] | null;
    configOptionDefaults?: ConfigOptionDefault[] | null;
}

export class ReportMacro implements IReportMacro {
    designerID!: string;
    reportDesignerID?: string | null;
    label?: string | null;
    datapointDesignerID!: string;
    datapointID?: number | null;
    seq!: number;
    datapoint?: Datapoint;
    code!: string;
    ownerDesignerID!: string;
    ownerID?: number | null;
    owner?: Owner;
    value?: string | null;
    id?: number;

    constructor(data?: IReportMacro) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.reportDesignerID = _data["reportDesignerID"] !== undefined ? _data["reportDesignerID"] : null as any;
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.datapointDesignerID = _data["datapointDesignerID"] !== undefined ? _data["datapointDesignerID"] : null as any;
            this.datapointID = _data["datapointID"] !== undefined ? _data["datapointID"] : null as any;
            this.seq = _data["seq"] !== undefined ? _data["seq"] : null as any;
            this.datapoint = _data["datapoint"] ? Datapoint.fromJS(_data["datapoint"]) : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.ownerDesignerID = _data["ownerDesignerID"] !== undefined ? _data["ownerDesignerID"] : null as any;
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): ReportMacro {
        data = typeof data === 'object' ? data : {};
        let result = new ReportMacro();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["reportDesignerID"] = this.reportDesignerID !== undefined ? this.reportDesignerID : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["datapointDesignerID"] = this.datapointDesignerID !== undefined ? this.datapointDesignerID : null as any;
        data["datapointID"] = this.datapointID !== undefined ? this.datapointID : null as any;
        data["seq"] = this.seq !== undefined ? this.seq : null as any;
        data["datapoint"] = this.datapoint ? this.datapoint.toJSON() : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["ownerDesignerID"] = this.ownerDesignerID !== undefined ? this.ownerDesignerID : null as any;
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["owner"] = this.owner ? this.owner.toJSON() : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IReportMacro {
    designerID: string;
    reportDesignerID?: string | null;
    label?: string | null;
    datapointDesignerID: string;
    datapointID?: number | null;
    seq: number;
    datapoint?: Datapoint;
    code: string;
    ownerDesignerID: string;
    ownerID?: number | null;
    owner?: Owner;
    value?: string | null;
    id?: number;
}

export class ReportRequest implements IReportRequest {
    reportName?: string | null;
    parms?: { [key: string]: any; } | null;

    constructor(data?: IReportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportName = _data["reportName"] !== undefined ? _data["reportName"] : null as any;
            if (_data["parms"]) {
                this.parms = {} as any;
                for (let key in _data["parms"]) {
                    if (_data["parms"].hasOwnProperty(key))
                        (this.parms as any)![key] = _data["parms"][key] !== undefined ? _data["parms"][key] : null as any;
                }
            }
            else {
                this.parms = null as any;
            }
        }
    }

    static fromJS(data: any): ReportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportName"] = this.reportName !== undefined ? this.reportName : null as any;
        if (this.parms) {
            data["parms"] = {};
            for (let key in this.parms) {
                if (this.parms.hasOwnProperty(key))
                    (data["parms"] as any)[key] = this.parms[key] !== undefined ? this.parms[key] : null as any;
            }
        }
        return data;
    }
}

export interface IReportRequest {
    reportName?: string | null;
    parms?: { [key: string]: any; } | null;
}

export class ReportTokenRequest implements IReportTokenRequest {
    name?: string | null;
    sessionKey?: string | null;
    reportDatas?: ReportData[] | null;

    constructor(data?: IReportTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.sessionKey = _data["sessionKey"] !== undefined ? _data["sessionKey"] : null as any;
            if (Array.isArray(_data["reportDatas"])) {
                this.reportDatas = [] as any;
                for (let item of _data["reportDatas"])
                    this.reportDatas!.push(ReportData.fromJS(item));
            }
            else {
                this.reportDatas = null as any;
            }
        }
    }

    static fromJS(data: any): ReportTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["sessionKey"] = this.sessionKey !== undefined ? this.sessionKey : null as any;
        if (Array.isArray(this.reportDatas)) {
            data["reportDatas"] = [];
            for (let item of this.reportDatas)
                data["reportDatas"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IReportTokenRequest {
    name?: string | null;
    sessionKey?: string | null;
    reportDatas?: ReportData[] | null;
}

export class ReportType implements IReportType {
    code!: string;
    name!: string;
    description?: string | null;
    reportTypeConfigOptions?: ReportTypeConfigOption[] | null;
    datapointTargetVisible?: boolean;
    visibleName?: string | null;
    designerID!: string;
    id?: number;

    constructor(data?: IReportType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            if (Array.isArray(_data["reportTypeConfigOptions"])) {
                this.reportTypeConfigOptions = [] as any;
                for (let item of _data["reportTypeConfigOptions"])
                    this.reportTypeConfigOptions!.push(ReportTypeConfigOption.fromJS(item));
            }
            else {
                this.reportTypeConfigOptions = null as any;
            }
            this.datapointTargetVisible = _data["datapointTargetVisible"] !== undefined ? _data["datapointTargetVisible"] : null as any;
            this.visibleName = _data["visibleName"] !== undefined ? _data["visibleName"] : null as any;
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): ReportType {
        data = typeof data === 'object' ? data : {};
        let result = new ReportType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        if (Array.isArray(this.reportTypeConfigOptions)) {
            data["reportTypeConfigOptions"] = [];
            for (let item of this.reportTypeConfigOptions)
                data["reportTypeConfigOptions"].push(item ? item.toJSON() : null as any);
        }
        data["datapointTargetVisible"] = this.datapointTargetVisible !== undefined ? this.datapointTargetVisible : null as any;
        data["visibleName"] = this.visibleName !== undefined ? this.visibleName : null as any;
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IReportType {
    code: string;
    name: string;
    description?: string | null;
    reportTypeConfigOptions?: ReportTypeConfigOption[] | null;
    datapointTargetVisible?: boolean;
    visibleName?: string | null;
    designerID: string;
    id?: number;
}

export class ReportTypeConfigOption implements IReportTypeConfigOption {
    id?: number;
    reportTypeID!: number;
    reportType?: ReportType;
    reportConfigOptionID!: number;
    reportConfigOption?: ReportConfigOption;
    notes?: string | null;

    constructor(data?: IReportTypeConfigOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.reportTypeID = _data["reportTypeID"] !== undefined ? _data["reportTypeID"] : null as any;
            this.reportType = _data["reportType"] ? ReportType.fromJS(_data["reportType"]) : null as any;
            this.reportConfigOptionID = _data["reportConfigOptionID"] !== undefined ? _data["reportConfigOptionID"] : null as any;
            this.reportConfigOption = _data["reportConfigOption"] ? ReportConfigOption.fromJS(_data["reportConfigOption"]) : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
        }
    }

    static fromJS(data: any): ReportTypeConfigOption {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTypeConfigOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["reportTypeID"] = this.reportTypeID !== undefined ? this.reportTypeID : null as any;
        data["reportType"] = this.reportType ? this.reportType.toJSON() : null as any;
        data["reportConfigOptionID"] = this.reportConfigOptionID !== undefined ? this.reportConfigOptionID : null as any;
        data["reportConfigOption"] = this.reportConfigOption ? this.reportConfigOption.toJSON() : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        return data;
    }
}

export interface IReportTypeConfigOption {
    id?: number;
    reportTypeID: number;
    reportType?: ReportType;
    reportConfigOptionID: number;
    reportConfigOption?: ReportConfigOption;
    notes?: string | null;
}

export class Request implements IRequest {
    ownerID?: number;
    processID?: number;
    respondentID?: number;
    datasetID?: number;
    iteration?: number;
    name?: string | null;
    createdDate!: Date;
    modifiedDate!: Date;
    stateID?: number | null;
    state?: State;
    stateDate?: Date | null;
    notes?: string | null;
    id?: number;

    constructor(data?: IRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.processID = _data["processID"] !== undefined ? _data["processID"] : null as any;
            this.respondentID = _data["respondentID"] !== undefined ? _data["respondentID"] : null as any;
            this.datasetID = _data["datasetID"] !== undefined ? _data["datasetID"] : null as any;
            this.iteration = _data["iteration"] !== undefined ? _data["iteration"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : null as any;
            this.stateID = _data["stateID"] !== undefined ? _data["stateID"] : null as any;
            this.state = _data["state"] ? State.fromJS(_data["state"]) : null as any;
            this.stateDate = _data["stateDate"] ? new Date(_data["stateDate"].toString()) : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): Request {
        data = typeof data === 'object' ? data : {};
        let result = new Request();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["processID"] = this.processID !== undefined ? this.processID : null as any;
        data["respondentID"] = this.respondentID !== undefined ? this.respondentID : null as any;
        data["datasetID"] = this.datasetID !== undefined ? this.datasetID : null as any;
        data["iteration"] = this.iteration !== undefined ? this.iteration : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : null as any;
        data["stateID"] = this.stateID !== undefined ? this.stateID : null as any;
        data["state"] = this.state ? this.state.toJSON() : null as any;
        data["stateDate"] = this.stateDate ? this.stateDate.toISOString() : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IRequest {
    ownerID?: number;
    processID?: number;
    respondentID?: number;
    datasetID?: number;
    iteration?: number;
    name?: string | null;
    createdDate: Date;
    modifiedDate: Date;
    stateID?: number | null;
    state?: State;
    stateDate?: Date | null;
    notes?: string | null;
    id?: number;
}

export class RequestSchedulesResponse implements IRequestSchedulesResponse {
    guardRequestId?: DatasetKey;
    primarySiteId?: number | null;
    isModification?: boolean;
    assignmentType?: string | null;
    details?: ServicePost[] | null;

    constructor(data?: IRequestSchedulesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guardRequestId = _data["guardRequestId"] ? DatasetKey.fromJS(_data["guardRequestId"]) : null as any;
            this.primarySiteId = _data["primarySiteId"] !== undefined ? _data["primarySiteId"] : null as any;
            this.isModification = _data["isModification"] !== undefined ? _data["isModification"] : null as any;
            this.assignmentType = _data["assignmentType"] !== undefined ? _data["assignmentType"] : null as any;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(ServicePost.fromJS(item));
            }
            else {
                this.details = null as any;
            }
        }
    }

    static fromJS(data: any): RequestSchedulesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RequestSchedulesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guardRequestId"] = this.guardRequestId ? this.guardRequestId.toJSON() : null as any;
        data["primarySiteId"] = this.primarySiteId !== undefined ? this.primarySiteId : null as any;
        data["isModification"] = this.isModification !== undefined ? this.isModification : null as any;
        data["assignmentType"] = this.assignmentType !== undefined ? this.assignmentType : null as any;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IRequestSchedulesResponse {
    guardRequestId?: DatasetKey;
    primarySiteId?: number | null;
    isModification?: boolean;
    assignmentType?: string | null;
    details?: ServicePost[] | null;
}

export class Respondent implements IRespondent {
    ownerID!: number;
    owner?: Owner;
    externalID?: number;
    externalName?: string | null;
    externalSourceTable?: string | null;
    roleID!: number;
    role?: Role;
    roleSourceTable!: string;
    createdDate!: Date;
    modifiedDate!: Date;
    notes?: string | null;
    externalSearchable!: boolean;
    externalVisible!: boolean;
    externalTypeID?: number | null;
    externalTypeName?: string | null;
    ownerSessionID?: number | null;
    externalGroups?: RespondentExternalGroup[] | null;
    id?: number;

    constructor(data?: IRespondent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : null as any;
            this.externalID = _data["externalID"] !== undefined ? _data["externalID"] : null as any;
            this.externalName = _data["externalName"] !== undefined ? _data["externalName"] : null as any;
            this.externalSourceTable = _data["externalSourceTable"] !== undefined ? _data["externalSourceTable"] : null as any;
            this.roleID = _data["roleID"] !== undefined ? _data["roleID"] : null as any;
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : null as any;
            this.roleSourceTable = _data["roleSourceTable"] !== undefined ? _data["roleSourceTable"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.externalSearchable = _data["externalSearchable"] !== undefined ? _data["externalSearchable"] : null as any;
            this.externalVisible = _data["externalVisible"] !== undefined ? _data["externalVisible"] : null as any;
            this.externalTypeID = _data["externalTypeID"] !== undefined ? _data["externalTypeID"] : null as any;
            this.externalTypeName = _data["externalTypeName"] !== undefined ? _data["externalTypeName"] : null as any;
            this.ownerSessionID = _data["ownerSessionID"] !== undefined ? _data["ownerSessionID"] : null as any;
            if (Array.isArray(_data["externalGroups"])) {
                this.externalGroups = [] as any;
                for (let item of _data["externalGroups"])
                    this.externalGroups!.push(RespondentExternalGroup.fromJS(item));
            }
            else {
                this.externalGroups = null as any;
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): Respondent {
        data = typeof data === 'object' ? data : {};
        let result = new Respondent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["owner"] = this.owner ? this.owner.toJSON() : null as any;
        data["externalID"] = this.externalID !== undefined ? this.externalID : null as any;
        data["externalName"] = this.externalName !== undefined ? this.externalName : null as any;
        data["externalSourceTable"] = this.externalSourceTable !== undefined ? this.externalSourceTable : null as any;
        data["roleID"] = this.roleID !== undefined ? this.roleID : null as any;
        data["role"] = this.role ? this.role.toJSON() : null as any;
        data["roleSourceTable"] = this.roleSourceTable !== undefined ? this.roleSourceTable : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["externalSearchable"] = this.externalSearchable !== undefined ? this.externalSearchable : null as any;
        data["externalVisible"] = this.externalVisible !== undefined ? this.externalVisible : null as any;
        data["externalTypeID"] = this.externalTypeID !== undefined ? this.externalTypeID : null as any;
        data["externalTypeName"] = this.externalTypeName !== undefined ? this.externalTypeName : null as any;
        data["ownerSessionID"] = this.ownerSessionID !== undefined ? this.ownerSessionID : null as any;
        if (Array.isArray(this.externalGroups)) {
            data["externalGroups"] = [];
            for (let item of this.externalGroups)
                data["externalGroups"].push(item ? item.toJSON() : null as any);
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IRespondent {
    ownerID: number;
    owner?: Owner;
    externalID?: number;
    externalName?: string | null;
    externalSourceTable?: string | null;
    roleID: number;
    role?: Role;
    roleSourceTable: string;
    createdDate: Date;
    modifiedDate: Date;
    notes?: string | null;
    externalSearchable: boolean;
    externalVisible: boolean;
    externalTypeID?: number | null;
    externalTypeName?: string | null;
    ownerSessionID?: number | null;
    externalGroups?: RespondentExternalGroup[] | null;
    id?: number;
}

export class RespondentExternalGroup implements IRespondentExternalGroup {
    respondentID?: number;
    groupID?: number;
    groupName?: string | null;
    ownerSessionID?: number | null;
    id?: number;

    constructor(data?: IRespondentExternalGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.respondentID = _data["respondentID"] !== undefined ? _data["respondentID"] : null as any;
            this.groupID = _data["groupID"] !== undefined ? _data["groupID"] : null as any;
            this.groupName = _data["groupName"] !== undefined ? _data["groupName"] : null as any;
            this.ownerSessionID = _data["ownerSessionID"] !== undefined ? _data["ownerSessionID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): RespondentExternalGroup {
        data = typeof data === 'object' ? data : {};
        let result = new RespondentExternalGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["respondentID"] = this.respondentID !== undefined ? this.respondentID : null as any;
        data["groupID"] = this.groupID !== undefined ? this.groupID : null as any;
        data["groupName"] = this.groupName !== undefined ? this.groupName : null as any;
        data["ownerSessionID"] = this.ownerSessionID !== undefined ? this.ownerSessionID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IRespondentExternalGroup {
    respondentID?: number;
    groupID?: number;
    groupName?: string | null;
    ownerSessionID?: number | null;
    id?: number;
}

export class RespondentInfo implements IRespondentInfo {
    name?: string | null;
    role?: string | null;

    constructor(data?: IRespondentInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.role = _data["role"] !== undefined ? _data["role"] : null as any;
        }
    }

    static fromJS(data: any): RespondentInfo {
        data = typeof data === 'object' ? data : {};
        let result = new RespondentInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["role"] = this.role !== undefined ? this.role : null as any;
        return data;
    }
}

export interface IRespondentInfo {
    name?: string | null;
    role?: string | null;
}

export class Response implements IResponse {
    action?: string | null;
    actionUserName?: string | null;
    actionDate?: Date;
    workflowState?: InvoiceWorkflowState;
    reasons?: ActionReason[] | null;
    notes?: string | null;

    constructor(data?: IResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"] !== undefined ? _data["action"] : null as any;
            this.actionUserName = _data["actionUserName"] !== undefined ? _data["actionUserName"] : null as any;
            this.actionDate = _data["actionDate"] ? new Date(_data["actionDate"].toString()) : null as any;
            this.workflowState = _data["workflowState"] ? InvoiceWorkflowState.fromJS(_data["workflowState"]) : null as any;
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(ActionReason.fromJS(item));
            }
            else {
                this.reasons = null as any;
            }
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
        }
    }

    static fromJS(data: any): Response {
        data = typeof data === 'object' ? data : {};
        let result = new Response();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action !== undefined ? this.action : null as any;
        data["actionUserName"] = this.actionUserName !== undefined ? this.actionUserName : null as any;
        data["actionDate"] = this.actionDate ? this.actionDate.toISOString() : null as any;
        data["workflowState"] = this.workflowState ? this.workflowState.toJSON() : null as any;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item ? item.toJSON() : null as any);
        }
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        return data;
    }
}

export interface IResponse {
    action?: string | null;
    actionUserName?: string | null;
    actionDate?: Date;
    workflowState?: InvoiceWorkflowState;
    reasons?: ActionReason[] | null;
    notes?: string | null;
}

export class RetentionPolicy implements IRetentionPolicy {
    name!: string;
    description?: string | null;
    retentionYears!: number;
    retentionMonths!: number;
    retentionWeeks!: number;
    retentionDays!: number;
    cutoffDate?: Date;
    id?: number;

    constructor(data?: IRetentionPolicy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.retentionYears = _data["retentionYears"] !== undefined ? _data["retentionYears"] : null as any;
            this.retentionMonths = _data["retentionMonths"] !== undefined ? _data["retentionMonths"] : null as any;
            this.retentionWeeks = _data["retentionWeeks"] !== undefined ? _data["retentionWeeks"] : null as any;
            this.retentionDays = _data["retentionDays"] !== undefined ? _data["retentionDays"] : null as any;
            this.cutoffDate = _data["cutoffDate"] ? new Date(_data["cutoffDate"].toString()) : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): RetentionPolicy {
        data = typeof data === 'object' ? data : {};
        let result = new RetentionPolicy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["retentionYears"] = this.retentionYears !== undefined ? this.retentionYears : null as any;
        data["retentionMonths"] = this.retentionMonths !== undefined ? this.retentionMonths : null as any;
        data["retentionWeeks"] = this.retentionWeeks !== undefined ? this.retentionWeeks : null as any;
        data["retentionDays"] = this.retentionDays !== undefined ? this.retentionDays : null as any;
        data["cutoffDate"] = this.cutoffDate ? this.cutoffDate.toISOString() : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IRetentionPolicy {
    name: string;
    description?: string | null;
    retentionYears: number;
    retentionMonths: number;
    retentionWeeks: number;
    retentionDays: number;
    cutoffDate?: Date;
    id?: number;
}

export class RiskModel implements IRiskModel {
    siteId?: number;
    externalId?: string | null;
    year?: number;
    quarter?: number;
    riskCategory?: number;
    locationPoints?: number;
    incidentPoints?: number;
    readonly incidentsByPeriod?: IncidentsByPeriod[] | null;

    constructor(data?: IRiskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null as any;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : null as any;
            this.year = _data["year"] !== undefined ? _data["year"] : null as any;
            this.quarter = _data["quarter"] !== undefined ? _data["quarter"] : null as any;
            this.riskCategory = _data["riskCategory"] !== undefined ? _data["riskCategory"] : null as any;
            this.locationPoints = _data["locationPoints"] !== undefined ? _data["locationPoints"] : null as any;
            this.incidentPoints = _data["incidentPoints"] !== undefined ? _data["incidentPoints"] : null as any;
            if (Array.isArray(_data["incidentsByPeriod"])) {
                (this as any).incidentsByPeriod = [] as any;
                for (let item of _data["incidentsByPeriod"])
                    (this as any).incidentsByPeriod!.push(IncidentsByPeriod.fromJS(item));
            }
            else {
                (this as any).incidentsByPeriod = null as any;
            }
        }
    }

    static fromJS(data: any): RiskModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId !== undefined ? this.siteId : null as any;
        data["externalId"] = this.externalId !== undefined ? this.externalId : null as any;
        data["year"] = this.year !== undefined ? this.year : null as any;
        data["quarter"] = this.quarter !== undefined ? this.quarter : null as any;
        data["riskCategory"] = this.riskCategory !== undefined ? this.riskCategory : null as any;
        data["locationPoints"] = this.locationPoints !== undefined ? this.locationPoints : null as any;
        data["incidentPoints"] = this.incidentPoints !== undefined ? this.incidentPoints : null as any;
        if (Array.isArray(this.incidentsByPeriod)) {
            data["incidentsByPeriod"] = [];
            for (let item of this.incidentsByPeriod)
                data["incidentsByPeriod"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IRiskModel {
    siteId?: number;
    externalId?: string | null;
    year?: number;
    quarter?: number;
    riskCategory?: number;
    locationPoints?: number;
    incidentPoints?: number;
    incidentsByPeriod?: IncidentsByPeriod[] | null;
}

export class RiskModelIncident implements IRiskModelIncident {
    type?: string | null;
    count?: number;

    constructor(data?: IRiskModelIncident) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.count = _data["count"] !== undefined ? _data["count"] : null as any;
        }
    }

    static fromJS(data: any): RiskModelIncident {
        data = typeof data === 'object' ? data : {};
        let result = new RiskModelIncident();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["count"] = this.count !== undefined ? this.count : null as any;
        return data;
    }
}

export interface IRiskModelIncident {
    type?: string | null;
    count?: number;
}

export class RiskModelPagedResult implements IRiskModelPagedResult {
    items?: RiskModel[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;

    constructor(data?: IRiskModelPagedResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(RiskModel.fromJS(item));
            }
            else {
                this.items = null as any;
            }
            this.page = _data["page"] !== undefined ? _data["page"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
            this.totalCount = _data["totalCount"] !== undefined ? _data["totalCount"] : null as any;
        }
    }

    static fromJS(data: any): RiskModelPagedResult {
        data = typeof data === 'object' ? data : {};
        let result = new RiskModelPagedResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        data["page"] = this.page !== undefined ? this.page : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        data["totalCount"] = this.totalCount !== undefined ? this.totalCount : null as any;
        return data;
    }
}

export interface IRiskModelPagedResult {
    items?: RiskModel[] | null;
    page?: number;
    pageSize?: number;
    totalCount?: number;
}

export class RiskModelQuery implements IRiskModelQuery {
    accountId?: number;
    year?: number;
    quarter?: number;
    siteId?: number | null;
    externalId?: string | null;
    page?: number | null;
    pageSize?: number;

    constructor(data?: IRiskModelQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.year = _data["year"] !== undefined ? _data["year"] : null as any;
            this.quarter = _data["quarter"] !== undefined ? _data["quarter"] : null as any;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null as any;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : null as any;
            this.page = _data["page"] !== undefined ? _data["page"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
        }
    }

    static fromJS(data: any): RiskModelQuery {
        data = typeof data === 'object' ? data : {};
        let result = new RiskModelQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["year"] = this.year !== undefined ? this.year : null as any;
        data["quarter"] = this.quarter !== undefined ? this.quarter : null as any;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null as any;
        data["externalId"] = this.externalId !== undefined ? this.externalId : null as any;
        data["page"] = this.page !== undefined ? this.page : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        return data;
    }
}

export interface IRiskModelQuery {
    accountId?: number;
    year?: number;
    quarter?: number;
    siteId?: number | null;
    externalId?: string | null;
    page?: number | null;
    pageSize?: number;
}

export class RiskModelRelease implements IRiskModelRelease {
    year?: number;
    quarter?: number;

    constructor(data?: IRiskModelRelease) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"] !== undefined ? _data["year"] : null as any;
            this.quarter = _data["quarter"] !== undefined ? _data["quarter"] : null as any;
        }
    }

    static fromJS(data: any): RiskModelRelease {
        data = typeof data === 'object' ? data : {};
        let result = new RiskModelRelease();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year !== undefined ? this.year : null as any;
        data["quarter"] = this.quarter !== undefined ? this.quarter : null as any;
        return data;
    }
}

export interface IRiskModelRelease {
    year?: number;
    quarter?: number;
}

export class Role implements IRole {
    code!: string;
    name!: string;
    level!: number;
    notes?: string | null;
    id?: number;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.level = _data["level"] !== undefined ? _data["level"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["level"] = this.level !== undefined ? this.level : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IRole {
    code: string;
    name: string;
    level: number;
    notes?: string | null;
    id?: number;
}

export class RowComment implements IRowComment {
    commentDate?: Date | null;
    commentRespondent?: string | null;
    commentText?: string | null;

    constructor(data?: IRowComment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.commentDate = _data["commentDate"] ? new Date(_data["commentDate"].toString()) : null as any;
            this.commentRespondent = _data["commentRespondent"] !== undefined ? _data["commentRespondent"] : null as any;
            this.commentText = _data["commentText"] !== undefined ? _data["commentText"] : null as any;
        }
    }

    static fromJS(data: any): RowComment {
        data = typeof data === 'object' ? data : {};
        let result = new RowComment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["commentDate"] = this.commentDate ? this.commentDate.toISOString() : null as any;
        data["commentRespondent"] = this.commentRespondent !== undefined ? this.commentRespondent : null as any;
        data["commentText"] = this.commentText !== undefined ? this.commentText : null as any;
        return data;
    }
}

export interface IRowComment {
    commentDate?: Date | null;
    commentRespondent?: string | null;
    commentText?: string | null;
}

export class SSOLoginRequest implements ISSOLoginRequest {
    accountId?: number;
    userId?: number;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;

    constructor(data?: ISSOLoginRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): SSOLoginRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SSOLoginRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["userId"] = this.userId !== undefined ? this.userId : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }
}

export interface ISSOLoginRequest {
    accountId?: number;
    userId?: number;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
}

export class Script implements IScript {
    ownerID?: number;
    owner?: Owner;
    name?: string | null;
    text?: string | null;
    typeID?: number;
    scriptType?: ScriptType;
    sequence?: number | null;
    notes?: string | null;
    designerID!: string;
    ownerDesignerID!: string;
    id?: number;

    constructor(data?: IScript) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.typeID = _data["typeID"] !== undefined ? _data["typeID"] : null as any;
            this.scriptType = _data["scriptType"] ? ScriptType.fromJS(_data["scriptType"]) : null as any;
            this.sequence = _data["sequence"] !== undefined ? _data["sequence"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.ownerDesignerID = _data["ownerDesignerID"] !== undefined ? _data["ownerDesignerID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): Script {
        data = typeof data === 'object' ? data : {};
        let result = new Script();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["owner"] = this.owner ? this.owner.toJSON() : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["typeID"] = this.typeID !== undefined ? this.typeID : null as any;
        data["scriptType"] = this.scriptType ? this.scriptType.toJSON() : null as any;
        data["sequence"] = this.sequence !== undefined ? this.sequence : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["ownerDesignerID"] = this.ownerDesignerID !== undefined ? this.ownerDesignerID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IScript {
    ownerID?: number;
    owner?: Owner;
    name?: string | null;
    text?: string | null;
    typeID?: number;
    scriptType?: ScriptType;
    sequence?: number | null;
    notes?: string | null;
    designerID: string;
    ownerDesignerID: string;
    id?: number;
}

export class ScriptType implements IScriptType {
    name?: string | null;
    description?: string | null;
    notes?: string | null;
    id?: number;

    constructor(data?: IScriptType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): ScriptType {
        data = typeof data === 'object' ? data : {};
        let result = new ScriptType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IScriptType {
    name?: string | null;
    description?: string | null;
    notes?: string | null;
    id?: number;
}

export class SearchRequest implements ISearchRequest {
    accountID?: number;
    userID?: number | null;
    datapointValues?: DatapointValue[] | null;
    fuzzySearch?: string | null;
    siteIDs?: number[] | null;
    datapointIDs?: number[] | null;
    datasetExternalIDs?: number[] | null;
    includeValuesInResults?: number;
    cacheMode?: number;

    constructor(data?: ISearchRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountID = _data["accountID"] !== undefined ? _data["accountID"] : null as any;
            this.userID = _data["userID"] !== undefined ? _data["userID"] : null as any;
            if (Array.isArray(_data["datapointValues"])) {
                this.datapointValues = [] as any;
                for (let item of _data["datapointValues"])
                    this.datapointValues!.push(DatapointValue.fromJS(item));
            }
            else {
                this.datapointValues = null as any;
            }
            this.fuzzySearch = _data["fuzzySearch"] !== undefined ? _data["fuzzySearch"] : null as any;
            if (Array.isArray(_data["siteIDs"])) {
                this.siteIDs = [] as any;
                for (let item of _data["siteIDs"])
                    this.siteIDs!.push(item);
            }
            else {
                this.siteIDs = null as any;
            }
            if (Array.isArray(_data["datapointIDs"])) {
                this.datapointIDs = [] as any;
                for (let item of _data["datapointIDs"])
                    this.datapointIDs!.push(item);
            }
            else {
                this.datapointIDs = null as any;
            }
            if (Array.isArray(_data["datasetExternalIDs"])) {
                this.datasetExternalIDs = [] as any;
                for (let item of _data["datasetExternalIDs"])
                    this.datasetExternalIDs!.push(item);
            }
            else {
                this.datasetExternalIDs = null as any;
            }
            this.includeValuesInResults = _data["includeValuesInResults"] !== undefined ? _data["includeValuesInResults"] : null as any;
            this.cacheMode = _data["cacheMode"] !== undefined ? _data["cacheMode"] : null as any;
        }
    }

    static fromJS(data: any): SearchRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountID"] = this.accountID !== undefined ? this.accountID : null as any;
        data["userID"] = this.userID !== undefined ? this.userID : null as any;
        if (Array.isArray(this.datapointValues)) {
            data["datapointValues"] = [];
            for (let item of this.datapointValues)
                data["datapointValues"].push(item ? item.toJSON() : null as any);
        }
        data["fuzzySearch"] = this.fuzzySearch !== undefined ? this.fuzzySearch : null as any;
        if (Array.isArray(this.siteIDs)) {
            data["siteIDs"] = [];
            for (let item of this.siteIDs)
                data["siteIDs"].push(item);
        }
        if (Array.isArray(this.datapointIDs)) {
            data["datapointIDs"] = [];
            for (let item of this.datapointIDs)
                data["datapointIDs"].push(item);
        }
        if (Array.isArray(this.datasetExternalIDs)) {
            data["datasetExternalIDs"] = [];
            for (let item of this.datasetExternalIDs)
                data["datasetExternalIDs"].push(item);
        }
        data["includeValuesInResults"] = this.includeValuesInResults !== undefined ? this.includeValuesInResults : null as any;
        data["cacheMode"] = this.cacheMode !== undefined ? this.cacheMode : null as any;
        return data;
    }
}

export interface ISearchRequest {
    accountID?: number;
    userID?: number | null;
    datapointValues?: DatapointValue[] | null;
    fuzzySearch?: string | null;
    siteIDs?: number[] | null;
    datapointIDs?: number[] | null;
    datasetExternalIDs?: number[] | null;
    includeValuesInResults?: number;
    cacheMode?: number;
}

export enum ServiceDurationType {
    Short = "Short",
    Temp = "Temp",
    Long = "Long",
}

export enum ServiceModificationType {
    Cancel = "Cancel",
    Extend = "Extend",
    Modify = "Modify",
}

export class ServicePost implements IServicePost {
    siteId?: number;
    shifts?: ShiftDetail[] | null;
    assignmentType?: GuardServiceType;
    patrolType?: PatrolType;
    billingType?: BillingType;
    perStopRecurrence?: string | null;
    perStopFrequency?: number | null;
    billingPeriod?: BillingPeriod;
    specialAttention?: boolean | null;
    errorHandlingLogic?: ErrorHandlingLogic;
    requestType?: MobilePatrolRequestType;

    constructor(data?: IServicePost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null as any;
            if (Array.isArray(_data["shifts"])) {
                this.shifts = [] as any;
                for (let item of _data["shifts"])
                    this.shifts!.push(ShiftDetail.fromJS(item));
            }
            else {
                this.shifts = null as any;
            }
            this.assignmentType = _data["assignmentType"] !== undefined ? _data["assignmentType"] : null as any;
            this.patrolType = _data["patrolType"] !== undefined ? _data["patrolType"] : null as any;
            this.billingType = _data["billingType"] !== undefined ? _data["billingType"] : null as any;
            this.perStopRecurrence = _data["perStopRecurrence"] !== undefined ? _data["perStopRecurrence"] : null as any;
            this.perStopFrequency = _data["perStopFrequency"] !== undefined ? _data["perStopFrequency"] : null as any;
            this.billingPeriod = _data["billingPeriod"] !== undefined ? _data["billingPeriod"] : null as any;
            this.specialAttention = _data["specialAttention"] !== undefined ? _data["specialAttention"] : null as any;
            this.errorHandlingLogic = _data["errorHandlingLogic"] !== undefined ? _data["errorHandlingLogic"] : null as any;
            this.requestType = _data["RequestType"] !== undefined ? _data["RequestType"] : null as any;
        }
    }

    static fromJS(data: any): ServicePost {
        data = typeof data === 'object' ? data : {};
        let result = new ServicePost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId !== undefined ? this.siteId : null as any;
        if (Array.isArray(this.shifts)) {
            data["shifts"] = [];
            for (let item of this.shifts)
                data["shifts"].push(item ? item.toJSON() : null as any);
        }
        data["assignmentType"] = this.assignmentType !== undefined ? this.assignmentType : null as any;
        data["patrolType"] = this.patrolType !== undefined ? this.patrolType : null as any;
        data["billingType"] = this.billingType !== undefined ? this.billingType : null as any;
        data["perStopRecurrence"] = this.perStopRecurrence !== undefined ? this.perStopRecurrence : null as any;
        data["perStopFrequency"] = this.perStopFrequency !== undefined ? this.perStopFrequency : null as any;
        data["billingPeriod"] = this.billingPeriod !== undefined ? this.billingPeriod : null as any;
        data["specialAttention"] = this.specialAttention !== undefined ? this.specialAttention : null as any;
        data["errorHandlingLogic"] = this.errorHandlingLogic !== undefined ? this.errorHandlingLogic : null as any;
        data["RequestType"] = this.requestType !== undefined ? this.requestType : null as any;
        return data;
    }
}

export interface IServicePost {
    siteId?: number;
    shifts?: ShiftDetail[] | null;
    assignmentType?: GuardServiceType;
    patrolType?: PatrolType;
    billingType?: BillingType;
    perStopRecurrence?: string | null;
    perStopFrequency?: number | null;
    billingPeriod?: BillingPeriod;
    specialAttention?: boolean | null;
    errorHandlingLogic?: ErrorHandlingLogic;
    requestType?: MobilePatrolRequestType;
}

export class ShiftDetail implements IShiftDetail {
    startTime?: string;
    endTime?: string;
    recurrence?: ShiftRecurrence;
    editorGroupIndex?: number | null;

    constructor(data?: IShiftDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startTime = _data["startTime"] !== undefined ? _data["startTime"] : null as any;
            this.endTime = _data["endTime"] !== undefined ? _data["endTime"] : null as any;
            this.recurrence = _data["recurrence"] ? ShiftRecurrence.fromJS(_data["recurrence"]) : null as any;
            this.editorGroupIndex = _data["editorGroupIndex"] !== undefined ? _data["editorGroupIndex"] : null as any;
        }
    }

    static fromJS(data: any): ShiftDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startTime"] = this.startTime !== undefined ? this.startTime : null as any;
        data["endTime"] = this.endTime !== undefined ? this.endTime : null as any;
        data["recurrence"] = this.recurrence ? this.recurrence.toJSON() : null as any;
        data["editorGroupIndex"] = this.editorGroupIndex !== undefined ? this.editorGroupIndex : null as any;
        return data;
    }
}

export interface IShiftDetail {
    startTime?: string;
    endTime?: string;
    recurrence?: ShiftRecurrence;
    editorGroupIndex?: number | null;
}

export class ShiftRecurrence implements IShiftRecurrence {

    constructor(data?: IShiftRecurrence) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ShiftRecurrence {
        data = typeof data === 'object' ? data : {};
        let result = new ShiftRecurrence();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IShiftRecurrence {
}

export enum ShiftRecurrenceType {
    Weekly = "Weekly",
    MonthlyByDate = "MonthlyByDate",
    MonthlyByDay = "MonthlyByDay",
    PerStopPerDay = "PerStopPerDay",
    PerStopPerWeek = "PerStopPerWeek",
}

export class Site implements ISite {
    siteId?: number;
    siteName?: string | null;
    street?: string | null;
    city?: string | null;
    state?: string | null;
    country?: string | null;
    zipCode?: string | null;
    externalId?: string | null;
    classificationIds?: number[] | null;
    division?: string | null;
    region?: string | null;

    constructor(data?: ISite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null as any;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null as any;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : null as any;
            if (Array.isArray(_data["classificationIds"])) {
                this.classificationIds = [] as any;
                for (let item of _data["classificationIds"])
                    this.classificationIds!.push(item);
            }
            else {
                this.classificationIds = null as any;
            }
            this.division = _data["division"] !== undefined ? _data["division"] : null as any;
            this.region = _data["region"] !== undefined ? _data["region"] : null as any;
        }
    }

    static fromJS(data: any): Site {
        data = typeof data === 'object' ? data : {};
        let result = new Site();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId !== undefined ? this.siteId : null as any;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null as any;
        data["externalId"] = this.externalId !== undefined ? this.externalId : null as any;
        if (Array.isArray(this.classificationIds)) {
            data["classificationIds"] = [];
            for (let item of this.classificationIds)
                data["classificationIds"].push(item);
        }
        data["division"] = this.division !== undefined ? this.division : null as any;
        data["region"] = this.region !== undefined ? this.region : null as any;
        return data;
    }
}

export interface ISite {
    siteId?: number;
    siteName?: string | null;
    street?: string | null;
    city?: string | null;
    state?: string | null;
    country?: string | null;
    zipCode?: string | null;
    externalId?: string | null;
    classificationIds?: number[] | null;
    division?: string | null;
    region?: string | null;
}

export class SiteLocation implements ISiteLocation {
    siteId?: number;
    siteName?: string | null;
    street?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;

    constructor(data?: ISiteLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null as any;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null as any;
            this.street = _data["street"] !== undefined ? _data["street"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null as any;
        }
    }

    static fromJS(data: any): SiteLocation {
        data = typeof data === 'object' ? data : {};
        let result = new SiteLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["siteId"] = this.siteId !== undefined ? this.siteId : null as any;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null as any;
        data["street"] = this.street !== undefined ? this.street : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null as any;
        return data;
    }
}

export interface ISiteLocation {
    siteId?: number;
    siteName?: string | null;
    street?: string | null;
    city?: string | null;
    state?: string | null;
    zipCode?: string | null;
}

export class SiteQueryRequest implements ISiteQueryRequest {
    siteIds?: number[] | null;
    page?: number | null;
    pageSize?: number | null;

    constructor(data?: ISiteQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["siteIds"])) {
                this.siteIds = [] as any;
                for (let item of _data["siteIds"])
                    this.siteIds!.push(item);
            }
            else {
                this.siteIds = null as any;
            }
            this.page = _data["page"] !== undefined ? _data["page"] : null as any;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : null as any;
        }
    }

    static fromJS(data: any): SiteQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SiteQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.siteIds)) {
            data["siteIds"] = [];
            for (let item of this.siteIds)
                data["siteIds"].push(item);
        }
        data["page"] = this.page !== undefined ? this.page : null as any;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : null as any;
        return data;
    }
}

export interface ISiteQueryRequest {
    siteIds?: number[] | null;
    page?: number | null;
    pageSize?: number | null;
}

export class SiteVendorInfo implements ISiteVendorInfo {
    division?: string | null;
    region?: string | null;
    retailMark?: string | null;
    state?: string | null;
    serviceType?: string | null;
    billingType?: string | null;
    guardType?: string | null;
    vendor?: string | null;
    tier?: number | null;
    rateVersion?: string | null;
    tempPayRate?: string | null;
    tempMarkup?: number | null;
    tempOdoMarkup?: string | null;
    tempBillRate?: string | null;
    permPayRate?: string | null;
    permMarkup?: number | null;
    permOdoMarkup?: string | null;
    permBillRate?: string | null;
    hasUnionTemp?: boolean | null;
    hasUnionPerm?: boolean | null;
    tempPayRate_U?: string | null;
    tempMarkup_U?: number | null;
    tempBillRate_U?: string | null;
    permPayRate_U?: string | null;
    permMarkup_U?: number | null;
    permBillRate_U?: string | null;
    v2TempServiceRate?: string | null;
    v2TempResponseRate?: string | null;
    v2TempAllInRate?: string | null;
    v2TempMarkup?: string | null;
    v2TempUnionMarkupLow?: string | null;
    v2TempUnionMarkupHigh?: string | null;
    v2TempUnionMarkupPctLow?: string | null;
    v2TempUnionMarkupPctHigh?: string | null;
    v2PermServiceRate?: string | null;
    v2PermResponseRate?: string | null;
    v2PermAllInRate?: string | null;
    v2PermMarkup?: string | null;
    v2PermUnionMarkupLow?: string | null;
    v2PermUnionMarkupHigh?: string | null;
    v2PermUnionMarkupPctLow?: string | null;
    v2PermUnionMarkupPctHigh?: string | null;
    v2TempNonUnionRate?: string | null;
    v2TempUnionRate?: string | null;
    v2PermNonUnionRate?: string | null;
    v2PermUnionRate?: string | null;
    servicePertains?: boolean | null;
    durationPertains?: boolean | null;
    pertains?: boolean | null;

    constructor(data?: ISiteVendorInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.division = _data["division"] !== undefined ? _data["division"] : null as any;
            this.region = _data["region"] !== undefined ? _data["region"] : null as any;
            this.retailMark = _data["retailMark"] !== undefined ? _data["retailMark"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.serviceType = _data["serviceType"] !== undefined ? _data["serviceType"] : null as any;
            this.billingType = _data["billingType"] !== undefined ? _data["billingType"] : null as any;
            this.guardType = _data["guardType"] !== undefined ? _data["guardType"] : null as any;
            this.vendor = _data["vendor"] !== undefined ? _data["vendor"] : null as any;
            this.tier = _data["tier"] !== undefined ? _data["tier"] : null as any;
            this.rateVersion = _data["rateVersion"] !== undefined ? _data["rateVersion"] : null as any;
            this.tempPayRate = _data["tempPayRate"] !== undefined ? _data["tempPayRate"] : null as any;
            this.tempMarkup = _data["tempMarkup"] !== undefined ? _data["tempMarkup"] : null as any;
            this.tempOdoMarkup = _data["tempOdoMarkup"] !== undefined ? _data["tempOdoMarkup"] : null as any;
            this.tempBillRate = _data["tempBillRate"] !== undefined ? _data["tempBillRate"] : null as any;
            this.permPayRate = _data["permPayRate"] !== undefined ? _data["permPayRate"] : null as any;
            this.permMarkup = _data["permMarkup"] !== undefined ? _data["permMarkup"] : null as any;
            this.permOdoMarkup = _data["permOdoMarkup"] !== undefined ? _data["permOdoMarkup"] : null as any;
            this.permBillRate = _data["permBillRate"] !== undefined ? _data["permBillRate"] : null as any;
            this.hasUnionTemp = _data["hasUnionTemp"] !== undefined ? _data["hasUnionTemp"] : null as any;
            this.hasUnionPerm = _data["hasUnionPerm"] !== undefined ? _data["hasUnionPerm"] : null as any;
            this.tempPayRate_U = _data["tempPayRate_U"] !== undefined ? _data["tempPayRate_U"] : null as any;
            this.tempMarkup_U = _data["tempMarkup_U"] !== undefined ? _data["tempMarkup_U"] : null as any;
            this.tempBillRate_U = _data["tempBillRate_U"] !== undefined ? _data["tempBillRate_U"] : null as any;
            this.permPayRate_U = _data["permPayRate_U"] !== undefined ? _data["permPayRate_U"] : null as any;
            this.permMarkup_U = _data["permMarkup_U"] !== undefined ? _data["permMarkup_U"] : null as any;
            this.permBillRate_U = _data["permBillRate_U"] !== undefined ? _data["permBillRate_U"] : null as any;
            this.v2TempServiceRate = _data["v2TempServiceRate"] !== undefined ? _data["v2TempServiceRate"] : null as any;
            this.v2TempResponseRate = _data["v2TempResponseRate"] !== undefined ? _data["v2TempResponseRate"] : null as any;
            this.v2TempAllInRate = _data["v2TempAllInRate"] !== undefined ? _data["v2TempAllInRate"] : null as any;
            this.v2TempMarkup = _data["v2TempMarkup"] !== undefined ? _data["v2TempMarkup"] : null as any;
            this.v2TempUnionMarkupLow = _data["v2TempUnionMarkupLow"] !== undefined ? _data["v2TempUnionMarkupLow"] : null as any;
            this.v2TempUnionMarkupHigh = _data["v2TempUnionMarkupHigh"] !== undefined ? _data["v2TempUnionMarkupHigh"] : null as any;
            this.v2TempUnionMarkupPctLow = _data["v2TempUnionMarkupPctLow"] !== undefined ? _data["v2TempUnionMarkupPctLow"] : null as any;
            this.v2TempUnionMarkupPctHigh = _data["v2TempUnionMarkupPctHigh"] !== undefined ? _data["v2TempUnionMarkupPctHigh"] : null as any;
            this.v2PermServiceRate = _data["v2PermServiceRate"] !== undefined ? _data["v2PermServiceRate"] : null as any;
            this.v2PermResponseRate = _data["v2PermResponseRate"] !== undefined ? _data["v2PermResponseRate"] : null as any;
            this.v2PermAllInRate = _data["v2PermAllInRate"] !== undefined ? _data["v2PermAllInRate"] : null as any;
            this.v2PermMarkup = _data["v2PermMarkup"] !== undefined ? _data["v2PermMarkup"] : null as any;
            this.v2PermUnionMarkupLow = _data["v2PermUnionMarkupLow"] !== undefined ? _data["v2PermUnionMarkupLow"] : null as any;
            this.v2PermUnionMarkupHigh = _data["v2PermUnionMarkupHigh"] !== undefined ? _data["v2PermUnionMarkupHigh"] : null as any;
            this.v2PermUnionMarkupPctLow = _data["v2PermUnionMarkupPctLow"] !== undefined ? _data["v2PermUnionMarkupPctLow"] : null as any;
            this.v2PermUnionMarkupPctHigh = _data["v2PermUnionMarkupPctHigh"] !== undefined ? _data["v2PermUnionMarkupPctHigh"] : null as any;
            this.v2TempNonUnionRate = _data["v2TempNonUnionRate"] !== undefined ? _data["v2TempNonUnionRate"] : null as any;
            this.v2TempUnionRate = _data["v2TempUnionRate"] !== undefined ? _data["v2TempUnionRate"] : null as any;
            this.v2PermNonUnionRate = _data["v2PermNonUnionRate"] !== undefined ? _data["v2PermNonUnionRate"] : null as any;
            this.v2PermUnionRate = _data["v2PermUnionRate"] !== undefined ? _data["v2PermUnionRate"] : null as any;
            this.servicePertains = _data["servicePertains"] !== undefined ? _data["servicePertains"] : null as any;
            this.durationPertains = _data["durationPertains"] !== undefined ? _data["durationPertains"] : null as any;
            this.pertains = _data["pertains"] !== undefined ? _data["pertains"] : null as any;
        }
    }

    static fromJS(data: any): SiteVendorInfo {
        data = typeof data === 'object' ? data : {};
        let result = new SiteVendorInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["division"] = this.division !== undefined ? this.division : null as any;
        data["region"] = this.region !== undefined ? this.region : null as any;
        data["retailMark"] = this.retailMark !== undefined ? this.retailMark : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["serviceType"] = this.serviceType !== undefined ? this.serviceType : null as any;
        data["billingType"] = this.billingType !== undefined ? this.billingType : null as any;
        data["guardType"] = this.guardType !== undefined ? this.guardType : null as any;
        data["vendor"] = this.vendor !== undefined ? this.vendor : null as any;
        data["tier"] = this.tier !== undefined ? this.tier : null as any;
        data["rateVersion"] = this.rateVersion !== undefined ? this.rateVersion : null as any;
        data["tempPayRate"] = this.tempPayRate !== undefined ? this.tempPayRate : null as any;
        data["tempMarkup"] = this.tempMarkup !== undefined ? this.tempMarkup : null as any;
        data["tempOdoMarkup"] = this.tempOdoMarkup !== undefined ? this.tempOdoMarkup : null as any;
        data["tempBillRate"] = this.tempBillRate !== undefined ? this.tempBillRate : null as any;
        data["permPayRate"] = this.permPayRate !== undefined ? this.permPayRate : null as any;
        data["permMarkup"] = this.permMarkup !== undefined ? this.permMarkup : null as any;
        data["permOdoMarkup"] = this.permOdoMarkup !== undefined ? this.permOdoMarkup : null as any;
        data["permBillRate"] = this.permBillRate !== undefined ? this.permBillRate : null as any;
        data["hasUnionTemp"] = this.hasUnionTemp !== undefined ? this.hasUnionTemp : null as any;
        data["hasUnionPerm"] = this.hasUnionPerm !== undefined ? this.hasUnionPerm : null as any;
        data["tempPayRate_U"] = this.tempPayRate_U !== undefined ? this.tempPayRate_U : null as any;
        data["tempMarkup_U"] = this.tempMarkup_U !== undefined ? this.tempMarkup_U : null as any;
        data["tempBillRate_U"] = this.tempBillRate_U !== undefined ? this.tempBillRate_U : null as any;
        data["permPayRate_U"] = this.permPayRate_U !== undefined ? this.permPayRate_U : null as any;
        data["permMarkup_U"] = this.permMarkup_U !== undefined ? this.permMarkup_U : null as any;
        data["permBillRate_U"] = this.permBillRate_U !== undefined ? this.permBillRate_U : null as any;
        data["v2TempServiceRate"] = this.v2TempServiceRate !== undefined ? this.v2TempServiceRate : null as any;
        data["v2TempResponseRate"] = this.v2TempResponseRate !== undefined ? this.v2TempResponseRate : null as any;
        data["v2TempAllInRate"] = this.v2TempAllInRate !== undefined ? this.v2TempAllInRate : null as any;
        data["v2TempMarkup"] = this.v2TempMarkup !== undefined ? this.v2TempMarkup : null as any;
        data["v2TempUnionMarkupLow"] = this.v2TempUnionMarkupLow !== undefined ? this.v2TempUnionMarkupLow : null as any;
        data["v2TempUnionMarkupHigh"] = this.v2TempUnionMarkupHigh !== undefined ? this.v2TempUnionMarkupHigh : null as any;
        data["v2TempUnionMarkupPctLow"] = this.v2TempUnionMarkupPctLow !== undefined ? this.v2TempUnionMarkupPctLow : null as any;
        data["v2TempUnionMarkupPctHigh"] = this.v2TempUnionMarkupPctHigh !== undefined ? this.v2TempUnionMarkupPctHigh : null as any;
        data["v2PermServiceRate"] = this.v2PermServiceRate !== undefined ? this.v2PermServiceRate : null as any;
        data["v2PermResponseRate"] = this.v2PermResponseRate !== undefined ? this.v2PermResponseRate : null as any;
        data["v2PermAllInRate"] = this.v2PermAllInRate !== undefined ? this.v2PermAllInRate : null as any;
        data["v2PermMarkup"] = this.v2PermMarkup !== undefined ? this.v2PermMarkup : null as any;
        data["v2PermUnionMarkupLow"] = this.v2PermUnionMarkupLow !== undefined ? this.v2PermUnionMarkupLow : null as any;
        data["v2PermUnionMarkupHigh"] = this.v2PermUnionMarkupHigh !== undefined ? this.v2PermUnionMarkupHigh : null as any;
        data["v2PermUnionMarkupPctLow"] = this.v2PermUnionMarkupPctLow !== undefined ? this.v2PermUnionMarkupPctLow : null as any;
        data["v2PermUnionMarkupPctHigh"] = this.v2PermUnionMarkupPctHigh !== undefined ? this.v2PermUnionMarkupPctHigh : null as any;
        data["v2TempNonUnionRate"] = this.v2TempNonUnionRate !== undefined ? this.v2TempNonUnionRate : null as any;
        data["v2TempUnionRate"] = this.v2TempUnionRate !== undefined ? this.v2TempUnionRate : null as any;
        data["v2PermNonUnionRate"] = this.v2PermNonUnionRate !== undefined ? this.v2PermNonUnionRate : null as any;
        data["v2PermUnionRate"] = this.v2PermUnionRate !== undefined ? this.v2PermUnionRate : null as any;
        data["servicePertains"] = this.servicePertains !== undefined ? this.servicePertains : null as any;
        data["durationPertains"] = this.durationPertains !== undefined ? this.durationPertains : null as any;
        data["pertains"] = this.pertains !== undefined ? this.pertains : null as any;
        return data;
    }
}

export interface ISiteVendorInfo {
    division?: string | null;
    region?: string | null;
    retailMark?: string | null;
    state?: string | null;
    serviceType?: string | null;
    billingType?: string | null;
    guardType?: string | null;
    vendor?: string | null;
    tier?: number | null;
    rateVersion?: string | null;
    tempPayRate?: string | null;
    tempMarkup?: number | null;
    tempOdoMarkup?: string | null;
    tempBillRate?: string | null;
    permPayRate?: string | null;
    permMarkup?: number | null;
    permOdoMarkup?: string | null;
    permBillRate?: string | null;
    hasUnionTemp?: boolean | null;
    hasUnionPerm?: boolean | null;
    tempPayRate_U?: string | null;
    tempMarkup_U?: number | null;
    tempBillRate_U?: string | null;
    permPayRate_U?: string | null;
    permMarkup_U?: number | null;
    permBillRate_U?: string | null;
    v2TempServiceRate?: string | null;
    v2TempResponseRate?: string | null;
    v2TempAllInRate?: string | null;
    v2TempMarkup?: string | null;
    v2TempUnionMarkupLow?: string | null;
    v2TempUnionMarkupHigh?: string | null;
    v2TempUnionMarkupPctLow?: string | null;
    v2TempUnionMarkupPctHigh?: string | null;
    v2PermServiceRate?: string | null;
    v2PermResponseRate?: string | null;
    v2PermAllInRate?: string | null;
    v2PermMarkup?: string | null;
    v2PermUnionMarkupLow?: string | null;
    v2PermUnionMarkupHigh?: string | null;
    v2PermUnionMarkupPctLow?: string | null;
    v2PermUnionMarkupPctHigh?: string | null;
    v2TempNonUnionRate?: string | null;
    v2TempUnionRate?: string | null;
    v2PermNonUnionRate?: string | null;
    v2PermUnionRate?: string | null;
    servicePertains?: boolean | null;
    durationPertains?: boolean | null;
    pertains?: boolean | null;
}

export class State implements IState {
    processID?: number;
    name!: string;
    friendlyName?: string | null;
    description?: string | null;
    ownerID?: number | null;
    seq?: number | null;
    processDesignerID!: string;
    designerID!: string;
    bulkTargets?: BulkTarget[] | null;
    datapointTargetPrereqs?: DatapointTargetPrereq[] | null;
    process?: Process;
    processDesigner?: Process;
    requests?: Request[] | null;
    targets?: Target[] | null;
    outgoingTransitions?: Transition[] | null;
    incomingTransitions?: Transition[] | null;
    workflowStatuses?: WorkflowStatus[] | null;
    id?: number;

    constructor(data?: IState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processID = _data["processID"] !== undefined ? _data["processID"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.friendlyName = _data["friendlyName"] !== undefined ? _data["friendlyName"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.seq = _data["seq"] !== undefined ? _data["seq"] : null as any;
            this.processDesignerID = _data["processDesignerID"] !== undefined ? _data["processDesignerID"] : null as any;
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            if (Array.isArray(_data["bulkTargets"])) {
                this.bulkTargets = [] as any;
                for (let item of _data["bulkTargets"])
                    this.bulkTargets!.push(BulkTarget.fromJS(item));
            }
            else {
                this.bulkTargets = null as any;
            }
            if (Array.isArray(_data["datapointTargetPrereqs"])) {
                this.datapointTargetPrereqs = [] as any;
                for (let item of _data["datapointTargetPrereqs"])
                    this.datapointTargetPrereqs!.push(DatapointTargetPrereq.fromJS(item));
            }
            else {
                this.datapointTargetPrereqs = null as any;
            }
            this.process = _data["process"] ? Process.fromJS(_data["process"]) : null as any;
            this.processDesigner = _data["processDesigner"] ? Process.fromJS(_data["processDesigner"]) : null as any;
            if (Array.isArray(_data["requests"])) {
                this.requests = [] as any;
                for (let item of _data["requests"])
                    this.requests!.push(Request.fromJS(item));
            }
            else {
                this.requests = null as any;
            }
            if (Array.isArray(_data["targets"])) {
                this.targets = [] as any;
                for (let item of _data["targets"])
                    this.targets!.push(Target.fromJS(item));
            }
            else {
                this.targets = null as any;
            }
            if (Array.isArray(_data["outgoingTransitions"])) {
                this.outgoingTransitions = [] as any;
                for (let item of _data["outgoingTransitions"])
                    this.outgoingTransitions!.push(Transition.fromJS(item));
            }
            else {
                this.outgoingTransitions = null as any;
            }
            if (Array.isArray(_data["incomingTransitions"])) {
                this.incomingTransitions = [] as any;
                for (let item of _data["incomingTransitions"])
                    this.incomingTransitions!.push(Transition.fromJS(item));
            }
            else {
                this.incomingTransitions = null as any;
            }
            if (Array.isArray(_data["workflowStatuses"])) {
                this.workflowStatuses = [] as any;
                for (let item of _data["workflowStatuses"])
                    this.workflowStatuses!.push(WorkflowStatus.fromJS(item));
            }
            else {
                this.workflowStatuses = null as any;
            }
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): State {
        data = typeof data === 'object' ? data : {};
        let result = new State();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processID"] = this.processID !== undefined ? this.processID : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["friendlyName"] = this.friendlyName !== undefined ? this.friendlyName : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["seq"] = this.seq !== undefined ? this.seq : null as any;
        data["processDesignerID"] = this.processDesignerID !== undefined ? this.processDesignerID : null as any;
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        if (Array.isArray(this.bulkTargets)) {
            data["bulkTargets"] = [];
            for (let item of this.bulkTargets)
                data["bulkTargets"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.datapointTargetPrereqs)) {
            data["datapointTargetPrereqs"] = [];
            for (let item of this.datapointTargetPrereqs)
                data["datapointTargetPrereqs"].push(item ? item.toJSON() : null as any);
        }
        data["process"] = this.process ? this.process.toJSON() : null as any;
        data["processDesigner"] = this.processDesigner ? this.processDesigner.toJSON() : null as any;
        if (Array.isArray(this.requests)) {
            data["requests"] = [];
            for (let item of this.requests)
                data["requests"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.targets)) {
            data["targets"] = [];
            for (let item of this.targets)
                data["targets"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.outgoingTransitions)) {
            data["outgoingTransitions"] = [];
            for (let item of this.outgoingTransitions)
                data["outgoingTransitions"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.incomingTransitions)) {
            data["incomingTransitions"] = [];
            for (let item of this.incomingTransitions)
                data["incomingTransitions"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.workflowStatuses)) {
            data["workflowStatuses"] = [];
            for (let item of this.workflowStatuses)
                data["workflowStatuses"].push(item ? item.toJSON() : null as any);
        }
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IState {
    processID?: number;
    name: string;
    friendlyName?: string | null;
    description?: string | null;
    ownerID?: number | null;
    seq?: number | null;
    processDesignerID: string;
    designerID: string;
    bulkTargets?: BulkTarget[] | null;
    datapointTargetPrereqs?: DatapointTargetPrereq[] | null;
    process?: Process;
    processDesigner?: Process;
    requests?: Request[] | null;
    targets?: Target[] | null;
    outgoingTransitions?: Transition[] | null;
    incomingTransitions?: Transition[] | null;
    workflowStatuses?: WorkflowStatus[] | null;
    id?: number;
}

export class SubmitETKActionRequest implements ISubmitETKActionRequest {
    action?: string | null;
    reasons?: string[] | null;
    notes?: string | null;

    constructor(data?: ISubmitETKActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"] !== undefined ? _data["action"] : null as any;
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(item);
            }
            else {
                this.reasons = null as any;
            }
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
        }
    }

    static fromJS(data: any): SubmitETKActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitETKActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action !== undefined ? this.action : null as any;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item);
        }
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        return data;
    }
}

export interface ISubmitETKActionRequest {
    action?: string | null;
    reasons?: string[] | null;
    notes?: string | null;
}

export class SubmitInvoiceActionRequest implements ISubmitInvoiceActionRequest {
    action!: string;
    reasons?: string[] | null;
    notes?: string | null;

    constructor(data?: ISubmitInvoiceActionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.action = _data["action"] !== undefined ? _data["action"] : null as any;
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(item);
            }
            else {
                this.reasons = null as any;
            }
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
        }
    }

    static fromJS(data: any): SubmitInvoiceActionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubmitInvoiceActionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["action"] = this.action !== undefined ? this.action : null as any;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item);
        }
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        return data;
    }
}

export interface ISubmitInvoiceActionRequest {
    action: string;
    reasons?: string[] | null;
    notes?: string | null;
}

export class Supplier implements ISupplier {
    supplierID?: string;
    supplierName?: string | null;
    ownerDesignerID?: string;
    guardRequests?: GuardRequest[] | null;
    supplierAliases?: SupplierAlias[] | null;
    supplierSupervisors?: SupplierSupervisor[] | null;

    constructor(data?: ISupplier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierID = _data["supplierID"] !== undefined ? _data["supplierID"] : null as any;
            this.supplierName = _data["supplierName"] !== undefined ? _data["supplierName"] : null as any;
            this.ownerDesignerID = _data["ownerDesignerID"] !== undefined ? _data["ownerDesignerID"] : null as any;
            if (Array.isArray(_data["guardRequests"])) {
                this.guardRequests = [] as any;
                for (let item of _data["guardRequests"])
                    this.guardRequests!.push(GuardRequest.fromJS(item));
            }
            else {
                this.guardRequests = null as any;
            }
            if (Array.isArray(_data["supplierAliases"])) {
                this.supplierAliases = [] as any;
                for (let item of _data["supplierAliases"])
                    this.supplierAliases!.push(SupplierAlias.fromJS(item));
            }
            else {
                this.supplierAliases = null as any;
            }
            if (Array.isArray(_data["supplierSupervisors"])) {
                this.supplierSupervisors = [] as any;
                for (let item of _data["supplierSupervisors"])
                    this.supplierSupervisors!.push(SupplierSupervisor.fromJS(item));
            }
            else {
                this.supplierSupervisors = null as any;
            }
        }
    }

    static fromJS(data: any): Supplier {
        data = typeof data === 'object' ? data : {};
        let result = new Supplier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierID"] = this.supplierID !== undefined ? this.supplierID : null as any;
        data["supplierName"] = this.supplierName !== undefined ? this.supplierName : null as any;
        data["ownerDesignerID"] = this.ownerDesignerID !== undefined ? this.ownerDesignerID : null as any;
        if (Array.isArray(this.guardRequests)) {
            data["guardRequests"] = [];
            for (let item of this.guardRequests)
                data["guardRequests"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.supplierAliases)) {
            data["supplierAliases"] = [];
            for (let item of this.supplierAliases)
                data["supplierAliases"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.supplierSupervisors)) {
            data["supplierSupervisors"] = [];
            for (let item of this.supplierSupervisors)
                data["supplierSupervisors"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ISupplier {
    supplierID?: string;
    supplierName?: string | null;
    ownerDesignerID?: string;
    guardRequests?: GuardRequest[] | null;
    supplierAliases?: SupplierAlias[] | null;
    supplierSupervisors?: SupplierSupervisor[] | null;
}

export class SupplierAlias implements ISupplierAlias {
    supplierAliasID?: number;
    ownerDesignerID?: string;
    supplierID?: string;
    aliasName?: string | null;
    normalizedAliasName?: string | null;
    supplier?: Supplier;

    constructor(data?: ISupplierAlias) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplierAliasID = _data["supplierAliasID"] !== undefined ? _data["supplierAliasID"] : null as any;
            this.ownerDesignerID = _data["ownerDesignerID"] !== undefined ? _data["ownerDesignerID"] : null as any;
            this.supplierID = _data["supplierID"] !== undefined ? _data["supplierID"] : null as any;
            this.aliasName = _data["aliasName"] !== undefined ? _data["aliasName"] : null as any;
            this.normalizedAliasName = _data["normalizedAliasName"] !== undefined ? _data["normalizedAliasName"] : null as any;
            this.supplier = _data["supplier"] ? Supplier.fromJS(_data["supplier"]) : null as any;
        }
    }

    static fromJS(data: any): SupplierAlias {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierAlias();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplierAliasID"] = this.supplierAliasID !== undefined ? this.supplierAliasID : null as any;
        data["ownerDesignerID"] = this.ownerDesignerID !== undefined ? this.ownerDesignerID : null as any;
        data["supplierID"] = this.supplierID !== undefined ? this.supplierID : null as any;
        data["aliasName"] = this.aliasName !== undefined ? this.aliasName : null as any;
        data["normalizedAliasName"] = this.normalizedAliasName !== undefined ? this.normalizedAliasName : null as any;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : null as any;
        return data;
    }
}

export interface ISupplierAlias {
    supplierAliasID?: number;
    ownerDesignerID?: string;
    supplierID?: string;
    aliasName?: string | null;
    normalizedAliasName?: string | null;
    supplier?: Supplier;
}

export enum SupplierApprovalDisposition {
    Approved = "Approved",
    Denied = "Denied",
    Request_Modification = "Request Modification",
}

export class SupplierContactList implements ISupplierContactList {
    supervisorId?: string;
    supplier?: string | null;
    supplierId?: string;
    phoneNumber?: string | null;
    mainSupplierEmail?: string | null;
    contactPerson?: string | null;
    additionalEmails?: string | null;
    isAccountManger?: boolean;

    constructor(data?: ISupplierContactList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supervisorId = _data["supervisorId"] !== undefined ? _data["supervisorId"] : null as any;
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
            this.supplierId = _data["supplierId"] !== undefined ? _data["supplierId"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
            this.mainSupplierEmail = _data["mainSupplierEmail"] !== undefined ? _data["mainSupplierEmail"] : null as any;
            this.contactPerson = _data["contactPerson"] !== undefined ? _data["contactPerson"] : null as any;
            this.additionalEmails = _data["additionalEmails"] !== undefined ? _data["additionalEmails"] : null as any;
            this.isAccountManger = _data["isAccountManger"] !== undefined ? _data["isAccountManger"] : null as any;
        }
    }

    static fromJS(data: any): SupplierContactList {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierContactList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supervisorId"] = this.supervisorId !== undefined ? this.supervisorId : null as any;
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        data["supplierId"] = this.supplierId !== undefined ? this.supplierId : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        data["mainSupplierEmail"] = this.mainSupplierEmail !== undefined ? this.mainSupplierEmail : null as any;
        data["contactPerson"] = this.contactPerson !== undefined ? this.contactPerson : null as any;
        data["additionalEmails"] = this.additionalEmails !== undefined ? this.additionalEmails : null as any;
        data["isAccountManger"] = this.isAccountManger !== undefined ? this.isAccountManger : null as any;
        return data;
    }
}

export interface ISupplierContactList {
    supervisorId?: string;
    supplier?: string | null;
    supplierId?: string;
    phoneNumber?: string | null;
    mainSupplierEmail?: string | null;
    contactPerson?: string | null;
    additionalEmails?: string | null;
    isAccountManger?: boolean;
}

export class SupplierCoveragesResponse implements ISupplierCoveragesResponse {
    supplier?: string | null;
    fulfillmentReliability?: number;
    fullFulfillment?: number;
    partialFulfillment?: number;
    cancellation?: number;

    constructor(data?: ISupplierCoveragesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
            this.fulfillmentReliability = _data["fulfillmentReliability"] !== undefined ? _data["fulfillmentReliability"] : null as any;
            this.fullFulfillment = _data["fullFulfillment"] !== undefined ? _data["fullFulfillment"] : null as any;
            this.partialFulfillment = _data["partialFulfillment"] !== undefined ? _data["partialFulfillment"] : null as any;
            this.cancellation = _data["cancellation"] !== undefined ? _data["cancellation"] : null as any;
        }
    }

    static fromJS(data: any): SupplierCoveragesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierCoveragesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        data["fulfillmentReliability"] = this.fulfillmentReliability !== undefined ? this.fulfillmentReliability : null as any;
        data["fullFulfillment"] = this.fullFulfillment !== undefined ? this.fullFulfillment : null as any;
        data["partialFulfillment"] = this.partialFulfillment !== undefined ? this.partialFulfillment : null as any;
        data["cancellation"] = this.cancellation !== undefined ? this.cancellation : null as any;
        return data;
    }
}

export interface ISupplierCoveragesResponse {
    supplier?: string | null;
    fulfillmentReliability?: number;
    fullFulfillment?: number;
    partialFulfillment?: number;
    cancellation?: number;
}

export class SupplierETKResponse implements ISupplierETKResponse {
    supplier?: string | null;
    totalETK?: number;

    constructor(data?: ISupplierETKResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
            this.totalETK = _data["totalETK"] !== undefined ? _data["totalETK"] : null as any;
        }
    }

    static fromJS(data: any): SupplierETKResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierETKResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        data["totalETK"] = this.totalETK !== undefined ? this.totalETK : null as any;
        return data;
    }
}

export interface ISupplierETKResponse {
    supplier?: string | null;
    totalETK?: number;
}

export enum SupplierFulfillmentPartialOption {
    Guard_Type = "Guard Type",
}

export enum SupplierFulfillmentResponse {
    Legacy = "Legacy",
    Confirm = "Confirm",
    Cancel = "Cancel",
    Delay = "Delay",
    Partial_Fulfill = "Partial Fulfill",
}

export class SupplierPermitVettingResponse implements ISupplierPermitVettingResponse {
    supplier?: string | null;
    passedVetting?: number;
    failedVetting?: number;
    pendingVetting?: number;
    totalGuardsSent?: number;

    constructor(data?: ISupplierPermitVettingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supplier = _data["supplier"] !== undefined ? _data["supplier"] : null as any;
            this.passedVetting = _data["passedVetting"] !== undefined ? _data["passedVetting"] : null as any;
            this.failedVetting = _data["failedVetting"] !== undefined ? _data["failedVetting"] : null as any;
            this.pendingVetting = _data["pendingVetting"] !== undefined ? _data["pendingVetting"] : null as any;
            this.totalGuardsSent = _data["totalGuardsSent"] !== undefined ? _data["totalGuardsSent"] : null as any;
        }
    }

    static fromJS(data: any): SupplierPermitVettingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierPermitVettingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supplier"] = this.supplier !== undefined ? this.supplier : null as any;
        data["passedVetting"] = this.passedVetting !== undefined ? this.passedVetting : null as any;
        data["failedVetting"] = this.failedVetting !== undefined ? this.failedVetting : null as any;
        data["pendingVetting"] = this.pendingVetting !== undefined ? this.pendingVetting : null as any;
        data["totalGuardsSent"] = this.totalGuardsSent !== undefined ? this.totalGuardsSent : null as any;
        return data;
    }
}

export interface ISupplierPermitVettingResponse {
    supplier?: string | null;
    passedVetting?: number;
    failedVetting?: number;
    pendingVetting?: number;
    totalGuardsSent?: number;
}

export class SupplierSupervisor implements ISupplierSupervisor {
    supervisorID?: string;
    supplierID?: string;
    supervisorName?: string | null;
    officePhoneNumber?: string | null;
    cellPhoneNumber?: string | null;
    emailAddress?: string | null;
    timeZone?: string | null;
    geographicalCoverage?: string | null;
    backupContact?: string | null;
    isIndividualServiceRequest?: boolean;
    isRequestsPendingApproval?: boolean;
    isPermitVetting?: boolean;
    isIssueManagement?: boolean;
    isAccountManager?: boolean;
    isAccountManagement?: boolean;
    isBillingAccounting?: boolean;
    isServiceRequest?: boolean;
    isRegionalAccountAccountManager?: boolean;
    isLocalAccountManager?: boolean;
    isAdHoc?: boolean;
    isNone?: boolean;
    isOther?: boolean;
    comments?: string | null;
    supplier?: Supplier;

    constructor(data?: ISupplierSupervisor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.supervisorID = _data["supervisorID"] !== undefined ? _data["supervisorID"] : null as any;
            this.supplierID = _data["supplierID"] !== undefined ? _data["supplierID"] : null as any;
            this.supervisorName = _data["supervisorName"] !== undefined ? _data["supervisorName"] : null as any;
            this.officePhoneNumber = _data["officePhoneNumber"] !== undefined ? _data["officePhoneNumber"] : null as any;
            this.cellPhoneNumber = _data["cellPhoneNumber"] !== undefined ? _data["cellPhoneNumber"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.timeZone = _data["timeZone"] !== undefined ? _data["timeZone"] : null as any;
            this.geographicalCoverage = _data["geographicalCoverage"] !== undefined ? _data["geographicalCoverage"] : null as any;
            this.backupContact = _data["backupContact"] !== undefined ? _data["backupContact"] : null as any;
            this.isIndividualServiceRequest = _data["isIndividualServiceRequest"] !== undefined ? _data["isIndividualServiceRequest"] : null as any;
            this.isRequestsPendingApproval = _data["isRequestsPendingApproval"] !== undefined ? _data["isRequestsPendingApproval"] : null as any;
            this.isPermitVetting = _data["isPermitVetting"] !== undefined ? _data["isPermitVetting"] : null as any;
            this.isIssueManagement = _data["isIssueManagement"] !== undefined ? _data["isIssueManagement"] : null as any;
            this.isAccountManager = _data["isAccountManager"] !== undefined ? _data["isAccountManager"] : null as any;
            this.isAccountManagement = _data["isAccountManagement"] !== undefined ? _data["isAccountManagement"] : null as any;
            this.isBillingAccounting = _data["isBillingAccounting"] !== undefined ? _data["isBillingAccounting"] : null as any;
            this.isServiceRequest = _data["isServiceRequest"] !== undefined ? _data["isServiceRequest"] : null as any;
            this.isRegionalAccountAccountManager = _data["isRegionalAccountAccountManager"] !== undefined ? _data["isRegionalAccountAccountManager"] : null as any;
            this.isLocalAccountManager = _data["isLocalAccountManager"] !== undefined ? _data["isLocalAccountManager"] : null as any;
            this.isAdHoc = _data["isAdHoc"] !== undefined ? _data["isAdHoc"] : null as any;
            this.isNone = _data["isNone"] !== undefined ? _data["isNone"] : null as any;
            this.isOther = _data["isOther"] !== undefined ? _data["isOther"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.supplier = _data["supplier"] ? Supplier.fromJS(_data["supplier"]) : null as any;
        }
    }

    static fromJS(data: any): SupplierSupervisor {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierSupervisor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["supervisorID"] = this.supervisorID !== undefined ? this.supervisorID : null as any;
        data["supplierID"] = this.supplierID !== undefined ? this.supplierID : null as any;
        data["supervisorName"] = this.supervisorName !== undefined ? this.supervisorName : null as any;
        data["officePhoneNumber"] = this.officePhoneNumber !== undefined ? this.officePhoneNumber : null as any;
        data["cellPhoneNumber"] = this.cellPhoneNumber !== undefined ? this.cellPhoneNumber : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["timeZone"] = this.timeZone !== undefined ? this.timeZone : null as any;
        data["geographicalCoverage"] = this.geographicalCoverage !== undefined ? this.geographicalCoverage : null as any;
        data["backupContact"] = this.backupContact !== undefined ? this.backupContact : null as any;
        data["isIndividualServiceRequest"] = this.isIndividualServiceRequest !== undefined ? this.isIndividualServiceRequest : null as any;
        data["isRequestsPendingApproval"] = this.isRequestsPendingApproval !== undefined ? this.isRequestsPendingApproval : null as any;
        data["isPermitVetting"] = this.isPermitVetting !== undefined ? this.isPermitVetting : null as any;
        data["isIssueManagement"] = this.isIssueManagement !== undefined ? this.isIssueManagement : null as any;
        data["isAccountManager"] = this.isAccountManager !== undefined ? this.isAccountManager : null as any;
        data["isAccountManagement"] = this.isAccountManagement !== undefined ? this.isAccountManagement : null as any;
        data["isBillingAccounting"] = this.isBillingAccounting !== undefined ? this.isBillingAccounting : null as any;
        data["isServiceRequest"] = this.isServiceRequest !== undefined ? this.isServiceRequest : null as any;
        data["isRegionalAccountAccountManager"] = this.isRegionalAccountAccountManager !== undefined ? this.isRegionalAccountAccountManager : null as any;
        data["isLocalAccountManager"] = this.isLocalAccountManager !== undefined ? this.isLocalAccountManager : null as any;
        data["isAdHoc"] = this.isAdHoc !== undefined ? this.isAdHoc : null as any;
        data["isNone"] = this.isNone !== undefined ? this.isNone : null as any;
        data["isOther"] = this.isOther !== undefined ? this.isOther : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["supplier"] = this.supplier ? this.supplier.toJSON() : null as any;
        return data;
    }
}

export interface ISupplierSupervisor {
    supervisorID?: string;
    supplierID?: string;
    supervisorName?: string | null;
    officePhoneNumber?: string | null;
    cellPhoneNumber?: string | null;
    emailAddress?: string | null;
    timeZone?: string | null;
    geographicalCoverage?: string | null;
    backupContact?: string | null;
    isIndividualServiceRequest?: boolean;
    isRequestsPendingApproval?: boolean;
    isPermitVetting?: boolean;
    isIssueManagement?: boolean;
    isAccountManager?: boolean;
    isAccountManagement?: boolean;
    isBillingAccounting?: boolean;
    isServiceRequest?: boolean;
    isRegionalAccountAccountManager?: boolean;
    isLocalAccountManager?: boolean;
    isAdHoc?: boolean;
    isNone?: boolean;
    isOther?: boolean;
    comments?: string | null;
    supplier?: Supplier;
}

export class Tag implements ITag {
    ownerID?: number | null;
    owner?: Owner;
    name!: string;
    notes?: string | null;
    designerID!: string;
    ownerDesignerID!: string;
    id?: number;

    constructor(data?: ITag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.ownerDesignerID = _data["ownerDesignerID"] !== undefined ? _data["ownerDesignerID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): Tag {
        data = typeof data === 'object' ? data : {};
        let result = new Tag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["owner"] = this.owner ? this.owner.toJSON() : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["ownerDesignerID"] = this.ownerDesignerID !== undefined ? this.ownerDesignerID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface ITag {
    ownerID?: number | null;
    owner?: Owner;
    name: string;
    notes?: string | null;
    designerID: string;
    ownerDesignerID: string;
    id?: number;
}

export class Target implements ITarget {
    ownerID?: number;
    owner?: Owner;
    createdDate!: Date;
    modifiedDate!: Date;
    name!: string;
    description?: string | null;
    active?: boolean;
    notes?: string | null;
    questionNumberTypeID?: number;
    questionNumberType?: QuestionNumberType;
    locked?: boolean;
    percentComplete?: number | null;
    completedDate?: Date | null;
    completedBy?: string | null;
    summaryItems?: DatasetDatapoint[] | null;
    externalSearchable!: boolean;
    externalVisible!: boolean;
    summaryTemplateID?: number | null;
    summaryTemplate?: Template;
    defaultNameStyleID?: number | null;
    defaultNameStyle?: Script;
    defaultValueStyleID?: number | null;
    defaultValueStyle?: Script;
    calculateDefaultHidden?: boolean;
    enhancedExpressionSecurity!: boolean;
    legacyRerenderStrategy!: boolean;
    readOnly!: boolean;
    global!: boolean;
    iterative!: boolean;
    submittable!: boolean;
    seq!: number;
    submitExpression?: string | null;
    validationExpression?: string | null;
    iterateExpression?: string | null;
    workflowProcessID?: number | null;
    workflowProcess?: Process;
    workflowInitialStateID?: number | null;
    workflowInitialState?: State;
    showSummaryDownload!: boolean;
    showProgress!: boolean;
    showCompletedBy!: boolean;
    showIterateButton!: boolean;
    cardTemplateID?: number | null;
    cardTemplate?: Template;
    iterateOnCardOpen!: boolean;
    beforeImportExpression?: string | null;
    afterImportExpression?: string | null;
    afterConfigDatasetExpression?: string | null;
    sqlTypeSchema?: string | null;
    sqlTypeName?: string | null;
    fromDataApi!: boolean;
    dataApiPost!: boolean;
    universal!: boolean;
    dataApiUrl?: string | null;
    dataApiBatchUrl?: string | null;
    retentionPolicyID?: number | null;
    retentionPolicy?: RetentionPolicy;
    retentionPolicyDatapointTargetID?: number | null;
    retentionPolicyDatapointTarget?: DatapointTarget;
    subTargetsReadOnly?: boolean | null;
    disableOnSave?: boolean;
    notifyOnSave?: boolean;
    dashboardsTargets?: DashboardTarget[] | null;
    published?: boolean;
    libraryItem?: boolean;
    accessExpression?: string | null;
    progressExpression?: string | null;
    headerTemplateOwnerVar?: string | null;
    footerTemplateOwnerVar?: string | null;
    disableDefaultNavButtons!: boolean;
    headerTemplateID?: number | null;
    footerTemplateID?: number | null;
    headerTemplate?: Template;
    footerTemplate?: Template;
    rerenderByDisplayParent!: boolean;
    subTargetROTracksTarget!: boolean;
    targetedElementBinding!: boolean;
    rerenderAllIndices!: boolean;
    designerID!: string;
    summaryTemplateDesignerID?: string | null;
    workflowProcessDesignerID?: string | null;
    workflowInitialStateDesignerID?: string | null;
    cardTemplateDesignerID?: string | null;
    ownerDesignerID!: string;
    workflowServiceID?: string | null;
    useWorkflowService?: boolean | null;
    id?: number;

    constructor(data?: ITarget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.questionNumberTypeID = _data["questionNumberTypeID"] !== undefined ? _data["questionNumberTypeID"] : null as any;
            this.questionNumberType = _data["questionNumberType"] ? QuestionNumberType.fromJS(_data["questionNumberType"]) : null as any;
            this.locked = _data["locked"] !== undefined ? _data["locked"] : null as any;
            this.percentComplete = _data["percentComplete"] !== undefined ? _data["percentComplete"] : null as any;
            this.completedDate = _data["completedDate"] ? new Date(_data["completedDate"].toString()) : null as any;
            this.completedBy = _data["completedBy"] !== undefined ? _data["completedBy"] : null as any;
            if (Array.isArray(_data["summaryItems"])) {
                this.summaryItems = [] as any;
                for (let item of _data["summaryItems"])
                    this.summaryItems!.push(DatasetDatapoint.fromJS(item));
            }
            else {
                this.summaryItems = null as any;
            }
            this.externalSearchable = _data["externalSearchable"] !== undefined ? _data["externalSearchable"] : null as any;
            this.externalVisible = _data["externalVisible"] !== undefined ? _data["externalVisible"] : null as any;
            this.summaryTemplateID = _data["summaryTemplateID"] !== undefined ? _data["summaryTemplateID"] : null as any;
            this.summaryTemplate = _data["summaryTemplate"] ? Template.fromJS(_data["summaryTemplate"]) : null as any;
            this.defaultNameStyleID = _data["defaultNameStyleID"] !== undefined ? _data["defaultNameStyleID"] : null as any;
            this.defaultNameStyle = _data["defaultNameStyle"] ? Script.fromJS(_data["defaultNameStyle"]) : null as any;
            this.defaultValueStyleID = _data["defaultValueStyleID"] !== undefined ? _data["defaultValueStyleID"] : null as any;
            this.defaultValueStyle = _data["defaultValueStyle"] ? Script.fromJS(_data["defaultValueStyle"]) : null as any;
            this.calculateDefaultHidden = _data["calculateDefaultHidden"] !== undefined ? _data["calculateDefaultHidden"] : null as any;
            this.enhancedExpressionSecurity = _data["enhancedExpressionSecurity"] !== undefined ? _data["enhancedExpressionSecurity"] : null as any;
            this.legacyRerenderStrategy = _data["legacyRerenderStrategy"] !== undefined ? _data["legacyRerenderStrategy"] : null as any;
            this.readOnly = _data["readOnly"] !== undefined ? _data["readOnly"] : null as any;
            this.global = _data["global"] !== undefined ? _data["global"] : null as any;
            this.iterative = _data["iterative"] !== undefined ? _data["iterative"] : null as any;
            this.submittable = _data["submittable"] !== undefined ? _data["submittable"] : null as any;
            this.seq = _data["seq"] !== undefined ? _data["seq"] : null as any;
            this.submitExpression = _data["submitExpression"] !== undefined ? _data["submitExpression"] : null as any;
            this.validationExpression = _data["validationExpression"] !== undefined ? _data["validationExpression"] : null as any;
            this.iterateExpression = _data["iterateExpression"] !== undefined ? _data["iterateExpression"] : null as any;
            this.workflowProcessID = _data["workflowProcessID"] !== undefined ? _data["workflowProcessID"] : null as any;
            this.workflowProcess = _data["workflowProcess"] ? Process.fromJS(_data["workflowProcess"]) : null as any;
            this.workflowInitialStateID = _data["workflowInitialStateID"] !== undefined ? _data["workflowInitialStateID"] : null as any;
            this.workflowInitialState = _data["workflowInitialState"] ? State.fromJS(_data["workflowInitialState"]) : null as any;
            this.showSummaryDownload = _data["showSummaryDownload"] !== undefined ? _data["showSummaryDownload"] : null as any;
            this.showProgress = _data["showProgress"] !== undefined ? _data["showProgress"] : null as any;
            this.showCompletedBy = _data["showCompletedBy"] !== undefined ? _data["showCompletedBy"] : null as any;
            this.showIterateButton = _data["showIterateButton"] !== undefined ? _data["showIterateButton"] : null as any;
            this.cardTemplateID = _data["cardTemplateID"] !== undefined ? _data["cardTemplateID"] : null as any;
            this.cardTemplate = _data["cardTemplate"] ? Template.fromJS(_data["cardTemplate"]) : null as any;
            this.iterateOnCardOpen = _data["iterateOnCardOpen"] !== undefined ? _data["iterateOnCardOpen"] : null as any;
            this.beforeImportExpression = _data["beforeImportExpression"] !== undefined ? _data["beforeImportExpression"] : null as any;
            this.afterImportExpression = _data["afterImportExpression"] !== undefined ? _data["afterImportExpression"] : null as any;
            this.afterConfigDatasetExpression = _data["afterConfigDatasetExpression"] !== undefined ? _data["afterConfigDatasetExpression"] : null as any;
            this.sqlTypeSchema = _data["sqlTypeSchema"] !== undefined ? _data["sqlTypeSchema"] : null as any;
            this.sqlTypeName = _data["sqlTypeName"] !== undefined ? _data["sqlTypeName"] : null as any;
            this.fromDataApi = _data["fromDataApi"] !== undefined ? _data["fromDataApi"] : null as any;
            this.dataApiPost = _data["dataApiPost"] !== undefined ? _data["dataApiPost"] : null as any;
            this.universal = _data["universal"] !== undefined ? _data["universal"] : null as any;
            this.dataApiUrl = _data["dataApiUrl"] !== undefined ? _data["dataApiUrl"] : null as any;
            this.dataApiBatchUrl = _data["dataApiBatchUrl"] !== undefined ? _data["dataApiBatchUrl"] : null as any;
            this.retentionPolicyID = _data["retentionPolicyID"] !== undefined ? _data["retentionPolicyID"] : null as any;
            this.retentionPolicy = _data["retentionPolicy"] ? RetentionPolicy.fromJS(_data["retentionPolicy"]) : null as any;
            this.retentionPolicyDatapointTargetID = _data["retentionPolicyDatapointTargetID"] !== undefined ? _data["retentionPolicyDatapointTargetID"] : null as any;
            this.retentionPolicyDatapointTarget = _data["retentionPolicyDatapointTarget"] ? DatapointTarget.fromJS(_data["retentionPolicyDatapointTarget"]) : null as any;
            this.subTargetsReadOnly = _data["subTargetsReadOnly"] !== undefined ? _data["subTargetsReadOnly"] : null as any;
            this.disableOnSave = _data["disableOnSave"] !== undefined ? _data["disableOnSave"] : null as any;
            this.notifyOnSave = _data["notifyOnSave"] !== undefined ? _data["notifyOnSave"] : null as any;
            if (Array.isArray(_data["dashboardsTargets"])) {
                this.dashboardsTargets = [] as any;
                for (let item of _data["dashboardsTargets"])
                    this.dashboardsTargets!.push(DashboardTarget.fromJS(item));
            }
            else {
                this.dashboardsTargets = null as any;
            }
            this.published = _data["published"] !== undefined ? _data["published"] : null as any;
            this.libraryItem = _data["libraryItem"] !== undefined ? _data["libraryItem"] : null as any;
            this.accessExpression = _data["accessExpression"] !== undefined ? _data["accessExpression"] : null as any;
            this.progressExpression = _data["progressExpression"] !== undefined ? _data["progressExpression"] : null as any;
            this.headerTemplateOwnerVar = _data["headerTemplateOwnerVar"] !== undefined ? _data["headerTemplateOwnerVar"] : null as any;
            this.footerTemplateOwnerVar = _data["footerTemplateOwnerVar"] !== undefined ? _data["footerTemplateOwnerVar"] : null as any;
            this.disableDefaultNavButtons = _data["disableDefaultNavButtons"] !== undefined ? _data["disableDefaultNavButtons"] : null as any;
            this.headerTemplateID = _data["headerTemplateID"] !== undefined ? _data["headerTemplateID"] : null as any;
            this.footerTemplateID = _data["footerTemplateID"] !== undefined ? _data["footerTemplateID"] : null as any;
            this.headerTemplate = _data["headerTemplate"] ? Template.fromJS(_data["headerTemplate"]) : null as any;
            this.footerTemplate = _data["footerTemplate"] ? Template.fromJS(_data["footerTemplate"]) : null as any;
            this.rerenderByDisplayParent = _data["rerenderByDisplayParent"] !== undefined ? _data["rerenderByDisplayParent"] : null as any;
            this.subTargetROTracksTarget = _data["subTargetROTracksTarget"] !== undefined ? _data["subTargetROTracksTarget"] : null as any;
            this.targetedElementBinding = _data["targetedElementBinding"] !== undefined ? _data["targetedElementBinding"] : null as any;
            this.rerenderAllIndices = _data["rerenderAllIndices"] !== undefined ? _data["rerenderAllIndices"] : null as any;
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.summaryTemplateDesignerID = _data["summaryTemplateDesignerID"] !== undefined ? _data["summaryTemplateDesignerID"] : null as any;
            this.workflowProcessDesignerID = _data["workflowProcessDesignerID"] !== undefined ? _data["workflowProcessDesignerID"] : null as any;
            this.workflowInitialStateDesignerID = _data["workflowInitialStateDesignerID"] !== undefined ? _data["workflowInitialStateDesignerID"] : null as any;
            this.cardTemplateDesignerID = _data["cardTemplateDesignerID"] !== undefined ? _data["cardTemplateDesignerID"] : null as any;
            this.ownerDesignerID = _data["ownerDesignerID"] !== undefined ? _data["ownerDesignerID"] : null as any;
            this.workflowServiceID = _data["workflowServiceID"] !== undefined ? _data["workflowServiceID"] : null as any;
            this.useWorkflowService = _data["useWorkflowService"] !== undefined ? _data["useWorkflowService"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): Target {
        data = typeof data === 'object' ? data : {};
        let result = new Target();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["owner"] = this.owner ? this.owner.toJSON() : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["questionNumberTypeID"] = this.questionNumberTypeID !== undefined ? this.questionNumberTypeID : null as any;
        data["questionNumberType"] = this.questionNumberType ? this.questionNumberType.toJSON() : null as any;
        data["locked"] = this.locked !== undefined ? this.locked : null as any;
        data["percentComplete"] = this.percentComplete !== undefined ? this.percentComplete : null as any;
        data["completedDate"] = this.completedDate ? this.completedDate.toISOString() : null as any;
        data["completedBy"] = this.completedBy !== undefined ? this.completedBy : null as any;
        if (Array.isArray(this.summaryItems)) {
            data["summaryItems"] = [];
            for (let item of this.summaryItems)
                data["summaryItems"].push(item ? item.toJSON() : null as any);
        }
        data["externalSearchable"] = this.externalSearchable !== undefined ? this.externalSearchable : null as any;
        data["externalVisible"] = this.externalVisible !== undefined ? this.externalVisible : null as any;
        data["summaryTemplateID"] = this.summaryTemplateID !== undefined ? this.summaryTemplateID : null as any;
        data["summaryTemplate"] = this.summaryTemplate ? this.summaryTemplate.toJSON() : null as any;
        data["defaultNameStyleID"] = this.defaultNameStyleID !== undefined ? this.defaultNameStyleID : null as any;
        data["defaultNameStyle"] = this.defaultNameStyle ? this.defaultNameStyle.toJSON() : null as any;
        data["defaultValueStyleID"] = this.defaultValueStyleID !== undefined ? this.defaultValueStyleID : null as any;
        data["defaultValueStyle"] = this.defaultValueStyle ? this.defaultValueStyle.toJSON() : null as any;
        data["calculateDefaultHidden"] = this.calculateDefaultHidden !== undefined ? this.calculateDefaultHidden : null as any;
        data["enhancedExpressionSecurity"] = this.enhancedExpressionSecurity !== undefined ? this.enhancedExpressionSecurity : null as any;
        data["legacyRerenderStrategy"] = this.legacyRerenderStrategy !== undefined ? this.legacyRerenderStrategy : null as any;
        data["readOnly"] = this.readOnly !== undefined ? this.readOnly : null as any;
        data["global"] = this.global !== undefined ? this.global : null as any;
        data["iterative"] = this.iterative !== undefined ? this.iterative : null as any;
        data["submittable"] = this.submittable !== undefined ? this.submittable : null as any;
        data["seq"] = this.seq !== undefined ? this.seq : null as any;
        data["submitExpression"] = this.submitExpression !== undefined ? this.submitExpression : null as any;
        data["validationExpression"] = this.validationExpression !== undefined ? this.validationExpression : null as any;
        data["iterateExpression"] = this.iterateExpression !== undefined ? this.iterateExpression : null as any;
        data["workflowProcessID"] = this.workflowProcessID !== undefined ? this.workflowProcessID : null as any;
        data["workflowProcess"] = this.workflowProcess ? this.workflowProcess.toJSON() : null as any;
        data["workflowInitialStateID"] = this.workflowInitialStateID !== undefined ? this.workflowInitialStateID : null as any;
        data["workflowInitialState"] = this.workflowInitialState ? this.workflowInitialState.toJSON() : null as any;
        data["showSummaryDownload"] = this.showSummaryDownload !== undefined ? this.showSummaryDownload : null as any;
        data["showProgress"] = this.showProgress !== undefined ? this.showProgress : null as any;
        data["showCompletedBy"] = this.showCompletedBy !== undefined ? this.showCompletedBy : null as any;
        data["showIterateButton"] = this.showIterateButton !== undefined ? this.showIterateButton : null as any;
        data["cardTemplateID"] = this.cardTemplateID !== undefined ? this.cardTemplateID : null as any;
        data["cardTemplate"] = this.cardTemplate ? this.cardTemplate.toJSON() : null as any;
        data["iterateOnCardOpen"] = this.iterateOnCardOpen !== undefined ? this.iterateOnCardOpen : null as any;
        data["beforeImportExpression"] = this.beforeImportExpression !== undefined ? this.beforeImportExpression : null as any;
        data["afterImportExpression"] = this.afterImportExpression !== undefined ? this.afterImportExpression : null as any;
        data["afterConfigDatasetExpression"] = this.afterConfigDatasetExpression !== undefined ? this.afterConfigDatasetExpression : null as any;
        data["sqlTypeSchema"] = this.sqlTypeSchema !== undefined ? this.sqlTypeSchema : null as any;
        data["sqlTypeName"] = this.sqlTypeName !== undefined ? this.sqlTypeName : null as any;
        data["fromDataApi"] = this.fromDataApi !== undefined ? this.fromDataApi : null as any;
        data["dataApiPost"] = this.dataApiPost !== undefined ? this.dataApiPost : null as any;
        data["universal"] = this.universal !== undefined ? this.universal : null as any;
        data["dataApiUrl"] = this.dataApiUrl !== undefined ? this.dataApiUrl : null as any;
        data["dataApiBatchUrl"] = this.dataApiBatchUrl !== undefined ? this.dataApiBatchUrl : null as any;
        data["retentionPolicyID"] = this.retentionPolicyID !== undefined ? this.retentionPolicyID : null as any;
        data["retentionPolicy"] = this.retentionPolicy ? this.retentionPolicy.toJSON() : null as any;
        data["retentionPolicyDatapointTargetID"] = this.retentionPolicyDatapointTargetID !== undefined ? this.retentionPolicyDatapointTargetID : null as any;
        data["retentionPolicyDatapointTarget"] = this.retentionPolicyDatapointTarget ? this.retentionPolicyDatapointTarget.toJSON() : null as any;
        data["subTargetsReadOnly"] = this.subTargetsReadOnly !== undefined ? this.subTargetsReadOnly : null as any;
        data["disableOnSave"] = this.disableOnSave !== undefined ? this.disableOnSave : null as any;
        data["notifyOnSave"] = this.notifyOnSave !== undefined ? this.notifyOnSave : null as any;
        if (Array.isArray(this.dashboardsTargets)) {
            data["dashboardsTargets"] = [];
            for (let item of this.dashboardsTargets)
                data["dashboardsTargets"].push(item ? item.toJSON() : null as any);
        }
        data["published"] = this.published !== undefined ? this.published : null as any;
        data["libraryItem"] = this.libraryItem !== undefined ? this.libraryItem : null as any;
        data["accessExpression"] = this.accessExpression !== undefined ? this.accessExpression : null as any;
        data["progressExpression"] = this.progressExpression !== undefined ? this.progressExpression : null as any;
        data["headerTemplateOwnerVar"] = this.headerTemplateOwnerVar !== undefined ? this.headerTemplateOwnerVar : null as any;
        data["footerTemplateOwnerVar"] = this.footerTemplateOwnerVar !== undefined ? this.footerTemplateOwnerVar : null as any;
        data["disableDefaultNavButtons"] = this.disableDefaultNavButtons !== undefined ? this.disableDefaultNavButtons : null as any;
        data["headerTemplateID"] = this.headerTemplateID !== undefined ? this.headerTemplateID : null as any;
        data["footerTemplateID"] = this.footerTemplateID !== undefined ? this.footerTemplateID : null as any;
        data["headerTemplate"] = this.headerTemplate ? this.headerTemplate.toJSON() : null as any;
        data["footerTemplate"] = this.footerTemplate ? this.footerTemplate.toJSON() : null as any;
        data["rerenderByDisplayParent"] = this.rerenderByDisplayParent !== undefined ? this.rerenderByDisplayParent : null as any;
        data["subTargetROTracksTarget"] = this.subTargetROTracksTarget !== undefined ? this.subTargetROTracksTarget : null as any;
        data["targetedElementBinding"] = this.targetedElementBinding !== undefined ? this.targetedElementBinding : null as any;
        data["rerenderAllIndices"] = this.rerenderAllIndices !== undefined ? this.rerenderAllIndices : null as any;
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["summaryTemplateDesignerID"] = this.summaryTemplateDesignerID !== undefined ? this.summaryTemplateDesignerID : null as any;
        data["workflowProcessDesignerID"] = this.workflowProcessDesignerID !== undefined ? this.workflowProcessDesignerID : null as any;
        data["workflowInitialStateDesignerID"] = this.workflowInitialStateDesignerID !== undefined ? this.workflowInitialStateDesignerID : null as any;
        data["cardTemplateDesignerID"] = this.cardTemplateDesignerID !== undefined ? this.cardTemplateDesignerID : null as any;
        data["ownerDesignerID"] = this.ownerDesignerID !== undefined ? this.ownerDesignerID : null as any;
        data["workflowServiceID"] = this.workflowServiceID !== undefined ? this.workflowServiceID : null as any;
        data["useWorkflowService"] = this.useWorkflowService !== undefined ? this.useWorkflowService : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface ITarget {
    ownerID?: number;
    owner?: Owner;
    createdDate: Date;
    modifiedDate: Date;
    name: string;
    description?: string | null;
    active?: boolean;
    notes?: string | null;
    questionNumberTypeID?: number;
    questionNumberType?: QuestionNumberType;
    locked?: boolean;
    percentComplete?: number | null;
    completedDate?: Date | null;
    completedBy?: string | null;
    summaryItems?: DatasetDatapoint[] | null;
    externalSearchable: boolean;
    externalVisible: boolean;
    summaryTemplateID?: number | null;
    summaryTemplate?: Template;
    defaultNameStyleID?: number | null;
    defaultNameStyle?: Script;
    defaultValueStyleID?: number | null;
    defaultValueStyle?: Script;
    calculateDefaultHidden?: boolean;
    enhancedExpressionSecurity: boolean;
    legacyRerenderStrategy: boolean;
    readOnly: boolean;
    global: boolean;
    iterative: boolean;
    submittable: boolean;
    seq: number;
    submitExpression?: string | null;
    validationExpression?: string | null;
    iterateExpression?: string | null;
    workflowProcessID?: number | null;
    workflowProcess?: Process;
    workflowInitialStateID?: number | null;
    workflowInitialState?: State;
    showSummaryDownload: boolean;
    showProgress: boolean;
    showCompletedBy: boolean;
    showIterateButton: boolean;
    cardTemplateID?: number | null;
    cardTemplate?: Template;
    iterateOnCardOpen: boolean;
    beforeImportExpression?: string | null;
    afterImportExpression?: string | null;
    afterConfigDatasetExpression?: string | null;
    sqlTypeSchema?: string | null;
    sqlTypeName?: string | null;
    fromDataApi: boolean;
    dataApiPost: boolean;
    universal: boolean;
    dataApiUrl?: string | null;
    dataApiBatchUrl?: string | null;
    retentionPolicyID?: number | null;
    retentionPolicy?: RetentionPolicy;
    retentionPolicyDatapointTargetID?: number | null;
    retentionPolicyDatapointTarget?: DatapointTarget;
    subTargetsReadOnly?: boolean | null;
    disableOnSave?: boolean;
    notifyOnSave?: boolean;
    dashboardsTargets?: DashboardTarget[] | null;
    published?: boolean;
    libraryItem?: boolean;
    accessExpression?: string | null;
    progressExpression?: string | null;
    headerTemplateOwnerVar?: string | null;
    footerTemplateOwnerVar?: string | null;
    disableDefaultNavButtons: boolean;
    headerTemplateID?: number | null;
    footerTemplateID?: number | null;
    headerTemplate?: Template;
    footerTemplate?: Template;
    rerenderByDisplayParent: boolean;
    subTargetROTracksTarget: boolean;
    targetedElementBinding: boolean;
    rerenderAllIndices: boolean;
    designerID: string;
    summaryTemplateDesignerID?: string | null;
    workflowProcessDesignerID?: string | null;
    workflowInitialStateDesignerID?: string | null;
    cardTemplateDesignerID?: string | null;
    ownerDesignerID: string;
    workflowServiceID?: string | null;
    useWorkflowService?: boolean | null;
    id?: number;
}

export class TargetType implements ITargetType {
    mode?: number;
    name!: string;
    sourceTable!: string;
    identityColumn!: string;
    nameColumn!: string;
    notes?: string | null;
    id?: number;

    constructor(data?: ITargetType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mode = _data["mode"] !== undefined ? _data["mode"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.sourceTable = _data["sourceTable"] !== undefined ? _data["sourceTable"] : null as any;
            this.identityColumn = _data["identityColumn"] !== undefined ? _data["identityColumn"] : null as any;
            this.nameColumn = _data["nameColumn"] !== undefined ? _data["nameColumn"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): TargetType {
        data = typeof data === 'object' ? data : {};
        let result = new TargetType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mode"] = this.mode !== undefined ? this.mode : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["sourceTable"] = this.sourceTable !== undefined ? this.sourceTable : null as any;
        data["identityColumn"] = this.identityColumn !== undefined ? this.identityColumn : null as any;
        data["nameColumn"] = this.nameColumn !== undefined ? this.nameColumn : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface ITargetType {
    mode?: number;
    name: string;
    sourceTable: string;
    identityColumn: string;
    nameColumn: string;
    notes?: string | null;
    id?: number;
}

export class Template implements ITemplate {
    ownerID?: number | null;
    owner?: Owner;
    createdDate!: Date;
    modifiedDate!: Date;
    name!: string;
    markup!: string;
    description?: string | null;
    notes?: string | null;
    executiveSummary!: boolean;
    universal!: boolean;
    libraryItem!: boolean;
    code?: string | null;
    designerID!: string;
    ownerDesignerID!: string;
    id?: number;

    constructor(data?: ITemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.markup = _data["markup"] !== undefined ? _data["markup"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.executiveSummary = _data["executiveSummary"] !== undefined ? _data["executiveSummary"] : null as any;
            this.universal = _data["universal"] !== undefined ? _data["universal"] : null as any;
            this.libraryItem = _data["libraryItem"] !== undefined ? _data["libraryItem"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.ownerDesignerID = _data["ownerDesignerID"] !== undefined ? _data["ownerDesignerID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): Template {
        data = typeof data === 'object' ? data : {};
        let result = new Template();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["owner"] = this.owner ? this.owner.toJSON() : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["markup"] = this.markup !== undefined ? this.markup : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["executiveSummary"] = this.executiveSummary !== undefined ? this.executiveSummary : null as any;
        data["universal"] = this.universal !== undefined ? this.universal : null as any;
        data["libraryItem"] = this.libraryItem !== undefined ? this.libraryItem : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["ownerDesignerID"] = this.ownerDesignerID !== undefined ? this.ownerDesignerID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface ITemplate {
    ownerID?: number | null;
    owner?: Owner;
    createdDate: Date;
    modifiedDate: Date;
    name: string;
    markup: string;
    description?: string | null;
    notes?: string | null;
    executiveSummary: boolean;
    universal: boolean;
    libraryItem: boolean;
    code?: string | null;
    designerID: string;
    ownerDesignerID: string;
    id?: number;
}

export class TokenRequest implements ITokenRequest {
    sessionID?: number;
    ownerExternalID?: number;
    ownerExternalName?: string | null;
    ownerExternalSourceTable?: string | null;
    respondentExternalID?: number;
    respondentExternalName?: string | null;
    respondentExternalSourceTable?: string | null;
    respondentExternalUserType?: UserType;
    respondentExternalGroups?: Group[] | null;
    durationHours?: number;

    constructor(data?: ITokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sessionID = _data["sessionID"] !== undefined ? _data["sessionID"] : null as any;
            this.ownerExternalID = _data["ownerExternalID"] !== undefined ? _data["ownerExternalID"] : null as any;
            this.ownerExternalName = _data["ownerExternalName"] !== undefined ? _data["ownerExternalName"] : null as any;
            this.ownerExternalSourceTable = _data["ownerExternalSourceTable"] !== undefined ? _data["ownerExternalSourceTable"] : null as any;
            this.respondentExternalID = _data["respondentExternalID"] !== undefined ? _data["respondentExternalID"] : null as any;
            this.respondentExternalName = _data["respondentExternalName"] !== undefined ? _data["respondentExternalName"] : null as any;
            this.respondentExternalSourceTable = _data["respondentExternalSourceTable"] !== undefined ? _data["respondentExternalSourceTable"] : null as any;
            this.respondentExternalUserType = _data["respondentExternalUserType"] !== undefined ? _data["respondentExternalUserType"] : null as any;
            if (Array.isArray(_data["respondentExternalGroups"])) {
                this.respondentExternalGroups = [] as any;
                for (let item of _data["respondentExternalGroups"])
                    this.respondentExternalGroups!.push(Group.fromJS(item));
            }
            else {
                this.respondentExternalGroups = null as any;
            }
            this.durationHours = _data["durationHours"] !== undefined ? _data["durationHours"] : null as any;
        }
    }

    static fromJS(data: any): TokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new TokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionID"] = this.sessionID !== undefined ? this.sessionID : null as any;
        data["ownerExternalID"] = this.ownerExternalID !== undefined ? this.ownerExternalID : null as any;
        data["ownerExternalName"] = this.ownerExternalName !== undefined ? this.ownerExternalName : null as any;
        data["ownerExternalSourceTable"] = this.ownerExternalSourceTable !== undefined ? this.ownerExternalSourceTable : null as any;
        data["respondentExternalID"] = this.respondentExternalID !== undefined ? this.respondentExternalID : null as any;
        data["respondentExternalName"] = this.respondentExternalName !== undefined ? this.respondentExternalName : null as any;
        data["respondentExternalSourceTable"] = this.respondentExternalSourceTable !== undefined ? this.respondentExternalSourceTable : null as any;
        data["respondentExternalUserType"] = this.respondentExternalUserType !== undefined ? this.respondentExternalUserType : null as any;
        if (Array.isArray(this.respondentExternalGroups)) {
            data["respondentExternalGroups"] = [];
            for (let item of this.respondentExternalGroups)
                data["respondentExternalGroups"].push(item ? item.toJSON() : null as any);
        }
        data["durationHours"] = this.durationHours !== undefined ? this.durationHours : null as any;
        return data;
    }
}

export interface ITokenRequest {
    sessionID?: number;
    ownerExternalID?: number;
    ownerExternalName?: string | null;
    ownerExternalSourceTable?: string | null;
    respondentExternalID?: number;
    respondentExternalName?: string | null;
    respondentExternalSourceTable?: string | null;
    respondentExternalUserType?: UserType;
    respondentExternalGroups?: Group[] | null;
    durationHours?: number;
}

export class Transition implements ITransition {
    processID?: number;
    currentStateID?: number;
    nextStateID?: number;
    currentState?: State;
    nextState?: State;
    notes?: string | null;
    triggerDatapointTargetID?: number | null;
    triggerValueTypeOptionID?: number | null;
    priorTriggerDatapointTargetID?: number | null;
    createdDate!: Date;
    modifiedDate!: Date;
    designerID!: string;
    processDesignerID!: string;
    currentStateDesignerID!: string;
    nextStateDesignerID!: string;
    id?: number;

    constructor(data?: ITransition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.processID = _data["processID"] !== undefined ? _data["processID"] : null as any;
            this.currentStateID = _data["currentStateID"] !== undefined ? _data["currentStateID"] : null as any;
            this.nextStateID = _data["nextStateID"] !== undefined ? _data["nextStateID"] : null as any;
            this.currentState = _data["currentState"] ? State.fromJS(_data["currentState"]) : null as any;
            this.nextState = _data["nextState"] ? State.fromJS(_data["nextState"]) : null as any;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : null as any;
            this.triggerDatapointTargetID = _data["triggerDatapointTargetID"] !== undefined ? _data["triggerDatapointTargetID"] : null as any;
            this.triggerValueTypeOptionID = _data["triggerValueTypeOptionID"] !== undefined ? _data["triggerValueTypeOptionID"] : null as any;
            this.priorTriggerDatapointTargetID = _data["priorTriggerDatapointTargetID"] !== undefined ? _data["priorTriggerDatapointTargetID"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.modifiedDate = _data["modifiedDate"] ? new Date(_data["modifiedDate"].toString()) : null as any;
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.processDesignerID = _data["processDesignerID"] !== undefined ? _data["processDesignerID"] : null as any;
            this.currentStateDesignerID = _data["currentStateDesignerID"] !== undefined ? _data["currentStateDesignerID"] : null as any;
            this.nextStateDesignerID = _data["nextStateDesignerID"] !== undefined ? _data["nextStateDesignerID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): Transition {
        data = typeof data === 'object' ? data : {};
        let result = new Transition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["processID"] = this.processID !== undefined ? this.processID : null as any;
        data["currentStateID"] = this.currentStateID !== undefined ? this.currentStateID : null as any;
        data["nextStateID"] = this.nextStateID !== undefined ? this.nextStateID : null as any;
        data["currentState"] = this.currentState ? this.currentState.toJSON() : null as any;
        data["nextState"] = this.nextState ? this.nextState.toJSON() : null as any;
        data["notes"] = this.notes !== undefined ? this.notes : null as any;
        data["triggerDatapointTargetID"] = this.triggerDatapointTargetID !== undefined ? this.triggerDatapointTargetID : null as any;
        data["triggerValueTypeOptionID"] = this.triggerValueTypeOptionID !== undefined ? this.triggerValueTypeOptionID : null as any;
        data["priorTriggerDatapointTargetID"] = this.priorTriggerDatapointTargetID !== undefined ? this.priorTriggerDatapointTargetID : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : null as any;
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["processDesignerID"] = this.processDesignerID !== undefined ? this.processDesignerID : null as any;
        data["currentStateDesignerID"] = this.currentStateDesignerID !== undefined ? this.currentStateDesignerID : null as any;
        data["nextStateDesignerID"] = this.nextStateDesignerID !== undefined ? this.nextStateDesignerID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface ITransition {
    processID?: number;
    currentStateID?: number;
    nextStateID?: number;
    currentState?: State;
    nextState?: State;
    notes?: string | null;
    triggerDatapointTargetID?: number | null;
    triggerValueTypeOptionID?: number | null;
    priorTriggerDatapointTargetID?: number | null;
    createdDate: Date;
    modifiedDate: Date;
    designerID: string;
    processDesignerID: string;
    currentStateDesignerID: string;
    nextStateDesignerID: string;
    id?: number;
}

export class UpsertGuardSchedulesRequest implements IUpsertGuardSchedulesRequest {
    respondentId?: number;
    guardRequestId?: DatasetKey;
    details?: ServicePost[] | null;

    constructor(data?: IUpsertGuardSchedulesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.respondentId = _data["respondentId"] !== undefined ? _data["respondentId"] : null as any;
            this.guardRequestId = _data["guardRequestId"] ? DatasetKey.fromJS(_data["guardRequestId"]) : null as any;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(ServicePost.fromJS(item));
            }
            else {
                this.details = null as any;
            }
        }
    }

    static fromJS(data: any): UpsertGuardSchedulesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertGuardSchedulesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["respondentId"] = this.respondentId !== undefined ? this.respondentId : null as any;
        data["guardRequestId"] = this.guardRequestId ? this.guardRequestId.toJSON() : null as any;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IUpsertGuardSchedulesRequest {
    respondentId?: number;
    guardRequestId?: DatasetKey;
    details?: ServicePost[] | null;
}

export class UpsertRateCardV2Dto implements IUpsertRateCardV2Dto {
    vendor?: string | null;
    division?: string | null;
    region?: string | null;
    retailMark?: string | null;
    state?: string | null;
    lT_MobilePatrol_ServiceRate?: string | null;
    lT_MobilePatrol_ResponseRate?: string | null;
    lT_Unarmed_AllInRate?: string | null;
    lT_Armed_AllInRate?: string | null;
    lT_ODLE_MarkUp?: string | null;
    temp_MobilePatrol_ServiceRate?: string | null;
    temp_MobilePatrol_ResponseRate?: string | null;
    temp_Unarmed_AllInRate?: string | null;
    temp_Armed_AllInRate?: string | null;
    temp_ODLE_MarkUp?: string | null;
    lT_Unarmed_UnionRate_L?: string | null;
    lT_Unarmed_UnionRate_H?: string | null;
    lT_Armed_UnionRate_L?: string | null;
    lT_Armed_UnionRate_H?: string | null;
    temp_Unarmed_UnionRate_L?: string | null;
    temp_Unarmed_UnionRate_H?: string | null;
    temp_Armed_UnionRate_L?: string | null;
    temp_Armed_UnionRate_H?: string | null;
    lT_Unarmed_UnionMarkup_L?: string | null;
    lT_Unarmed_UnionMarkup_H?: string | null;
    lT_Armed_UnionMarkup_L?: string | null;
    lT_Armed_UnionMarkup_H?: string | null;
    temp_Unarmed_UnionMarkup_L?: string | null;
    temp_Unarmed_UnionMarkup_H?: string | null;
    temp_Armed_UnionMarkup_L?: string | null;
    temp_Armed_UnionMarkup_H?: string | null;

    constructor(data?: IUpsertRateCardV2Dto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vendor = _data["vendor"] !== undefined ? _data["vendor"] : null as any;
            this.division = _data["division"] !== undefined ? _data["division"] : null as any;
            this.region = _data["region"] !== undefined ? _data["region"] : null as any;
            this.retailMark = _data["retailMark"] !== undefined ? _data["retailMark"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.lT_MobilePatrol_ServiceRate = _data["lT_MobilePatrol_ServiceRate"] !== undefined ? _data["lT_MobilePatrol_ServiceRate"] : null as any;
            this.lT_MobilePatrol_ResponseRate = _data["lT_MobilePatrol_ResponseRate"] !== undefined ? _data["lT_MobilePatrol_ResponseRate"] : null as any;
            this.lT_Unarmed_AllInRate = _data["lT_Unarmed_AllInRate"] !== undefined ? _data["lT_Unarmed_AllInRate"] : null as any;
            this.lT_Armed_AllInRate = _data["lT_Armed_AllInRate"] !== undefined ? _data["lT_Armed_AllInRate"] : null as any;
            this.lT_ODLE_MarkUp = _data["lT_ODLE_MarkUp"] !== undefined ? _data["lT_ODLE_MarkUp"] : null as any;
            this.temp_MobilePatrol_ServiceRate = _data["temp_MobilePatrol_ServiceRate"] !== undefined ? _data["temp_MobilePatrol_ServiceRate"] : null as any;
            this.temp_MobilePatrol_ResponseRate = _data["temp_MobilePatrol_ResponseRate"] !== undefined ? _data["temp_MobilePatrol_ResponseRate"] : null as any;
            this.temp_Unarmed_AllInRate = _data["temp_Unarmed_AllInRate"] !== undefined ? _data["temp_Unarmed_AllInRate"] : null as any;
            this.temp_Armed_AllInRate = _data["temp_Armed_AllInRate"] !== undefined ? _data["temp_Armed_AllInRate"] : null as any;
            this.temp_ODLE_MarkUp = _data["temp_ODLE_MarkUp"] !== undefined ? _data["temp_ODLE_MarkUp"] : null as any;
            this.lT_Unarmed_UnionRate_L = _data["lT_Unarmed_UnionRate_L"] !== undefined ? _data["lT_Unarmed_UnionRate_L"] : null as any;
            this.lT_Unarmed_UnionRate_H = _data["lT_Unarmed_UnionRate_H"] !== undefined ? _data["lT_Unarmed_UnionRate_H"] : null as any;
            this.lT_Armed_UnionRate_L = _data["lT_Armed_UnionRate_L"] !== undefined ? _data["lT_Armed_UnionRate_L"] : null as any;
            this.lT_Armed_UnionRate_H = _data["lT_Armed_UnionRate_H"] !== undefined ? _data["lT_Armed_UnionRate_H"] : null as any;
            this.temp_Unarmed_UnionRate_L = _data["temp_Unarmed_UnionRate_L"] !== undefined ? _data["temp_Unarmed_UnionRate_L"] : null as any;
            this.temp_Unarmed_UnionRate_H = _data["temp_Unarmed_UnionRate_H"] !== undefined ? _data["temp_Unarmed_UnionRate_H"] : null as any;
            this.temp_Armed_UnionRate_L = _data["temp_Armed_UnionRate_L"] !== undefined ? _data["temp_Armed_UnionRate_L"] : null as any;
            this.temp_Armed_UnionRate_H = _data["temp_Armed_UnionRate_H"] !== undefined ? _data["temp_Armed_UnionRate_H"] : null as any;
            this.lT_Unarmed_UnionMarkup_L = _data["lT_Unarmed_UnionMarkup_L"] !== undefined ? _data["lT_Unarmed_UnionMarkup_L"] : null as any;
            this.lT_Unarmed_UnionMarkup_H = _data["lT_Unarmed_UnionMarkup_H"] !== undefined ? _data["lT_Unarmed_UnionMarkup_H"] : null as any;
            this.lT_Armed_UnionMarkup_L = _data["lT_Armed_UnionMarkup_L"] !== undefined ? _data["lT_Armed_UnionMarkup_L"] : null as any;
            this.lT_Armed_UnionMarkup_H = _data["lT_Armed_UnionMarkup_H"] !== undefined ? _data["lT_Armed_UnionMarkup_H"] : null as any;
            this.temp_Unarmed_UnionMarkup_L = _data["temp_Unarmed_UnionMarkup_L"] !== undefined ? _data["temp_Unarmed_UnionMarkup_L"] : null as any;
            this.temp_Unarmed_UnionMarkup_H = _data["temp_Unarmed_UnionMarkup_H"] !== undefined ? _data["temp_Unarmed_UnionMarkup_H"] : null as any;
            this.temp_Armed_UnionMarkup_L = _data["temp_Armed_UnionMarkup_L"] !== undefined ? _data["temp_Armed_UnionMarkup_L"] : null as any;
            this.temp_Armed_UnionMarkup_H = _data["temp_Armed_UnionMarkup_H"] !== undefined ? _data["temp_Armed_UnionMarkup_H"] : null as any;
        }
    }

    static fromJS(data: any): UpsertRateCardV2Dto {
        data = typeof data === 'object' ? data : {};
        let result = new UpsertRateCardV2Dto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vendor"] = this.vendor !== undefined ? this.vendor : null as any;
        data["division"] = this.division !== undefined ? this.division : null as any;
        data["region"] = this.region !== undefined ? this.region : null as any;
        data["retailMark"] = this.retailMark !== undefined ? this.retailMark : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["lT_MobilePatrol_ServiceRate"] = this.lT_MobilePatrol_ServiceRate !== undefined ? this.lT_MobilePatrol_ServiceRate : null as any;
        data["lT_MobilePatrol_ResponseRate"] = this.lT_MobilePatrol_ResponseRate !== undefined ? this.lT_MobilePatrol_ResponseRate : null as any;
        data["lT_Unarmed_AllInRate"] = this.lT_Unarmed_AllInRate !== undefined ? this.lT_Unarmed_AllInRate : null as any;
        data["lT_Armed_AllInRate"] = this.lT_Armed_AllInRate !== undefined ? this.lT_Armed_AllInRate : null as any;
        data["lT_ODLE_MarkUp"] = this.lT_ODLE_MarkUp !== undefined ? this.lT_ODLE_MarkUp : null as any;
        data["temp_MobilePatrol_ServiceRate"] = this.temp_MobilePatrol_ServiceRate !== undefined ? this.temp_MobilePatrol_ServiceRate : null as any;
        data["temp_MobilePatrol_ResponseRate"] = this.temp_MobilePatrol_ResponseRate !== undefined ? this.temp_MobilePatrol_ResponseRate : null as any;
        data["temp_Unarmed_AllInRate"] = this.temp_Unarmed_AllInRate !== undefined ? this.temp_Unarmed_AllInRate : null as any;
        data["temp_Armed_AllInRate"] = this.temp_Armed_AllInRate !== undefined ? this.temp_Armed_AllInRate : null as any;
        data["temp_ODLE_MarkUp"] = this.temp_ODLE_MarkUp !== undefined ? this.temp_ODLE_MarkUp : null as any;
        data["lT_Unarmed_UnionRate_L"] = this.lT_Unarmed_UnionRate_L !== undefined ? this.lT_Unarmed_UnionRate_L : null as any;
        data["lT_Unarmed_UnionRate_H"] = this.lT_Unarmed_UnionRate_H !== undefined ? this.lT_Unarmed_UnionRate_H : null as any;
        data["lT_Armed_UnionRate_L"] = this.lT_Armed_UnionRate_L !== undefined ? this.lT_Armed_UnionRate_L : null as any;
        data["lT_Armed_UnionRate_H"] = this.lT_Armed_UnionRate_H !== undefined ? this.lT_Armed_UnionRate_H : null as any;
        data["temp_Unarmed_UnionRate_L"] = this.temp_Unarmed_UnionRate_L !== undefined ? this.temp_Unarmed_UnionRate_L : null as any;
        data["temp_Unarmed_UnionRate_H"] = this.temp_Unarmed_UnionRate_H !== undefined ? this.temp_Unarmed_UnionRate_H : null as any;
        data["temp_Armed_UnionRate_L"] = this.temp_Armed_UnionRate_L !== undefined ? this.temp_Armed_UnionRate_L : null as any;
        data["temp_Armed_UnionRate_H"] = this.temp_Armed_UnionRate_H !== undefined ? this.temp_Armed_UnionRate_H : null as any;
        data["lT_Unarmed_UnionMarkup_L"] = this.lT_Unarmed_UnionMarkup_L !== undefined ? this.lT_Unarmed_UnionMarkup_L : null as any;
        data["lT_Unarmed_UnionMarkup_H"] = this.lT_Unarmed_UnionMarkup_H !== undefined ? this.lT_Unarmed_UnionMarkup_H : null as any;
        data["lT_Armed_UnionMarkup_L"] = this.lT_Armed_UnionMarkup_L !== undefined ? this.lT_Armed_UnionMarkup_L : null as any;
        data["lT_Armed_UnionMarkup_H"] = this.lT_Armed_UnionMarkup_H !== undefined ? this.lT_Armed_UnionMarkup_H : null as any;
        data["temp_Unarmed_UnionMarkup_L"] = this.temp_Unarmed_UnionMarkup_L !== undefined ? this.temp_Unarmed_UnionMarkup_L : null as any;
        data["temp_Unarmed_UnionMarkup_H"] = this.temp_Unarmed_UnionMarkup_H !== undefined ? this.temp_Unarmed_UnionMarkup_H : null as any;
        data["temp_Armed_UnionMarkup_L"] = this.temp_Armed_UnionMarkup_L !== undefined ? this.temp_Armed_UnionMarkup_L : null as any;
        data["temp_Armed_UnionMarkup_H"] = this.temp_Armed_UnionMarkup_H !== undefined ? this.temp_Armed_UnionMarkup_H : null as any;
        return data;
    }
}

export interface IUpsertRateCardV2Dto {
    vendor?: string | null;
    division?: string | null;
    region?: string | null;
    retailMark?: string | null;
    state?: string | null;
    lT_MobilePatrol_ServiceRate?: string | null;
    lT_MobilePatrol_ResponseRate?: string | null;
    lT_Unarmed_AllInRate?: string | null;
    lT_Armed_AllInRate?: string | null;
    lT_ODLE_MarkUp?: string | null;
    temp_MobilePatrol_ServiceRate?: string | null;
    temp_MobilePatrol_ResponseRate?: string | null;
    temp_Unarmed_AllInRate?: string | null;
    temp_Armed_AllInRate?: string | null;
    temp_ODLE_MarkUp?: string | null;
    lT_Unarmed_UnionRate_L?: string | null;
    lT_Unarmed_UnionRate_H?: string | null;
    lT_Armed_UnionRate_L?: string | null;
    lT_Armed_UnionRate_H?: string | null;
    temp_Unarmed_UnionRate_L?: string | null;
    temp_Unarmed_UnionRate_H?: string | null;
    temp_Armed_UnionRate_L?: string | null;
    temp_Armed_UnionRate_H?: string | null;
    lT_Unarmed_UnionMarkup_L?: string | null;
    lT_Unarmed_UnionMarkup_H?: string | null;
    lT_Armed_UnionMarkup_L?: string | null;
    lT_Armed_UnionMarkup_H?: string | null;
    temp_Unarmed_UnionMarkup_L?: string | null;
    temp_Unarmed_UnionMarkup_H?: string | null;
    temp_Armed_UnionMarkup_L?: string | null;
    temp_Armed_UnionMarkup_H?: string | null;
}

export enum UserType {
    ReadOnlyUser = "ReadOnlyUser",
    StandardUser = "StandardUser",
    Administrator = "Administrator",
    CAPAdmin = "CAPAdmin",
}

export class ValueConfig implements IValueConfig {
    ownerID?: number;
    owner?: Owner;
    name!: string;
    datatypeID?: number;
    datatype?: Datatype;
    expression?: string | null;
    regexID?: number | null;
    regex?: Regex;
    width?: number;
    precision?: number;
    step?: number | null;
    expressionExternalConfigID?: number | null;
    subTargetID?: number | null;
    config?: Config;
    valueConfigOptions?: ValueConfigOption[] | null;
    designerID!: string;
    subTargetDesignerID?: string | null;
    ownerDesignerID!: string;
    regexDesignerID?: string | null;
    datatypeDesignerID!: string;
    id?: number;

    constructor(data?: IValueConfig) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.datatypeID = _data["datatypeID"] !== undefined ? _data["datatypeID"] : null as any;
            this.datatype = _data["datatype"] ? Datatype.fromJS(_data["datatype"]) : null as any;
            this.expression = _data["expression"] !== undefined ? _data["expression"] : null as any;
            this.regexID = _data["regexID"] !== undefined ? _data["regexID"] : null as any;
            this.regex = _data["regex"] ? Regex.fromJS(_data["regex"]) : null as any;
            this.width = _data["width"] !== undefined ? _data["width"] : null as any;
            this.precision = _data["precision"] !== undefined ? _data["precision"] : null as any;
            this.step = _data["step"] !== undefined ? _data["step"] : null as any;
            this.expressionExternalConfigID = _data["expressionExternalConfigID"] !== undefined ? _data["expressionExternalConfigID"] : null as any;
            this.subTargetID = _data["subTargetID"] !== undefined ? _data["subTargetID"] : null as any;
            this.config = _data["config"] ? Config.fromJS(_data["config"]) : null as any;
            if (Array.isArray(_data["valueConfigOptions"])) {
                this.valueConfigOptions = [] as any;
                for (let item of _data["valueConfigOptions"])
                    this.valueConfigOptions!.push(ValueConfigOption.fromJS(item));
            }
            else {
                this.valueConfigOptions = null as any;
            }
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.subTargetDesignerID = _data["subTargetDesignerID"] !== undefined ? _data["subTargetDesignerID"] : null as any;
            this.ownerDesignerID = _data["ownerDesignerID"] !== undefined ? _data["ownerDesignerID"] : null as any;
            this.regexDesignerID = _data["regexDesignerID"] !== undefined ? _data["regexDesignerID"] : null as any;
            this.datatypeDesignerID = _data["datatypeDesignerID"] !== undefined ? _data["datatypeDesignerID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): ValueConfig {
        data = typeof data === 'object' ? data : {};
        let result = new ValueConfig();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["owner"] = this.owner ? this.owner.toJSON() : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["datatypeID"] = this.datatypeID !== undefined ? this.datatypeID : null as any;
        data["datatype"] = this.datatype ? this.datatype.toJSON() : null as any;
        data["expression"] = this.expression !== undefined ? this.expression : null as any;
        data["regexID"] = this.regexID !== undefined ? this.regexID : null as any;
        data["regex"] = this.regex ? this.regex.toJSON() : null as any;
        data["width"] = this.width !== undefined ? this.width : null as any;
        data["precision"] = this.precision !== undefined ? this.precision : null as any;
        data["step"] = this.step !== undefined ? this.step : null as any;
        data["expressionExternalConfigID"] = this.expressionExternalConfigID !== undefined ? this.expressionExternalConfigID : null as any;
        data["subTargetID"] = this.subTargetID !== undefined ? this.subTargetID : null as any;
        data["config"] = this.config ? this.config.toJSON() : null as any;
        if (Array.isArray(this.valueConfigOptions)) {
            data["valueConfigOptions"] = [];
            for (let item of this.valueConfigOptions)
                data["valueConfigOptions"].push(item ? item.toJSON() : null as any);
        }
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["subTargetDesignerID"] = this.subTargetDesignerID !== undefined ? this.subTargetDesignerID : null as any;
        data["ownerDesignerID"] = this.ownerDesignerID !== undefined ? this.ownerDesignerID : null as any;
        data["regexDesignerID"] = this.regexDesignerID !== undefined ? this.regexDesignerID : null as any;
        data["datatypeDesignerID"] = this.datatypeDesignerID !== undefined ? this.datatypeDesignerID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IValueConfig {
    ownerID?: number;
    owner?: Owner;
    name: string;
    datatypeID?: number;
    datatype?: Datatype;
    expression?: string | null;
    regexID?: number | null;
    regex?: Regex;
    width?: number;
    precision?: number;
    step?: number | null;
    expressionExternalConfigID?: number | null;
    subTargetID?: number | null;
    config?: Config;
    valueConfigOptions?: ValueConfigOption[] | null;
    designerID: string;
    subTargetDesignerID?: string | null;
    ownerDesignerID: string;
    regexDesignerID?: string | null;
    datatypeDesignerID: string;
    id?: number;
}

export class ValueConfigOption implements IValueConfigOption {
    ownerID?: number;
    owner?: Owner;
    valueConfigID?: number;
    valueConfig?: ValueConfig;
    optionText!: string;
    optionValue?: string | null;
    optionExpression?: string | null;
    dynamic?: boolean;
    optionWeight?: number | null;
    seq?: number | null;
    designerID!: string;
    valueConfigDesignerID!: string;
    ownerDesignerID!: string;
    id?: number;

    constructor(data?: IValueConfigOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.owner = _data["owner"] ? Owner.fromJS(_data["owner"]) : null as any;
            this.valueConfigID = _data["valueConfigID"] !== undefined ? _data["valueConfigID"] : null as any;
            this.valueConfig = _data["valueConfig"] ? ValueConfig.fromJS(_data["valueConfig"]) : null as any;
            this.optionText = _data["optionText"] !== undefined ? _data["optionText"] : null as any;
            this.optionValue = _data["optionValue"] !== undefined ? _data["optionValue"] : null as any;
            this.optionExpression = _data["optionExpression"] !== undefined ? _data["optionExpression"] : null as any;
            this.dynamic = _data["dynamic"] !== undefined ? _data["dynamic"] : null as any;
            this.optionWeight = _data["optionWeight"] !== undefined ? _data["optionWeight"] : null as any;
            this.seq = _data["seq"] !== undefined ? _data["seq"] : null as any;
            this.designerID = _data["designerID"] !== undefined ? _data["designerID"] : null as any;
            this.valueConfigDesignerID = _data["valueConfigDesignerID"] !== undefined ? _data["valueConfigDesignerID"] : null as any;
            this.ownerDesignerID = _data["ownerDesignerID"] !== undefined ? _data["ownerDesignerID"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): ValueConfigOption {
        data = typeof data === 'object' ? data : {};
        let result = new ValueConfigOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["owner"] = this.owner ? this.owner.toJSON() : null as any;
        data["valueConfigID"] = this.valueConfigID !== undefined ? this.valueConfigID : null as any;
        data["valueConfig"] = this.valueConfig ? this.valueConfig.toJSON() : null as any;
        data["optionText"] = this.optionText !== undefined ? this.optionText : null as any;
        data["optionValue"] = this.optionValue !== undefined ? this.optionValue : null as any;
        data["optionExpression"] = this.optionExpression !== undefined ? this.optionExpression : null as any;
        data["dynamic"] = this.dynamic !== undefined ? this.dynamic : null as any;
        data["optionWeight"] = this.optionWeight !== undefined ? this.optionWeight : null as any;
        data["seq"] = this.seq !== undefined ? this.seq : null as any;
        data["designerID"] = this.designerID !== undefined ? this.designerID : null as any;
        data["valueConfigDesignerID"] = this.valueConfigDesignerID !== undefined ? this.valueConfigDesignerID : null as any;
        data["ownerDesignerID"] = this.ownerDesignerID !== undefined ? this.ownerDesignerID : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }
}

export interface IValueConfigOption {
    ownerID?: number;
    owner?: Owner;
    valueConfigID?: number;
    valueConfig?: ValueConfig;
    optionText: string;
    optionValue?: string | null;
    optionExpression?: string | null;
    dynamic?: boolean;
    optionWeight?: number | null;
    seq?: number | null;
    designerID: string;
    valueConfigDesignerID: string;
    ownerDesignerID: string;
    id?: number;
}

export class ValueData implements IValueData {
    valueTypeOptionID?: number | null;
    value?: string | null;

    constructor(data?: IValueData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.valueTypeOptionID = _data["valueTypeOptionID"] !== undefined ? _data["valueTypeOptionID"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static fromJS(data: any): ValueData {
        data = typeof data === 'object' ? data : {};
        let result = new ValueData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["valueTypeOptionID"] = this.valueTypeOptionID !== undefined ? this.valueTypeOptionID : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }
}

export interface IValueData {
    valueTypeOptionID?: number | null;
    value?: string | null;
}

export class WeeklyShiftDetail implements IWeeklyShiftDetail {
    billingType?: string | null;
    assignmentType?: string | null;
    siteName?: string | null;
    siteAddress?: string | null;
    siteBUID?: string | null;
    siteServiceId?: string;
    siteId?: number;
    sequenceNumber?: number;
    perStopRecurrence?: string | null;
    perStopFrequency?: number | null;
    monStart?: string | null;
    monEnd?: string | null;
    tueStart?: string | null;
    tueEnd?: string | null;
    wedStart?: string | null;
    wedEnd?: string | null;
    thuStart?: string | null;
    thuEnd?: string | null;
    friStart?: string | null;
    friEnd?: string | null;
    satStart?: string | null;
    satEnd?: string | null;
    sunStart?: string | null;
    sunEnd?: string | null;

    constructor(data?: IWeeklyShiftDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.billingType = _data["billingType"] !== undefined ? _data["billingType"] : null as any;
            this.assignmentType = _data["assignmentType"] !== undefined ? _data["assignmentType"] : null as any;
            this.siteName = _data["siteName"] !== undefined ? _data["siteName"] : null as any;
            this.siteAddress = _data["siteAddress"] !== undefined ? _data["siteAddress"] : null as any;
            this.siteBUID = _data["siteBUID"] !== undefined ? _data["siteBUID"] : null as any;
            this.siteServiceId = _data["siteServiceId"] !== undefined ? _data["siteServiceId"] : null as any;
            this.siteId = _data["siteId"] !== undefined ? _data["siteId"] : null as any;
            this.sequenceNumber = _data["sequenceNumber"] !== undefined ? _data["sequenceNumber"] : null as any;
            this.perStopRecurrence = _data["perStopRecurrence"] !== undefined ? _data["perStopRecurrence"] : null as any;
            this.perStopFrequency = _data["perStopFrequency"] !== undefined ? _data["perStopFrequency"] : null as any;
            this.monStart = _data["monStart"] !== undefined ? _data["monStart"] : null as any;
            this.monEnd = _data["monEnd"] !== undefined ? _data["monEnd"] : null as any;
            this.tueStart = _data["tueStart"] !== undefined ? _data["tueStart"] : null as any;
            this.tueEnd = _data["tueEnd"] !== undefined ? _data["tueEnd"] : null as any;
            this.wedStart = _data["wedStart"] !== undefined ? _data["wedStart"] : null as any;
            this.wedEnd = _data["wedEnd"] !== undefined ? _data["wedEnd"] : null as any;
            this.thuStart = _data["thuStart"] !== undefined ? _data["thuStart"] : null as any;
            this.thuEnd = _data["thuEnd"] !== undefined ? _data["thuEnd"] : null as any;
            this.friStart = _data["friStart"] !== undefined ? _data["friStart"] : null as any;
            this.friEnd = _data["friEnd"] !== undefined ? _data["friEnd"] : null as any;
            this.satStart = _data["satStart"] !== undefined ? _data["satStart"] : null as any;
            this.satEnd = _data["satEnd"] !== undefined ? _data["satEnd"] : null as any;
            this.sunStart = _data["sunStart"] !== undefined ? _data["sunStart"] : null as any;
            this.sunEnd = _data["sunEnd"] !== undefined ? _data["sunEnd"] : null as any;
        }
    }

    static fromJS(data: any): WeeklyShiftDetail {
        data = typeof data === 'object' ? data : {};
        let result = new WeeklyShiftDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["billingType"] = this.billingType !== undefined ? this.billingType : null as any;
        data["assignmentType"] = this.assignmentType !== undefined ? this.assignmentType : null as any;
        data["siteName"] = this.siteName !== undefined ? this.siteName : null as any;
        data["siteAddress"] = this.siteAddress !== undefined ? this.siteAddress : null as any;
        data["siteBUID"] = this.siteBUID !== undefined ? this.siteBUID : null as any;
        data["siteServiceId"] = this.siteServiceId !== undefined ? this.siteServiceId : null as any;
        data["siteId"] = this.siteId !== undefined ? this.siteId : null as any;
        data["sequenceNumber"] = this.sequenceNumber !== undefined ? this.sequenceNumber : null as any;
        data["perStopRecurrence"] = this.perStopRecurrence !== undefined ? this.perStopRecurrence : null as any;
        data["perStopFrequency"] = this.perStopFrequency !== undefined ? this.perStopFrequency : null as any;
        data["monStart"] = this.monStart !== undefined ? this.monStart : null as any;
        data["monEnd"] = this.monEnd !== undefined ? this.monEnd : null as any;
        data["tueStart"] = this.tueStart !== undefined ? this.tueStart : null as any;
        data["tueEnd"] = this.tueEnd !== undefined ? this.tueEnd : null as any;
        data["wedStart"] = this.wedStart !== undefined ? this.wedStart : null as any;
        data["wedEnd"] = this.wedEnd !== undefined ? this.wedEnd : null as any;
        data["thuStart"] = this.thuStart !== undefined ? this.thuStart : null as any;
        data["thuEnd"] = this.thuEnd !== undefined ? this.thuEnd : null as any;
        data["friStart"] = this.friStart !== undefined ? this.friStart : null as any;
        data["friEnd"] = this.friEnd !== undefined ? this.friEnd : null as any;
        data["satStart"] = this.satStart !== undefined ? this.satStart : null as any;
        data["satEnd"] = this.satEnd !== undefined ? this.satEnd : null as any;
        data["sunStart"] = this.sunStart !== undefined ? this.sunStart : null as any;
        data["sunEnd"] = this.sunEnd !== undefined ? this.sunEnd : null as any;
        return data;
    }
}

export interface IWeeklyShiftDetail {
    billingType?: string | null;
    assignmentType?: string | null;
    siteName?: string | null;
    siteAddress?: string | null;
    siteBUID?: string | null;
    siteServiceId?: string;
    siteId?: number;
    sequenceNumber?: number;
    perStopRecurrence?: string | null;
    perStopFrequency?: number | null;
    monStart?: string | null;
    monEnd?: string | null;
    tueStart?: string | null;
    tueEnd?: string | null;
    wedStart?: string | null;
    wedEnd?: string | null;
    thuStart?: string | null;
    thuEnd?: string | null;
    friStart?: string | null;
    friEnd?: string | null;
    satStart?: string | null;
    satEnd?: string | null;
    sunStart?: string | null;
    sunEnd?: string | null;
}

export class WorkflowException implements IWorkflowException {
    exceptionType?: WorkflowExceptionType;
    detail?: string | null;
    comment?: string | null;

    constructor(data?: IWorkflowException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exceptionType = _data["exceptionType"] !== undefined ? _data["exceptionType"] : null as any;
            this.detail = _data["detail"] !== undefined ? _data["detail"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
        }
    }

    static fromJS(data: any): WorkflowException {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowException();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exceptionType"] = this.exceptionType !== undefined ? this.exceptionType : null as any;
        data["detail"] = this.detail !== undefined ? this.detail : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        return data;
    }
}

export interface IWorkflowException {
    exceptionType?: WorkflowExceptionType;
    detail?: string | null;
    comment?: string | null;
}

export enum WorkflowExceptionType {
    ServiceType = "ServiceType",
    Duration = "Duration",
    Cost = "Cost",
    Approval = "Approval",
    VestibuleStrategy = "VestibuleStrategy",
    ExistingServices = "ExistingServices",
}

export class WorkflowResult implements IWorkflowResult {
    id?: number;
    stakeholderID?: number;
    requestID?: number;
    actionID?: number;
    ownerExternalID?: number;
    ownerExternalName?: string | null;
    ownerExternalSourceTable?: string | null;
    respondentExternalID?: number;
    respondentExternalName?: string | null;
    respondentExternalSourceTable?: string | null;
    datasetExternalID?: number;
    iteration?: number;
    datasetID?: number;
    emailToScsv?: string | null;
    emailCcScsv?: string | null;
    subject?: string | null;
    emailTextTemplateID?: number;
    emailHtmlTemplateID?: number;
    ownerID?: number;
    url?: string | null;
    data?: string | null;
    sendEmailViaCCS?: boolean;
    emailReplyTo?: string | null;
    emailFrom?: string | null;
    method?: string | null;
    urlAuth?: string | null;
    readonly isEndpointResult?: boolean;
    readonly isActionExpressionResult?: boolean;
    exceptionMessage?: string | null;
    success?: boolean;
    emailResult?: EmailLog;

    constructor(data?: IWorkflowResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.stakeholderID = _data["stakeholderID"] !== undefined ? _data["stakeholderID"] : null as any;
            this.requestID = _data["requestID"] !== undefined ? _data["requestID"] : null as any;
            this.actionID = _data["actionID"] !== undefined ? _data["actionID"] : null as any;
            this.ownerExternalID = _data["ownerExternalID"] !== undefined ? _data["ownerExternalID"] : null as any;
            this.ownerExternalName = _data["ownerExternalName"] !== undefined ? _data["ownerExternalName"] : null as any;
            this.ownerExternalSourceTable = _data["ownerExternalSourceTable"] !== undefined ? _data["ownerExternalSourceTable"] : null as any;
            this.respondentExternalID = _data["respondentExternalID"] !== undefined ? _data["respondentExternalID"] : null as any;
            this.respondentExternalName = _data["respondentExternalName"] !== undefined ? _data["respondentExternalName"] : null as any;
            this.respondentExternalSourceTable = _data["respondentExternalSourceTable"] !== undefined ? _data["respondentExternalSourceTable"] : null as any;
            this.datasetExternalID = _data["datasetExternalID"] !== undefined ? _data["datasetExternalID"] : null as any;
            this.iteration = _data["iteration"] !== undefined ? _data["iteration"] : null as any;
            this.datasetID = _data["datasetID"] !== undefined ? _data["datasetID"] : null as any;
            this.emailToScsv = _data["emailToScsv"] !== undefined ? _data["emailToScsv"] : null as any;
            this.emailCcScsv = _data["emailCcScsv"] !== undefined ? _data["emailCcScsv"] : null as any;
            this.subject = _data["subject"] !== undefined ? _data["subject"] : null as any;
            this.emailTextTemplateID = _data["emailTextTemplateID"] !== undefined ? _data["emailTextTemplateID"] : null as any;
            this.emailHtmlTemplateID = _data["emailHtmlTemplateID"] !== undefined ? _data["emailHtmlTemplateID"] : null as any;
            this.ownerID = _data["ownerID"] !== undefined ? _data["ownerID"] : null as any;
            this.url = _data["url"] !== undefined ? _data["url"] : null as any;
            this.data = _data["data"] !== undefined ? _data["data"] : null as any;
            this.sendEmailViaCCS = _data["sendEmailViaCCS"] !== undefined ? _data["sendEmailViaCCS"] : null as any;
            this.emailReplyTo = _data["emailReplyTo"] !== undefined ? _data["emailReplyTo"] : null as any;
            this.emailFrom = _data["emailFrom"] !== undefined ? _data["emailFrom"] : null as any;
            this.method = _data["method"] !== undefined ? _data["method"] : null as any;
            this.urlAuth = _data["urlAuth"] !== undefined ? _data["urlAuth"] : null as any;
            (this as any).isEndpointResult = _data["isEndpointResult"] !== undefined ? _data["isEndpointResult"] : null as any;
            (this as any).isActionExpressionResult = _data["isActionExpressionResult"] !== undefined ? _data["isActionExpressionResult"] : null as any;
            this.exceptionMessage = _data["exceptionMessage"] !== undefined ? _data["exceptionMessage"] : null as any;
            this.success = _data["success"] !== undefined ? _data["success"] : null as any;
            this.emailResult = _data["emailResult"] ? EmailLog.fromJS(_data["emailResult"]) : null as any;
        }
    }

    static fromJS(data: any): WorkflowResult {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["stakeholderID"] = this.stakeholderID !== undefined ? this.stakeholderID : null as any;
        data["requestID"] = this.requestID !== undefined ? this.requestID : null as any;
        data["actionID"] = this.actionID !== undefined ? this.actionID : null as any;
        data["ownerExternalID"] = this.ownerExternalID !== undefined ? this.ownerExternalID : null as any;
        data["ownerExternalName"] = this.ownerExternalName !== undefined ? this.ownerExternalName : null as any;
        data["ownerExternalSourceTable"] = this.ownerExternalSourceTable !== undefined ? this.ownerExternalSourceTable : null as any;
        data["respondentExternalID"] = this.respondentExternalID !== undefined ? this.respondentExternalID : null as any;
        data["respondentExternalName"] = this.respondentExternalName !== undefined ? this.respondentExternalName : null as any;
        data["respondentExternalSourceTable"] = this.respondentExternalSourceTable !== undefined ? this.respondentExternalSourceTable : null as any;
        data["datasetExternalID"] = this.datasetExternalID !== undefined ? this.datasetExternalID : null as any;
        data["iteration"] = this.iteration !== undefined ? this.iteration : null as any;
        data["datasetID"] = this.datasetID !== undefined ? this.datasetID : null as any;
        data["emailToScsv"] = this.emailToScsv !== undefined ? this.emailToScsv : null as any;
        data["emailCcScsv"] = this.emailCcScsv !== undefined ? this.emailCcScsv : null as any;
        data["subject"] = this.subject !== undefined ? this.subject : null as any;
        data["emailTextTemplateID"] = this.emailTextTemplateID !== undefined ? this.emailTextTemplateID : null as any;
        data["emailHtmlTemplateID"] = this.emailHtmlTemplateID !== undefined ? this.emailHtmlTemplateID : null as any;
        data["ownerID"] = this.ownerID !== undefined ? this.ownerID : null as any;
        data["url"] = this.url !== undefined ? this.url : null as any;
        data["data"] = this.data !== undefined ? this.data : null as any;
        data["sendEmailViaCCS"] = this.sendEmailViaCCS !== undefined ? this.sendEmailViaCCS : null as any;
        data["emailReplyTo"] = this.emailReplyTo !== undefined ? this.emailReplyTo : null as any;
        data["emailFrom"] = this.emailFrom !== undefined ? this.emailFrom : null as any;
        data["method"] = this.method !== undefined ? this.method : null as any;
        data["urlAuth"] = this.urlAuth !== undefined ? this.urlAuth : null as any;
        data["isEndpointResult"] = this.isEndpointResult !== undefined ? this.isEndpointResult : null as any;
        data["isActionExpressionResult"] = this.isActionExpressionResult !== undefined ? this.isActionExpressionResult : null as any;
        data["exceptionMessage"] = this.exceptionMessage !== undefined ? this.exceptionMessage : null as any;
        data["success"] = this.success !== undefined ? this.success : null as any;
        data["emailResult"] = this.emailResult ? this.emailResult.toJSON() : null as any;
        return data;
    }
}

export interface IWorkflowResult {
    id?: number;
    stakeholderID?: number;
    requestID?: number;
    actionID?: number;
    ownerExternalID?: number;
    ownerExternalName?: string | null;
    ownerExternalSourceTable?: string | null;
    respondentExternalID?: number;
    respondentExternalName?: string | null;
    respondentExternalSourceTable?: string | null;
    datasetExternalID?: number;
    iteration?: number;
    datasetID?: number;
    emailToScsv?: string | null;
    emailCcScsv?: string | null;
    subject?: string | null;
    emailTextTemplateID?: number;
    emailHtmlTemplateID?: number;
    ownerID?: number;
    url?: string | null;
    data?: string | null;
    sendEmailViaCCS?: boolean;
    emailReplyTo?: string | null;
    emailFrom?: string | null;
    method?: string | null;
    urlAuth?: string | null;
    isEndpointResult?: boolean;
    isActionExpressionResult?: boolean;
    exceptionMessage?: string | null;
    success?: boolean;
    emailResult?: EmailLog;
}

export class WorkflowStatus implements IWorkflowStatus {
    workflowStatusID?: string;
    referenceID?: string | null;
    createdDate?: Date;
    stateDesignerID?: string | null;
    guardRequests?: GuardRequest[] | null;
    stateDesigner?: State;
    workflowInstanceID?: string | null;

    constructor(data?: IWorkflowStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workflowStatusID = _data["workflowStatusID"] !== undefined ? _data["workflowStatusID"] : null as any;
            this.referenceID = _data["referenceID"] !== undefined ? _data["referenceID"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.stateDesignerID = _data["stateDesignerID"] !== undefined ? _data["stateDesignerID"] : null as any;
            if (Array.isArray(_data["guardRequests"])) {
                this.guardRequests = [] as any;
                for (let item of _data["guardRequests"])
                    this.guardRequests!.push(GuardRequest.fromJS(item));
            }
            else {
                this.guardRequests = null as any;
            }
            this.stateDesigner = _data["stateDesigner"] ? State.fromJS(_data["stateDesigner"]) : null as any;
            this.workflowInstanceID = _data["workflowInstanceID"] !== undefined ? _data["workflowInstanceID"] : null as any;
        }
    }

    static fromJS(data: any): WorkflowStatus {
        data = typeof data === 'object' ? data : {};
        let result = new WorkflowStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workflowStatusID"] = this.workflowStatusID !== undefined ? this.workflowStatusID : null as any;
        data["referenceID"] = this.referenceID !== undefined ? this.referenceID : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["stateDesignerID"] = this.stateDesignerID !== undefined ? this.stateDesignerID : null as any;
        if (Array.isArray(this.guardRequests)) {
            data["guardRequests"] = [];
            for (let item of this.guardRequests)
                data["guardRequests"].push(item ? item.toJSON() : null as any);
        }
        data["stateDesigner"] = this.stateDesigner ? this.stateDesigner.toJSON() : null as any;
        data["workflowInstanceID"] = this.workflowInstanceID !== undefined ? this.workflowInstanceID : null as any;
        return data;
    }
}

export interface IWorkflowStatus {
    workflowStatusID?: string;
    referenceID?: string | null;
    createdDate?: Date;
    stateDesignerID?: string | null;
    guardRequests?: GuardRequest[] | null;
    stateDesigner?: State;
    workflowInstanceID?: string | null;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}